import { ThemeContextProvider as JT } from "./theme.mjs";
import { Box as j } from "./box.mjs";
import { Button as B1 } from "./button.mjs";
import { T as Y, j as T, X as en, e as Xr, D as K1, r as cu, n as Ui, i as q1, H as fu, z as hu, L as du, K as Tl, M as mi, U as Gi, F as mu, E as pu, _ as Tu, a as gu, b as Eu, R as Au, P as _u, W as yu, c as pi, Q as Ti } from "./index-2269cfe0.js";
import ee, { useContext as Cu, createContext as Su, useRef as wt, useState as Ke, useCallback as Ut, useEffect as Fe, useMemo as Rt, Suspense as xu } from "react";
import { c as Ve, g as fn, o as Nu } from "./WCLComponent.styles-68ac5b1f.js";
import { css as R } from "styled-components";
import { CheckIcon as bu, DropdownArrowIcon as Ou, VisibilityIcon as Iu, VisibilityOffIcon as Ru, LockFilledIcon as ku, WarningIcon as ji, CloseIcon as s1, BackIcon as r1, ForwardIcon as wu } from "./icon.mjs";
import { AccessibilityFilledIcon as e2, AccessibilityIcon as t2, AccessibilityOutlinedIcon as n2, BedIcon as r2, BellIcon as i2, CalendarIcon as o2, CardsIcon as s2, CartIcon as l2, CheckoutIcon as a2, CloseAltIcon as u2, CloseFilledIcon as c2, CocktailIcon as f2, CreditCardIcon as h2, DiamondIcon as d2, EnlargeIcon as m2, FamilyIcon as p2, FilterIcon as T2, FineDiningIcon as g2, GridFilledIcon as E2, GridOutlinedIcon as A2, GuestIcon as _2, HotelIcon as y2, InformationIcon as C2, LeftArrowIcon as S2, ListIcon as x2, LocationFilledIcon as N2, LocationIcon as b2, LockOutlinedIcon as O2, LoungeChairIcon as I2, MGMRewardsIcon as R2, MenuIcon as k2, MicrophoneIcon as w2, MinusIcon as L2, MinusOutlinedIcon as M2, NightLifeIcon as P2, ParkingIcon as v2, PinIcon as D2, PlateIcon as H2, PlayIcon as F2, PlusIcon as B2, PlusOutlinedIcon as $2, RefreshIcon as U2, RewardPointsIcon as G2, RightArrowIcon as j2, ShieldIcon as z2, SlotDollarsIcon as K2, SortAscendingIcon as q2, SortDescendingIcon as Y2, SpaIcon as V2, StairsIcon as W2, StarIcon as X2, StartPointIcon as Q2, TaxiIcon as J2, TentIcon as Z2, TravelCreditIcon as eg, UpwardArrowIcon as tg, WarningOutlinedIcon as ng } from "./icon.mjs";
import { E as Ge } from "./ErrorBoundary-60d80e23.js";
import { Typography as ut } from "./typography.mjs";
import { r as Vn } from "./polished.esm-7edc4d30.js";
import { Grid as ig } from "./grid.mjs";
import { L as Lu } from "./LoadingSpinnerIcon-943ea1b3.js";
import { a as sg, I as lg } from "./LoadingSpinnerIcon-943ea1b3.js";
import { Alert as ug } from "./alert.mjs";
import "react-inlinesvg";
var $1;
(function(e) {
  e[e.Right = -1] = "Right", e[e.Left = 1] = "Left";
})($1 || ($1 = {}));
function zi(e) {
  return e.nativeEvent instanceof window.MouseEvent ? e.nativeEvent.pageX : e.nativeEvent instanceof window.TouchEvent ? e.nativeEvent.changedTouches[0].pageX : 0;
}
function Tr(e) {
  return e.nativeEvent instanceof window.MouseEvent ? e.nativeEvent.pageY : e.nativeEvent instanceof window.TouchEvent ? e.nativeEvent.changedTouches[0].pageY : 0;
}
const Mu = `
  width: 100%;
  height: 100%;
  background-color: ${en};
  border-radius: 8px;
`, Pu = (e, t) => t === 0 || t === 1 || t === 2 ? "" : e ? `border: 1px solid ${Xr};` : "box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);", vu = Y(/* @__PURE__ */ ee.forwardRef(function(t, n) {
  return /* @__PURE__ */ T.jsx(j, {
    ref: n,
    ...t
  });
}))`
  ${Mu}
  ${({ noShadow: e, elevation: t }) => Pu(e, t)}
  ${Ve}
`, Du = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "card-container", noShadow: n = !1, children: r, onClick: i, elevation: o, ...s }, l) {
  const c = (u) => {
    u.persist(), i && i(u);
  };
  return /* @__PURE__ */ T.jsx(vu, {
    ref: l,
    testId: t,
    noShadow: n,
    elevation: o,
    onClick: c,
    ...s,
    children: r
  });
}), Hu = `
  ${K1}
  width: 100%;
  height: 100%;
  opacity: 0;
  position: relative;
  cursor: inherit;
  z-index: 1;
`, Fu = () => R`
    cursor: pointer;
    border: 1px solid ${({ theme: e }) => e.colors.interface};
    display: flex;
    justify-content: center;

    &:focus-within {
      border: solid 2px ${({ theme: e }) => e.colors.outlineColor};
      box-shadow: 0 0 2px ${({ theme: e }) => e.colors.interface};
    }
  `, Bu = (e) => {
  switch (e) {
    case "large":
      return R`
        border-radius: 8px;
      `;
    case "small":
      return R`
        border-radius: 4px;
      `;
  }
}, Ki = (e, t) => {
  switch (e) {
    case "radio":
      return R`
        border-radius: 46px;
      `;
    case "checkbox":
      return R`
        ${Bu(t)}
      `;
  }
}, qi = (e) => {
  switch (e) {
    case "large":
      return R`
        width: 2rem;
        height: 2rem;
      `;
    case "small":
      return R`
        width: 1rem;
        height: 1rem;
      `;
  }
}, $u = (e) => e ? R`
      background-color: ${({ theme: t }) => t.colors.interface};
      & div:first-child {
        color: ${({ theme: t }) => t.colors.white};
      }
    ` : R`
      background-color: ${({ theme: t }) => t.colors.white};
      & div:first-child {
        color: ${({ theme: t }) => t.colors.white};
      }
    `, Uu = (e) => {
  const t = R`
    background-color: ${({ theme: n }) => n.colors.disabledGrey};
    border: 1px solid ${({ theme: n }) => n.colors.disabledGrey};
    cursor: default;
  `;
  return e ? R`
      ${t}
      & div:first-child {
        color: ${({ theme: n }) => n.colors.white};
      }
    ` : R`
      ${t}
      & div:first-child {
        color: ${({ theme: n }) => n.colors.disabledGrey};
      }
    `;
}, Gu = Y(({ children: e, className: t, testId: n }) => /* @__PURE__ */ T.jsx("span", {
  className: t,
  "data-testid": n,
  children: e
}))`
  ${Fu}
  ${({ size: e, checked: t, disabled: n = !1, variant: r = "checkbox" }) => n ? R`
        ${Uu(t)}
        ${qi(e)}
        ${Ki(r, e)}
      ` : R`
      ${$u(t)}
      ${qi(e)}
      ${Ki(r, e)}
    `}
`, ju = Y(/* @__PURE__ */ ee.forwardRef(function({ className: t, onChange: n, testId: r, disabled: i, checked: o, onBlur: s, name: l, domProps: c }, u) {
  return /* @__PURE__ */ T.jsx("input", {
    type: "checkbox",
    className: t,
    "data-testid": r,
    onChange: n,
    onBlur: s,
    name: l,
    disabled: i,
    checked: o,
    ref: u,
    ...c
  });
}))`
  ${Hu}
  ${Ve}
`, TT = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "checkbox", size: n, checked: r, variant: i, disabled: o, onChange: s, onBlur: l, name: c, domProps: u, ...f }, m) {
  const E = () => {
    const h = n === "large" ? "1.4rem" : "1rem", x = n === "large" ? "1.4rem" : "0.8rem", y = o ? cu : "white", b = o ? "50%" : void 0;
    return /* @__PURE__ */ T.jsx(j, {
      height: h,
      width: x,
      children: /* @__PURE__ */ T.jsx(bu, {
        size: "100%",
        color: y,
        opacity: b
      })
    });
  };
  return /* @__PURE__ */ T.jsxs(Gu, {
    variant: i,
    size: n,
    checked: r,
    disabled: o,
    testId: t,
    ...f,
    children: [
      /* @__PURE__ */ T.jsx(ju, {
        testId: `${t}-internal-checkbox`,
        checked: r,
        disabled: o,
        onChange: s,
        onBlur: l,
        name: c,
        ref: m,
        domProps: u
      }),
      r && /* @__PURE__ */ T.jsx(j, {
        display: "inline-flex",
        alignSelf: "center",
        position: "absolute",
        testId: `${t}-icon-container`,
        children: /* @__PURE__ */ T.jsx(E, {})
      })
    ]
  });
}), zu = (e) => R`
    background-color: ${({ theme: t }) => e ? t.colors.lightestGrey : t.colors.white};
  `, Ku = Y(/* @__PURE__ */ ee.forwardRef(function({ testId: t, className: n, ...r }, i) {
  return /* @__PURE__ */ T.jsx(j, {
    testId: t,
    className: n,
    ref: i,
    ...r
  });
}))`
  ${({ grayBackground: e }) => zu(e)}
  ${Ve}
`, gl = /* @__PURE__ */ Su({}), qu = gl.Provider, gT = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "column-item", grayBackground: n = !1, height: r, children: i, ...o }, s) {
  const { height: l } = Cu(gl);
  return /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsx(Ku, {
      testId: t,
      display: "flex",
      alignItems: "center",
      padding: "1rem",
      width: "100%",
      grayBackground: n,
      height: r || l,
      minHeight: r || l,
      maxHeight: r || l,
      ref: s,
      ...o,
      children: i
    })
  });
}), ET = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "divider", variant: n = "horizontal", ...r }, i) {
  return /* @__PURE__ */ T.jsx(Ge, {
    children: n === "horizontal" ? /* @__PURE__ */ T.jsx(j, {
      testId: t,
      height: 1,
      margin: "1rem 0",
      backgroundColor: Xr,
      ref: i,
      ...r
    }) : /* @__PURE__ */ T.jsx(j, {
      testId: t,
      height: "inherit",
      margin: "0 1rem",
      display: "inline-block",
      borderLeft: `1px solid ${Xr}`,
      ref: i,
      ...r
    })
  });
}), Yu = `
  width: 100%;
  height: 100%;
  background-color: ${en};
  border-radius: 8px;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.12), 0 0 4px 0 rgba(0, 0, 0, 0.24);
`, Vu = Y(/* @__PURE__ */ ee.forwardRef(function({ children: t, className: n, testId: r, ...i }, o) {
  return /* @__PURE__ */ T.jsx(j, {
    testId: r,
    className: n,
    ref: o,
    ...i,
    children: t
  });
}))`
  ${Yu}
  ${Ve}
`, AT = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "dropdown-container", children: n, ...r }, i) {
  return /* @__PURE__ */ T.jsx(Vu, {
    testId: t,
    ref: i,
    ...r,
    children: n
  });
}), Wu = R`
  cursor: pointer;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 19rem;
  height: 3rem;
  background-color: ${({ theme: e }) => e.colors.white};
`, Xu = (e) => e ? R`
      background-color: ${({ theme: t }) => Vn(t.colors.interface, 0.08)};

      & > span {
        color: ${({ theme: t }) => t.colors.interface};
      }
    ` : R`
      &:hover {
        background-color: ${({ theme: t }) => Vn(t.colors.black, 0.04)};
      }

      &:focus-visible {
        background-color: ${({ theme: t }) => Vn(t.colors.black, 0.12)};
      }
    `, Qu = Y(/* @__PURE__ */ ee.forwardRef(function({ testId: t, className: n, ...r }, i) {
  return /* @__PURE__ */ T.jsx(j, {
    tabIndex: 0,
    testId: t,
    className: n,
    ref: i,
    ...r
  });
}))`
  ${Wu}
  ${({ selected: e }) => Xu(e)}
  ${Ve}
`, _T = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "dropdown-item", selected: n = !1, id: r, text: i, onClick: o, ...s }, l) {
  return /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsx(Qu, {
      onClick: () => o(r, i, n),
      testId: `${t}-${r}`,
      ref: l,
      ...s,
      children: /* @__PURE__ */ T.jsx(ut, {
        fontWeight: "600",
        variant: "paragraph",
        children: i
      })
    })
  });
}), Ju = Y(/* @__PURE__ */ ee.forwardRef(function({ loaded: t, className: n, testId: r, alt: i, domProps: o }, s) {
  return /* @__PURE__ */ T.jsx("div", {
    role: "img",
    "aria-label": i,
    className: n,
    "data-testid": r,
    ref: s,
    style: {
      opacity: t ? 1 : 0
    },
    ...o
  });
}))`
  background-image: url(${({ src: e }) => e});
  background-size: ${({ fit: e }) => e};
  background-repeat: no-repeat;
  background-position: center center;
  position: absolute;
  transition: opacity 160ms ease-in;
  ${Ve}
`, yT = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "image", height: n = "100%", width: r = "100%", src: i, alt: o, fit: s = "cover", timeout: l = 1e4, fallbackSrc: c, cropFix: u = !1, hasDAMUrl: f = !1, ...m }, E) {
  const h = wt(null), x = wt(null), [y, b] = Ke(!1), [_, M] = Ke(!1), [O, P] = Ke(i), [N, C] = Ke(!1), I = Ut((D) => {
    if (!x || !x.current)
      return D;
    const z = f || !!D.match(/\/content\/dam\//);
    let ie = D;
    if (z) {
      const v = window.devicePixelRatio || 1, U = Math.round(x.current.clientWidth * v), L = Math.round(x.current.clientHeight * v);
      L !== 0 && U !== 0 && (ie = `${D}.image.${U}.${L}.high.jpg`);
    }
    if (D.indexOf("https://images.contentstack.io/v3/assets") > -1) {
      const v = window.devicePixelRatio || 1, U = Math.round(x.current.clientWidth), L = Math.round(x.current.clientHeight), Q = D.indexOf("?") > -1 ? "&" : "?";
      if (L !== 0 && U !== 0) {
        let te = "", pe = "";
        u && (pe = "&crop=1:1"), U > L ? te = `width=${U}` : te = `height=${L}`, ie = `${D}${Q}${te}${pe}&format=webp&dpr=${v}`;
      }
    }
    return ie;
  }, [
    u,
    f
  ]);
  return Fe(() => {
    h.current && h.current.complete && b(!0);
  }, []), Fe(() => {
    const D = setTimeout(() => {
      h.current && (h.current.complete || C(!0));
    }, l);
    return () => clearTimeout(D);
  }, [
    l
  ]), Fe(() => {
    N && c && P(I(c));
  }, [
    N,
    c,
    I
  ]), Fe(() => {
    P(i), M(!1);
  }, [
    i
  ]), Fe(() => {
    _ || (P((D) => I(D)), M(!0));
  }, [
    O,
    _,
    I
  ]), /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsx(j, {
      testId: t,
      height: n,
      width: r,
      ref: x,
      position: "relative",
      overflow: "hidden",
      ...m,
      children: _ && /* @__PURE__ */ T.jsxs(T.Fragment, {
        children: [
          !y && /* @__PURE__ */ T.jsx("img", {
            ref: h,
            src: O,
            style: {
              position: "absolute",
              width: 200,
              opacity: 0
            },
            onError: () => {
              c && P(I(c)), b(!0);
            },
            onLoad: () => b(!0)
          }),
          s === "cover" && /* @__PURE__ */ T.jsx(j, {
            width: "100%",
            height: "100%",
            position: "absolute",
            backgroundColor: Ui
          }),
          /* @__PURE__ */ T.jsx(Ju, {
            width: "100%",
            height: "100%",
            src: O,
            loaded: y,
            fit: s,
            alt: o,
            ref: E
          }),
          !y && /* @__PURE__ */ T.jsx(j, {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            width: "100%",
            height: "100%",
            children: /* @__PURE__ */ T.jsx(Lu, {
              color: s === "cover" ? en : Ui,
              strokeWidth: "5.5",
              size: "48px",
              showSpinnerBackground: !0
            })
          })
        ]
      })
    })
  });
}), Zu = R`
  width: 100%;
  height: 4rem;
  background-color: ${({ theme: e }) => e.colors.lightestGrey};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`, ec = Y(/* @__PURE__ */ ee.forwardRef(function({ children: t, className: n, testId: r, ...i }, o) {
  return /* @__PURE__ */ T.jsx(j, {
    testId: r,
    className: n,
    ref: o,
    ...i,
    children: t
  });
}))`
  ${Zu}
  ${Ve}
`, tc = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "input-container", children: n, ...r }, i) {
  return /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsx(ec, {
      testId: t,
      ref: i,
      ...r,
      children: n
    })
  });
}), nc = R`
  cursor: pointer;
  user-select: none;
  padding: 1.75rem 0;
  white-space: nowrap;
  background-color: ${({ theme: e }) => e.colors.white};
  position: relative;
  display: inline-block;
`, rc = R`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 3px;
  background-color: ${({ theme: e }) => e.colors.interface};
`, ic = R`
  color: ${({ theme: e }) => Vn(e.colors.darkGrey, 0.5)};
  cursor: not-allowed;
`, oc = Y(/* @__PURE__ */ ee.forwardRef(function({ testId: t, className: n, ...r }, i) {
  return /* @__PURE__ */ T.jsx(j, {
    testId: t,
    tabIndex: 0,
    className: n,
    ref: i,
    ...r
  });
}))`
  ${nc}
`, sc = Y(j)`
  ${rc}
`, lc = Y(j)`
  ${ic}
`, CT = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "navigation-item", selected: n = !1, disabled: r = !1, children: i, ...o }, s) {
  return /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsxs(oc, {
      testId: t,
      ref: s,
      ...o,
      children: [
        i,
        n && /* @__PURE__ */ T.jsx(sc, {
          testId: `${t}-select-indicator`
        }),
        r && /* @__PURE__ */ T.jsx(lc, {
          testId: `${t}-disabled-indicator`
        })
      ]
    })
  });
}), ac = `
  width: 100%;
  height: 100%;
  overflow: hidden;
`, uc = (e) => {
  if (!e)
    return `
      position: fixed;
  `;
}, cc = (e, t) => {
  const n = t / 100;
  switch (e) {
    case "left-to-right":
      return `
        background-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, ${n}));
      `;
    case "right-to-left":
      return `
        background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, ${n}));
      `;
    case "bottom-to-top":
      return `
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, ${n}));
      `;
    case "top-to-bottom":
      return `
        background-image: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, ${n}));
      `;
    case "default":
      return `
        background-color: rgba(0, 0, 0, ${n});
      `;
  }
}, fc = Y(/* @__PURE__ */ ee.forwardRef(function({ children: t, className: n, testId: r, onClick: i, domProps: o }, s) {
  return /* @__PURE__ */ T.jsx("div", {
    "data-testid": r,
    onClick: i,
    className: n,
    ref: s,
    ...o,
    children: t
  });
}))`
  ${ac}

  ${({ variant: e = "default", percentage: t = 60, disabledFullscreen: n = !1 }) => R`
    ${cc(e, t)}
    ${uc(n)}
  `}

  ${Ve}
`, Y1 = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "overlay", children: n, ...r }, i) {
  return /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsx(fc, {
      testId: t,
      ref: i,
      ...r,
      children: n
    })
  });
}), hc = R`
  ${K1}
  margin: 0;
  opacity: 0;
  cursor: inherit;
  padding: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
`, dc = (e) => e ? R`
      & + ${i1} {
        & > div {
          transform: scale(1);
          transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1) 0ms;
          background-color: ${({ theme: t }) => t.colors.interface};
          opacity: 1;
        }
      }
    ` : R`
      & + ${i1} {
        & > div {
          background-color: ${({ theme: t }) => t.colors.white};
          transform: scale(0);
        }
      }
    `, mc = (e) => {
  const t = R`
    background-color: ${({ theme: n }) => n.colors.disabledGrey};
    border: 1px solid ${({ theme: n }) => n.colors.disabledGrey};
    opacity: 0.5;
  `;
  return e ? R`
      cursor: default;
      & + ${i1} {
        ${t}
        & > div {
          color: ${({ theme: n }) => n.colors.white};
          background-color: ${({ theme: n }) => n.colors.darkGrey};
        }
      }
    ` : R`
      cursor: default;
      & + ${i1} {
        ${t}
        & > div {
          color: ${({ theme: n }) => n.colors.disabledGrey};
        }
      }
    `;
}, gi = R`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 46px;
`, pc = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  ${gi}
  width: 1.5rem;
  height: 1.5rem;
`, Tc = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  ${gi}
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  position: relative;
  &:focus,
  &:focus-within,
  &:focus-visible {
    width: 2rem;
    height: 2rem;
    border-radius: 48px;
    outline: solid 2px ${q1};
  }
`, i1 = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  ${gi}
  width: 100%;
  height: 100%;
  border: 1px solid ${({ theme: e }) => e.colors.interface};
  position: absolute;
`, gc = Y(/* @__PURE__ */ ee.forwardRef(function({ name: t, value: n, checked: r, disabled: i, testId: o, onChange: s, className: l, domProps: c }, u) {
  return /* @__PURE__ */ T.jsx("input", {
    type: "radio",
    name: t,
    checked: r,
    disabled: i,
    "data-testid": o,
    className: l,
    value: n,
    onChange: () => s ? s(n) : void 0,
    ref: u,
    ...c
  });
}))`
  ${hc}

  ${({ checked: e, disabled: t = !1 }) => t ? R`
        ${mc(e)}
      ` : R`
      ${dc(e)}
    `}

  ${Ve}
`, ST = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "radio", checked: n, disabled: r, name: i, value: o, onChange: s, domProps: l, ...c }, u) {
  const f = Ut((m) => {
    s && s(m);
  }, [
    s
  ]);
  return /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsxs(Tc, {
      testId: t,
      ...c,
      children: [
        /* @__PURE__ */ T.jsx(gc, {
          name: i,
          value: o,
          checked: n,
          disabled: r,
          testId: `${t}-internal-radio`,
          onChange: f,
          ref: u,
          domProps: l
        }),
        /* @__PURE__ */ T.jsx(i1, {
          children: /* @__PURE__ */ T.jsx(pc, {
            testId: `${t}-indicator`
          })
        })
      ]
    })
  });
}), Ec = `
  ${K1}
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 1;
  position: absolute;
  cursor: inherit;
`, Ac = () => R`
    ${K1};
    position: relative;
    display: inline-block;
    width: 3.25rem;
    height: 2rem;
    border-radius: 16px;
    transition: background-color 0.3s;
    align-self: center;
    object-fit: contain;
    cursor: pointer;

    &:focus-within {
      outline: solid 2px ${({ theme: e }) => e.colors.outlineColor};
      box-shadow: 0 0 2px ${({ theme: e }) => e.colors.interface};
    }
  `, _c = () => R`
    cursor: pointer;
    border-radius: 50%;
    &:before {
      position: absolute;
      content: '';
      width: 1.875rem;
      height: 1.875rem;
      left: 0px;
      bottom: 1px;
      background-color: ${({ theme: e }) => e.colors.white};
      transition: transform 0.3s;
      border-radius: 50%;
    }
  `, yc = () => R`
    cursor: pointer;
    border-radius: 50%;
    position: absolute;
    width: 1.875rem;
    height: 1.875rem;
    left: 0px;
    bottom: 1px;
    background-color: ${({ theme: e }) => e.colors.white};
    transition: transform 0.3s;
    border-radius: 50%;
    size: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    > svg {
      height: 1.2rem;
      width: 1.2rem;
    }
  `, El = (e) => R`
  transform: ${e ? "translateX(1.313rem)" : "none"};
  body:not(.has-keyboard-focus) .ToggleFocusableContainer:focus & {
    ${hu}
  }
`, Cc = (e) => R`
    &:before {
      ${El(e)}
    }
  `, Sc = (e) => R`
    ${El(e)}
  `, xc = (e) => e ? R`
      background-color: ${({ theme: t }) => t.colors.interface};
    ` : R`
      background-color: ${({ theme: t }) => t.colors.lightGrey};
    `, Nc = (e) => e ? R`
      cursor: default;
      background-color: ${({ theme: t }) => Vn(t.colors.interface, 0.5)};
      svg {
        * {
          fill: ${({ theme: t }) => t.colors.disabledGrey};
        }
      }
      ${Qr} {
        &:before {
          background-color: ${({ theme: t }) => t.colors.lightestGrey};
        }
      }
    ` : R`
      cursor: default;
      background-color: ${({ theme: t }) => t.colors.disabledGrey};
      svg {
        * {
          fill: ${({ theme: t }) => t.colors.disabledGrey};
        }
      }
      ${Qr} {
        &:before {
          background-color: ${({ theme: t }) => t.colors.lightestGrey};
        }
      }
    `, bc = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  ${Ac}
  ${({ checked: e, disabled: t = !1 }) => t ? R`
        ${Nc(e)}
      ` : R`
      ${xc(e)}
    `}
`, Oc = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  ${yc}
  ${({ checked: e }) => R`
      ${Sc(e)}
    `}
`, Qr = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  ${fu()}
  ${_c}
  ${({ checked: e }) => R`
      ${Cc(e)}
    `}
`, Ic = Y(/* @__PURE__ */ ee.forwardRef(function({ checked: t, disabled: n, testId: r, className: i, onChange: o, domProps: s }, l) {
  return /* @__PURE__ */ T.jsx("input", {
    type: "checkbox",
    checked: t,
    disabled: n,
    "data-testid": r,
    className: i,
    onChange: o,
    ref: l,
    ...s
  });
}))`
  ${Ec}
  ${Ve}
`, xT = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "switch", checked: n, disabled: r, onChange: i, icon: o, domProps: s, ...l }, c) {
  const u = (f) => f ? /* @__PURE__ */ T.jsx(Oc, {
    checked: n,
    disabled: r,
    testId: `${t}-icon`,
    children: f
  }) : /* @__PURE__ */ T.jsx(Qr, {
    checked: n,
    testId: `${t}-indicator`
  });
  return /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsxs(bc, {
      checked: n,
      disabled: r,
      testId: t,
      ...l,
      children: [
        /* @__PURE__ */ T.jsx(Ic, {
          checked: n,
          disabled: r,
          testId: `${t}-internal-checkbox`,
          onChange: i,
          ref: c,
          domProps: s
        }),
        u(o)
      ]
    })
  });
}), Rc = (e, t) => e && t ? R`
      margin-bottom: 1rem;
    ` : !e && t ? R`
      margin-bottom: 1.5rem;
    ` : R`
      margin-bottom: 0;
    `, kc = (e) => {
  if (e)
    return R`
      transform: rotate(180deg);
    `;
}, wc = Y(j)`
  ${({ $expanded: e, $small: t }) => Rc(t, e)}
  transition: all 0.3s ease-in-out;
  min-height: ${({ $small: e }) => e ? "56px" : "72px"};
  background-color: ${({ theme: e }) => e.colors.white};
`, Lc = Y(j)`
  cursor: pointer;
  min-height: ${({ $small: e }) => e ? "56px" : "72px"};
  background-color: ${({ theme: e }) => e.colors.white};
`, Mc = Y(j)`
  word-break: break-word;
`, Pc = Y(j)`
  transition: all 0.4s ease-in-out;
  ${({ $expanded: e }) => kc(e)}
`, vc = Y(j)`
  transition: all 0.3s ease-in-out;
  margin-top: ${({ $expanded: e }) => e ? "0" : "-100%"};
  visibility: ${({ $expanded: e }) => e ? "visible" : "hidden"};
  max-height: ${({ $expanded: e }) => e ? "100%" : "0"};
`, NT = /* @__PURE__ */ ee.forwardRef(function({ content: t, expanded: n, summary: r, alwaysExpanded: i = !1, hiddenArrow: o = !1, scrollToView: s = !1, onChange: l, size: c = "large", testId: u = "accordion", width: f = "100%", ...m }, E) {
  const h = i || n, x = wt(null);
  return Fe(() => {
    x.current && n && s && window.scrollTo({
      behavior: "smooth",
      top: x.current.offsetTop
    });
  }, [
    n,
    s
  ]), /* @__PURE__ */ T.jsxs(wc, {
    testId: u,
    ariaExpanded: h,
    $expanded: h,
    $small: c === "small",
    ref: E,
    width: f,
    ...m,
    children: [
      /* @__PURE__ */ T.jsxs(Lc, {
        testId: `${u}-summary`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        ref: x,
        onClick: l,
        $expanded: h,
        $small: c === "small",
        children: [
          /* @__PURE__ */ T.jsx(Mc, {
            display: "flex",
            flexGrow: 1,
            testId: `${u}-summary-content`,
            children: r
          }),
          !o && /* @__PURE__ */ T.jsx(Pc, {
            testId: `${u}-summary-icon`,
            display: "flex",
            $expanded: h,
            children: /* @__PURE__ */ T.jsx(Ou, {
              size: 37
            })
          })
        ]
      }),
      /* @__PURE__ */ T.jsx(vc, {
        testId: `${u}-content`,
        $expanded: h,
        children: t
      })
    ]
  });
}), V1 = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "card", noShadow: n = !1, children: r, onClick: i, ...o }, s) {
  return (
    // For now this is just a card container, but the future features of card-like displays should be implemented here
    /* @__PURE__ */ T.jsx(Ge, {
      children: /* @__PURE__ */ T.jsx(Du, {
        ref: s,
        testId: t,
        noShadow: n,
        onClick: i,
        ...o,
        children: r
      })
    })
  );
}), Dc = `
  display: flex;
  justify-content: center;
  align-items: center;

`, Hc = `
  -webkit-transition: visibility 0.3s, opacity 0.3s ease-in-out;
  -moz-transition: visibility 0.3s, opacity 0.3s ease-in-out;
  -ms-transition: visibility 0.3s, opacity 0.3s ease-in-out;
  -o-transition: visibility 0.3s, opacity 0.3s ease-in-out;
   opacity: 1;
   visibility: visible;
`, Fc = Y(({ children: e, className: t, testId: n, onMouseDown: r, visibleOverlay: i }) => i ? /* @__PURE__ */ T.jsx(Y1, {
  className: t,
  testId: n,
  children: /* @__PURE__ */ T.jsx(j, {
    className: t,
    onMouseDown: r,
    children: e
  })
}) : /* @__PURE__ */ T.jsx(j, {
  size: "100%",
  position: "fixed",
  testId: n,
  className: t,
  children: e
}))`
  ${Dc}
  ${({ open: e = !1 }) => e ? R`
        ${Hc}
        ${Ve}
      ` : R`
        -webkit-transition: visibility 0.3s, opacity 0.3s ease-in-out;
        -moz-transition: visibility 0.3s, opacity 0.3s ease-in-out;
        -ms-transition: visibility 0.3s, opacity 0.3s ease-in-out;
        -o-transition: visibility 0.3s, opacity 0.3s ease-in-out;
        opacity: 0;
        visibility: hidden;
      `}
`, Bc = (e) => R`
    padding: ${e ? "" : "1.25rem 0px"};
    border-radius: 10px 10px 0px 0px;
  `, $c = `
  overflow: auto;
  position: relative;
`, Uc = Y(/* @__PURE__ */ ee.forwardRef(function({ ...t }, n) {
  return /* @__PURE__ */ T.jsx(V1, {
    ref: n,
    ...t
  });
}))`
  ${$c}
  user-select: none;
  ${({ visibleOverlay: e, noMargin: t }) => t && !e ? R`
        border-radius: 0px;
      ` : e ? R`
        ${Bc(t)}
      ` : R`
        box-shadow: none;
        padding: 1.25rem;
      `}
`, Gc = () => R`
    position: fixed;
    bottom: 0;
  `, jc = `
  opacity: 1;
  transform: translate(0);

`, zc = (e) => {
  if (!e)
    return `
    max-height: 100%;
    overflow: auto;
  `;
}, Kc = () => R`
    overflow: hidden;
  `, qc = Y(/* @__PURE__ */ ee.forwardRef(function({ children: t, className: n, testId: r, ...i }, o) {
  return /* @__PURE__ */ T.jsx(j, {
    testId: r,
    className: n,
    ref: o,
    ...i,
    children: t
  });
}))`
  ${Gc}

  ${({ open: e = !1, disabledHeightLimit: t }) => {
  if (e)
    return R`
        ${zc(t)}
        ${jc}
      `;
}}

  ${Kc}
`, Yc = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  overflow: auto;

  ${({ hiddenScrollBar: e }) => {
  if (e)
    return R`
        > *:first-child {
          ::-webkit-scrollbar {
            width: 0;
          }
          overflow: -moz-scrollbars-none;
          -ms-overflow-style: none;
        }
      `;
}}
`, Vc = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  width: 52px;
  height: 5px;
  border-radius: 5px;
  cursor: pointer;
`, Wc = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  width: 134px;
  height: 5px;
  object-fit: contain;
  border-radius: 100px;
`, Xc = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "modal", children: n, maxWidth: r, minWidth: i, bodyScrollDisabled: o = !1, open: s, onScroll: l, dragDisabled: c = !1, dragAmount: u = 100, noMargin: f = !1, persistent: m = !1, onClose: E, zIndex: h = 100, hiddenScrollBar: x = !1, containerHeight: y = "100vh", disabledHeightLimit: b = !1, ..._ }, M) {
  const O = wt(null), P = !0;
  Fe(() => {
    o && (s ? document.body.style.overflow = "hidden" : document.body.style.overflow = "visible");
  }, [
    o,
    s
  ]);
  const N = (Q) => {
    if (m)
      return;
    const te = Q.target;
    s && O.current && te instanceof Node && !O.current.contains(te) && E(Q);
  }, [C, I] = Ke(0), [D, z] = Ke(!1), [ie, v] = Ke(0);
  Fe(() => {
    s && I(0);
  }, [
    s
  ]);
  const U = Rt(() => {
    const Q = (Ae) => {
      v(Tr(Ae)), Ae.persist(), z(!0);
    }, te = (Ae) => {
      if (!D)
        return;
      Ae.persist();
      const ke = Tr(Ae) - ie, d = ke * -1;
      if (D && ke > u) {
        E(Ae), z(!1);
        return;
      }
      ke > 0 && I(d);
    }, pe = (Ae) => {
      if (Ae.persist(), !D)
        return;
      const ke = Tr(Ae) - ie;
      if (ke > 0 && ke < u) {
        I(0);
        return;
      }
      z(!1);
    }, ye = c ? {} : {
      onMouseDown: Q,
      onTouchStart: Q
    };
    return /* @__PURE__ */ T.jsxs(Uc, {
      ref: M,
      testId: `${t}-card`,
      visibleOverlay: P,
      noMargin: f,
      domProps: c ? void 0 : {
        onMouseMove: te,
        onTouchMove: te,
        onMouseUp: pe,
        onTouchCancel: pe,
        onTouchEnd: pe
      },
      ..._,
      marginBottom: c ? void 0 : C,
      children: [
        !m && !c && /* @__PURE__ */ T.jsx(j, {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "1.25rem",
          children: /* @__PURE__ */ T.jsx(Vc, {
            ...ye,
            backgroundColor: du
          })
        }),
        /* @__PURE__ */ T.jsx(Yc, {
          testId: `${t}-card-content`,
          noMargin: f,
          onScroll: l,
          hiddenScrollBar: x,
          children: n
        }),
        !c && /* @__PURE__ */ T.jsx(j, {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1.25rem",
          children: /* @__PURE__ */ T.jsx(Wc, {
            backgroundColor: Tl
          })
        })
      ]
    });
  }, [
    c,
    M,
    t,
    P,
    f,
    _,
    C,
    l,
    n,
    D,
    ie,
    u,
    x,
    m,
    E
  ]), L = Rt(() => U, [
    U
  ]);
  return /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsx(Fc, {
      height: y,
      width: "100vw",
      top: "0",
      left: "0",
      zIndex: h,
      visibleOverlay: P,
      onMouseDown: N,
      open: s,
      testId: t,
      children: /* @__PURE__ */ T.jsx(qc, {
        open: s,
        ref: O,
        disabledHeightLimit: b,
        maxWidth: r,
        minWidth: i,
        children: L
      })
    })
  });
}), bT = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "column", itemHeight: n, children: r, ...i }, o) {
  return /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsx(j, {
      testId: t,
      ref: o,
      ...i,
      children: /* @__PURE__ */ T.jsx(qu, {
        value: {
          height: n
        },
        children: r
      })
    })
  });
}), Qc = () => R`
    @keyframes shrinkThenGrow {
      0% {
        transform: scaleX(1);
        background-color: ${({ theme: e }) => e.colors.interface};
      }
      50% {
        transform: scaleX(0);
      }
      100% {
        transform: scaleX(1);
        background-color: ${({ theme: e }) => e.colors.errorRed};
      }
    }
    animation: shrinkThenGrow 0.6s;
  `, Jc = R`
  @keyframes shake {
    0% {
      transform: translate(4px, 0px) rotate(0deg);
    }
    50% {
      transform: translate(-8px, 0px) rotate(0deg);
    }
    100% {
      transform: translate(4px, 0px) rotate(0deg);
    }
  }
  animation: shake 0.15s;
`, Al = R`
  transition: 0.3s ease all;
  font-size: 0.625rem;
  top: 0.5rem;
`, Zc = R`
  position: absolute;
  pointer-events: none;
  left: 0.75rem;
  top: 1.475rem;
  color: ${({ theme: e }) => e.colors.black};
`, e0 = `
  padding: 0.20rem 0.75rem;
  transform: translateY(-5px);
  transition: 0.3s ease all;
  transform: translateY(0px);
`, t0 = `
  height: 0.125rem;
  width: 100%;
  position: absolute;
  margin-top: 4rem;
`, Yi = (e) => e ? R`
      ${({ theme: t }) => t.colors.errorRed}
    ` : R`
      ${({ theme: t }) => t.colors.interface}
    `, n0 = (e) => R`
    &:focus:not([disabled]) ~ ${_l} {
      transform: scaleX(1);
      background-color: ${Yi(e)};
    }
    &:focus:not([disabled]) ~ ${W1} {
      ${Al};
      color: ${Yi(e)};
    }
  `, r0 = (e) => {
  if (e)
    return R`
      ~ ${W1} {
        ${Al}
      }
    `;
}, i0 = (e, t, n) => e ? R`
      color: ${({ theme: r }) => r.colors.errorRed};
    ` : t ? R`
      color: ${({ theme: r }) => r.colors.grey};
    ` : n ? R`
      color: ${({ theme: r }) => r.colors.interface};
    ` : R`
      color: ${({ theme: r }) => r.colors.darkGrey};
    `, W1 = Y(({ children: e, id: t, testId: n, className: r }) => /* @__PURE__ */ T.jsx("label", {
  htmlFor: t,
  "data-testid": n,
  className: r,
  children: e
}))`
  ${Zc}
  ${mi}
  ${({ error: e = !1, disabled: t = !1 }) => {
  if (e && !t)
    return R`
        ${Jc}
        color: ${({ theme: n }) => n.colors.errorRed};
      `;
}}
`, o0 = R`
  ${mi}
  width: 100%;
  min-height: 4rem;
  padding: 1rem 0.5rem 0.5rem 0.7rem;
  background: ${({ theme: e }) => e.colors.lightestGrey};
  color: ${({ theme: e }) => e.colors.black};
  caret-color: ${({ theme: e }) => e.colors.interface};
  background: transparent;
  border: none;
  outline: none;

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1.125rem ${({ theme: e }) => e.colors.lightestGrey} inset;
  }

  &[disabled] ~ ${W1} {
    color: ${({ theme: e }) => e.colors.grey};
  }

  &[disabled] {
    color: ${({ theme: e }) => e.colors.grey};
  }
`, s0 = Y(/* @__PURE__ */ ee.forwardRef(function({ value: t, type: n, disabled: r, autoFocus: i, onChange: o, onBlur: s, onFocus: l, onKeyDown: c, className: u, testId: f, required: m, id: E, hint: h, error: x, name: y, maxLength: b, domProps: _ }, M) {
  return /* @__PURE__ */ T.jsx("input", {
    type: n,
    value: t,
    disabled: r,
    onChange: o,
    onBlur: s,
    onFocus: l,
    onKeyDown: c,
    className: u,
    "data-testid": f,
    autoFocus: i,
    "aria-required": m,
    "aria-describedby": h ? `${E}-hint` : void 0,
    "aria-live": x ? "polite" : "off",
    id: E,
    name: y,
    ref: M,
    maxLength: b,
    ..._
  });
}))`
  ${o0}

  ${({ error: e = !1, value: t = "" }) => R`
      ${r0(t)}
      ${n0(e)}
    `}

${Ve}
`, _l = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  ${t0}
  ${({ error: e = !1, disabled: t = !1 }) => e && !t ? R`
        ${Qc()}
        background-color: ${({ theme: n }) => n.colors.errorRed};
      ` : R`
        transition: transform 0.3s ease, background-color 0.3s ease;
        transform: scaleX(0);
      `}
`, Vi = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  cursor: pointer;
`, l0 = Y(({ id: e, ...t }) => /* @__PURE__ */ T.jsx(ut, {
  id: `${e}-hint`,
  variant: "small",
  ...t
}))`
  ${e0}
  ${({ error: e = !1, disabled: t = !1, required: n = !1 }) => R`
      ${i0(e, t, n)};
    `}
`, OT = /* @__PURE__ */ ee.forwardRef(function({ id: t, maxLength: n, type: r = "text", testId: i = "input", disabled: o = !1, error: s = !1, label: l = "", onChange: c, onBlur: u, onFocus: f, onKeyDown: m, autoFocus: E = !1, hint: h = "", value: x = "", required: y = !1, visiblePassword: b = !1, name: _, domProps: M, ...O }, P) {
  const N = (Q) => {
    Q.persist(), u && u(Q);
  }, C = (Q) => {
    Q.persist(), f && f(Q);
  }, I = (Q) => {
    Q.persist(), c && c(Q);
  }, D = (Q) => {
    Q.persist(), m && m(Q);
  }, [z, ie] = Ke(!b), v = Ut(() => z ? /* @__PURE__ */ T.jsxs(Vi, {
    children: [
      /* @__PURE__ */ T.jsx(Iu, {
        size: 24
      }, "icon"),
      " "
    ]
  }) : /* @__PURE__ */ T.jsx(Vi, {
    children: /* @__PURE__ */ T.jsx(Ru, {
      size: 24
    }, "icon")
  }), [
    z
  ]), U = Ut((Q) => Q == "text" ? "text" : z ? "password" : "text", [
    z
  ]), L = Ut((Q) => {
    const te = () => {
      ie(!z);
    };
    if (o)
      return /* @__PURE__ */ T.jsx(ku, {
        color: Tl,
        size: 24
      });
    if (s && Q === "password")
      return /* @__PURE__ */ T.jsxs(j, {
        display: "flex",
        justifyContent: "space-between",
        width: "3.5rem",
        children: [
          /* @__PURE__ */ T.jsx(j, {
            onClick: te,
            children: v()
          }),
          /* @__PURE__ */ T.jsx(ji, {
            color: Gi,
            size: 24
          })
        ]
      });
    if (s)
      return /* @__PURE__ */ T.jsx(ji, {
        color: Gi,
        size: 24
      });
    if (Q === "password")
      return /* @__PURE__ */ T.jsx(j, {
        display: "flex",
        onClick: te,
        children: v()
      });
  }, [
    o,
    s,
    z,
    v
  ]);
  return /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsxs(tc, {
      position: "relative",
      margin: "0.5rem 0 1.5rem",
      testId: i,
      ...O,
      children: [
        /* @__PURE__ */ T.jsxs(j, {
          display: "flex",
          children: [
            /* @__PURE__ */ T.jsx(s0, {
              id: t,
              type: U(r),
              testId: `${i}-internal-input`,
              disabled: o,
              value: x,
              error: s,
              autoFocus: E,
              onChange: I,
              onBlur: N,
              onFocus: C,
              onKeyDown: D,
              required: y,
              hint: h,
              ref: P,
              name: _,
              maxLength: n,
              domProps: M
            }),
            /* @__PURE__ */ T.jsx(W1, {
              id: t,
              testId: `${i}-label`,
              disabled: o,
              error: s,
              children: l
            }),
            /* @__PURE__ */ T.jsx(j, {
              testId: `${i}-icon-container`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "1rem",
              children: L(r)
            }),
            /* @__PURE__ */ T.jsx(_l, {
              testId: `${i}-underline`,
              disabled: o,
              error: s
            })
          ]
        }),
        h && /* @__PURE__ */ T.jsx(l0, {
          id: t,
          testId: `${i}-hint`,
          disabled: o,
          error: s,
          required: y,
          children: h
        })
      ]
    })
  });
}), Wi = ["http", "https", "mailto", "tel"];
function a0(e) {
  const t = (e || "").trim(), n = t.charAt(0);
  if (n === "#" || n === "/")
    return t;
  const r = t.indexOf(":");
  if (r === -1)
    return t;
  let i = -1;
  for (; ++i < Wi.length; ) {
    const o = Wi[i];
    if (r === o.length && t.slice(0, o.length).toLowerCase() === o)
      return t;
  }
  return i = t.indexOf("?"), i !== -1 && r > i || (i = t.indexOf("#"), i !== -1 && r > i) ? t : "javascript:void(0)";
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var u0 = function(t) {
  return t != null && t.constructor != null && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
};
const yl = /* @__PURE__ */ fn(u0);
function Wn(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Xi(e.position) : "start" in e || "end" in e ? Xi(e) : "line" in e || "column" in e ? Jr(e) : "";
}
function Jr(e) {
  return Qi(e && e.line) + ":" + Qi(e && e.column);
}
function Xi(e) {
  return Jr(e && e.start) + "-" + Jr(e && e.end);
}
function Qi(e) {
  return e && typeof e == "number" ? e : 1;
}
class dt extends Error {
  /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // To do: next major: expose `undefined` everywhere instead of `null`.
  constructor(t, n, r) {
    const i = [null, null];
    let o = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: { line: null, column: null },
      // @ts-expect-error: "
      end: { line: null, column: null }
    };
    if (super(), typeof n == "string" && (r = n, n = void 0), typeof r == "string") {
      const s = r.indexOf(":");
      s === -1 ? i[1] = r : (i[0] = r.slice(0, s), i[1] = r.slice(s + 1));
    }
    n && ("type" in n || "position" in n ? n.position && (o = n.position) : "start" in n || "end" in n ? o = n : ("line" in n || "column" in n) && (o.start = n)), this.name = Wn(n) || "1:1", this.message = typeof t == "object" ? t.message : t, this.stack = "", typeof t == "object" && t.stack && (this.stack = t.stack), this.reason = this.message, this.fatal, this.line = o.start.line, this.column = o.start.column, this.position = o, this.source = i[0], this.ruleId = i[1], this.file, this.actual, this.expected, this.url, this.note;
  }
}
dt.prototype.file = "";
dt.prototype.name = "";
dt.prototype.reason = "";
dt.prototype.message = "";
dt.prototype.stack = "";
dt.prototype.fatal = null;
dt.prototype.column = null;
dt.prototype.line = null;
dt.prototype.source = null;
dt.prototype.ruleId = null;
dt.prototype.position = null;
const bt = { basename: c0, dirname: f0, extname: h0, join: d0, sep: "/" };
function c0(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  l1(e);
  let n = 0, r = -1, i = e.length, o;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.charCodeAt(i) === 47) {
        if (o) {
          n = i + 1;
          break;
        }
      } else
        r < 0 && (o = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let s = -1, l = t.length - 1;
  for (; i--; )
    if (e.charCodeAt(i) === 47) {
      if (o) {
        n = i + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = i + 1), l > -1 && (e.charCodeAt(i) === t.charCodeAt(l--) ? l < 0 && (r = i) : (l = -1, r = s));
  return n === r ? r = s : r < 0 && (r = e.length), e.slice(n, r);
}
function f0(e) {
  if (l1(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.charCodeAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else
      r || (r = !0);
  return t < 0 ? e.charCodeAt(0) === 47 ? "/" : "." : t === 1 && e.charCodeAt(0) === 47 ? "//" : e.slice(0, t);
}
function h0(e) {
  l1(e);
  let t = e.length, n = -1, r = 0, i = -1, o = 0, s;
  for (; t--; ) {
    const l = e.charCodeAt(t);
    if (l === 47) {
      if (s) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (s = !0, n = t + 1), l === 46 ? i < 0 ? i = t : o !== 1 && (o = 1) : i > -1 && (o = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function d0(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    l1(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : m0(n);
}
function m0(e) {
  l1(e);
  const t = e.charCodeAt(0) === 47;
  let n = p0(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.charCodeAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function p0(e, t) {
  let n = "", r = 0, i = -1, o = 0, s = -1, l, c;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.charCodeAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(i === s - 1 || o === 1))
        if (i !== s - 1 && o === 2) {
          if (n.length < 2 || r !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              if (c = n.lastIndexOf("/"), c !== n.length - 1) {
                c < 0 ? (n = "", r = 0) : (n = n.slice(0, c), r = n.length - 1 - n.lastIndexOf("/")), i = s, o = 0;
                continue;
              }
            } else if (n.length > 0) {
              n = "", r = 0, i = s, o = 0;
              continue;
            }
          }
          t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
        } else
          n.length > 0 ? n += "/" + e.slice(i + 1, s) : n = e.slice(i + 1, s), r = s - i - 1;
      i = s, o = 0;
    } else
      l === 46 && o > -1 ? o++ : o = -1;
  }
  return n;
}
function l1(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const T0 = { cwd: g0 };
function g0() {
  return "/";
}
function Zr(e) {
  return e !== null && typeof e == "object" && // @ts-expect-error: indexable.
  e.href && // @ts-expect-error: indexable.
  e.origin;
}
function E0(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Zr(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return A0(e);
}
function A0(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.charCodeAt(n) === 37 && t.charCodeAt(n + 1) === 50) {
      const r = t.charCodeAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const gr = ["history", "path", "basename", "stem", "extname", "dirname"];
class Cl {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? typeof t == "string" || _0(t) ? n = { value: t } : Zr(t) ? n = { path: t } : n = t : n = {}, this.data = {}, this.messages = [], this.history = [], this.cwd = T0.cwd(), this.value, this.stored, this.result, this.map;
    let r = -1;
    for (; ++r < gr.length; ) {
      const o = gr[r];
      o in n && n[o] !== void 0 && n[o] !== null && (this[o] = o === "history" ? [...n[o]] : n[o]);
    }
    let i;
    for (i in n)
      gr.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */
  set path(t) {
    Zr(t) && (t = E0(t)), Ar(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path == "string" ? bt.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(t) {
    Ji(this.basename, "dirname"), this.path = bt.join(t || "", this.basename);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path == "string" ? bt.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(t) {
    Ar(t, "basename"), Er(t, "basename"), this.path = bt.join(this.dirname || "", t);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path == "string" ? bt.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(t) {
    if (Er(t, "extname"), Ji(this.dirname, "extname"), t) {
      if (t.charCodeAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = bt.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path == "string" ? bt.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(t) {
    Ar(t, "stem"), Er(t, "stem"), this.path = bt.join(this.dirname || "", t + (this.extname || ""));
  }
  /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return (this.value || "").toString(t || void 0);
  }
  /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new dt(t, n, r);
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = null, i;
  }
  /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
}
function Er(e, t) {
  if (e && e.includes(bt.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + bt.sep + "`"
    );
}
function Ar(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Ji(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function _0(e) {
  return yl(e);
}
function Zi(e) {
  if (e)
    throw e;
}
var L1 = Object.prototype.hasOwnProperty, Sl = Object.prototype.toString, eo = Object.defineProperty, to = Object.getOwnPropertyDescriptor, no = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : Sl.call(t) === "[object Array]";
}, ro = function(t) {
  if (!t || Sl.call(t) !== "[object Object]")
    return !1;
  var n = L1.call(t, "constructor"), r = t.constructor && t.constructor.prototype && L1.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var i;
  for (i in t)
    ;
  return typeof i > "u" || L1.call(t, i);
}, io = function(t, n) {
  eo && n.name === "__proto__" ? eo(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, oo = function(t, n) {
  if (n === "__proto__")
    if (L1.call(t, n)) {
      if (to)
        return to(t, n).value;
    } else
      return;
  return t[n];
}, y0 = function e() {
  var t, n, r, i, o, s, l = arguments[0], c = 1, u = arguments.length, f = !1;
  for (typeof l == "boolean" && (f = l, l = arguments[1] || {}, c = 2), (l == null || typeof l != "object" && typeof l != "function") && (l = {}); c < u; ++c)
    if (t = arguments[c], t != null)
      for (n in t)
        r = oo(l, n), i = oo(t, n), l !== i && (f && i && (ro(i) || (o = no(i))) ? (o ? (o = !1, s = r && no(r) ? r : []) : s = r && ro(r) ? r : {}, io(l, { name: n, newValue: e(f, s, i) })) : typeof i < "u" && io(l, { name: n, newValue: i }));
  return l;
};
const so = /* @__PURE__ */ fn(y0);
function ei(e) {
  if (Object.prototype.toString.call(e) !== "[object Object]")
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function C0() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let o = -1;
    const s = i.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...i);
    function l(c, ...u) {
      const f = e[++o];
      let m = -1;
      if (c) {
        s(c);
        return;
      }
      for (; ++m < i.length; )
        (u[m] === null || u[m] === void 0) && (u[m] = i[m]);
      i = u, f ? S0(f, l)(...u) : s(null, ...u);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function S0(e, t) {
  let n;
  return r;
  function r(...s) {
    const l = e.length > s.length;
    let c;
    l && s.push(i);
    try {
      c = e(...s);
    } catch (u) {
      const f = u;
      if (l && n)
        throw f;
      return i(f);
    }
    l || (c instanceof Promise ? c.then(o, i) : c instanceof Error ? i(c) : o(c));
  }
  function i(s, ...l) {
    n || (n = !0, t(s, ...l));
  }
  function o(s) {
    i(null, s);
  }
}
const x0 = Nl().freeze(), xl = {}.hasOwnProperty;
function Nl() {
  const e = C0(), t = [];
  let n = {}, r, i = -1;
  return o.data = s, o.Parser = void 0, o.Compiler = void 0, o.freeze = l, o.attachers = t, o.use = c, o.parse = u, o.stringify = f, o.run = m, o.runSync = E, o.process = h, o.processSync = x, o;
  function o() {
    const y = Nl();
    let b = -1;
    for (; ++b < t.length; )
      y.use(...t[b]);
    return y.data(so(!0, {}, n)), y;
  }
  function s(y, b) {
    return typeof y == "string" ? arguments.length === 2 ? (Cr("data", r), n[y] = b, o) : xl.call(n, y) && n[y] || null : y ? (Cr("data", r), n = y, o) : n;
  }
  function l() {
    if (r)
      return o;
    for (; ++i < t.length; ) {
      const [y, ...b] = t[i];
      if (b[0] === !1)
        continue;
      b[0] === !0 && (b[0] = void 0);
      const _ = y.call(o, ...b);
      typeof _ == "function" && e.use(_);
    }
    return r = !0, i = Number.POSITIVE_INFINITY, o;
  }
  function c(y, ...b) {
    let _;
    if (Cr("use", r), y != null)
      if (typeof y == "function")
        N(y, ...b);
      else if (typeof y == "object")
        Array.isArray(y) ? P(y) : O(y);
      else
        throw new TypeError("Expected usable value, not `" + y + "`");
    return _ && (n.settings = Object.assign(n.settings || {}, _)), o;
    function M(C) {
      if (typeof C == "function")
        N(C);
      else if (typeof C == "object")
        if (Array.isArray(C)) {
          const [I, ...D] = C;
          N(I, ...D);
        } else
          O(C);
      else
        throw new TypeError("Expected usable value, not `" + C + "`");
    }
    function O(C) {
      P(C.plugins), C.settings && (_ = Object.assign(_ || {}, C.settings));
    }
    function P(C) {
      let I = -1;
      if (C != null)
        if (Array.isArray(C))
          for (; ++I < C.length; ) {
            const D = C[I];
            M(D);
          }
        else
          throw new TypeError("Expected a list of plugins, not `" + C + "`");
    }
    function N(C, I) {
      let D = -1, z;
      for (; ++D < t.length; )
        if (t[D][0] === C) {
          z = t[D];
          break;
        }
      z ? (ei(z[1]) && ei(I) && (I = so(!0, z[1], I)), z[1] = I) : t.push([...arguments]);
    }
  }
  function u(y) {
    o.freeze();
    const b = Bn(y), _ = o.Parser;
    return _r("parse", _), lo(_, "parse") ? new _(String(b), b).parse() : _(String(b), b);
  }
  function f(y, b) {
    o.freeze();
    const _ = Bn(b), M = o.Compiler;
    return yr("stringify", M), ao(y), lo(M, "compile") ? new M(y, _).compile() : M(y, _);
  }
  function m(y, b, _) {
    if (ao(y), o.freeze(), !_ && typeof b == "function" && (_ = b, b = void 0), !_)
      return new Promise(M);
    M(null, _);
    function M(O, P) {
      e.run(y, Bn(b), N);
      function N(C, I, D) {
        I = I || y, C ? P(C) : O ? O(I) : _(null, I, D);
      }
    }
  }
  function E(y, b) {
    let _, M;
    return o.run(y, b, O), uo("runSync", "run", M), _;
    function O(P, N) {
      Zi(P), _ = N, M = !0;
    }
  }
  function h(y, b) {
    if (o.freeze(), _r("process", o.Parser), yr("process", o.Compiler), !b)
      return new Promise(_);
    _(null, b);
    function _(M, O) {
      const P = Bn(y);
      o.run(o.parse(P), P, (C, I, D) => {
        if (C || !I || !D)
          N(C);
        else {
          const z = o.stringify(I, D);
          z == null || (O0(z) ? D.value = z : D.result = z), N(C, D);
        }
      });
      function N(C, I) {
        C || !I ? O(C) : M ? M(I) : b(null, I);
      }
    }
  }
  function x(y) {
    let b;
    o.freeze(), _r("processSync", o.Parser), yr("processSync", o.Compiler);
    const _ = Bn(y);
    return o.process(_, M), uo("processSync", "process", b), _;
    function M(O) {
      b = !0, Zi(O);
    }
  }
}
function lo(e, t) {
  return typeof e == "function" && // Prototypes do exist.
  // type-coverage:ignore-next-line
  e.prototype && // A function with keys in its prototype is probably a constructor.
  // Classes’ prototype methods are not enumerable, so we check if some value
  // exists in the prototype.
  // type-coverage:ignore-next-line
  (N0(e.prototype) || t in e.prototype);
}
function N0(e) {
  let t;
  for (t in e)
    if (xl.call(e, t))
      return !0;
  return !1;
}
function _r(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Parser`");
}
function yr(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Compiler`");
}
function Cr(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function ao(e) {
  if (!ei(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function uo(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Bn(e) {
  return b0(e) ? e : new Cl(e);
}
function b0(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function O0(e) {
  return typeof e == "string" || yl(e);
}
const I0 = {};
function R0(e, t) {
  const n = t || I0, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return bl(e, r, i);
}
function bl(e, t, n) {
  if (k0(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return co(e.children, t, n);
  }
  return Array.isArray(e) ? co(e, t, n) : "";
}
function co(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = bl(e[i], t, n);
  return r.join("");
}
function k0(e) {
  return !!(e && typeof e == "object");
}
function Lt(e, t, n, r) {
  const i = e.length;
  let o = 0, s;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    s = Array.from(r), s.unshift(t, n), e.splice(...s);
  else
    for (n && e.splice(t, n); o < r.length; )
      s = r.slice(o, o + 1e4), s.unshift(t, 0), e.splice(...s), o += 1e4, t += 1e4;
}
function ft(e, t) {
  return e.length > 0 ? (Lt(e, e.length, 0, t), e) : t;
}
const fo = {}.hasOwnProperty;
function w0(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    L0(t, e[n]);
  return t;
}
function L0(e, t) {
  let n;
  for (n in t) {
    const i = (fo.call(e, n) ? e[n] : void 0) || (e[n] = {}), o = t[n];
    let s;
    if (o)
      for (s in o) {
        fo.call(i, s) || (i[s] = []);
        const l = o[s];
        M0(
          // @ts-expect-error Looks like a list.
          i[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function M0(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Lt(e, 0, 0, r);
}
const P0 = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, Ot = tn(/[A-Za-z]/), Ct = tn(/[\dA-Za-z]/), v0 = tn(/[#-'*+\--9=?A-Z^-~]/);
function ti(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const ni = tn(/\d/), D0 = tn(/[\dA-Fa-f]/), H0 = tn(/[!-/:-@[-`{-~]/);
function ae(e) {
  return e !== null && e < -2;
}
function nt(e) {
  return e !== null && (e < 0 || e === 32);
}
function Se(e) {
  return e === -2 || e === -1 || e === 32;
}
const F0 = tn(P0), B0 = tn(/\s/);
function tn(e) {
  return t;
  function t(n) {
    return n !== null && e.test(String.fromCharCode(n));
  }
}
function we(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(c) {
    return Se(c) ? (e.enter(n), l(c)) : t(c);
  }
  function l(c) {
    return Se(c) && o++ < i ? (e.consume(c), l) : (e.exit(n), t(c));
  }
}
const $0 = {
  tokenize: U0
};
function U0(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  );
  let n;
  return t;
  function r(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), we(e, t, "linePrefix");
  }
  function i(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const c = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = c), n = c, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return ae(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const G0 = {
  tokenize: j0
}, ho = {
  tokenize: z0
};
function j0(e) {
  const t = this, n = [];
  let r = 0, i, o, s;
  return l;
  function l(O) {
    if (r < n.length) {
      const P = n[r];
      return t.containerState = P[1], e.attempt(
        P[0].continuation,
        c,
        u
      )(O);
    }
    return u(O);
  }
  function c(O) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && M();
      const P = t.events.length;
      let N = P, C;
      for (; N--; )
        if (t.events[N][0] === "exit" && t.events[N][1].type === "chunkFlow") {
          C = t.events[N][1].end;
          break;
        }
      _(r);
      let I = P;
      for (; I < t.events.length; )
        t.events[I][1].end = Object.assign({}, C), I++;
      return Lt(
        t.events,
        N + 1,
        0,
        t.events.slice(P)
      ), t.events.length = I, u(O);
    }
    return l(O);
  }
  function u(O) {
    if (r === n.length) {
      if (!i)
        return E(O);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return x(O);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(
      ho,
      f,
      m
    )(O);
  }
  function f(O) {
    return i && M(), _(r), E(O);
  }
  function m(O) {
    return t.parser.lazy[t.now().line] = r !== n.length, s = t.now().offset, x(O);
  }
  function E(O) {
    return t.containerState = {}, e.attempt(
      ho,
      h,
      x
    )(O);
  }
  function h(O) {
    return r++, n.push([t.currentConstruct, t.containerState]), E(O);
  }
  function x(O) {
    if (O === null) {
      i && M(), _(0), e.consume(O);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: o,
      _tokenizer: i
    }), y(O);
  }
  function y(O) {
    if (O === null) {
      b(e.exit("chunkFlow"), !0), _(0), e.consume(O);
      return;
    }
    return ae(O) ? (e.consume(O), b(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, l) : (e.consume(O), y);
  }
  function b(O, P) {
    const N = t.sliceStream(O);
    if (P && N.push(null), O.previous = o, o && (o.next = O), o = O, i.defineSkip(O.start), i.write(N), t.parser.lazy[O.start.line]) {
      let C = i.events.length;
      for (; C--; )
        if (
          // The token starts before the line ending…
          i.events[C][1].start.offset < s && // …and either is not ended yet…
          (!i.events[C][1].end || // …or ends after it.
          i.events[C][1].end.offset > s)
        )
          return;
      const I = t.events.length;
      let D = I, z, ie;
      for (; D--; )
        if (t.events[D][0] === "exit" && t.events[D][1].type === "chunkFlow") {
          if (z) {
            ie = t.events[D][1].end;
            break;
          }
          z = !0;
        }
      for (_(r), C = I; C < t.events.length; )
        t.events[C][1].end = Object.assign({}, ie), C++;
      Lt(
        t.events,
        D + 1,
        0,
        t.events.slice(I)
      ), t.events.length = C;
    }
  }
  function _(O) {
    let P = n.length;
    for (; P-- > O; ) {
      const N = n[P];
      t.containerState = N[1], N[0].exit.call(t, e);
    }
    n.length = O;
  }
  function M() {
    i.write([null]), o = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function z0(e, t, n) {
  return we(
    e,
    e.attempt(this.parser.constructs.document, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function mo(e) {
  if (e === null || nt(e) || B0(e))
    return 1;
  if (F0(e))
    return 2;
}
function Ei(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const o = e[i].resolveAll;
    o && !r.includes(o) && (t = o(t, n), r.push(o));
  }
  return t;
}
const ri = {
  name: "attention",
  tokenize: q0,
  resolveAll: K0
};
function K0(e, t) {
  let n = -1, r, i, o, s, l, c, u, f;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          c = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const m = Object.assign({}, e[r][1].end), E = Object.assign({}, e[n][1].start);
          po(m, -c), po(E, c), s = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: m,
            end: Object.assign({}, e[r][1].end)
          }, l = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[n][1].start),
            end: E
          }, o = {
            type: c > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[n][1].start)
          }, i = {
            type: c > 1 ? "strong" : "emphasis",
            start: Object.assign({}, s.start),
            end: Object.assign({}, l.end)
          }, e[r][1].end = Object.assign({}, s.start), e[n][1].start = Object.assign({}, l.end), u = [], e[r][1].end.offset - e[r][1].start.offset && (u = ft(u, [
            ["enter", e[r][1], t],
            ["exit", e[r][1], t]
          ])), u = ft(u, [
            ["enter", i, t],
            ["enter", s, t],
            ["exit", s, t],
            ["enter", o, t]
          ]), u = ft(
            u,
            Ei(
              t.parser.constructs.insideSpan.null,
              e.slice(r + 1, n),
              t
            )
          ), u = ft(u, [
            ["exit", o, t],
            ["enter", l, t],
            ["exit", l, t],
            ["exit", i, t]
          ]), e[n][1].end.offset - e[n][1].start.offset ? (f = 2, u = ft(u, [
            ["enter", e[n][1], t],
            ["exit", e[n][1], t]
          ])) : f = 0, Lt(e, r - 1, n - r + 3, u), n = r + u.length - f - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function q0(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = mo(r);
  let o;
  return s;
  function s(c) {
    return o = c, e.enter("attentionSequence"), l(c);
  }
  function l(c) {
    if (c === o)
      return e.consume(c), l;
    const u = e.exit("attentionSequence"), f = mo(c), m = !f || f === 2 && i || n.includes(c), E = !i || i === 2 && f || n.includes(r);
    return u._open = !!(o === 42 ? m : m && (i || !E)), u._close = !!(o === 42 ? E : E && (f || !m)), t(c);
  }
}
function po(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const Y0 = {
  name: "autolink",
  tokenize: V0
};
function V0(e, t, n) {
  let r = 0;
  return i;
  function i(h) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(h) {
    return Ot(h) ? (e.consume(h), s) : u(h);
  }
  function s(h) {
    return h === 43 || h === 45 || h === 46 || Ct(h) ? (r = 1, l(h)) : u(h);
  }
  function l(h) {
    return h === 58 ? (e.consume(h), r = 0, c) : (h === 43 || h === 45 || h === 46 || Ct(h)) && r++ < 32 ? (e.consume(h), l) : (r = 0, u(h));
  }
  function c(h) {
    return h === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : h === null || h === 32 || h === 60 || ti(h) ? n(h) : (e.consume(h), c);
  }
  function u(h) {
    return h === 64 ? (e.consume(h), f) : v0(h) ? (e.consume(h), u) : n(h);
  }
  function f(h) {
    return Ct(h) ? m(h) : n(h);
  }
  function m(h) {
    return h === 46 ? (e.consume(h), r = 0, f) : h === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : E(h);
  }
  function E(h) {
    if ((h === 45 || Ct(h)) && r++ < 63) {
      const x = h === 45 ? E : m;
      return e.consume(h), x;
    }
    return n(h);
  }
}
const X1 = {
  tokenize: W0,
  partial: !0
};
function W0(e, t, n) {
  return r;
  function r(o) {
    return Se(o) ? we(e, i, "linePrefix")(o) : i(o);
  }
  function i(o) {
    return o === null || ae(o) ? t(o) : n(o);
  }
}
const Ol = {
  name: "blockQuote",
  tokenize: X0,
  continuation: {
    tokenize: Q0
  },
  exit: J0
};
function X0(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    if (s === 62) {
      const l = r.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return n(s);
  }
  function o(s) {
    return Se(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(s));
  }
}
function Q0(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return Se(s) ? we(
      e,
      o,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(s) : o(s);
  }
  function o(s) {
    return e.attempt(Ol, t, n)(s);
  }
}
function J0(e) {
  e.exit("blockQuote");
}
const Il = {
  name: "characterEscape",
  tokenize: Z0
};
function Z0(e, t, n) {
  return r;
  function r(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), i;
  }
  function i(o) {
    return H0(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(o);
  }
}
const To = {
  AEli: "Æ",
  AElig: "Æ",
  AM: "&",
  AMP: "&",
  Aacut: "Á",
  Aacute: "Á",
  Abreve: "Ă",
  Acir: "Â",
  Acirc: "Â",
  Acy: "А",
  Afr: "𝔄",
  Agrav: "À",
  Agrave: "À",
  Alpha: "Α",
  Amacr: "Ā",
  And: "⩓",
  Aogon: "Ą",
  Aopf: "𝔸",
  ApplyFunction: "⁡",
  Arin: "Å",
  Aring: "Å",
  Ascr: "𝒜",
  Assign: "≔",
  Atild: "Ã",
  Atilde: "Ã",
  Aum: "Ä",
  Auml: "Ä",
  Backslash: "∖",
  Barv: "⫧",
  Barwed: "⌆",
  Bcy: "Б",
  Because: "∵",
  Bernoullis: "ℬ",
  Beta: "Β",
  Bfr: "𝔅",
  Bopf: "𝔹",
  Breve: "˘",
  Bscr: "ℬ",
  Bumpeq: "≎",
  CHcy: "Ч",
  COP: "©",
  COPY: "©",
  Cacute: "Ć",
  Cap: "⋒",
  CapitalDifferentialD: "ⅅ",
  Cayleys: "ℭ",
  Ccaron: "Č",
  Ccedi: "Ç",
  Ccedil: "Ç",
  Ccirc: "Ĉ",
  Cconint: "∰",
  Cdot: "Ċ",
  Cedilla: "¸",
  CenterDot: "·",
  Cfr: "ℭ",
  Chi: "Χ",
  CircleDot: "⊙",
  CircleMinus: "⊖",
  CirclePlus: "⊕",
  CircleTimes: "⊗",
  ClockwiseContourIntegral: "∲",
  CloseCurlyDoubleQuote: "”",
  CloseCurlyQuote: "’",
  Colon: "∷",
  Colone: "⩴",
  Congruent: "≡",
  Conint: "∯",
  ContourIntegral: "∮",
  Copf: "ℂ",
  Coproduct: "∐",
  CounterClockwiseContourIntegral: "∳",
  Cross: "⨯",
  Cscr: "𝒞",
  Cup: "⋓",
  CupCap: "≍",
  DD: "ⅅ",
  DDotrahd: "⤑",
  DJcy: "Ђ",
  DScy: "Ѕ",
  DZcy: "Џ",
  Dagger: "‡",
  Darr: "↡",
  Dashv: "⫤",
  Dcaron: "Ď",
  Dcy: "Д",
  Del: "∇",
  Delta: "Δ",
  Dfr: "𝔇",
  DiacriticalAcute: "´",
  DiacriticalDot: "˙",
  DiacriticalDoubleAcute: "˝",
  DiacriticalGrave: "`",
  DiacriticalTilde: "˜",
  Diamond: "⋄",
  DifferentialD: "ⅆ",
  Dopf: "𝔻",
  Dot: "¨",
  DotDot: "⃜",
  DotEqual: "≐",
  DoubleContourIntegral: "∯",
  DoubleDot: "¨",
  DoubleDownArrow: "⇓",
  DoubleLeftArrow: "⇐",
  DoubleLeftRightArrow: "⇔",
  DoubleLeftTee: "⫤",
  DoubleLongLeftArrow: "⟸",
  DoubleLongLeftRightArrow: "⟺",
  DoubleLongRightArrow: "⟹",
  DoubleRightArrow: "⇒",
  DoubleRightTee: "⊨",
  DoubleUpArrow: "⇑",
  DoubleUpDownArrow: "⇕",
  DoubleVerticalBar: "∥",
  DownArrow: "↓",
  DownArrowBar: "⤓",
  DownArrowUpArrow: "⇵",
  DownBreve: "̑",
  DownLeftRightVector: "⥐",
  DownLeftTeeVector: "⥞",
  DownLeftVector: "↽",
  DownLeftVectorBar: "⥖",
  DownRightTeeVector: "⥟",
  DownRightVector: "⇁",
  DownRightVectorBar: "⥗",
  DownTee: "⊤",
  DownTeeArrow: "↧",
  Downarrow: "⇓",
  Dscr: "𝒟",
  Dstrok: "Đ",
  ENG: "Ŋ",
  ET: "Ð",
  ETH: "Ð",
  Eacut: "É",
  Eacute: "É",
  Ecaron: "Ě",
  Ecir: "Ê",
  Ecirc: "Ê",
  Ecy: "Э",
  Edot: "Ė",
  Efr: "𝔈",
  Egrav: "È",
  Egrave: "È",
  Element: "∈",
  Emacr: "Ē",
  EmptySmallSquare: "◻",
  EmptyVerySmallSquare: "▫",
  Eogon: "Ę",
  Eopf: "𝔼",
  Epsilon: "Ε",
  Equal: "⩵",
  EqualTilde: "≂",
  Equilibrium: "⇌",
  Escr: "ℰ",
  Esim: "⩳",
  Eta: "Η",
  Eum: "Ë",
  Euml: "Ë",
  Exists: "∃",
  ExponentialE: "ⅇ",
  Fcy: "Ф",
  Ffr: "𝔉",
  FilledSmallSquare: "◼",
  FilledVerySmallSquare: "▪",
  Fopf: "𝔽",
  ForAll: "∀",
  Fouriertrf: "ℱ",
  Fscr: "ℱ",
  GJcy: "Ѓ",
  G: ">",
  GT: ">",
  Gamma: "Γ",
  Gammad: "Ϝ",
  Gbreve: "Ğ",
  Gcedil: "Ģ",
  Gcirc: "Ĝ",
  Gcy: "Г",
  Gdot: "Ġ",
  Gfr: "𝔊",
  Gg: "⋙",
  Gopf: "𝔾",
  GreaterEqual: "≥",
  GreaterEqualLess: "⋛",
  GreaterFullEqual: "≧",
  GreaterGreater: "⪢",
  GreaterLess: "≷",
  GreaterSlantEqual: "⩾",
  GreaterTilde: "≳",
  Gscr: "𝒢",
  Gt: "≫",
  HARDcy: "Ъ",
  Hacek: "ˇ",
  Hat: "^",
  Hcirc: "Ĥ",
  Hfr: "ℌ",
  HilbertSpace: "ℋ",
  Hopf: "ℍ",
  HorizontalLine: "─",
  Hscr: "ℋ",
  Hstrok: "Ħ",
  HumpDownHump: "≎",
  HumpEqual: "≏",
  IEcy: "Е",
  IJlig: "Ĳ",
  IOcy: "Ё",
  Iacut: "Í",
  Iacute: "Í",
  Icir: "Î",
  Icirc: "Î",
  Icy: "И",
  Idot: "İ",
  Ifr: "ℑ",
  Igrav: "Ì",
  Igrave: "Ì",
  Im: "ℑ",
  Imacr: "Ī",
  ImaginaryI: "ⅈ",
  Implies: "⇒",
  Int: "∬",
  Integral: "∫",
  Intersection: "⋂",
  InvisibleComma: "⁣",
  InvisibleTimes: "⁢",
  Iogon: "Į",
  Iopf: "𝕀",
  Iota: "Ι",
  Iscr: "ℐ",
  Itilde: "Ĩ",
  Iukcy: "І",
  Ium: "Ï",
  Iuml: "Ï",
  Jcirc: "Ĵ",
  Jcy: "Й",
  Jfr: "𝔍",
  Jopf: "𝕁",
  Jscr: "𝒥",
  Jsercy: "Ј",
  Jukcy: "Є",
  KHcy: "Х",
  KJcy: "Ќ",
  Kappa: "Κ",
  Kcedil: "Ķ",
  Kcy: "К",
  Kfr: "𝔎",
  Kopf: "𝕂",
  Kscr: "𝒦",
  LJcy: "Љ",
  L: "<",
  LT: "<",
  Lacute: "Ĺ",
  Lambda: "Λ",
  Lang: "⟪",
  Laplacetrf: "ℒ",
  Larr: "↞",
  Lcaron: "Ľ",
  Lcedil: "Ļ",
  Lcy: "Л",
  LeftAngleBracket: "⟨",
  LeftArrow: "←",
  LeftArrowBar: "⇤",
  LeftArrowRightArrow: "⇆",
  LeftCeiling: "⌈",
  LeftDoubleBracket: "⟦",
  LeftDownTeeVector: "⥡",
  LeftDownVector: "⇃",
  LeftDownVectorBar: "⥙",
  LeftFloor: "⌊",
  LeftRightArrow: "↔",
  LeftRightVector: "⥎",
  LeftTee: "⊣",
  LeftTeeArrow: "↤",
  LeftTeeVector: "⥚",
  LeftTriangle: "⊲",
  LeftTriangleBar: "⧏",
  LeftTriangleEqual: "⊴",
  LeftUpDownVector: "⥑",
  LeftUpTeeVector: "⥠",
  LeftUpVector: "↿",
  LeftUpVectorBar: "⥘",
  LeftVector: "↼",
  LeftVectorBar: "⥒",
  Leftarrow: "⇐",
  Leftrightarrow: "⇔",
  LessEqualGreater: "⋚",
  LessFullEqual: "≦",
  LessGreater: "≶",
  LessLess: "⪡",
  LessSlantEqual: "⩽",
  LessTilde: "≲",
  Lfr: "𝔏",
  Ll: "⋘",
  Lleftarrow: "⇚",
  Lmidot: "Ŀ",
  LongLeftArrow: "⟵",
  LongLeftRightArrow: "⟷",
  LongRightArrow: "⟶",
  Longleftarrow: "⟸",
  Longleftrightarrow: "⟺",
  Longrightarrow: "⟹",
  Lopf: "𝕃",
  LowerLeftArrow: "↙",
  LowerRightArrow: "↘",
  Lscr: "ℒ",
  Lsh: "↰",
  Lstrok: "Ł",
  Lt: "≪",
  Map: "⤅",
  Mcy: "М",
  MediumSpace: " ",
  Mellintrf: "ℳ",
  Mfr: "𝔐",
  MinusPlus: "∓",
  Mopf: "𝕄",
  Mscr: "ℳ",
  Mu: "Μ",
  NJcy: "Њ",
  Nacute: "Ń",
  Ncaron: "Ň",
  Ncedil: "Ņ",
  Ncy: "Н",
  NegativeMediumSpace: "​",
  NegativeThickSpace: "​",
  NegativeThinSpace: "​",
  NegativeVeryThinSpace: "​",
  NestedGreaterGreater: "≫",
  NestedLessLess: "≪",
  NewLine: `
`,
  Nfr: "𝔑",
  NoBreak: "⁠",
  NonBreakingSpace: " ",
  Nopf: "ℕ",
  Not: "⫬",
  NotCongruent: "≢",
  NotCupCap: "≭",
  NotDoubleVerticalBar: "∦",
  NotElement: "∉",
  NotEqual: "≠",
  NotEqualTilde: "≂̸",
  NotExists: "∄",
  NotGreater: "≯",
  NotGreaterEqual: "≱",
  NotGreaterFullEqual: "≧̸",
  NotGreaterGreater: "≫̸",
  NotGreaterLess: "≹",
  NotGreaterSlantEqual: "⩾̸",
  NotGreaterTilde: "≵",
  NotHumpDownHump: "≎̸",
  NotHumpEqual: "≏̸",
  NotLeftTriangle: "⋪",
  NotLeftTriangleBar: "⧏̸",
  NotLeftTriangleEqual: "⋬",
  NotLess: "≮",
  NotLessEqual: "≰",
  NotLessGreater: "≸",
  NotLessLess: "≪̸",
  NotLessSlantEqual: "⩽̸",
  NotLessTilde: "≴",
  NotNestedGreaterGreater: "⪢̸",
  NotNestedLessLess: "⪡̸",
  NotPrecedes: "⊀",
  NotPrecedesEqual: "⪯̸",
  NotPrecedesSlantEqual: "⋠",
  NotReverseElement: "∌",
  NotRightTriangle: "⋫",
  NotRightTriangleBar: "⧐̸",
  NotRightTriangleEqual: "⋭",
  NotSquareSubset: "⊏̸",
  NotSquareSubsetEqual: "⋢",
  NotSquareSuperset: "⊐̸",
  NotSquareSupersetEqual: "⋣",
  NotSubset: "⊂⃒",
  NotSubsetEqual: "⊈",
  NotSucceeds: "⊁",
  NotSucceedsEqual: "⪰̸",
  NotSucceedsSlantEqual: "⋡",
  NotSucceedsTilde: "≿̸",
  NotSuperset: "⊃⃒",
  NotSupersetEqual: "⊉",
  NotTilde: "≁",
  NotTildeEqual: "≄",
  NotTildeFullEqual: "≇",
  NotTildeTilde: "≉",
  NotVerticalBar: "∤",
  Nscr: "𝒩",
  Ntild: "Ñ",
  Ntilde: "Ñ",
  Nu: "Ν",
  OElig: "Œ",
  Oacut: "Ó",
  Oacute: "Ó",
  Ocir: "Ô",
  Ocirc: "Ô",
  Ocy: "О",
  Odblac: "Ő",
  Ofr: "𝔒",
  Ograv: "Ò",
  Ograve: "Ò",
  Omacr: "Ō",
  Omega: "Ω",
  Omicron: "Ο",
  Oopf: "𝕆",
  OpenCurlyDoubleQuote: "“",
  OpenCurlyQuote: "‘",
  Or: "⩔",
  Oscr: "𝒪",
  Oslas: "Ø",
  Oslash: "Ø",
  Otild: "Õ",
  Otilde: "Õ",
  Otimes: "⨷",
  Oum: "Ö",
  Ouml: "Ö",
  OverBar: "‾",
  OverBrace: "⏞",
  OverBracket: "⎴",
  OverParenthesis: "⏜",
  PartialD: "∂",
  Pcy: "П",
  Pfr: "𝔓",
  Phi: "Φ",
  Pi: "Π",
  PlusMinus: "±",
  Poincareplane: "ℌ",
  Popf: "ℙ",
  Pr: "⪻",
  Precedes: "≺",
  PrecedesEqual: "⪯",
  PrecedesSlantEqual: "≼",
  PrecedesTilde: "≾",
  Prime: "″",
  Product: "∏",
  Proportion: "∷",
  Proportional: "∝",
  Pscr: "𝒫",
  Psi: "Ψ",
  QUO: '"',
  QUOT: '"',
  Qfr: "𝔔",
  Qopf: "ℚ",
  Qscr: "𝒬",
  RBarr: "⤐",
  RE: "®",
  REG: "®",
  Racute: "Ŕ",
  Rang: "⟫",
  Rarr: "↠",
  Rarrtl: "⤖",
  Rcaron: "Ř",
  Rcedil: "Ŗ",
  Rcy: "Р",
  Re: "ℜ",
  ReverseElement: "∋",
  ReverseEquilibrium: "⇋",
  ReverseUpEquilibrium: "⥯",
  Rfr: "ℜ",
  Rho: "Ρ",
  RightAngleBracket: "⟩",
  RightArrow: "→",
  RightArrowBar: "⇥",
  RightArrowLeftArrow: "⇄",
  RightCeiling: "⌉",
  RightDoubleBracket: "⟧",
  RightDownTeeVector: "⥝",
  RightDownVector: "⇂",
  RightDownVectorBar: "⥕",
  RightFloor: "⌋",
  RightTee: "⊢",
  RightTeeArrow: "↦",
  RightTeeVector: "⥛",
  RightTriangle: "⊳",
  RightTriangleBar: "⧐",
  RightTriangleEqual: "⊵",
  RightUpDownVector: "⥏",
  RightUpTeeVector: "⥜",
  RightUpVector: "↾",
  RightUpVectorBar: "⥔",
  RightVector: "⇀",
  RightVectorBar: "⥓",
  Rightarrow: "⇒",
  Ropf: "ℝ",
  RoundImplies: "⥰",
  Rrightarrow: "⇛",
  Rscr: "ℛ",
  Rsh: "↱",
  RuleDelayed: "⧴",
  SHCHcy: "Щ",
  SHcy: "Ш",
  SOFTcy: "Ь",
  Sacute: "Ś",
  Sc: "⪼",
  Scaron: "Š",
  Scedil: "Ş",
  Scirc: "Ŝ",
  Scy: "С",
  Sfr: "𝔖",
  ShortDownArrow: "↓",
  ShortLeftArrow: "←",
  ShortRightArrow: "→",
  ShortUpArrow: "↑",
  Sigma: "Σ",
  SmallCircle: "∘",
  Sopf: "𝕊",
  Sqrt: "√",
  Square: "□",
  SquareIntersection: "⊓",
  SquareSubset: "⊏",
  SquareSubsetEqual: "⊑",
  SquareSuperset: "⊐",
  SquareSupersetEqual: "⊒",
  SquareUnion: "⊔",
  Sscr: "𝒮",
  Star: "⋆",
  Sub: "⋐",
  Subset: "⋐",
  SubsetEqual: "⊆",
  Succeeds: "≻",
  SucceedsEqual: "⪰",
  SucceedsSlantEqual: "≽",
  SucceedsTilde: "≿",
  SuchThat: "∋",
  Sum: "∑",
  Sup: "⋑",
  Superset: "⊃",
  SupersetEqual: "⊇",
  Supset: "⋑",
  THOR: "Þ",
  THORN: "Þ",
  TRADE: "™",
  TSHcy: "Ћ",
  TScy: "Ц",
  Tab: "	",
  Tau: "Τ",
  Tcaron: "Ť",
  Tcedil: "Ţ",
  Tcy: "Т",
  Tfr: "𝔗",
  Therefore: "∴",
  Theta: "Θ",
  ThickSpace: "  ",
  ThinSpace: " ",
  Tilde: "∼",
  TildeEqual: "≃",
  TildeFullEqual: "≅",
  TildeTilde: "≈",
  Topf: "𝕋",
  TripleDot: "⃛",
  Tscr: "𝒯",
  Tstrok: "Ŧ",
  Uacut: "Ú",
  Uacute: "Ú",
  Uarr: "↟",
  Uarrocir: "⥉",
  Ubrcy: "Ў",
  Ubreve: "Ŭ",
  Ucir: "Û",
  Ucirc: "Û",
  Ucy: "У",
  Udblac: "Ű",
  Ufr: "𝔘",
  Ugrav: "Ù",
  Ugrave: "Ù",
  Umacr: "Ū",
  UnderBar: "_",
  UnderBrace: "⏟",
  UnderBracket: "⎵",
  UnderParenthesis: "⏝",
  Union: "⋃",
  UnionPlus: "⊎",
  Uogon: "Ų",
  Uopf: "𝕌",
  UpArrow: "↑",
  UpArrowBar: "⤒",
  UpArrowDownArrow: "⇅",
  UpDownArrow: "↕",
  UpEquilibrium: "⥮",
  UpTee: "⊥",
  UpTeeArrow: "↥",
  Uparrow: "⇑",
  Updownarrow: "⇕",
  UpperLeftArrow: "↖",
  UpperRightArrow: "↗",
  Upsi: "ϒ",
  Upsilon: "Υ",
  Uring: "Ů",
  Uscr: "𝒰",
  Utilde: "Ũ",
  Uum: "Ü",
  Uuml: "Ü",
  VDash: "⊫",
  Vbar: "⫫",
  Vcy: "В",
  Vdash: "⊩",
  Vdashl: "⫦",
  Vee: "⋁",
  Verbar: "‖",
  Vert: "‖",
  VerticalBar: "∣",
  VerticalLine: "|",
  VerticalSeparator: "❘",
  VerticalTilde: "≀",
  VeryThinSpace: " ",
  Vfr: "𝔙",
  Vopf: "𝕍",
  Vscr: "𝒱",
  Vvdash: "⊪",
  Wcirc: "Ŵ",
  Wedge: "⋀",
  Wfr: "𝔚",
  Wopf: "𝕎",
  Wscr: "𝒲",
  Xfr: "𝔛",
  Xi: "Ξ",
  Xopf: "𝕏",
  Xscr: "𝒳",
  YAcy: "Я",
  YIcy: "Ї",
  YUcy: "Ю",
  Yacut: "Ý",
  Yacute: "Ý",
  Ycirc: "Ŷ",
  Ycy: "Ы",
  Yfr: "𝔜",
  Yopf: "𝕐",
  Yscr: "𝒴",
  Yuml: "Ÿ",
  ZHcy: "Ж",
  Zacute: "Ź",
  Zcaron: "Ž",
  Zcy: "З",
  Zdot: "Ż",
  ZeroWidthSpace: "​",
  Zeta: "Ζ",
  Zfr: "ℨ",
  Zopf: "ℤ",
  Zscr: "𝒵",
  aacut: "á",
  aacute: "á",
  abreve: "ă",
  ac: "∾",
  acE: "∾̳",
  acd: "∿",
  acir: "â",
  acirc: "â",
  acut: "´",
  acute: "´",
  acy: "а",
  aeli: "æ",
  aelig: "æ",
  af: "⁡",
  afr: "𝔞",
  agrav: "à",
  agrave: "à",
  alefsym: "ℵ",
  aleph: "ℵ",
  alpha: "α",
  amacr: "ā",
  amalg: "⨿",
  am: "&",
  amp: "&",
  and: "∧",
  andand: "⩕",
  andd: "⩜",
  andslope: "⩘",
  andv: "⩚",
  ang: "∠",
  ange: "⦤",
  angle: "∠",
  angmsd: "∡",
  angmsdaa: "⦨",
  angmsdab: "⦩",
  angmsdac: "⦪",
  angmsdad: "⦫",
  angmsdae: "⦬",
  angmsdaf: "⦭",
  angmsdag: "⦮",
  angmsdah: "⦯",
  angrt: "∟",
  angrtvb: "⊾",
  angrtvbd: "⦝",
  angsph: "∢",
  angst: "Å",
  angzarr: "⍼",
  aogon: "ą",
  aopf: "𝕒",
  ap: "≈",
  apE: "⩰",
  apacir: "⩯",
  ape: "≊",
  apid: "≋",
  apos: "'",
  approx: "≈",
  approxeq: "≊",
  arin: "å",
  aring: "å",
  ascr: "𝒶",
  ast: "*",
  asymp: "≈",
  asympeq: "≍",
  atild: "ã",
  atilde: "ã",
  aum: "ä",
  auml: "ä",
  awconint: "∳",
  awint: "⨑",
  bNot: "⫭",
  backcong: "≌",
  backepsilon: "϶",
  backprime: "‵",
  backsim: "∽",
  backsimeq: "⋍",
  barvee: "⊽",
  barwed: "⌅",
  barwedge: "⌅",
  bbrk: "⎵",
  bbrktbrk: "⎶",
  bcong: "≌",
  bcy: "б",
  bdquo: "„",
  becaus: "∵",
  because: "∵",
  bemptyv: "⦰",
  bepsi: "϶",
  bernou: "ℬ",
  beta: "β",
  beth: "ℶ",
  between: "≬",
  bfr: "𝔟",
  bigcap: "⋂",
  bigcirc: "◯",
  bigcup: "⋃",
  bigodot: "⨀",
  bigoplus: "⨁",
  bigotimes: "⨂",
  bigsqcup: "⨆",
  bigstar: "★",
  bigtriangledown: "▽",
  bigtriangleup: "△",
  biguplus: "⨄",
  bigvee: "⋁",
  bigwedge: "⋀",
  bkarow: "⤍",
  blacklozenge: "⧫",
  blacksquare: "▪",
  blacktriangle: "▴",
  blacktriangledown: "▾",
  blacktriangleleft: "◂",
  blacktriangleright: "▸",
  blank: "␣",
  blk12: "▒",
  blk14: "░",
  blk34: "▓",
  block: "█",
  bne: "=⃥",
  bnequiv: "≡⃥",
  bnot: "⌐",
  bopf: "𝕓",
  bot: "⊥",
  bottom: "⊥",
  bowtie: "⋈",
  boxDL: "╗",
  boxDR: "╔",
  boxDl: "╖",
  boxDr: "╓",
  boxH: "═",
  boxHD: "╦",
  boxHU: "╩",
  boxHd: "╤",
  boxHu: "╧",
  boxUL: "╝",
  boxUR: "╚",
  boxUl: "╜",
  boxUr: "╙",
  boxV: "║",
  boxVH: "╬",
  boxVL: "╣",
  boxVR: "╠",
  boxVh: "╫",
  boxVl: "╢",
  boxVr: "╟",
  boxbox: "⧉",
  boxdL: "╕",
  boxdR: "╒",
  boxdl: "┐",
  boxdr: "┌",
  boxh: "─",
  boxhD: "╥",
  boxhU: "╨",
  boxhd: "┬",
  boxhu: "┴",
  boxminus: "⊟",
  boxplus: "⊞",
  boxtimes: "⊠",
  boxuL: "╛",
  boxuR: "╘",
  boxul: "┘",
  boxur: "└",
  boxv: "│",
  boxvH: "╪",
  boxvL: "╡",
  boxvR: "╞",
  boxvh: "┼",
  boxvl: "┤",
  boxvr: "├",
  bprime: "‵",
  breve: "˘",
  brvba: "¦",
  brvbar: "¦",
  bscr: "𝒷",
  bsemi: "⁏",
  bsim: "∽",
  bsime: "⋍",
  bsol: "\\",
  bsolb: "⧅",
  bsolhsub: "⟈",
  bull: "•",
  bullet: "•",
  bump: "≎",
  bumpE: "⪮",
  bumpe: "≏",
  bumpeq: "≏",
  cacute: "ć",
  cap: "∩",
  capand: "⩄",
  capbrcup: "⩉",
  capcap: "⩋",
  capcup: "⩇",
  capdot: "⩀",
  caps: "∩︀",
  caret: "⁁",
  caron: "ˇ",
  ccaps: "⩍",
  ccaron: "č",
  ccedi: "ç",
  ccedil: "ç",
  ccirc: "ĉ",
  ccups: "⩌",
  ccupssm: "⩐",
  cdot: "ċ",
  cedi: "¸",
  cedil: "¸",
  cemptyv: "⦲",
  cen: "¢",
  cent: "¢",
  centerdot: "·",
  cfr: "𝔠",
  chcy: "ч",
  check: "✓",
  checkmark: "✓",
  chi: "χ",
  cir: "○",
  cirE: "⧃",
  circ: "ˆ",
  circeq: "≗",
  circlearrowleft: "↺",
  circlearrowright: "↻",
  circledR: "®",
  circledS: "Ⓢ",
  circledast: "⊛",
  circledcirc: "⊚",
  circleddash: "⊝",
  cire: "≗",
  cirfnint: "⨐",
  cirmid: "⫯",
  cirscir: "⧂",
  clubs: "♣",
  clubsuit: "♣",
  colon: ":",
  colone: "≔",
  coloneq: "≔",
  comma: ",",
  commat: "@",
  comp: "∁",
  compfn: "∘",
  complement: "∁",
  complexes: "ℂ",
  cong: "≅",
  congdot: "⩭",
  conint: "∮",
  copf: "𝕔",
  coprod: "∐",
  cop: "©",
  copy: "©",
  copysr: "℗",
  crarr: "↵",
  cross: "✗",
  cscr: "𝒸",
  csub: "⫏",
  csube: "⫑",
  csup: "⫐",
  csupe: "⫒",
  ctdot: "⋯",
  cudarrl: "⤸",
  cudarrr: "⤵",
  cuepr: "⋞",
  cuesc: "⋟",
  cularr: "↶",
  cularrp: "⤽",
  cup: "∪",
  cupbrcap: "⩈",
  cupcap: "⩆",
  cupcup: "⩊",
  cupdot: "⊍",
  cupor: "⩅",
  cups: "∪︀",
  curarr: "↷",
  curarrm: "⤼",
  curlyeqprec: "⋞",
  curlyeqsucc: "⋟",
  curlyvee: "⋎",
  curlywedge: "⋏",
  curre: "¤",
  curren: "¤",
  curvearrowleft: "↶",
  curvearrowright: "↷",
  cuvee: "⋎",
  cuwed: "⋏",
  cwconint: "∲",
  cwint: "∱",
  cylcty: "⌭",
  dArr: "⇓",
  dHar: "⥥",
  dagger: "†",
  daleth: "ℸ",
  darr: "↓",
  dash: "‐",
  dashv: "⊣",
  dbkarow: "⤏",
  dblac: "˝",
  dcaron: "ď",
  dcy: "д",
  dd: "ⅆ",
  ddagger: "‡",
  ddarr: "⇊",
  ddotseq: "⩷",
  de: "°",
  deg: "°",
  delta: "δ",
  demptyv: "⦱",
  dfisht: "⥿",
  dfr: "𝔡",
  dharl: "⇃",
  dharr: "⇂",
  diam: "⋄",
  diamond: "⋄",
  diamondsuit: "♦",
  diams: "♦",
  die: "¨",
  digamma: "ϝ",
  disin: "⋲",
  div: "÷",
  divid: "÷",
  divide: "÷",
  divideontimes: "⋇",
  divonx: "⋇",
  djcy: "ђ",
  dlcorn: "⌞",
  dlcrop: "⌍",
  dollar: "$",
  dopf: "𝕕",
  dot: "˙",
  doteq: "≐",
  doteqdot: "≑",
  dotminus: "∸",
  dotplus: "∔",
  dotsquare: "⊡",
  doublebarwedge: "⌆",
  downarrow: "↓",
  downdownarrows: "⇊",
  downharpoonleft: "⇃",
  downharpoonright: "⇂",
  drbkarow: "⤐",
  drcorn: "⌟",
  drcrop: "⌌",
  dscr: "𝒹",
  dscy: "ѕ",
  dsol: "⧶",
  dstrok: "đ",
  dtdot: "⋱",
  dtri: "▿",
  dtrif: "▾",
  duarr: "⇵",
  duhar: "⥯",
  dwangle: "⦦",
  dzcy: "џ",
  dzigrarr: "⟿",
  eDDot: "⩷",
  eDot: "≑",
  eacut: "é",
  eacute: "é",
  easter: "⩮",
  ecaron: "ě",
  ecir: "ê",
  ecirc: "ê",
  ecolon: "≕",
  ecy: "э",
  edot: "ė",
  ee: "ⅇ",
  efDot: "≒",
  efr: "𝔢",
  eg: "⪚",
  egrav: "è",
  egrave: "è",
  egs: "⪖",
  egsdot: "⪘",
  el: "⪙",
  elinters: "⏧",
  ell: "ℓ",
  els: "⪕",
  elsdot: "⪗",
  emacr: "ē",
  empty: "∅",
  emptyset: "∅",
  emptyv: "∅",
  emsp13: " ",
  emsp14: " ",
  emsp: " ",
  eng: "ŋ",
  ensp: " ",
  eogon: "ę",
  eopf: "𝕖",
  epar: "⋕",
  eparsl: "⧣",
  eplus: "⩱",
  epsi: "ε",
  epsilon: "ε",
  epsiv: "ϵ",
  eqcirc: "≖",
  eqcolon: "≕",
  eqsim: "≂",
  eqslantgtr: "⪖",
  eqslantless: "⪕",
  equals: "=",
  equest: "≟",
  equiv: "≡",
  equivDD: "⩸",
  eqvparsl: "⧥",
  erDot: "≓",
  erarr: "⥱",
  escr: "ℯ",
  esdot: "≐",
  esim: "≂",
  eta: "η",
  et: "ð",
  eth: "ð",
  eum: "ë",
  euml: "ë",
  euro: "€",
  excl: "!",
  exist: "∃",
  expectation: "ℰ",
  exponentiale: "ⅇ",
  fallingdotseq: "≒",
  fcy: "ф",
  female: "♀",
  ffilig: "ﬃ",
  fflig: "ﬀ",
  ffllig: "ﬄ",
  ffr: "𝔣",
  filig: "ﬁ",
  fjlig: "fj",
  flat: "♭",
  fllig: "ﬂ",
  fltns: "▱",
  fnof: "ƒ",
  fopf: "𝕗",
  forall: "∀",
  fork: "⋔",
  forkv: "⫙",
  fpartint: "⨍",
  frac1: "¼",
  frac12: "½",
  frac13: "⅓",
  frac14: "¼",
  frac15: "⅕",
  frac16: "⅙",
  frac18: "⅛",
  frac23: "⅔",
  frac25: "⅖",
  frac3: "¾",
  frac34: "¾",
  frac35: "⅗",
  frac38: "⅜",
  frac45: "⅘",
  frac56: "⅚",
  frac58: "⅝",
  frac78: "⅞",
  frasl: "⁄",
  frown: "⌢",
  fscr: "𝒻",
  gE: "≧",
  gEl: "⪌",
  gacute: "ǵ",
  gamma: "γ",
  gammad: "ϝ",
  gap: "⪆",
  gbreve: "ğ",
  gcirc: "ĝ",
  gcy: "г",
  gdot: "ġ",
  ge: "≥",
  gel: "⋛",
  geq: "≥",
  geqq: "≧",
  geqslant: "⩾",
  ges: "⩾",
  gescc: "⪩",
  gesdot: "⪀",
  gesdoto: "⪂",
  gesdotol: "⪄",
  gesl: "⋛︀",
  gesles: "⪔",
  gfr: "𝔤",
  gg: "≫",
  ggg: "⋙",
  gimel: "ℷ",
  gjcy: "ѓ",
  gl: "≷",
  glE: "⪒",
  gla: "⪥",
  glj: "⪤",
  gnE: "≩",
  gnap: "⪊",
  gnapprox: "⪊",
  gne: "⪈",
  gneq: "⪈",
  gneqq: "≩",
  gnsim: "⋧",
  gopf: "𝕘",
  grave: "`",
  gscr: "ℊ",
  gsim: "≳",
  gsime: "⪎",
  gsiml: "⪐",
  g: ">",
  gt: ">",
  gtcc: "⪧",
  gtcir: "⩺",
  gtdot: "⋗",
  gtlPar: "⦕",
  gtquest: "⩼",
  gtrapprox: "⪆",
  gtrarr: "⥸",
  gtrdot: "⋗",
  gtreqless: "⋛",
  gtreqqless: "⪌",
  gtrless: "≷",
  gtrsim: "≳",
  gvertneqq: "≩︀",
  gvnE: "≩︀",
  hArr: "⇔",
  hairsp: " ",
  half: "½",
  hamilt: "ℋ",
  hardcy: "ъ",
  harr: "↔",
  harrcir: "⥈",
  harrw: "↭",
  hbar: "ℏ",
  hcirc: "ĥ",
  hearts: "♥",
  heartsuit: "♥",
  hellip: "…",
  hercon: "⊹",
  hfr: "𝔥",
  hksearow: "⤥",
  hkswarow: "⤦",
  hoarr: "⇿",
  homtht: "∻",
  hookleftarrow: "↩",
  hookrightarrow: "↪",
  hopf: "𝕙",
  horbar: "―",
  hscr: "𝒽",
  hslash: "ℏ",
  hstrok: "ħ",
  hybull: "⁃",
  hyphen: "‐",
  iacut: "í",
  iacute: "í",
  ic: "⁣",
  icir: "î",
  icirc: "î",
  icy: "и",
  iecy: "е",
  iexc: "¡",
  iexcl: "¡",
  iff: "⇔",
  ifr: "𝔦",
  igrav: "ì",
  igrave: "ì",
  ii: "ⅈ",
  iiiint: "⨌",
  iiint: "∭",
  iinfin: "⧜",
  iiota: "℩",
  ijlig: "ĳ",
  imacr: "ī",
  image: "ℑ",
  imagline: "ℐ",
  imagpart: "ℑ",
  imath: "ı",
  imof: "⊷",
  imped: "Ƶ",
  in: "∈",
  incare: "℅",
  infin: "∞",
  infintie: "⧝",
  inodot: "ı",
  int: "∫",
  intcal: "⊺",
  integers: "ℤ",
  intercal: "⊺",
  intlarhk: "⨗",
  intprod: "⨼",
  iocy: "ё",
  iogon: "į",
  iopf: "𝕚",
  iota: "ι",
  iprod: "⨼",
  iques: "¿",
  iquest: "¿",
  iscr: "𝒾",
  isin: "∈",
  isinE: "⋹",
  isindot: "⋵",
  isins: "⋴",
  isinsv: "⋳",
  isinv: "∈",
  it: "⁢",
  itilde: "ĩ",
  iukcy: "і",
  ium: "ï",
  iuml: "ï",
  jcirc: "ĵ",
  jcy: "й",
  jfr: "𝔧",
  jmath: "ȷ",
  jopf: "𝕛",
  jscr: "𝒿",
  jsercy: "ј",
  jukcy: "є",
  kappa: "κ",
  kappav: "ϰ",
  kcedil: "ķ",
  kcy: "к",
  kfr: "𝔨",
  kgreen: "ĸ",
  khcy: "х",
  kjcy: "ќ",
  kopf: "𝕜",
  kscr: "𝓀",
  lAarr: "⇚",
  lArr: "⇐",
  lAtail: "⤛",
  lBarr: "⤎",
  lE: "≦",
  lEg: "⪋",
  lHar: "⥢",
  lacute: "ĺ",
  laemptyv: "⦴",
  lagran: "ℒ",
  lambda: "λ",
  lang: "⟨",
  langd: "⦑",
  langle: "⟨",
  lap: "⪅",
  laqu: "«",
  laquo: "«",
  larr: "←",
  larrb: "⇤",
  larrbfs: "⤟",
  larrfs: "⤝",
  larrhk: "↩",
  larrlp: "↫",
  larrpl: "⤹",
  larrsim: "⥳",
  larrtl: "↢",
  lat: "⪫",
  latail: "⤙",
  late: "⪭",
  lates: "⪭︀",
  lbarr: "⤌",
  lbbrk: "❲",
  lbrace: "{",
  lbrack: "[",
  lbrke: "⦋",
  lbrksld: "⦏",
  lbrkslu: "⦍",
  lcaron: "ľ",
  lcedil: "ļ",
  lceil: "⌈",
  lcub: "{",
  lcy: "л",
  ldca: "⤶",
  ldquo: "“",
  ldquor: "„",
  ldrdhar: "⥧",
  ldrushar: "⥋",
  ldsh: "↲",
  le: "≤",
  leftarrow: "←",
  leftarrowtail: "↢",
  leftharpoondown: "↽",
  leftharpoonup: "↼",
  leftleftarrows: "⇇",
  leftrightarrow: "↔",
  leftrightarrows: "⇆",
  leftrightharpoons: "⇋",
  leftrightsquigarrow: "↭",
  leftthreetimes: "⋋",
  leg: "⋚",
  leq: "≤",
  leqq: "≦",
  leqslant: "⩽",
  les: "⩽",
  lescc: "⪨",
  lesdot: "⩿",
  lesdoto: "⪁",
  lesdotor: "⪃",
  lesg: "⋚︀",
  lesges: "⪓",
  lessapprox: "⪅",
  lessdot: "⋖",
  lesseqgtr: "⋚",
  lesseqqgtr: "⪋",
  lessgtr: "≶",
  lesssim: "≲",
  lfisht: "⥼",
  lfloor: "⌊",
  lfr: "𝔩",
  lg: "≶",
  lgE: "⪑",
  lhard: "↽",
  lharu: "↼",
  lharul: "⥪",
  lhblk: "▄",
  ljcy: "љ",
  ll: "≪",
  llarr: "⇇",
  llcorner: "⌞",
  llhard: "⥫",
  lltri: "◺",
  lmidot: "ŀ",
  lmoust: "⎰",
  lmoustache: "⎰",
  lnE: "≨",
  lnap: "⪉",
  lnapprox: "⪉",
  lne: "⪇",
  lneq: "⪇",
  lneqq: "≨",
  lnsim: "⋦",
  loang: "⟬",
  loarr: "⇽",
  lobrk: "⟦",
  longleftarrow: "⟵",
  longleftrightarrow: "⟷",
  longmapsto: "⟼",
  longrightarrow: "⟶",
  looparrowleft: "↫",
  looparrowright: "↬",
  lopar: "⦅",
  lopf: "𝕝",
  loplus: "⨭",
  lotimes: "⨴",
  lowast: "∗",
  lowbar: "_",
  loz: "◊",
  lozenge: "◊",
  lozf: "⧫",
  lpar: "(",
  lparlt: "⦓",
  lrarr: "⇆",
  lrcorner: "⌟",
  lrhar: "⇋",
  lrhard: "⥭",
  lrm: "‎",
  lrtri: "⊿",
  lsaquo: "‹",
  lscr: "𝓁",
  lsh: "↰",
  lsim: "≲",
  lsime: "⪍",
  lsimg: "⪏",
  lsqb: "[",
  lsquo: "‘",
  lsquor: "‚",
  lstrok: "ł",
  l: "<",
  lt: "<",
  ltcc: "⪦",
  ltcir: "⩹",
  ltdot: "⋖",
  lthree: "⋋",
  ltimes: "⋉",
  ltlarr: "⥶",
  ltquest: "⩻",
  ltrPar: "⦖",
  ltri: "◃",
  ltrie: "⊴",
  ltrif: "◂",
  lurdshar: "⥊",
  luruhar: "⥦",
  lvertneqq: "≨︀",
  lvnE: "≨︀",
  mDDot: "∺",
  mac: "¯",
  macr: "¯",
  male: "♂",
  malt: "✠",
  maltese: "✠",
  map: "↦",
  mapsto: "↦",
  mapstodown: "↧",
  mapstoleft: "↤",
  mapstoup: "↥",
  marker: "▮",
  mcomma: "⨩",
  mcy: "м",
  mdash: "—",
  measuredangle: "∡",
  mfr: "𝔪",
  mho: "℧",
  micr: "µ",
  micro: "µ",
  mid: "∣",
  midast: "*",
  midcir: "⫰",
  middo: "·",
  middot: "·",
  minus: "−",
  minusb: "⊟",
  minusd: "∸",
  minusdu: "⨪",
  mlcp: "⫛",
  mldr: "…",
  mnplus: "∓",
  models: "⊧",
  mopf: "𝕞",
  mp: "∓",
  mscr: "𝓂",
  mstpos: "∾",
  mu: "μ",
  multimap: "⊸",
  mumap: "⊸",
  nGg: "⋙̸",
  nGt: "≫⃒",
  nGtv: "≫̸",
  nLeftarrow: "⇍",
  nLeftrightarrow: "⇎",
  nLl: "⋘̸",
  nLt: "≪⃒",
  nLtv: "≪̸",
  nRightarrow: "⇏",
  nVDash: "⊯",
  nVdash: "⊮",
  nabla: "∇",
  nacute: "ń",
  nang: "∠⃒",
  nap: "≉",
  napE: "⩰̸",
  napid: "≋̸",
  napos: "ŉ",
  napprox: "≉",
  natur: "♮",
  natural: "♮",
  naturals: "ℕ",
  nbs: " ",
  nbsp: " ",
  nbump: "≎̸",
  nbumpe: "≏̸",
  ncap: "⩃",
  ncaron: "ň",
  ncedil: "ņ",
  ncong: "≇",
  ncongdot: "⩭̸",
  ncup: "⩂",
  ncy: "н",
  ndash: "–",
  ne: "≠",
  neArr: "⇗",
  nearhk: "⤤",
  nearr: "↗",
  nearrow: "↗",
  nedot: "≐̸",
  nequiv: "≢",
  nesear: "⤨",
  nesim: "≂̸",
  nexist: "∄",
  nexists: "∄",
  nfr: "𝔫",
  ngE: "≧̸",
  nge: "≱",
  ngeq: "≱",
  ngeqq: "≧̸",
  ngeqslant: "⩾̸",
  nges: "⩾̸",
  ngsim: "≵",
  ngt: "≯",
  ngtr: "≯",
  nhArr: "⇎",
  nharr: "↮",
  nhpar: "⫲",
  ni: "∋",
  nis: "⋼",
  nisd: "⋺",
  niv: "∋",
  njcy: "њ",
  nlArr: "⇍",
  nlE: "≦̸",
  nlarr: "↚",
  nldr: "‥",
  nle: "≰",
  nleftarrow: "↚",
  nleftrightarrow: "↮",
  nleq: "≰",
  nleqq: "≦̸",
  nleqslant: "⩽̸",
  nles: "⩽̸",
  nless: "≮",
  nlsim: "≴",
  nlt: "≮",
  nltri: "⋪",
  nltrie: "⋬",
  nmid: "∤",
  nopf: "𝕟",
  no: "¬",
  not: "¬",
  notin: "∉",
  notinE: "⋹̸",
  notindot: "⋵̸",
  notinva: "∉",
  notinvb: "⋷",
  notinvc: "⋶",
  notni: "∌",
  notniva: "∌",
  notnivb: "⋾",
  notnivc: "⋽",
  npar: "∦",
  nparallel: "∦",
  nparsl: "⫽⃥",
  npart: "∂̸",
  npolint: "⨔",
  npr: "⊀",
  nprcue: "⋠",
  npre: "⪯̸",
  nprec: "⊀",
  npreceq: "⪯̸",
  nrArr: "⇏",
  nrarr: "↛",
  nrarrc: "⤳̸",
  nrarrw: "↝̸",
  nrightarrow: "↛",
  nrtri: "⋫",
  nrtrie: "⋭",
  nsc: "⊁",
  nsccue: "⋡",
  nsce: "⪰̸",
  nscr: "𝓃",
  nshortmid: "∤",
  nshortparallel: "∦",
  nsim: "≁",
  nsime: "≄",
  nsimeq: "≄",
  nsmid: "∤",
  nspar: "∦",
  nsqsube: "⋢",
  nsqsupe: "⋣",
  nsub: "⊄",
  nsubE: "⫅̸",
  nsube: "⊈",
  nsubset: "⊂⃒",
  nsubseteq: "⊈",
  nsubseteqq: "⫅̸",
  nsucc: "⊁",
  nsucceq: "⪰̸",
  nsup: "⊅",
  nsupE: "⫆̸",
  nsupe: "⊉",
  nsupset: "⊃⃒",
  nsupseteq: "⊉",
  nsupseteqq: "⫆̸",
  ntgl: "≹",
  ntild: "ñ",
  ntilde: "ñ",
  ntlg: "≸",
  ntriangleleft: "⋪",
  ntrianglelefteq: "⋬",
  ntriangleright: "⋫",
  ntrianglerighteq: "⋭",
  nu: "ν",
  num: "#",
  numero: "№",
  numsp: " ",
  nvDash: "⊭",
  nvHarr: "⤄",
  nvap: "≍⃒",
  nvdash: "⊬",
  nvge: "≥⃒",
  nvgt: ">⃒",
  nvinfin: "⧞",
  nvlArr: "⤂",
  nvle: "≤⃒",
  nvlt: "<⃒",
  nvltrie: "⊴⃒",
  nvrArr: "⤃",
  nvrtrie: "⊵⃒",
  nvsim: "∼⃒",
  nwArr: "⇖",
  nwarhk: "⤣",
  nwarr: "↖",
  nwarrow: "↖",
  nwnear: "⤧",
  oS: "Ⓢ",
  oacut: "ó",
  oacute: "ó",
  oast: "⊛",
  ocir: "ô",
  ocirc: "ô",
  ocy: "о",
  odash: "⊝",
  odblac: "ő",
  odiv: "⨸",
  odot: "⊙",
  odsold: "⦼",
  oelig: "œ",
  ofcir: "⦿",
  ofr: "𝔬",
  ogon: "˛",
  ograv: "ò",
  ograve: "ò",
  ogt: "⧁",
  ohbar: "⦵",
  ohm: "Ω",
  oint: "∮",
  olarr: "↺",
  olcir: "⦾",
  olcross: "⦻",
  oline: "‾",
  olt: "⧀",
  omacr: "ō",
  omega: "ω",
  omicron: "ο",
  omid: "⦶",
  ominus: "⊖",
  oopf: "𝕠",
  opar: "⦷",
  operp: "⦹",
  oplus: "⊕",
  or: "∨",
  orarr: "↻",
  ord: "º",
  order: "ℴ",
  orderof: "ℴ",
  ordf: "ª",
  ordm: "º",
  origof: "⊶",
  oror: "⩖",
  orslope: "⩗",
  orv: "⩛",
  oscr: "ℴ",
  oslas: "ø",
  oslash: "ø",
  osol: "⊘",
  otild: "õ",
  otilde: "õ",
  otimes: "⊗",
  otimesas: "⨶",
  oum: "ö",
  ouml: "ö",
  ovbar: "⌽",
  par: "¶",
  para: "¶",
  parallel: "∥",
  parsim: "⫳",
  parsl: "⫽",
  part: "∂",
  pcy: "п",
  percnt: "%",
  period: ".",
  permil: "‰",
  perp: "⊥",
  pertenk: "‱",
  pfr: "𝔭",
  phi: "φ",
  phiv: "ϕ",
  phmmat: "ℳ",
  phone: "☎",
  pi: "π",
  pitchfork: "⋔",
  piv: "ϖ",
  planck: "ℏ",
  planckh: "ℎ",
  plankv: "ℏ",
  plus: "+",
  plusacir: "⨣",
  plusb: "⊞",
  pluscir: "⨢",
  plusdo: "∔",
  plusdu: "⨥",
  pluse: "⩲",
  plusm: "±",
  plusmn: "±",
  plussim: "⨦",
  plustwo: "⨧",
  pm: "±",
  pointint: "⨕",
  popf: "𝕡",
  poun: "£",
  pound: "£",
  pr: "≺",
  prE: "⪳",
  prap: "⪷",
  prcue: "≼",
  pre: "⪯",
  prec: "≺",
  precapprox: "⪷",
  preccurlyeq: "≼",
  preceq: "⪯",
  precnapprox: "⪹",
  precneqq: "⪵",
  precnsim: "⋨",
  precsim: "≾",
  prime: "′",
  primes: "ℙ",
  prnE: "⪵",
  prnap: "⪹",
  prnsim: "⋨",
  prod: "∏",
  profalar: "⌮",
  profline: "⌒",
  profsurf: "⌓",
  prop: "∝",
  propto: "∝",
  prsim: "≾",
  prurel: "⊰",
  pscr: "𝓅",
  psi: "ψ",
  puncsp: " ",
  qfr: "𝔮",
  qint: "⨌",
  qopf: "𝕢",
  qprime: "⁗",
  qscr: "𝓆",
  quaternions: "ℍ",
  quatint: "⨖",
  quest: "?",
  questeq: "≟",
  quo: '"',
  quot: '"',
  rAarr: "⇛",
  rArr: "⇒",
  rAtail: "⤜",
  rBarr: "⤏",
  rHar: "⥤",
  race: "∽̱",
  racute: "ŕ",
  radic: "√",
  raemptyv: "⦳",
  rang: "⟩",
  rangd: "⦒",
  range: "⦥",
  rangle: "⟩",
  raqu: "»",
  raquo: "»",
  rarr: "→",
  rarrap: "⥵",
  rarrb: "⇥",
  rarrbfs: "⤠",
  rarrc: "⤳",
  rarrfs: "⤞",
  rarrhk: "↪",
  rarrlp: "↬",
  rarrpl: "⥅",
  rarrsim: "⥴",
  rarrtl: "↣",
  rarrw: "↝",
  ratail: "⤚",
  ratio: "∶",
  rationals: "ℚ",
  rbarr: "⤍",
  rbbrk: "❳",
  rbrace: "}",
  rbrack: "]",
  rbrke: "⦌",
  rbrksld: "⦎",
  rbrkslu: "⦐",
  rcaron: "ř",
  rcedil: "ŗ",
  rceil: "⌉",
  rcub: "}",
  rcy: "р",
  rdca: "⤷",
  rdldhar: "⥩",
  rdquo: "”",
  rdquor: "”",
  rdsh: "↳",
  real: "ℜ",
  realine: "ℛ",
  realpart: "ℜ",
  reals: "ℝ",
  rect: "▭",
  re: "®",
  reg: "®",
  rfisht: "⥽",
  rfloor: "⌋",
  rfr: "𝔯",
  rhard: "⇁",
  rharu: "⇀",
  rharul: "⥬",
  rho: "ρ",
  rhov: "ϱ",
  rightarrow: "→",
  rightarrowtail: "↣",
  rightharpoondown: "⇁",
  rightharpoonup: "⇀",
  rightleftarrows: "⇄",
  rightleftharpoons: "⇌",
  rightrightarrows: "⇉",
  rightsquigarrow: "↝",
  rightthreetimes: "⋌",
  ring: "˚",
  risingdotseq: "≓",
  rlarr: "⇄",
  rlhar: "⇌",
  rlm: "‏",
  rmoust: "⎱",
  rmoustache: "⎱",
  rnmid: "⫮",
  roang: "⟭",
  roarr: "⇾",
  robrk: "⟧",
  ropar: "⦆",
  ropf: "𝕣",
  roplus: "⨮",
  rotimes: "⨵",
  rpar: ")",
  rpargt: "⦔",
  rppolint: "⨒",
  rrarr: "⇉",
  rsaquo: "›",
  rscr: "𝓇",
  rsh: "↱",
  rsqb: "]",
  rsquo: "’",
  rsquor: "’",
  rthree: "⋌",
  rtimes: "⋊",
  rtri: "▹",
  rtrie: "⊵",
  rtrif: "▸",
  rtriltri: "⧎",
  ruluhar: "⥨",
  rx: "℞",
  sacute: "ś",
  sbquo: "‚",
  sc: "≻",
  scE: "⪴",
  scap: "⪸",
  scaron: "š",
  sccue: "≽",
  sce: "⪰",
  scedil: "ş",
  scirc: "ŝ",
  scnE: "⪶",
  scnap: "⪺",
  scnsim: "⋩",
  scpolint: "⨓",
  scsim: "≿",
  scy: "с",
  sdot: "⋅",
  sdotb: "⊡",
  sdote: "⩦",
  seArr: "⇘",
  searhk: "⤥",
  searr: "↘",
  searrow: "↘",
  sec: "§",
  sect: "§",
  semi: ";",
  seswar: "⤩",
  setminus: "∖",
  setmn: "∖",
  sext: "✶",
  sfr: "𝔰",
  sfrown: "⌢",
  sharp: "♯",
  shchcy: "щ",
  shcy: "ш",
  shortmid: "∣",
  shortparallel: "∥",
  sh: "­",
  shy: "­",
  sigma: "σ",
  sigmaf: "ς",
  sigmav: "ς",
  sim: "∼",
  simdot: "⩪",
  sime: "≃",
  simeq: "≃",
  simg: "⪞",
  simgE: "⪠",
  siml: "⪝",
  simlE: "⪟",
  simne: "≆",
  simplus: "⨤",
  simrarr: "⥲",
  slarr: "←",
  smallsetminus: "∖",
  smashp: "⨳",
  smeparsl: "⧤",
  smid: "∣",
  smile: "⌣",
  smt: "⪪",
  smte: "⪬",
  smtes: "⪬︀",
  softcy: "ь",
  sol: "/",
  solb: "⧄",
  solbar: "⌿",
  sopf: "𝕤",
  spades: "♠",
  spadesuit: "♠",
  spar: "∥",
  sqcap: "⊓",
  sqcaps: "⊓︀",
  sqcup: "⊔",
  sqcups: "⊔︀",
  sqsub: "⊏",
  sqsube: "⊑",
  sqsubset: "⊏",
  sqsubseteq: "⊑",
  sqsup: "⊐",
  sqsupe: "⊒",
  sqsupset: "⊐",
  sqsupseteq: "⊒",
  squ: "□",
  square: "□",
  squarf: "▪",
  squf: "▪",
  srarr: "→",
  sscr: "𝓈",
  ssetmn: "∖",
  ssmile: "⌣",
  sstarf: "⋆",
  star: "☆",
  starf: "★",
  straightepsilon: "ϵ",
  straightphi: "ϕ",
  strns: "¯",
  sub: "⊂",
  subE: "⫅",
  subdot: "⪽",
  sube: "⊆",
  subedot: "⫃",
  submult: "⫁",
  subnE: "⫋",
  subne: "⊊",
  subplus: "⪿",
  subrarr: "⥹",
  subset: "⊂",
  subseteq: "⊆",
  subseteqq: "⫅",
  subsetneq: "⊊",
  subsetneqq: "⫋",
  subsim: "⫇",
  subsub: "⫕",
  subsup: "⫓",
  succ: "≻",
  succapprox: "⪸",
  succcurlyeq: "≽",
  succeq: "⪰",
  succnapprox: "⪺",
  succneqq: "⪶",
  succnsim: "⋩",
  succsim: "≿",
  sum: "∑",
  sung: "♪",
  sup: "⊃",
  sup1: "¹",
  sup2: "²",
  sup3: "³",
  supE: "⫆",
  supdot: "⪾",
  supdsub: "⫘",
  supe: "⊇",
  supedot: "⫄",
  suphsol: "⟉",
  suphsub: "⫗",
  suplarr: "⥻",
  supmult: "⫂",
  supnE: "⫌",
  supne: "⊋",
  supplus: "⫀",
  supset: "⊃",
  supseteq: "⊇",
  supseteqq: "⫆",
  supsetneq: "⊋",
  supsetneqq: "⫌",
  supsim: "⫈",
  supsub: "⫔",
  supsup: "⫖",
  swArr: "⇙",
  swarhk: "⤦",
  swarr: "↙",
  swarrow: "↙",
  swnwar: "⤪",
  szli: "ß",
  szlig: "ß",
  target: "⌖",
  tau: "τ",
  tbrk: "⎴",
  tcaron: "ť",
  tcedil: "ţ",
  tcy: "т",
  tdot: "⃛",
  telrec: "⌕",
  tfr: "𝔱",
  there4: "∴",
  therefore: "∴",
  theta: "θ",
  thetasym: "ϑ",
  thetav: "ϑ",
  thickapprox: "≈",
  thicksim: "∼",
  thinsp: " ",
  thkap: "≈",
  thksim: "∼",
  thor: "þ",
  thorn: "þ",
  tilde: "˜",
  time: "×",
  times: "×",
  timesb: "⊠",
  timesbar: "⨱",
  timesd: "⨰",
  tint: "∭",
  toea: "⤨",
  top: "⊤",
  topbot: "⌶",
  topcir: "⫱",
  topf: "𝕥",
  topfork: "⫚",
  tosa: "⤩",
  tprime: "‴",
  trade: "™",
  triangle: "▵",
  triangledown: "▿",
  triangleleft: "◃",
  trianglelefteq: "⊴",
  triangleq: "≜",
  triangleright: "▹",
  trianglerighteq: "⊵",
  tridot: "◬",
  trie: "≜",
  triminus: "⨺",
  triplus: "⨹",
  trisb: "⧍",
  tritime: "⨻",
  trpezium: "⏢",
  tscr: "𝓉",
  tscy: "ц",
  tshcy: "ћ",
  tstrok: "ŧ",
  twixt: "≬",
  twoheadleftarrow: "↞",
  twoheadrightarrow: "↠",
  uArr: "⇑",
  uHar: "⥣",
  uacut: "ú",
  uacute: "ú",
  uarr: "↑",
  ubrcy: "ў",
  ubreve: "ŭ",
  ucir: "û",
  ucirc: "û",
  ucy: "у",
  udarr: "⇅",
  udblac: "ű",
  udhar: "⥮",
  ufisht: "⥾",
  ufr: "𝔲",
  ugrav: "ù",
  ugrave: "ù",
  uharl: "↿",
  uharr: "↾",
  uhblk: "▀",
  ulcorn: "⌜",
  ulcorner: "⌜",
  ulcrop: "⌏",
  ultri: "◸",
  umacr: "ū",
  um: "¨",
  uml: "¨",
  uogon: "ų",
  uopf: "𝕦",
  uparrow: "↑",
  updownarrow: "↕",
  upharpoonleft: "↿",
  upharpoonright: "↾",
  uplus: "⊎",
  upsi: "υ",
  upsih: "ϒ",
  upsilon: "υ",
  upuparrows: "⇈",
  urcorn: "⌝",
  urcorner: "⌝",
  urcrop: "⌎",
  uring: "ů",
  urtri: "◹",
  uscr: "𝓊",
  utdot: "⋰",
  utilde: "ũ",
  utri: "▵",
  utrif: "▴",
  uuarr: "⇈",
  uum: "ü",
  uuml: "ü",
  uwangle: "⦧",
  vArr: "⇕",
  vBar: "⫨",
  vBarv: "⫩",
  vDash: "⊨",
  vangrt: "⦜",
  varepsilon: "ϵ",
  varkappa: "ϰ",
  varnothing: "∅",
  varphi: "ϕ",
  varpi: "ϖ",
  varpropto: "∝",
  varr: "↕",
  varrho: "ϱ",
  varsigma: "ς",
  varsubsetneq: "⊊︀",
  varsubsetneqq: "⫋︀",
  varsupsetneq: "⊋︀",
  varsupsetneqq: "⫌︀",
  vartheta: "ϑ",
  vartriangleleft: "⊲",
  vartriangleright: "⊳",
  vcy: "в",
  vdash: "⊢",
  vee: "∨",
  veebar: "⊻",
  veeeq: "≚",
  vellip: "⋮",
  verbar: "|",
  vert: "|",
  vfr: "𝔳",
  vltri: "⊲",
  vnsub: "⊂⃒",
  vnsup: "⊃⃒",
  vopf: "𝕧",
  vprop: "∝",
  vrtri: "⊳",
  vscr: "𝓋",
  vsubnE: "⫋︀",
  vsubne: "⊊︀",
  vsupnE: "⫌︀",
  vsupne: "⊋︀",
  vzigzag: "⦚",
  wcirc: "ŵ",
  wedbar: "⩟",
  wedge: "∧",
  wedgeq: "≙",
  weierp: "℘",
  wfr: "𝔴",
  wopf: "𝕨",
  wp: "℘",
  wr: "≀",
  wreath: "≀",
  wscr: "𝓌",
  xcap: "⋂",
  xcirc: "◯",
  xcup: "⋃",
  xdtri: "▽",
  xfr: "𝔵",
  xhArr: "⟺",
  xharr: "⟷",
  xi: "ξ",
  xlArr: "⟸",
  xlarr: "⟵",
  xmap: "⟼",
  xnis: "⋻",
  xodot: "⨀",
  xopf: "𝕩",
  xoplus: "⨁",
  xotime: "⨂",
  xrArr: "⟹",
  xrarr: "⟶",
  xscr: "𝓍",
  xsqcup: "⨆",
  xuplus: "⨄",
  xutri: "△",
  xvee: "⋁",
  xwedge: "⋀",
  yacut: "ý",
  yacute: "ý",
  yacy: "я",
  ycirc: "ŷ",
  ycy: "ы",
  ye: "¥",
  yen: "¥",
  yfr: "𝔶",
  yicy: "ї",
  yopf: "𝕪",
  yscr: "𝓎",
  yucy: "ю",
  yum: "ÿ",
  yuml: "ÿ",
  zacute: "ź",
  zcaron: "ž",
  zcy: "з",
  zdot: "ż",
  zeetrf: "ℨ",
  zeta: "ζ",
  zfr: "𝔷",
  zhcy: "ж",
  zigrarr: "⇝",
  zopf: "𝕫",
  zscr: "𝓏",
  zwj: "‍",
  zwnj: "‌"
}, e9 = {}.hasOwnProperty;
function Ai(e) {
  return e9.call(To, e) ? To[e] : !1;
}
const Rl = {
  name: "characterReference",
  tokenize: t9
};
function t9(e, t, n) {
  const r = this;
  let i = 0, o, s;
  return l;
  function l(m) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(m), e.exit("characterReferenceMarker"), c;
  }
  function c(m) {
    return m === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(m), e.exit("characterReferenceMarkerNumeric"), u) : (e.enter("characterReferenceValue"), o = 31, s = Ct, f(m));
  }
  function u(m) {
    return m === 88 || m === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(m), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = D0, f) : (e.enter("characterReferenceValue"), o = 7, s = ni, f(m));
  }
  function f(m) {
    if (m === 59 && i) {
      const E = e.exit("characterReferenceValue");
      return s === Ct && !Ai(r.sliceSerialize(E)) ? n(m) : (e.enter("characterReferenceMarker"), e.consume(m), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return s(m) && i++ < o ? (e.consume(m), f) : n(m);
  }
}
const go = {
  tokenize: r9,
  partial: !0
}, Eo = {
  name: "codeFenced",
  tokenize: n9,
  concrete: !0
};
function n9(e, t, n) {
  const r = this, i = {
    tokenize: N,
    partial: !0
  };
  let o = 0, s = 0, l;
  return c;
  function c(C) {
    return u(C);
  }
  function u(C) {
    const I = r.events[r.events.length - 1];
    return o = I && I[1].type === "linePrefix" ? I[2].sliceSerialize(I[1], !0).length : 0, l = C, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), f(C);
  }
  function f(C) {
    return C === l ? (s++, e.consume(C), f) : s < 3 ? n(C) : (e.exit("codeFencedFenceSequence"), Se(C) ? we(e, m, "whitespace")(C) : m(C));
  }
  function m(C) {
    return C === null || ae(C) ? (e.exit("codeFencedFence"), r.interrupt ? t(C) : e.check(go, y, P)(C)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), E(C));
  }
  function E(C) {
    return C === null || ae(C) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), m(C)) : Se(C) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), we(e, h, "whitespace")(C)) : C === 96 && C === l ? n(C) : (e.consume(C), E);
  }
  function h(C) {
    return C === null || ae(C) ? m(C) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), x(C));
  }
  function x(C) {
    return C === null || ae(C) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), m(C)) : C === 96 && C === l ? n(C) : (e.consume(C), x);
  }
  function y(C) {
    return e.attempt(i, P, b)(C);
  }
  function b(C) {
    return e.enter("lineEnding"), e.consume(C), e.exit("lineEnding"), _;
  }
  function _(C) {
    return o > 0 && Se(C) ? we(
      e,
      M,
      "linePrefix",
      o + 1
    )(C) : M(C);
  }
  function M(C) {
    return C === null || ae(C) ? e.check(go, y, P)(C) : (e.enter("codeFlowValue"), O(C));
  }
  function O(C) {
    return C === null || ae(C) ? (e.exit("codeFlowValue"), M(C)) : (e.consume(C), O);
  }
  function P(C) {
    return e.exit("codeFenced"), t(C);
  }
  function N(C, I, D) {
    let z = 0;
    return ie;
    function ie(te) {
      return C.enter("lineEnding"), C.consume(te), C.exit("lineEnding"), v;
    }
    function v(te) {
      return C.enter("codeFencedFence"), Se(te) ? we(
        C,
        U,
        "linePrefix",
        r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(te) : U(te);
    }
    function U(te) {
      return te === l ? (C.enter("codeFencedFenceSequence"), L(te)) : D(te);
    }
    function L(te) {
      return te === l ? (z++, C.consume(te), L) : z >= s ? (C.exit("codeFencedFenceSequence"), Se(te) ? we(C, Q, "whitespace")(te) : Q(te)) : D(te);
    }
    function Q(te) {
      return te === null || ae(te) ? (C.exit("codeFencedFence"), I(te)) : D(te);
    }
  }
}
function r9(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return s === null ? n(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return r.parser.lazy[r.now().line] ? n(s) : t(s);
  }
}
const Sr = {
  name: "codeIndented",
  tokenize: o9
}, i9 = {
  tokenize: s9,
  partial: !0
};
function o9(e, t, n) {
  const r = this;
  return i;
  function i(u) {
    return e.enter("codeIndented"), we(e, o, "linePrefix", 4 + 1)(u);
  }
  function o(u) {
    const f = r.events[r.events.length - 1];
    return f && f[1].type === "linePrefix" && f[2].sliceSerialize(f[1], !0).length >= 4 ? s(u) : n(u);
  }
  function s(u) {
    return u === null ? c(u) : ae(u) ? e.attempt(i9, s, c)(u) : (e.enter("codeFlowValue"), l(u));
  }
  function l(u) {
    return u === null || ae(u) ? (e.exit("codeFlowValue"), s(u)) : (e.consume(u), l);
  }
  function c(u) {
    return e.exit("codeIndented"), t(u);
  }
}
function s9(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return r.parser.lazy[r.now().line] ? n(s) : ae(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), i) : we(e, o, "linePrefix", 4 + 1)(s);
  }
  function o(s) {
    const l = r.events[r.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(s) : ae(s) ? i(s) : n(s);
  }
}
const l9 = {
  name: "codeText",
  tokenize: c9,
  resolve: a9,
  previous: u9
};
function a9(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function u9(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function c9(e, t, n) {
  let r = 0, i, o;
  return s;
  function s(m) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(m);
  }
  function l(m) {
    return m === 96 ? (e.consume(m), r++, l) : (e.exit("codeTextSequence"), c(m));
  }
  function c(m) {
    return m === null ? n(m) : m === 32 ? (e.enter("space"), e.consume(m), e.exit("space"), c) : m === 96 ? (o = e.enter("codeTextSequence"), i = 0, f(m)) : ae(m) ? (e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), c) : (e.enter("codeTextData"), u(m));
  }
  function u(m) {
    return m === null || m === 32 || m === 96 || ae(m) ? (e.exit("codeTextData"), c(m)) : (e.consume(m), u);
  }
  function f(m) {
    return m === 96 ? (e.consume(m), i++, f) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(m)) : (o.type = "codeTextData", u(m));
  }
}
function kl(e) {
  const t = {};
  let n = -1, r, i, o, s, l, c, u;
  for (; ++n < e.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = e[n], n && r[1].type === "chunkFlow" && e[n - 1][1].type === "listItemPrefix" && (c = r[1]._tokenizer.events, o = 0, o < c.length && c[o][1].type === "lineEndingBlank" && (o += 2), o < c.length && c[o][1].type === "content"))
      for (; ++o < c.length && c[o][1].type !== "content"; )
        c[o][1].type === "chunkText" && (c[o][1]._isInFirstContentOfListItem = !0, o++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, f9(e, n)), n = t[n], u = !0);
    else if (r[1]._container) {
      for (o = n, i = void 0; o-- && (s = e[o], s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (i && (e[i][1].type = "lineEndingBlank"), s[1].type = "lineEnding", i = o);
      i && (r[1].end = Object.assign({}, e[i][1].start), l = e.slice(i, n), l.unshift(r), Lt(e, i, n - i + 1, l));
    }
  }
  return !u;
}
function f9(e, t) {
  const n = e[t][1], r = e[t][2];
  let i = t - 1;
  const o = [], s = n._tokenizer || r.parser[n.contentType](n.start), l = s.events, c = [], u = {};
  let f, m, E = -1, h = n, x = 0, y = 0;
  const b = [y];
  for (; h; ) {
    for (; e[++i][1] !== h; )
      ;
    o.push(i), h._tokenizer || (f = r.sliceStream(h), h.next || f.push(null), m && s.defineSkip(h.start), h._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(f), h._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), m = h, h = h.next;
  }
  for (h = n; ++E < l.length; )
    // Find a void token that includes a break.
    l[E][0] === "exit" && l[E - 1][0] === "enter" && l[E][1].type === l[E - 1][1].type && l[E][1].start.line !== l[E][1].end.line && (y = E + 1, b.push(y), h._tokenizer = void 0, h.previous = void 0, h = h.next);
  for (s.events = [], h ? (h._tokenizer = void 0, h.previous = void 0) : b.pop(), E = b.length; E--; ) {
    const _ = l.slice(b[E], b[E + 1]), M = o.pop();
    c.unshift([M, M + _.length - 1]), Lt(e, M, 2, _);
  }
  for (E = -1; ++E < c.length; )
    u[x + c[E][0]] = x + c[E][1], x += c[E][1] - c[E][0] - 1;
  return u;
}
const h9 = {
  tokenize: p9,
  resolve: m9
}, d9 = {
  tokenize: T9,
  partial: !0
};
function m9(e) {
  return kl(e), e;
}
function p9(e, t) {
  let n;
  return r;
  function r(l) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(l);
  }
  function i(l) {
    return l === null ? o(l) : ae(l) ? e.check(
      d9,
      s,
      o
    )(l) : (e.consume(l), i);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), t(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function T9(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), we(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || ae(s))
      return n(s);
    const l = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(s) : e.interrupt(r.parser.constructs.flow, n, t)(s);
  }
}
function wl(e, t, n, r, i, o, s, l, c) {
  const u = c || Number.POSITIVE_INFINITY;
  let f = 0;
  return m;
  function m(_) {
    return _ === 60 ? (e.enter(r), e.enter(i), e.enter(o), e.consume(_), e.exit(o), E) : _ === null || _ === 32 || _ === 41 || ti(_) ? n(_) : (e.enter(r), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), y(_));
  }
  function E(_) {
    return _ === 62 ? (e.enter(o), e.consume(_), e.exit(o), e.exit(i), e.exit(r), t) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), h(_));
  }
  function h(_) {
    return _ === 62 ? (e.exit("chunkString"), e.exit(l), E(_)) : _ === null || _ === 60 || ae(_) ? n(_) : (e.consume(_), _ === 92 ? x : h);
  }
  function x(_) {
    return _ === 60 || _ === 62 || _ === 92 ? (e.consume(_), h) : h(_);
  }
  function y(_) {
    return !f && (_ === null || _ === 41 || nt(_)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(r), t(_)) : f < u && _ === 40 ? (e.consume(_), f++, y) : _ === 41 ? (e.consume(_), f--, y) : _ === null || _ === 32 || _ === 40 || ti(_) ? n(_) : (e.consume(_), _ === 92 ? b : y);
  }
  function b(_) {
    return _ === 40 || _ === 41 || _ === 92 ? (e.consume(_), y) : y(_);
  }
}
function Ll(e, t, n, r, i, o) {
  const s = this;
  let l = 0, c;
  return u;
  function u(h) {
    return e.enter(r), e.enter(i), e.consume(h), e.exit(i), e.enter(o), f;
  }
  function f(h) {
    return l > 999 || h === null || h === 91 || h === 93 && !c || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    h === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? n(h) : h === 93 ? (e.exit(o), e.enter(i), e.consume(h), e.exit(i), e.exit(r), t) : ae(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), f) : (e.enter("chunkString", {
      contentType: "string"
    }), m(h));
  }
  function m(h) {
    return h === null || h === 91 || h === 93 || ae(h) || l++ > 999 ? (e.exit("chunkString"), f(h)) : (e.consume(h), c || (c = !Se(h)), h === 92 ? E : m);
  }
  function E(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), l++, m) : m(h);
  }
}
function Ml(e, t, n, r, i, o) {
  let s;
  return l;
  function l(E) {
    return E === 34 || E === 39 || E === 40 ? (e.enter(r), e.enter(i), e.consume(E), e.exit(i), s = E === 40 ? 41 : E, c) : n(E);
  }
  function c(E) {
    return E === s ? (e.enter(i), e.consume(E), e.exit(i), e.exit(r), t) : (e.enter(o), u(E));
  }
  function u(E) {
    return E === s ? (e.exit(o), c(s)) : E === null ? n(E) : ae(E) ? (e.enter("lineEnding"), e.consume(E), e.exit("lineEnding"), we(e, u, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), f(E));
  }
  function f(E) {
    return E === s || E === null || ae(E) ? (e.exit("chunkString"), u(E)) : (e.consume(E), E === 92 ? m : f);
  }
  function m(E) {
    return E === s || E === 92 ? (e.consume(E), f) : f(E);
  }
}
function Xn(e, t) {
  let n;
  return r;
  function r(i) {
    return ae(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : Se(i) ? we(
      e,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(i) : t(i);
  }
}
function bn(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const g9 = {
  name: "definition",
  tokenize: A9
}, E9 = {
  tokenize: _9,
  partial: !0
};
function A9(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(h) {
    return e.enter("definition"), s(h);
  }
  function s(h) {
    return Ll.call(
      r,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(h);
  }
  function l(h) {
    return i = bn(
      r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
    ), h === 58 ? (e.enter("definitionMarker"), e.consume(h), e.exit("definitionMarker"), c) : n(h);
  }
  function c(h) {
    return nt(h) ? Xn(e, u)(h) : u(h);
  }
  function u(h) {
    return wl(
      e,
      f,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(h);
  }
  function f(h) {
    return e.attempt(E9, m, m)(h);
  }
  function m(h) {
    return Se(h) ? we(e, E, "whitespace")(h) : E(h);
  }
  function E(h) {
    return h === null || ae(h) ? (e.exit("definition"), r.parser.defined.push(i), t(h)) : n(h);
  }
}
function _9(e, t, n) {
  return r;
  function r(l) {
    return nt(l) ? Xn(e, i)(l) : n(l);
  }
  function i(l) {
    return Ml(
      e,
      o,
      n,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(l);
  }
  function o(l) {
    return Se(l) ? we(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || ae(l) ? t(l) : n(l);
  }
}
const y9 = {
  name: "hardBreakEscape",
  tokenize: C9
};
function C9(e, t, n) {
  return r;
  function r(o) {
    return e.enter("hardBreakEscape"), e.consume(o), i;
  }
  function i(o) {
    return ae(o) ? (e.exit("hardBreakEscape"), t(o)) : n(o);
  }
}
const S9 = {
  name: "headingAtx",
  tokenize: N9,
  resolve: x9
};
function x9(e, t) {
  let n = e.length - 2, r = 3, i, o;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, o = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Lt(e, r, n - r + 1, [
    ["enter", i, t],
    ["enter", o, t],
    ["exit", o, t],
    ["exit", i, t]
  ])), e;
}
function N9(e, t, n) {
  let r = 0;
  return i;
  function i(f) {
    return e.enter("atxHeading"), o(f);
  }
  function o(f) {
    return e.enter("atxHeadingSequence"), s(f);
  }
  function s(f) {
    return f === 35 && r++ < 6 ? (e.consume(f), s) : f === null || nt(f) ? (e.exit("atxHeadingSequence"), l(f)) : n(f);
  }
  function l(f) {
    return f === 35 ? (e.enter("atxHeadingSequence"), c(f)) : f === null || ae(f) ? (e.exit("atxHeading"), t(f)) : Se(f) ? we(e, l, "whitespace")(f) : (e.enter("atxHeadingText"), u(f));
  }
  function c(f) {
    return f === 35 ? (e.consume(f), c) : (e.exit("atxHeadingSequence"), l(f));
  }
  function u(f) {
    return f === null || f === 35 || nt(f) ? (e.exit("atxHeadingText"), l(f)) : (e.consume(f), u);
  }
}
const b9 = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Ao = ["pre", "script", "style", "textarea"], O9 = {
  name: "htmlFlow",
  tokenize: w9,
  resolveTo: k9,
  concrete: !0
}, I9 = {
  tokenize: M9,
  partial: !0
}, R9 = {
  tokenize: L9,
  partial: !0
};
function k9(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function w9(e, t, n) {
  const r = this;
  let i, o, s, l, c;
  return u;
  function u(p) {
    return f(p);
  }
  function f(p) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(p), m;
  }
  function m(p) {
    return p === 33 ? (e.consume(p), E) : p === 47 ? (e.consume(p), o = !0, y) : p === 63 ? (e.consume(p), i = 3, r.interrupt ? t : d) : Ot(p) ? (e.consume(p), s = String.fromCharCode(p), b) : n(p);
  }
  function E(p) {
    return p === 45 ? (e.consume(p), i = 2, h) : p === 91 ? (e.consume(p), i = 5, l = 0, x) : Ot(p) ? (e.consume(p), i = 4, r.interrupt ? t : d) : n(p);
  }
  function h(p) {
    return p === 45 ? (e.consume(p), r.interrupt ? t : d) : n(p);
  }
  function x(p) {
    const ne = "CDATA[";
    return p === ne.charCodeAt(l++) ? (e.consume(p), l === ne.length ? r.interrupt ? t : U : x) : n(p);
  }
  function y(p) {
    return Ot(p) ? (e.consume(p), s = String.fromCharCode(p), b) : n(p);
  }
  function b(p) {
    if (p === null || p === 47 || p === 62 || nt(p)) {
      const ne = p === 47, se = s.toLowerCase();
      return !ne && !o && Ao.includes(se) ? (i = 1, r.interrupt ? t(p) : U(p)) : b9.includes(s.toLowerCase()) ? (i = 6, ne ? (e.consume(p), _) : r.interrupt ? t(p) : U(p)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(p) : o ? M(p) : O(p));
    }
    return p === 45 || Ct(p) ? (e.consume(p), s += String.fromCharCode(p), b) : n(p);
  }
  function _(p) {
    return p === 62 ? (e.consume(p), r.interrupt ? t : U) : n(p);
  }
  function M(p) {
    return Se(p) ? (e.consume(p), M) : ie(p);
  }
  function O(p) {
    return p === 47 ? (e.consume(p), ie) : p === 58 || p === 95 || Ot(p) ? (e.consume(p), P) : Se(p) ? (e.consume(p), O) : ie(p);
  }
  function P(p) {
    return p === 45 || p === 46 || p === 58 || p === 95 || Ct(p) ? (e.consume(p), P) : N(p);
  }
  function N(p) {
    return p === 61 ? (e.consume(p), C) : Se(p) ? (e.consume(p), N) : O(p);
  }
  function C(p) {
    return p === null || p === 60 || p === 61 || p === 62 || p === 96 ? n(p) : p === 34 || p === 39 ? (e.consume(p), c = p, I) : Se(p) ? (e.consume(p), C) : D(p);
  }
  function I(p) {
    return p === c ? (e.consume(p), c = null, z) : p === null || ae(p) ? n(p) : (e.consume(p), I);
  }
  function D(p) {
    return p === null || p === 34 || p === 39 || p === 47 || p === 60 || p === 61 || p === 62 || p === 96 || nt(p) ? N(p) : (e.consume(p), D);
  }
  function z(p) {
    return p === 47 || p === 62 || Se(p) ? O(p) : n(p);
  }
  function ie(p) {
    return p === 62 ? (e.consume(p), v) : n(p);
  }
  function v(p) {
    return p === null || ae(p) ? U(p) : Se(p) ? (e.consume(p), v) : n(p);
  }
  function U(p) {
    return p === 45 && i === 2 ? (e.consume(p), pe) : p === 60 && i === 1 ? (e.consume(p), ye) : p === 62 && i === 4 ? (e.consume(p), q) : p === 63 && i === 3 ? (e.consume(p), d) : p === 93 && i === 5 ? (e.consume(p), ke) : ae(p) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(
      I9,
      oe,
      L
    )(p)) : p === null || ae(p) ? (e.exit("htmlFlowData"), L(p)) : (e.consume(p), U);
  }
  function L(p) {
    return e.check(
      R9,
      Q,
      oe
    )(p);
  }
  function Q(p) {
    return e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), te;
  }
  function te(p) {
    return p === null || ae(p) ? L(p) : (e.enter("htmlFlowData"), U(p));
  }
  function pe(p) {
    return p === 45 ? (e.consume(p), d) : U(p);
  }
  function ye(p) {
    return p === 47 ? (e.consume(p), s = "", Ae) : U(p);
  }
  function Ae(p) {
    if (p === 62) {
      const ne = s.toLowerCase();
      return Ao.includes(ne) ? (e.consume(p), q) : U(p);
    }
    return Ot(p) && s.length < 8 ? (e.consume(p), s += String.fromCharCode(p), Ae) : U(p);
  }
  function ke(p) {
    return p === 93 ? (e.consume(p), d) : U(p);
  }
  function d(p) {
    return p === 62 ? (e.consume(p), q) : p === 45 && i === 2 ? (e.consume(p), d) : U(p);
  }
  function q(p) {
    return p === null || ae(p) ? (e.exit("htmlFlowData"), oe(p)) : (e.consume(p), q);
  }
  function oe(p) {
    return e.exit("htmlFlow"), t(p);
  }
}
function L9(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return ae(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : n(s);
  }
  function o(s) {
    return r.parser.lazy[r.now().line] ? n(s) : t(s);
  }
}
function M9(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(X1, t, n);
  }
}
const P9 = {
  name: "htmlText",
  tokenize: v9
};
function v9(e, t, n) {
  const r = this;
  let i, o, s;
  return l;
  function l(d) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(d), c;
  }
  function c(d) {
    return d === 33 ? (e.consume(d), u) : d === 47 ? (e.consume(d), N) : d === 63 ? (e.consume(d), O) : Ot(d) ? (e.consume(d), D) : n(d);
  }
  function u(d) {
    return d === 45 ? (e.consume(d), f) : d === 91 ? (e.consume(d), o = 0, x) : Ot(d) ? (e.consume(d), M) : n(d);
  }
  function f(d) {
    return d === 45 ? (e.consume(d), h) : n(d);
  }
  function m(d) {
    return d === null ? n(d) : d === 45 ? (e.consume(d), E) : ae(d) ? (s = m, ye(d)) : (e.consume(d), m);
  }
  function E(d) {
    return d === 45 ? (e.consume(d), h) : m(d);
  }
  function h(d) {
    return d === 62 ? pe(d) : d === 45 ? E(d) : m(d);
  }
  function x(d) {
    const q = "CDATA[";
    return d === q.charCodeAt(o++) ? (e.consume(d), o === q.length ? y : x) : n(d);
  }
  function y(d) {
    return d === null ? n(d) : d === 93 ? (e.consume(d), b) : ae(d) ? (s = y, ye(d)) : (e.consume(d), y);
  }
  function b(d) {
    return d === 93 ? (e.consume(d), _) : y(d);
  }
  function _(d) {
    return d === 62 ? pe(d) : d === 93 ? (e.consume(d), _) : y(d);
  }
  function M(d) {
    return d === null || d === 62 ? pe(d) : ae(d) ? (s = M, ye(d)) : (e.consume(d), M);
  }
  function O(d) {
    return d === null ? n(d) : d === 63 ? (e.consume(d), P) : ae(d) ? (s = O, ye(d)) : (e.consume(d), O);
  }
  function P(d) {
    return d === 62 ? pe(d) : O(d);
  }
  function N(d) {
    return Ot(d) ? (e.consume(d), C) : n(d);
  }
  function C(d) {
    return d === 45 || Ct(d) ? (e.consume(d), C) : I(d);
  }
  function I(d) {
    return ae(d) ? (s = I, ye(d)) : Se(d) ? (e.consume(d), I) : pe(d);
  }
  function D(d) {
    return d === 45 || Ct(d) ? (e.consume(d), D) : d === 47 || d === 62 || nt(d) ? z(d) : n(d);
  }
  function z(d) {
    return d === 47 ? (e.consume(d), pe) : d === 58 || d === 95 || Ot(d) ? (e.consume(d), ie) : ae(d) ? (s = z, ye(d)) : Se(d) ? (e.consume(d), z) : pe(d);
  }
  function ie(d) {
    return d === 45 || d === 46 || d === 58 || d === 95 || Ct(d) ? (e.consume(d), ie) : v(d);
  }
  function v(d) {
    return d === 61 ? (e.consume(d), U) : ae(d) ? (s = v, ye(d)) : Se(d) ? (e.consume(d), v) : z(d);
  }
  function U(d) {
    return d === null || d === 60 || d === 61 || d === 62 || d === 96 ? n(d) : d === 34 || d === 39 ? (e.consume(d), i = d, L) : ae(d) ? (s = U, ye(d)) : Se(d) ? (e.consume(d), U) : (e.consume(d), Q);
  }
  function L(d) {
    return d === i ? (e.consume(d), i = void 0, te) : d === null ? n(d) : ae(d) ? (s = L, ye(d)) : (e.consume(d), L);
  }
  function Q(d) {
    return d === null || d === 34 || d === 39 || d === 60 || d === 61 || d === 96 ? n(d) : d === 47 || d === 62 || nt(d) ? z(d) : (e.consume(d), Q);
  }
  function te(d) {
    return d === 47 || d === 62 || nt(d) ? z(d) : n(d);
  }
  function pe(d) {
    return d === 62 ? (e.consume(d), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(d);
  }
  function ye(d) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), Ae;
  }
  function Ae(d) {
    return Se(d) ? we(
      e,
      ke,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(d) : ke(d);
  }
  function ke(d) {
    return e.enter("htmlTextData"), s(d);
  }
}
const _i = {
  name: "labelEnd",
  tokenize: U9,
  resolveTo: $9,
  resolveAll: B9
}, D9 = {
  tokenize: G9
}, H9 = {
  tokenize: j9
}, F9 = {
  tokenize: z9
};
function B9(e) {
  let t = -1;
  for (; ++t < e.length; ) {
    const n = e[t][1];
    (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (e.splice(t + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", t++);
  }
  return e;
}
function $9(e, t) {
  let n = e.length, r = 0, i, o, s, l;
  for (; n--; )
    if (i = e[n][1], o) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (s) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (o = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else
      i.type === "labelEnd" && (s = n);
  const c = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, u = {
    type: "label",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[s][1].end)
  }, f = {
    type: "labelText",
    start: Object.assign({}, e[o + r + 2][1].end),
    end: Object.assign({}, e[s - 2][1].start)
  };
  return l = [
    ["enter", c, t],
    ["enter", u, t]
  ], l = ft(l, e.slice(o + 1, o + r + 3)), l = ft(l, [["enter", f, t]]), l = ft(
    l,
    Ei(
      t.parser.constructs.insideSpan.null,
      e.slice(o + r + 4, s - 3),
      t
    )
  ), l = ft(l, [
    ["exit", f, t],
    e[s - 2],
    e[s - 1],
    ["exit", u, t]
  ]), l = ft(l, e.slice(s + 1)), l = ft(l, [["exit", c, t]]), Lt(e, o, e.length, l), e;
}
function U9(e, t, n) {
  const r = this;
  let i = r.events.length, o, s;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      o = r.events[i][1];
      break;
    }
  return l;
  function l(E) {
    return o ? o._inactive ? m(E) : (s = r.parser.defined.includes(
      bn(
        r.sliceSerialize({
          start: o.end,
          end: r.now()
        })
      )
    ), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(E), e.exit("labelMarker"), e.exit("labelEnd"), c) : n(E);
  }
  function c(E) {
    return E === 40 ? e.attempt(
      D9,
      f,
      s ? f : m
    )(E) : E === 91 ? e.attempt(
      H9,
      f,
      s ? u : m
    )(E) : s ? f(E) : m(E);
  }
  function u(E) {
    return e.attempt(
      F9,
      f,
      m
    )(E);
  }
  function f(E) {
    return t(E);
  }
  function m(E) {
    return o._balanced = !0, n(E);
  }
}
function G9(e, t, n) {
  return r;
  function r(m) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(m), e.exit("resourceMarker"), i;
  }
  function i(m) {
    return nt(m) ? Xn(e, o)(m) : o(m);
  }
  function o(m) {
    return m === 41 ? f(m) : wl(
      e,
      s,
      l,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(m);
  }
  function s(m) {
    return nt(m) ? Xn(e, c)(m) : f(m);
  }
  function l(m) {
    return n(m);
  }
  function c(m) {
    return m === 34 || m === 39 || m === 40 ? Ml(
      e,
      u,
      n,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(m) : f(m);
  }
  function u(m) {
    return nt(m) ? Xn(e, f)(m) : f(m);
  }
  function f(m) {
    return m === 41 ? (e.enter("resourceMarker"), e.consume(m), e.exit("resourceMarker"), e.exit("resource"), t) : n(m);
  }
}
function j9(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return Ll.call(
      r,
      e,
      o,
      s,
      "reference",
      "referenceMarker",
      "referenceString"
    )(l);
  }
  function o(l) {
    return r.parser.defined.includes(
      bn(
        r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
      )
    ) ? t(l) : n(l);
  }
  function s(l) {
    return n(l);
  }
}
function z9(e, t, n) {
  return r;
  function r(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), i;
  }
  function i(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), t) : n(o);
  }
}
const K9 = {
  name: "labelStartImage",
  tokenize: q9,
  resolveAll: _i.resolveAll
};
function q9(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : n(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(l) : t(l);
  }
}
const Y9 = {
  name: "labelStartLink",
  tokenize: V9,
  resolveAll: _i.resolveAll
};
function V9(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const xr = {
  name: "lineEnding",
  tokenize: W9
};
function W9(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), we(e, t, "linePrefix");
  }
}
const M1 = {
  name: "thematicBreak",
  tokenize: X9
};
function X9(e, t, n) {
  let r = 0, i;
  return o;
  function o(u) {
    return e.enter("thematicBreak"), s(u);
  }
  function s(u) {
    return i = u, l(u);
  }
  function l(u) {
    return u === i ? (e.enter("thematicBreakSequence"), c(u)) : r >= 3 && (u === null || ae(u)) ? (e.exit("thematicBreak"), t(u)) : n(u);
  }
  function c(u) {
    return u === i ? (e.consume(u), r++, c) : (e.exit("thematicBreakSequence"), Se(u) ? we(e, l, "whitespace")(u) : l(u));
  }
}
const Ze = {
  name: "list",
  tokenize: Z9,
  continuation: {
    tokenize: ef
  },
  exit: nf
}, Q9 = {
  tokenize: rf,
  partial: !0
}, J9 = {
  tokenize: tf,
  partial: !0
};
function Z9(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let o = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, s = 0;
  return l;
  function l(h) {
    const x = r.containerState.type || (h === 42 || h === 43 || h === 45 ? "listUnordered" : "listOrdered");
    if (x === "listUnordered" ? !r.containerState.marker || h === r.containerState.marker : ni(h)) {
      if (r.containerState.type || (r.containerState.type = x, e.enter(x, {
        _container: !0
      })), x === "listUnordered")
        return e.enter("listItemPrefix"), h === 42 || h === 45 ? e.check(M1, n, u)(h) : u(h);
      if (!r.interrupt || h === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), c(h);
    }
    return n(h);
  }
  function c(h) {
    return ni(h) && ++s < 10 ? (e.consume(h), c) : (!r.interrupt || s < 2) && (r.containerState.marker ? h === r.containerState.marker : h === 41 || h === 46) ? (e.exit("listItemValue"), u(h)) : n(h);
  }
  function u(h) {
    return e.enter("listItemMarker"), e.consume(h), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || h, e.check(
      X1,
      // Can’t be empty when interrupting.
      r.interrupt ? n : f,
      e.attempt(
        Q9,
        E,
        m
      )
    );
  }
  function f(h) {
    return r.containerState.initialBlankLine = !0, o++, E(h);
  }
  function m(h) {
    return Se(h) ? (e.enter("listItemPrefixWhitespace"), e.consume(h), e.exit("listItemPrefixWhitespace"), E) : n(h);
  }
  function E(h) {
    return r.containerState.size = o + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(h);
  }
}
function ef(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(X1, i, o);
  function i(l) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, we(
      e,
      t,
      "listItemIndent",
      r.containerState.size + 1
    )(l);
  }
  function o(l) {
    return r.containerState.furtherBlankLines || !Se(l) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, s(l)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(J9, t, s)(l));
  }
  function s(l) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, we(
      e,
      e.attempt(Ze, t, n),
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(l);
  }
}
function tf(e, t, n) {
  const r = this;
  return we(
    e,
    i,
    "listItemIndent",
    r.containerState.size + 1
  );
  function i(o) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === r.containerState.size ? t(o) : n(o);
  }
}
function nf(e) {
  e.exit(this.containerState.type);
}
function rf(e, t, n) {
  const r = this;
  return we(
    e,
    i,
    "listItemPrefixWhitespace",
    r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1
  );
  function i(o) {
    const s = r.events[r.events.length - 1];
    return !Se(o) && s && s[1].type === "listItemPrefixWhitespace" ? t(o) : n(o);
  }
}
const _o = {
  name: "setextUnderline",
  tokenize: sf,
  resolveTo: of
};
function of(e, t) {
  let n = e.length, r, i, o;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !o && e[n][1].type === "definition" && (o = n);
  const s = {
    type: "setextHeading",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[i][1].type = "setextHeadingText", o ? (e.splice(i, 0, ["enter", s, t]), e.splice(o + 1, 0, ["exit", e[r][1], t]), e[r][1].end = Object.assign({}, e[o][1].end)) : e[r][1] = s, e.push(["exit", s, t]), e;
}
function sf(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(u) {
    let f = r.events.length, m;
    for (; f--; )
      if (r.events[f][1].type !== "lineEnding" && r.events[f][1].type !== "linePrefix" && r.events[f][1].type !== "content") {
        m = r.events[f][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || m) ? (e.enter("setextHeadingLine"), i = u, s(u)) : n(u);
  }
  function s(u) {
    return e.enter("setextHeadingLineSequence"), l(u);
  }
  function l(u) {
    return u === i ? (e.consume(u), l) : (e.exit("setextHeadingLineSequence"), Se(u) ? we(e, c, "lineSuffix")(u) : c(u));
  }
  function c(u) {
    return u === null || ae(u) ? (e.exit("setextHeadingLine"), t(u)) : n(u);
  }
}
const lf = {
  tokenize: af
};
function af(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    X1,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      i,
      we(
        e,
        e.attempt(
          this.parser.constructs.flow,
          i,
          e.attempt(h9, i)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const uf = {
  resolveAll: vl()
}, cf = Pl("string"), ff = Pl("text");
function Pl(e) {
  return {
    tokenize: t,
    resolveAll: vl(
      e === "text" ? hf : void 0
    )
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], o = n.attempt(i, s, l);
    return s;
    function s(f) {
      return u(f) ? o(f) : l(f);
    }
    function l(f) {
      if (f === null) {
        n.consume(f);
        return;
      }
      return n.enter("data"), n.consume(f), c;
    }
    function c(f) {
      return u(f) ? (n.exit("data"), o(f)) : (n.consume(f), c);
    }
    function u(f) {
      if (f === null)
        return !0;
      const m = i[f];
      let E = -1;
      if (m)
        for (; ++E < m.length; ) {
          const h = m[E];
          if (!h.previous || h.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function vl(e) {
  return t;
  function t(n, r) {
    let i = -1, o;
    for (; ++i <= n.length; )
      o === void 0 ? n[i] && n[i][1].type === "data" && (o = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== o + 2 && (n[o][1].end = n[i - 1][1].end, n.splice(o + 2, i - o - 2), i = o + 2), o = void 0);
    return e ? e(n, r) : n;
  }
}
function hf(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let o = i.length, s = -1, l = 0, c;
      for (; o--; ) {
        const u = i[o];
        if (typeof u == "string") {
          for (s = u.length; u.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s)
            break;
          s = -1;
        } else if (u === -2)
          c = !0, l++;
        else if (u !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const u = {
          type: n === e.length || c || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - l,
            offset: r.end.offset - l,
            _index: r.start._index + o,
            _bufferIndex: o ? s : r.start._bufferIndex + s
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, u.start), r.start.offset === r.end.offset ? Object.assign(r, u) : (e.splice(
          n,
          0,
          ["enter", u, t],
          ["exit", u, t]
        ), n += 2);
      }
      n++;
    }
  return e;
}
function df(e, t, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const i = {}, o = [];
  let s = [], l = [];
  const c = {
    consume: M,
    enter: O,
    exit: P,
    attempt: I(N),
    check: I(C),
    interrupt: I(C, {
      interrupt: !0
    })
  }, u = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: h,
    sliceSerialize: E,
    now: x,
    defineSkip: y,
    write: m
  };
  let f = t.tokenize.call(u, c);
  return t.resolveAll && o.push(t), u;
  function m(v) {
    return s = ft(s, v), b(), s[s.length - 1] !== null ? [] : (D(t, 0), u.events = Ei(o, u.events, u), u.events);
  }
  function E(v, U) {
    return pf(h(v), U);
  }
  function h(v) {
    return mf(s, v);
  }
  function x() {
    const { line: v, column: U, offset: L, _index: Q, _bufferIndex: te } = r;
    return {
      line: v,
      column: U,
      offset: L,
      _index: Q,
      _bufferIndex: te
    };
  }
  function y(v) {
    i[v.line] = v.column, ie();
  }
  function b() {
    let v;
    for (; r._index < s.length; ) {
      const U = s[r._index];
      if (typeof U == "string")
        for (v = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === v && r._bufferIndex < U.length; )
          _(U.charCodeAt(r._bufferIndex));
      else
        _(U);
    }
  }
  function _(v) {
    f = f(v);
  }
  function M(v) {
    ae(v) ? (r.line++, r.column = 1, r.offset += v === -3 ? 2 : 1, ie()) : v !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === s[r._index].length && (r._bufferIndex = -1, r._index++)), u.previous = v;
  }
  function O(v, U) {
    const L = U || {};
    return L.type = v, L.start = x(), u.events.push(["enter", L, u]), l.push(L), L;
  }
  function P(v) {
    const U = l.pop();
    return U.end = x(), u.events.push(["exit", U, u]), U;
  }
  function N(v, U) {
    D(v, U.from);
  }
  function C(v, U) {
    U.restore();
  }
  function I(v, U) {
    return L;
    function L(Q, te, pe) {
      let ye, Ae, ke, d;
      return Array.isArray(Q) ? oe(Q) : "tokenize" in Q ? (
        // @ts-expect-error Looks like a construct.
        oe([Q])
      ) : q(Q);
      function q(J) {
        return Z;
        function Z(le) {
          const ue = le !== null && J[le], ce = le !== null && J.null, W = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(ue) ? ue : ue ? [ue] : [],
            ...Array.isArray(ce) ? ce : ce ? [ce] : []
          ];
          return oe(W)(le);
        }
      }
      function oe(J) {
        return ye = J, Ae = 0, J.length === 0 ? pe : p(J[Ae]);
      }
      function p(J) {
        return Z;
        function Z(le) {
          return d = z(), ke = J, J.partial || (u.currentConstruct = J), J.name && u.parser.constructs.disable.null.includes(J.name) ? se() : J.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            U ? Object.assign(Object.create(u), U) : u,
            c,
            ne,
            se
          )(le);
        }
      }
      function ne(J) {
        return v(ke, d), te;
      }
      function se(J) {
        return d.restore(), ++Ae < ye.length ? p(ye[Ae]) : pe;
      }
    }
  }
  function D(v, U) {
    v.resolveAll && !o.includes(v) && o.push(v), v.resolve && Lt(
      u.events,
      U,
      u.events.length - U,
      v.resolve(u.events.slice(U), u)
    ), v.resolveTo && (u.events = v.resolveTo(u.events, u));
  }
  function z() {
    const v = x(), U = u.previous, L = u.currentConstruct, Q = u.events.length, te = Array.from(l);
    return {
      restore: pe,
      from: Q
    };
    function pe() {
      r = v, u.previous = U, u.currentConstruct = L, u.events.length = Q, l = te, ie();
    }
  }
  function ie() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function mf(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, o = t.end._bufferIndex;
  let s;
  if (n === i)
    s = [e[n].slice(r, o)];
  else {
    if (s = e.slice(n, i), r > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(r) : s.shift();
    }
    o > 0 && s.push(e[i].slice(0, o));
  }
  return s;
}
function pf(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const o = e[n];
    let s;
    if (typeof o == "string")
      s = o;
    else
      switch (o) {
        case -5: {
          s = "\r";
          break;
        }
        case -4: {
          s = `
`;
          break;
        }
        case -3: {
          s = `\r
`;
          break;
        }
        case -2: {
          s = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && i)
            continue;
          s = " ";
          break;
        }
        default:
          s = String.fromCharCode(o);
      }
    i = o === -2, r.push(s);
  }
  return r.join("");
}
const Tf = {
  42: Ze,
  43: Ze,
  45: Ze,
  48: Ze,
  49: Ze,
  50: Ze,
  51: Ze,
  52: Ze,
  53: Ze,
  54: Ze,
  55: Ze,
  56: Ze,
  57: Ze,
  62: Ol
}, gf = {
  91: g9
}, Ef = {
  [-2]: Sr,
  [-1]: Sr,
  32: Sr
}, Af = {
  35: S9,
  42: M1,
  45: [_o, M1],
  60: O9,
  61: _o,
  95: M1,
  96: Eo,
  126: Eo
}, _f = {
  38: Rl,
  92: Il
}, yf = {
  [-5]: xr,
  [-4]: xr,
  [-3]: xr,
  33: K9,
  38: Rl,
  42: ri,
  60: [Y0, P9],
  91: Y9,
  92: [y9, Il],
  93: _i,
  95: ri,
  96: l9
}, Cf = {
  null: [ri, uf]
}, Sf = {
  null: [42, 95]
}, xf = {
  null: []
}, Nf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: Sf,
  contentInitial: gf,
  disable: xf,
  document: Tf,
  flow: Af,
  flowInitial: Ef,
  insideSpan: Cf,
  string: _f,
  text: yf
}, Symbol.toStringTag, { value: "Module" }));
function bf(e) {
  const n = (
    /** @type {FullNormalizedExtension} */
    w0([Nf, ...(e || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: n,
    content: i($0),
    document: i(G0),
    flow: i(lf),
    string: i(cf),
    text: i(ff)
  };
  return r;
  function i(o) {
    return s;
    function s(l) {
      return df(r, o, l);
    }
  }
}
const yo = /[\0\t\n\r]/g;
function Of() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(o, s, l) {
    const c = [];
    let u, f, m, E, h;
    for (o = t + o.toString(s), m = 0, t = "", n && (o.charCodeAt(0) === 65279 && m++, n = void 0); m < o.length; ) {
      if (yo.lastIndex = m, u = yo.exec(o), E = u && u.index !== void 0 ? u.index : o.length, h = o.charCodeAt(E), !u) {
        t = o.slice(m);
        break;
      }
      if (h === 10 && m === E && r)
        c.push(-3), r = void 0;
      else
        switch (r && (c.push(-5), r = void 0), m < E && (c.push(o.slice(m, E)), e += E - m), h) {
          case 0: {
            c.push(65533), e++;
            break;
          }
          case 9: {
            for (f = Math.ceil(e / 4) * 4, c.push(-2); e++ < f; )
              c.push(-1);
            break;
          }
          case 10: {
            c.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      m = E + 1;
    }
    return l && (r && c.push(-5), t && c.push(t), c.push(null)), c;
  }
}
function If(e) {
  for (; !kl(e); )
    ;
  return e;
}
function Dl(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || (n & 65535) === 65535 || (n & 65535) === 65534 || // Out of range
    n > 1114111 ? "�" : String.fromCharCode(n)
  );
}
const Rf = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function kf(e) {
  return e.replace(Rf, wf);
}
function wf(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), o = i === 120 || i === 88;
    return Dl(n.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Ai(n) || e;
}
const Hl = {}.hasOwnProperty, Lf = (
  /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */
  /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */
  function(e, t, n) {
    return typeof t != "string" && (n = t, t = void 0), Mf(n)(
      If(
        bf(n).document().write(Of()(e, t, !0))
      )
    );
  }
);
function Mf(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: l(h1),
      autolinkProtocol: v,
      autolinkEmail: v,
      atxHeading: l(vn),
      blockQuote: l(W),
      characterEscape: v,
      characterReference: v,
      codeFenced: l(K),
      codeFencedFenceInfo: c,
      codeFencedFenceMeta: c,
      codeIndented: l(K, c),
      codeText: l(je, c),
      codeTextData: v,
      data: v,
      codeFlowValue: v,
      definition: l(lt),
      definitionDestinationString: c,
      definitionLabelString: c,
      definitionTitleString: c,
      emphasis: l(rn),
      hardBreakEscape: l(gn),
      hardBreakTrailing: l(gn),
      htmlFlow: l(Dn, c),
      htmlFlowData: v,
      htmlText: l(Dn, c),
      htmlTextData: v,
      image: l(ur),
      label: c,
      link: l(h1),
      listItem: l(cr),
      listItemValue: x,
      listOrdered: l(d1, h),
      listUnordered: l(d1),
      paragraph: l(fr),
      reference: se,
      referenceString: c,
      resourceDestinationString: c,
      resourceTitleString: c,
      setextHeading: l(vn),
      strong: l(hr),
      thematicBreak: l(mr)
    },
    exit: {
      atxHeading: f(),
      atxHeadingSequence: I,
      autolink: f(),
      autolinkEmail: ce,
      autolinkProtocol: ue,
      blockQuote: f(),
      characterEscapeValue: U,
      characterReferenceMarkerHexadecimal: Z,
      characterReferenceMarkerNumeric: Z,
      characterReferenceValue: le,
      codeFenced: f(M),
      codeFencedFence: _,
      codeFencedFenceInfo: y,
      codeFencedFenceMeta: b,
      codeFlowValue: U,
      codeIndented: f(O),
      codeText: f(ye),
      codeTextData: U,
      data: U,
      definition: f(),
      definitionDestinationString: C,
      definitionLabelString: P,
      definitionTitleString: N,
      emphasis: f(),
      hardBreakEscape: f(Q),
      hardBreakTrailing: f(Q),
      htmlFlow: f(te),
      htmlFlowData: U,
      htmlText: f(pe),
      htmlTextData: U,
      image: f(ke),
      label: q,
      labelText: d,
      lineEnding: L,
      link: f(Ae),
      listItem: f(),
      listOrdered: f(),
      listUnordered: f(),
      paragraph: f(),
      referenceString: J,
      resourceDestinationString: oe,
      resourceTitleString: p,
      resource: ne,
      setextHeading: f(ie),
      setextHeadingLineSequence: z,
      setextHeadingText: D,
      strong: f(),
      thematicBreak: f()
    }
  };
  Fl(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(S) {
    let w = {
      type: "root",
      children: []
    };
    const V = {
      stack: [w],
      tokenStack: [],
      config: t,
      enter: u,
      exit: m,
      buffer: c,
      resume: E,
      setData: o,
      getData: s
    }, fe = [];
    let Ce = -1;
    for (; ++Ce < S.length; )
      if (S[Ce][1].type === "listOrdered" || S[Ce][1].type === "listUnordered")
        if (S[Ce][0] === "enter")
          fe.push(Ce);
        else {
          const Et = fe.pop();
          Ce = i(S, Et, Ce);
        }
    for (Ce = -1; ++Ce < S.length; ) {
      const Et = t[S[Ce][0]];
      Hl.call(Et, S[Ce][1].type) && Et[S[Ce][1].type].call(
        Object.assign(
          {
            sliceSerialize: S[Ce][2].sliceSerialize
          },
          V
        ),
        S[Ce][1]
      );
    }
    if (V.tokenStack.length > 0) {
      const Et = V.tokenStack[V.tokenStack.length - 1];
      (Et[1] || Co).call(V, void 0, Et[0]);
    }
    for (w.position = {
      start: Kt(
        S.length > 0 ? S[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: Kt(
        S.length > 0 ? S[S.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, Ce = -1; ++Ce < t.transforms.length; )
      w = t.transforms[Ce](w) || w;
    return w;
  }
  function i(S, w, V) {
    let fe = w - 1, Ce = -1, Et = !1, zt, Mt, Hn, Fn;
    for (; ++fe <= V; ) {
      const He = S[fe];
      if (He[1].type === "listUnordered" || He[1].type === "listOrdered" || He[1].type === "blockQuote" ? (He[0] === "enter" ? Ce++ : Ce--, Fn = void 0) : He[1].type === "lineEndingBlank" ? He[0] === "enter" && (zt && !Fn && !Ce && !Hn && (Hn = fe), Fn = void 0) : He[1].type === "linePrefix" || He[1].type === "listItemValue" || He[1].type === "listItemMarker" || He[1].type === "listItemPrefix" || He[1].type === "listItemPrefixWhitespace" || (Fn = void 0), !Ce && He[0] === "enter" && He[1].type === "listItemPrefix" || Ce === -1 && He[0] === "exit" && (He[1].type === "listUnordered" || He[1].type === "listOrdered")) {
        if (zt) {
          let pr = fe;
          for (Mt = void 0; pr--; ) {
            const Pt = S[pr];
            if (Pt[1].type === "lineEnding" || Pt[1].type === "lineEndingBlank") {
              if (Pt[0] === "exit")
                continue;
              Mt && (S[Mt][1].type = "lineEndingBlank", Et = !0), Pt[1].type = "lineEnding", Mt = pr;
            } else if (!(Pt[1].type === "linePrefix" || Pt[1].type === "blockQuotePrefix" || Pt[1].type === "blockQuotePrefixWhitespace" || Pt[1].type === "blockQuoteMarker" || Pt[1].type === "listItemIndent"))
              break;
          }
          Hn && (!Mt || Hn < Mt) && (zt._spread = !0), zt.end = Object.assign(
            {},
            Mt ? S[Mt][1].start : He[1].end
          ), S.splice(Mt || fe, 0, ["exit", zt, He[2]]), fe++, V++;
        }
        He[1].type === "listItemPrefix" && (zt = {
          type: "listItem",
          _spread: !1,
          start: Object.assign({}, He[1].start),
          // @ts-expect-error: we’ll add `end` in a second.
          end: void 0
        }, S.splice(fe, 0, ["enter", zt, He[2]]), fe++, V++, Hn = void 0, Fn = !0);
      }
    }
    return S[w][1]._spread = Et, V;
  }
  function o(S, w) {
    n[S] = w;
  }
  function s(S) {
    return n[S];
  }
  function l(S, w) {
    return V;
    function V(fe) {
      u.call(this, S(fe), fe), w && w.call(this, fe);
    }
  }
  function c() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function u(S, w, V) {
    return this.stack[this.stack.length - 1].children.push(S), this.stack.push(S), this.tokenStack.push([w, V]), S.position = {
      start: Kt(w.start)
    }, S;
  }
  function f(S) {
    return w;
    function w(V) {
      S && S.call(this, V), m.call(this, V);
    }
  }
  function m(S, w) {
    const V = this.stack.pop(), fe = this.tokenStack.pop();
    if (fe)
      fe[0].type !== S.type && (w ? w.call(this, S, fe[0]) : (fe[1] || Co).call(this, S, fe[0]));
    else
      throw new Error(
        "Cannot close `" + S.type + "` (" + Wn({
          start: S.start,
          end: S.end
        }) + "): it’s not open"
      );
    return V.position.end = Kt(S.end), V;
  }
  function E() {
    return R0(this.stack.pop());
  }
  function h() {
    o("expectingFirstListItemValue", !0);
  }
  function x(S) {
    if (s("expectingFirstListItemValue")) {
      const w = this.stack[this.stack.length - 2];
      w.start = Number.parseInt(this.sliceSerialize(S), 10), o("expectingFirstListItemValue");
    }
  }
  function y() {
    const S = this.resume(), w = this.stack[this.stack.length - 1];
    w.lang = S;
  }
  function b() {
    const S = this.resume(), w = this.stack[this.stack.length - 1];
    w.meta = S;
  }
  function _() {
    s("flowCodeInside") || (this.buffer(), o("flowCodeInside", !0));
  }
  function M() {
    const S = this.resume(), w = this.stack[this.stack.length - 1];
    w.value = S.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), o("flowCodeInside");
  }
  function O() {
    const S = this.resume(), w = this.stack[this.stack.length - 1];
    w.value = S.replace(/(\r?\n|\r)$/g, "");
  }
  function P(S) {
    const w = this.resume(), V = this.stack[this.stack.length - 1];
    V.label = w, V.identifier = bn(
      this.sliceSerialize(S)
    ).toLowerCase();
  }
  function N() {
    const S = this.resume(), w = this.stack[this.stack.length - 1];
    w.title = S;
  }
  function C() {
    const S = this.resume(), w = this.stack[this.stack.length - 1];
    w.url = S;
  }
  function I(S) {
    const w = this.stack[this.stack.length - 1];
    if (!w.depth) {
      const V = this.sliceSerialize(S).length;
      w.depth = V;
    }
  }
  function D() {
    o("setextHeadingSlurpLineEnding", !0);
  }
  function z(S) {
    const w = this.stack[this.stack.length - 1];
    w.depth = this.sliceSerialize(S).charCodeAt(0) === 61 ? 1 : 2;
  }
  function ie() {
    o("setextHeadingSlurpLineEnding");
  }
  function v(S) {
    const w = this.stack[this.stack.length - 1];
    let V = w.children[w.children.length - 1];
    (!V || V.type !== "text") && (V = dr(), V.position = {
      start: Kt(S.start)
    }, w.children.push(V)), this.stack.push(V);
  }
  function U(S) {
    const w = this.stack.pop();
    w.value += this.sliceSerialize(S), w.position.end = Kt(S.end);
  }
  function L(S) {
    const w = this.stack[this.stack.length - 1];
    if (s("atHardBreak")) {
      const V = w.children[w.children.length - 1];
      V.position.end = Kt(S.end), o("atHardBreak");
      return;
    }
    !s("setextHeadingSlurpLineEnding") && t.canContainEols.includes(w.type) && (v.call(this, S), U.call(this, S));
  }
  function Q() {
    o("atHardBreak", !0);
  }
  function te() {
    const S = this.resume(), w = this.stack[this.stack.length - 1];
    w.value = S;
  }
  function pe() {
    const S = this.resume(), w = this.stack[this.stack.length - 1];
    w.value = S;
  }
  function ye() {
    const S = this.resume(), w = this.stack[this.stack.length - 1];
    w.value = S;
  }
  function Ae() {
    const S = this.stack[this.stack.length - 1];
    if (s("inReference")) {
      const w = s("referenceType") || "shortcut";
      S.type += "Reference", S.referenceType = w, delete S.url, delete S.title;
    } else
      delete S.identifier, delete S.label;
    o("referenceType");
  }
  function ke() {
    const S = this.stack[this.stack.length - 1];
    if (s("inReference")) {
      const w = s("referenceType") || "shortcut";
      S.type += "Reference", S.referenceType = w, delete S.url, delete S.title;
    } else
      delete S.identifier, delete S.label;
    o("referenceType");
  }
  function d(S) {
    const w = this.sliceSerialize(S), V = this.stack[this.stack.length - 2];
    V.label = kf(w), V.identifier = bn(w).toLowerCase();
  }
  function q() {
    const S = this.stack[this.stack.length - 1], w = this.resume(), V = this.stack[this.stack.length - 1];
    if (o("inReference", !0), V.type === "link") {
      const fe = S.children;
      V.children = fe;
    } else
      V.alt = w;
  }
  function oe() {
    const S = this.resume(), w = this.stack[this.stack.length - 1];
    w.url = S;
  }
  function p() {
    const S = this.resume(), w = this.stack[this.stack.length - 1];
    w.title = S;
  }
  function ne() {
    o("inReference");
  }
  function se() {
    o("referenceType", "collapsed");
  }
  function J(S) {
    const w = this.resume(), V = this.stack[this.stack.length - 1];
    V.label = w, V.identifier = bn(
      this.sliceSerialize(S)
    ).toLowerCase(), o("referenceType", "full");
  }
  function Z(S) {
    o("characterReferenceType", S.type);
  }
  function le(S) {
    const w = this.sliceSerialize(S), V = s("characterReferenceType");
    let fe;
    V ? (fe = Dl(
      w,
      V === "characterReferenceMarkerNumeric" ? 10 : 16
    ), o("characterReferenceType")) : fe = Ai(w);
    const Ce = this.stack.pop();
    Ce.value += fe, Ce.position.end = Kt(S.end);
  }
  function ue(S) {
    U.call(this, S);
    const w = this.stack[this.stack.length - 1];
    w.url = this.sliceSerialize(S);
  }
  function ce(S) {
    U.call(this, S);
    const w = this.stack[this.stack.length - 1];
    w.url = "mailto:" + this.sliceSerialize(S);
  }
  function W() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function K() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function je() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function lt() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function rn() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function vn() {
    return {
      type: "heading",
      depth: void 0,
      children: []
    };
  }
  function gn() {
    return {
      type: "break"
    };
  }
  function Dn() {
    return {
      type: "html",
      value: ""
    };
  }
  function ur() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function h1() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function d1(S) {
    return {
      type: "list",
      ordered: S.type === "listOrdered",
      start: null,
      spread: S._spread,
      children: []
    };
  }
  function cr(S) {
    return {
      type: "listItem",
      spread: S._spread,
      checked: null,
      children: []
    };
  }
  function fr() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function hr() {
    return {
      type: "strong",
      children: []
    };
  }
  function dr() {
    return {
      type: "text",
      value: ""
    };
  }
  function mr() {
    return {
      type: "thematicBreak"
    };
  }
}
function Kt(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Fl(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? Fl(e, r) : Pf(e, r);
  }
}
function Pf(e, t) {
  let n;
  for (n in t)
    if (Hl.call(t, n)) {
      if (n === "canContainEols") {
        const r = t[n];
        r && e[n].push(...r);
      } else if (n === "transforms") {
        const r = t[n];
        r && e[n].push(...r);
      } else if (n === "enter" || n === "exit") {
        const r = t[n];
        r && Object.assign(e[n], r);
      }
    }
}
function Co(e, t) {
  throw e ? new Error(
    "Cannot close `" + e.type + "` (" + Wn({
      start: e.start,
      end: e.end
    }) + "): a different token (`" + t.type + "`, " + Wn({
      start: t.start,
      end: t.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + t.type + "`, " + Wn({
      start: t.start,
      end: t.end
    }) + ") is still open"
  );
}
function vf(e) {
  Object.assign(this, { Parser: (n) => {
    const r = (
      /** @type {Options} */
      this.data("settings")
    );
    return Lf(
      n,
      Object.assign({}, r, e, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: this.data("micromarkExtensions") || [],
        mdastExtensions: this.data("fromMarkdownExtensions") || []
      })
    );
  } });
}
const Ye = (
  /**
   * @type {(
   *   (<T extends string>(type: T) => {type: T}) &
   *   (<T extends string, P extends Props>(type: T, props: P) => {type: T} & P) &
   *   (<T extends string>(type: T, value: string) => {type: T, value: string}) &
   *   (<T extends string, P extends Props>(type: T, props: P, value: string) => {type: T, value: string} & P) &
   *   (<T extends string, C extends Array<Node>>(type: T, children: C) => {type: T, children: C}) &
   *   (<T extends string, P extends Props, C extends Array<Node>>(type: T, props: P, children: C) => {type: T, children: C} & P)
   * )}
   */
  /**
   * @param {string} type
   * @param {Props | ChildrenOrValue | null | undefined} [props]
   * @param {ChildrenOrValue | null | undefined} [value]
   * @returns {Node}
   */
  function(e, t, n) {
    const r = { type: String(e) };
    return n == null && (typeof t == "string" || Array.isArray(t)) ? n = t : Object.assign(r, t), Array.isArray(n) ? r.children = n : n != null && (r.value = String(n)), r;
  }
), P1 = {}.hasOwnProperty;
function Df(e, t) {
  const n = t.data || {};
  return "value" in t && !(P1.call(n, "hName") || P1.call(n, "hProperties") || P1.call(n, "hChildren")) ? e.augment(t, Ye("text", t.value)) : e(t, "div", Je(e, t));
}
function Bl(e, t, n) {
  const r = t && t.type;
  let i;
  if (!r)
    throw new Error("Expected node, got `" + t + "`");
  return P1.call(e.handlers, r) ? i = e.handlers[r] : e.passThrough && e.passThrough.includes(r) ? i = Hf : i = e.unknownHandler, (typeof i == "function" ? i : Df)(e, t, n);
}
function Hf(e, t) {
  return "children" in t ? { ...t, children: Je(e, t) } : t;
}
function Je(e, t) {
  const n = [];
  if ("children" in t) {
    const r = t.children;
    let i = -1;
    for (; ++i < r.length; ) {
      const o = Bl(e, r[i], t);
      if (o) {
        if (i && r[i - 1].type === "break" && (!Array.isArray(o) && o.type === "text" && (o.value = o.value.replace(/^\s+/, "")), !Array.isArray(o) && o.type === "element")) {
          const s = o.children[0];
          s && s.type === "text" && (s.value = s.value.replace(/^\s+/, ""));
        }
        Array.isArray(o) ? n.push(...o) : n.push(o);
      }
    }
  }
  return n;
}
const $l = (
  /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {AssertAnything}
   */
  function(e) {
    if (e == null)
      return Uf;
    if (typeof e == "string")
      return $f(e);
    if (typeof e == "object")
      return Array.isArray(e) ? Ff(e) : Bf(e);
    if (typeof e == "function")
      return Q1(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function Ff(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = $l(e[n]);
  return Q1(r);
  function r(...i) {
    let o = -1;
    for (; ++o < t.length; )
      if (t[o].call(this, ...i))
        return !0;
    return !1;
  }
}
function Bf(e) {
  return Q1(t);
  function t(n) {
    let r;
    for (r in e)
      if (n[r] !== e[r])
        return !1;
    return !0;
  }
}
function $f(e) {
  return Q1(t);
  function t(n) {
    return n && n.type === e;
  }
}
function Q1(e) {
  return t;
  function t(n, ...r) {
    return !!(n && typeof n == "object" && "type" in n && e.call(this, n, ...r));
  }
}
function Uf() {
  return !0;
}
const Gf = !0, So = !1, jf = "skip", zf = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor<Node>} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null);
    const i = $l(t), o = r ? -1 : 1;
    s(e, void 0, [])();
    function s(l, c, u) {
      const f = l && typeof l == "object" ? l : {};
      if (typeof f.type == "string") {
        const E = (
          // `hast`
          typeof f.tagName == "string" ? f.tagName : (
            // `xast`
            typeof f.name == "string" ? f.name : void 0
          )
        );
        Object.defineProperty(m, "name", {
          value: "node (" + (l.type + (E ? "<" + E + ">" : "")) + ")"
        });
      }
      return m;
      function m() {
        let E = [], h, x, y;
        if ((!t || i(l, c, u[u.length - 1] || null)) && (E = Kf(n(l, u)), E[0] === So))
          return E;
        if (l.children && E[0] !== jf)
          for (x = (r ? l.children.length : -1) + o, y = u.concat(l); x > -1 && x < l.children.length; ) {
            if (h = s(l.children[x], x, y)(), h[0] === So)
              return h;
            x = typeof h[1] == "number" ? h[1] : x + o;
          }
        return E;
      }
    }
  }
);
function Kf(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [Gf, e] : [e];
}
const Ul = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null), zf(e, t, i, r);
    function i(o, s) {
      const l = s[s.length - 1];
      return n(
        o,
        l ? l.children.indexOf(o) : null,
        l
      );
    }
  }
), Gl = zl("start"), jl = zl("end");
function zl(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    return {
      // @ts-expect-error: in practice, null is allowed.
      line: r.line || null,
      // @ts-expect-error: in practice, null is allowed.
      column: r.column || null,
      // @ts-expect-error: in practice, null is allowed.
      offset: r.offset > -1 ? r.offset : null
    };
  }
}
function qf(e) {
  return !e || !e.position || !e.position.start || !e.position.start.line || !e.position.start.column || !e.position.end || !e.position.end.line || !e.position.end.column;
}
const xo = {}.hasOwnProperty;
function Yf(e) {
  const t = /* @__PURE__ */ Object.create(null);
  if (!e || !e.type)
    throw new Error("mdast-util-definitions expected node");
  return Ul(e, "definition", (r) => {
    const i = No(r.identifier);
    i && !xo.call(t, i) && (t[i] = r);
  }), n;
  function n(r) {
    const i = No(r);
    return i && xo.call(t, i) ? t[i] : null;
  }
}
function No(e) {
  return String(e || "").toUpperCase();
}
function Kl(e, t) {
  return e(t, "hr");
}
function Zt(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push(Ye("text", `
`)); ++r < e.length; )
    r && n.push(Ye("text", `
`)), n.push(e[r]);
  return t && e.length > 0 && n.push(Ye("text", `
`)), n;
}
function ql(e, t) {
  const n = {}, r = t.ordered ? "ol" : "ul", i = Je(e, t);
  let o = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++o < i.length; ) {
    const s = i[o];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  return e(t, r, n, Zt(i, !0));
}
function Vf(e) {
  const t = e.footnoteById, n = e.footnoteOrder;
  let r = -1;
  const i = [];
  for (; ++r < n.length; ) {
    const o = t[n[r].toUpperCase()];
    if (!o)
      continue;
    const s = String(r + 1), l = [...o.children], c = {
      type: "link",
      url: "#fnref" + s,
      data: { hProperties: { className: ["footnote-back"], role: "doc-backlink" } },
      children: [{ type: "text", value: "↩" }]
    }, u = l[l.length - 1];
    u && u.type === "paragraph" ? u.children.push(c) : l.push(c), i.push({
      type: "listItem",
      data: { hProperties: { id: "fn" + s, role: "doc-endnote" } },
      children: l,
      position: o.position
    });
  }
  return i.length === 0 ? null : e(
    null,
    "section",
    { className: ["footnotes"], role: "doc-endnotes" },
    Zt(
      [
        Kl(e),
        ql(e, { type: "list", ordered: !0, children: i })
      ],
      !0
    )
  );
}
function Wf(e, t) {
  return e(t, "blockquote", Zt(Je(e, t), !0));
}
function Xf(e, t) {
  return [e(t, "br"), Ye("text", `
`)];
}
function Qf(e, t) {
  const n = t.value ? t.value + `
` : "", r = t.lang && t.lang.match(/^[^ \t]+(?=[ \t]|$)/), i = {};
  r && (i.className = ["language-" + r]);
  const o = e(t, "code", i, [Ye("text", n)]);
  return t.meta && (o.data = { meta: t.meta }), e(t.position, "pre", [o]);
}
function Jf(e, t) {
  return e(t, "del", Je(e, t));
}
function Zf(e, t) {
  return e(t, "em", Je(e, t));
}
function Yl(e, t) {
  const n = e.footnoteOrder, r = String(t.identifier), i = n.indexOf(r), o = String(
    i === -1 ? n.push(r) : i + 1
  );
  return e(
    t,
    "a",
    {
      href: "#fn" + o,
      className: ["footnote-ref"],
      id: "fnref" + o,
      role: "doc-noteref"
    },
    [e(t.position, "sup", [Ye("text", o)])]
  );
}
function e5(e, t) {
  const n = e.footnoteById, r = e.footnoteOrder;
  let i = 1;
  for (; i in n; )
    i++;
  const o = String(i);
  return r.push(o), n[o] = {
    type: "footnoteDefinition",
    identifier: o,
    children: [{ type: "paragraph", children: t.children }],
    position: t.position
  }, Yl(e, {
    type: "footnoteReference",
    identifier: o,
    position: t.position
  });
}
function t5(e, t) {
  return e(t, "h" + t.depth, Je(e, t));
}
function n5(e, t) {
  return e.dangerous ? e.augment(t, Ye("raw", t.value)) : null;
}
var bo = {};
function r5(e) {
  var t, n, r = bo[e];
  if (r)
    return r;
  for (r = bo[e] = [], t = 0; t < 128; t++)
    n = String.fromCharCode(t), /^[0-9a-z]$/i.test(n) ? r.push(n) : r.push("%" + ("0" + t.toString(16).toUpperCase()).slice(-2));
  for (t = 0; t < e.length; t++)
    r[e.charCodeAt(t)] = e[t];
  return r;
}
function J1(e, t, n) {
  var r, i, o, s, l, c = "";
  for (typeof t != "string" && (n = t, t = J1.defaultChars), typeof n > "u" && (n = !0), l = r5(t), r = 0, i = e.length; r < i; r++) {
    if (o = e.charCodeAt(r), n && o === 37 && r + 2 < i && /^[0-9a-f]{2}$/i.test(e.slice(r + 1, r + 3))) {
      c += e.slice(r, r + 3), r += 2;
      continue;
    }
    if (o < 128) {
      c += l[o];
      continue;
    }
    if (o >= 55296 && o <= 57343) {
      if (o >= 55296 && o <= 56319 && r + 1 < i && (s = e.charCodeAt(r + 1), s >= 56320 && s <= 57343)) {
        c += encodeURIComponent(e[r] + e[r + 1]), r++;
        continue;
      }
      c += "%EF%BF%BD";
      continue;
    }
    c += encodeURIComponent(e[r]);
  }
  return c;
}
J1.defaultChars = ";/?:@&=+$,-_.!~*'()#";
J1.componentChars = "-_.!~*'()";
var i5 = J1;
const Z1 = /* @__PURE__ */ fn(i5);
function Vl(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return Ye("text", "![" + t.alt + r);
  const i = Je(e, t), o = i[0];
  o && o.type === "text" ? o.value = "[" + o.value : i.unshift(Ye("text", "["));
  const s = i[i.length - 1];
  return s && s.type === "text" ? s.value += r : i.push(Ye("text", r)), i;
}
function o5(e, t) {
  const n = e.definition(t.identifier);
  if (!n)
    return Vl(e, t);
  const r = { src: Z1(n.url || ""), alt: t.alt };
  return n.title !== null && n.title !== void 0 && (r.title = n.title), e(t, "img", r);
}
function s5(e, t) {
  const n = { src: Z1(t.url), alt: t.alt };
  return t.title !== null && t.title !== void 0 && (n.title = t.title), e(t, "img", n);
}
function l5(e, t) {
  return e(t, "code", [Ye("text", t.value.replace(/\r?\n|\r/g, " "))]);
}
function a5(e, t) {
  const n = e.definition(t.identifier);
  if (!n)
    return Vl(e, t);
  const r = { href: Z1(n.url || "") };
  return n.title !== null && n.title !== void 0 && (r.title = n.title), e(t, "a", r, Je(e, t));
}
function u5(e, t) {
  const n = { href: Z1(t.url) };
  return t.title !== null && t.title !== void 0 && (n.title = t.title), e(t, "a", n, Je(e, t));
}
function c5(e, t, n) {
  const r = Je(e, t), i = n ? f5(n) : Wl(t), o = {}, s = [];
  if (typeof t.checked == "boolean") {
    let u;
    r[0] && r[0].type === "element" && r[0].tagName === "p" ? u = r[0] : (u = e(null, "p", []), r.unshift(u)), u.children.length > 0 && u.children.unshift(Ye("text", " ")), u.children.unshift(
      e(null, "input", {
        type: "checkbox",
        checked: t.checked,
        disabled: !0
      })
    ), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < r.length; ) {
    const u = r[l];
    (i || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push(Ye("text", `
`)), u.type === "element" && u.tagName === "p" && !i ? s.push(...u.children) : s.push(u);
  }
  const c = r[r.length - 1];
  return c && (i || !("tagName" in c) || c.tagName !== "p") && s.push(Ye("text", `
`)), e(t, "li", o, s);
}
function f5(e) {
  let t = e.spread;
  const n = e.children;
  let r = -1;
  for (; !t && ++r < n.length; )
    t = Wl(n[r]);
  return !!t;
}
function Wl(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function h5(e, t) {
  return e(t, "p", Je(e, t));
}
function d5(e, t) {
  return e.augment(t, Ye("root", Zt(Je(e, t))));
}
function m5(e, t) {
  return e(t, "strong", Je(e, t));
}
function p5(e, t) {
  const n = t.children;
  let r = -1;
  const i = t.align || [], o = [];
  for (; ++r < n.length; ) {
    const s = n[r].children, l = r === 0 ? "th" : "td";
    let c = t.align ? i.length : s.length;
    const u = [];
    for (; c--; ) {
      const f = s[c];
      u[c] = e(f, l, { align: i[c] }, f ? Je(e, f) : []);
    }
    o[r] = e(n[r], "tr", Zt(u, !0));
  }
  return e(
    t,
    "table",
    Zt(
      [e(o[0].position, "thead", Zt([o[0]], !0))].concat(
        o[1] ? e(
          {
            start: Gl(o[1]),
            end: jl(o[o.length - 1])
          },
          "tbody",
          Zt(o.slice(1), !0)
        ) : []
      ),
      !0
    )
  );
}
function T5(e, t) {
  return e.augment(
    t,
    Ye("text", String(t.value).replace(/[ \t]*(\r?\n|\r)[ \t]*/g, "$1"))
  );
}
const g5 = {
  blockquote: Wf,
  break: Xf,
  code: Qf,
  delete: Jf,
  emphasis: Zf,
  footnoteReference: Yl,
  footnote: e5,
  heading: t5,
  html: n5,
  imageReference: o5,
  image: s5,
  inlineCode: l5,
  linkReference: a5,
  link: u5,
  listItem: c5,
  list: ql,
  paragraph: h5,
  root: d5,
  strong: m5,
  table: p5,
  text: T5,
  thematicBreak: Kl,
  toml: m1,
  yaml: m1,
  definition: m1,
  footnoteDefinition: m1
};
function m1() {
  return null;
}
const E5 = {}.hasOwnProperty;
function A5(e, t) {
  const n = t || {}, r = n.allowDangerousHtml || !1, i = {};
  return s.dangerous = r, s.definition = Yf(e), s.footnoteById = i, s.footnoteOrder = [], s.augment = o, s.handlers = { ...g5, ...n.handlers }, s.unknownHandler = n.unknownHandler, s.passThrough = n.passThrough, Ul(e, "footnoteDefinition", (l) => {
    const c = String(l.identifier).toUpperCase();
    E5.call(i, c) || (i[c] = l);
  }), s;
  function o(l, c) {
    if (l && "data" in l && l.data) {
      const u = l.data;
      u.hName && (c.type !== "element" && (c = {
        type: "element",
        tagName: "",
        properties: {},
        children: []
      }), c.tagName = u.hName), c.type === "element" && u.hProperties && (c.properties = { ...c.properties, ...u.hProperties }), "children" in c && c.children && u.hChildren && (c.children = u.hChildren);
    }
    if (l) {
      const u = "type" in l ? l : { position: l };
      qf(u) || (c.position = { start: Gl(u), end: jl(u) });
    }
    return c;
  }
  function s(l, c, u, f) {
    return Array.isArray(u) && (f = u, u = {}), o(l, {
      type: "element",
      tagName: c,
      properties: u || {},
      children: f || []
    });
  }
}
function Xl(e, t) {
  const n = A5(e, t), r = Bl(n, e, null), i = Vf(n);
  return i && r.children.push(Ye("text", `
`), i), Array.isArray(r) ? { type: "root", children: r } : r;
}
const _5 = (
  /** @type {(import('unified').Plugin<[Processor, Options?]|[Options]|[], MdastRoot>)} */
  function(e, t) {
    return e && "run" in e ? C5(e, t) : S5(e);
  }
), y5 = _5;
function C5(e, t) {
  return (n, r, i) => {
    e.run(Xl(n, t), r, (o) => {
      i(o);
    });
  };
}
function S5(e) {
  return (t) => Xl(t, e);
}
var ii = { exports: {} }, p1 = { exports: {} }, xe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Oo;
function x5() {
  if (Oo)
    return xe;
  Oo = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, x = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, M = e ? Symbol.for("react.scope") : 60119;
  function O(N) {
    if (typeof N == "object" && N !== null) {
      var C = N.$$typeof;
      switch (C) {
        case t:
          switch (N = N.type, N) {
            case c:
            case u:
            case r:
            case o:
            case i:
            case m:
              return N;
            default:
              switch (N = N && N.$$typeof, N) {
                case l:
                case f:
                case x:
                case h:
                case s:
                  return N;
                default:
                  return C;
              }
          }
        case n:
          return C;
      }
    }
  }
  function P(N) {
    return O(N) === u;
  }
  return xe.AsyncMode = c, xe.ConcurrentMode = u, xe.ContextConsumer = l, xe.ContextProvider = s, xe.Element = t, xe.ForwardRef = f, xe.Fragment = r, xe.Lazy = x, xe.Memo = h, xe.Portal = n, xe.Profiler = o, xe.StrictMode = i, xe.Suspense = m, xe.isAsyncMode = function(N) {
    return P(N) || O(N) === c;
  }, xe.isConcurrentMode = P, xe.isContextConsumer = function(N) {
    return O(N) === l;
  }, xe.isContextProvider = function(N) {
    return O(N) === s;
  }, xe.isElement = function(N) {
    return typeof N == "object" && N !== null && N.$$typeof === t;
  }, xe.isForwardRef = function(N) {
    return O(N) === f;
  }, xe.isFragment = function(N) {
    return O(N) === r;
  }, xe.isLazy = function(N) {
    return O(N) === x;
  }, xe.isMemo = function(N) {
    return O(N) === h;
  }, xe.isPortal = function(N) {
    return O(N) === n;
  }, xe.isProfiler = function(N) {
    return O(N) === o;
  }, xe.isStrictMode = function(N) {
    return O(N) === i;
  }, xe.isSuspense = function(N) {
    return O(N) === m;
  }, xe.isValidElementType = function(N) {
    return typeof N == "string" || typeof N == "function" || N === r || N === u || N === o || N === i || N === m || N === E || typeof N == "object" && N !== null && (N.$$typeof === x || N.$$typeof === h || N.$$typeof === s || N.$$typeof === l || N.$$typeof === f || N.$$typeof === b || N.$$typeof === _ || N.$$typeof === M || N.$$typeof === y);
  }, xe.typeOf = O, xe;
}
var Ne = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Io;
function N5() {
  return Io || (Io = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, x = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, M = e ? Symbol.for("react.scope") : 60119;
    function O(K) {
      return typeof K == "string" || typeof K == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      K === r || K === u || K === o || K === i || K === m || K === E || typeof K == "object" && K !== null && (K.$$typeof === x || K.$$typeof === h || K.$$typeof === s || K.$$typeof === l || K.$$typeof === f || K.$$typeof === b || K.$$typeof === _ || K.$$typeof === M || K.$$typeof === y);
    }
    function P(K) {
      if (typeof K == "object" && K !== null) {
        var je = K.$$typeof;
        switch (je) {
          case t:
            var lt = K.type;
            switch (lt) {
              case c:
              case u:
              case r:
              case o:
              case i:
              case m:
                return lt;
              default:
                var rn = lt && lt.$$typeof;
                switch (rn) {
                  case l:
                  case f:
                  case x:
                  case h:
                  case s:
                    return rn;
                  default:
                    return je;
                }
            }
          case n:
            return je;
        }
      }
    }
    var N = c, C = u, I = l, D = s, z = t, ie = f, v = r, U = x, L = h, Q = n, te = o, pe = i, ye = m, Ae = !1;
    function ke(K) {
      return Ae || (Ae = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), d(K) || P(K) === c;
    }
    function d(K) {
      return P(K) === u;
    }
    function q(K) {
      return P(K) === l;
    }
    function oe(K) {
      return P(K) === s;
    }
    function p(K) {
      return typeof K == "object" && K !== null && K.$$typeof === t;
    }
    function ne(K) {
      return P(K) === f;
    }
    function se(K) {
      return P(K) === r;
    }
    function J(K) {
      return P(K) === x;
    }
    function Z(K) {
      return P(K) === h;
    }
    function le(K) {
      return P(K) === n;
    }
    function ue(K) {
      return P(K) === o;
    }
    function ce(K) {
      return P(K) === i;
    }
    function W(K) {
      return P(K) === m;
    }
    Ne.AsyncMode = N, Ne.ConcurrentMode = C, Ne.ContextConsumer = I, Ne.ContextProvider = D, Ne.Element = z, Ne.ForwardRef = ie, Ne.Fragment = v, Ne.Lazy = U, Ne.Memo = L, Ne.Portal = Q, Ne.Profiler = te, Ne.StrictMode = pe, Ne.Suspense = ye, Ne.isAsyncMode = ke, Ne.isConcurrentMode = d, Ne.isContextConsumer = q, Ne.isContextProvider = oe, Ne.isElement = p, Ne.isForwardRef = ne, Ne.isFragment = se, Ne.isLazy = J, Ne.isMemo = Z, Ne.isPortal = le, Ne.isProfiler = ue, Ne.isStrictMode = ce, Ne.isSuspense = W, Ne.isValidElementType = O, Ne.typeOf = P;
  }()), Ne;
}
var Ro;
function Ql() {
  return Ro || (Ro = 1, process.env.NODE_ENV === "production" ? p1.exports = x5() : p1.exports = N5()), p1.exports;
}
var Nr, ko;
function yi() {
  if (ko)
    return Nr;
  ko = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Nr = e, Nr;
}
var br, wo;
function Jl() {
  return wo || (wo = 1, br = Function.call.bind(Object.prototype.hasOwnProperty)), br;
}
var Or, Lo;
function b5() {
  if (Lo)
    return Or;
  Lo = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = yi(), n = {}, r = Jl();
    e = function(o) {
      var s = "Warning: " + o;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(o, s, l, c, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in o)
        if (r(o, f)) {
          var m;
          try {
            if (typeof o[f] != "function") {
              var E = Error(
                (c || "React class") + ": " + l + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw E.name = "Invariant Violation", E;
            }
            m = o[f](s, f, c, l, null, t);
          } catch (x) {
            m = x;
          }
          if (m && !(m instanceof Error) && e(
            (c || "React class") + ": type specification of " + l + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof m + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), m instanceof Error && !(m.message in n)) {
            n[m.message] = !0;
            var h = u ? u() : "";
            e(
              "Failed " + l + " type: " + m.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Or = i, Or;
}
var Ir, Mo;
function O5() {
  if (Mo)
    return Ir;
  Mo = 1;
  var e = Ql(), t = Nu, n = yi(), r = Jl(), i = b5(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(l) {
    var c = "Warning: " + l;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return Ir = function(l, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function m(d) {
      var q = d && (u && d[u] || d[f]);
      if (typeof q == "function")
        return q;
    }
    var E = "<<anonymous>>", h = {
      array: _("array"),
      bigint: _("bigint"),
      bool: _("boolean"),
      func: _("function"),
      number: _("number"),
      object: _("object"),
      string: _("string"),
      symbol: _("symbol"),
      any: M(),
      arrayOf: O,
      element: P(),
      elementType: N(),
      instanceOf: C,
      node: ie(),
      objectOf: D,
      oneOf: I,
      oneOfType: z,
      shape: U,
      exact: L
    };
    function x(d, q) {
      return d === q ? d !== 0 || 1 / d === 1 / q : d !== d && q !== q;
    }
    function y(d, q) {
      this.message = d, this.data = q && typeof q == "object" ? q : {}, this.stack = "";
    }
    y.prototype = Error.prototype;
    function b(d) {
      if (process.env.NODE_ENV !== "production")
        var q = {}, oe = 0;
      function p(se, J, Z, le, ue, ce, W) {
        if (le = le || E, ce = ce || Z, W !== n) {
          if (c) {
            var K = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw K.name = "Invariant Violation", K;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var je = le + ":" + Z;
            !q[je] && // Avoid spamming the console because they are often not actionable except for lib authors
            oe < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + ce + "` prop on `" + le + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), q[je] = !0, oe++);
          }
        }
        return J[Z] == null ? se ? J[Z] === null ? new y("The " + ue + " `" + ce + "` is marked as required " + ("in `" + le + "`, but its value is `null`.")) : new y("The " + ue + " `" + ce + "` is marked as required in " + ("`" + le + "`, but its value is `undefined`.")) : null : d(J, Z, le, ue, ce);
      }
      var ne = p.bind(null, !1);
      return ne.isRequired = p.bind(null, !0), ne;
    }
    function _(d) {
      function q(oe, p, ne, se, J, Z) {
        var le = oe[p], ue = pe(le);
        if (ue !== d) {
          var ce = ye(le);
          return new y(
            "Invalid " + se + " `" + J + "` of type " + ("`" + ce + "` supplied to `" + ne + "`, expected ") + ("`" + d + "`."),
            { expectedType: d }
          );
        }
        return null;
      }
      return b(q);
    }
    function M() {
      return b(s);
    }
    function O(d) {
      function q(oe, p, ne, se, J) {
        if (typeof d != "function")
          return new y("Property `" + J + "` of component `" + ne + "` has invalid PropType notation inside arrayOf.");
        var Z = oe[p];
        if (!Array.isArray(Z)) {
          var le = pe(Z);
          return new y("Invalid " + se + " `" + J + "` of type " + ("`" + le + "` supplied to `" + ne + "`, expected an array."));
        }
        for (var ue = 0; ue < Z.length; ue++) {
          var ce = d(Z, ue, ne, se, J + "[" + ue + "]", n);
          if (ce instanceof Error)
            return ce;
        }
        return null;
      }
      return b(q);
    }
    function P() {
      function d(q, oe, p, ne, se) {
        var J = q[oe];
        if (!l(J)) {
          var Z = pe(J);
          return new y("Invalid " + ne + " `" + se + "` of type " + ("`" + Z + "` supplied to `" + p + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(d);
    }
    function N() {
      function d(q, oe, p, ne, se) {
        var J = q[oe];
        if (!e.isValidElementType(J)) {
          var Z = pe(J);
          return new y("Invalid " + ne + " `" + se + "` of type " + ("`" + Z + "` supplied to `" + p + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(d);
    }
    function C(d) {
      function q(oe, p, ne, se, J) {
        if (!(oe[p] instanceof d)) {
          var Z = d.name || E, le = ke(oe[p]);
          return new y("Invalid " + se + " `" + J + "` of type " + ("`" + le + "` supplied to `" + ne + "`, expected ") + ("instance of `" + Z + "`."));
        }
        return null;
      }
      return b(q);
    }
    function I(d) {
      if (!Array.isArray(d))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), s;
      function q(oe, p, ne, se, J) {
        for (var Z = oe[p], le = 0; le < d.length; le++)
          if (x(Z, d[le]))
            return null;
        var ue = JSON.stringify(d, function(W, K) {
          var je = ye(K);
          return je === "symbol" ? String(K) : K;
        });
        return new y("Invalid " + se + " `" + J + "` of value `" + String(Z) + "` " + ("supplied to `" + ne + "`, expected one of " + ue + "."));
      }
      return b(q);
    }
    function D(d) {
      function q(oe, p, ne, se, J) {
        if (typeof d != "function")
          return new y("Property `" + J + "` of component `" + ne + "` has invalid PropType notation inside objectOf.");
        var Z = oe[p], le = pe(Z);
        if (le !== "object")
          return new y("Invalid " + se + " `" + J + "` of type " + ("`" + le + "` supplied to `" + ne + "`, expected an object."));
        for (var ue in Z)
          if (r(Z, ue)) {
            var ce = d(Z, ue, ne, se, J + "." + ue, n);
            if (ce instanceof Error)
              return ce;
          }
        return null;
      }
      return b(q);
    }
    function z(d) {
      if (!Array.isArray(d))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var q = 0; q < d.length; q++) {
        var oe = d[q];
        if (typeof oe != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Ae(oe) + " at index " + q + "."
          ), s;
      }
      function p(ne, se, J, Z, le) {
        for (var ue = [], ce = 0; ce < d.length; ce++) {
          var W = d[ce], K = W(ne, se, J, Z, le, n);
          if (K == null)
            return null;
          K.data && r(K.data, "expectedType") && ue.push(K.data.expectedType);
        }
        var je = ue.length > 0 ? ", expected one of type [" + ue.join(", ") + "]" : "";
        return new y("Invalid " + Z + " `" + le + "` supplied to " + ("`" + J + "`" + je + "."));
      }
      return b(p);
    }
    function ie() {
      function d(q, oe, p, ne, se) {
        return Q(q[oe]) ? null : new y("Invalid " + ne + " `" + se + "` supplied to " + ("`" + p + "`, expected a ReactNode."));
      }
      return b(d);
    }
    function v(d, q, oe, p, ne) {
      return new y(
        (d || "React class") + ": " + q + " type `" + oe + "." + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ne + "`."
      );
    }
    function U(d) {
      function q(oe, p, ne, se, J) {
        var Z = oe[p], le = pe(Z);
        if (le !== "object")
          return new y("Invalid " + se + " `" + J + "` of type `" + le + "` " + ("supplied to `" + ne + "`, expected `object`."));
        for (var ue in d) {
          var ce = d[ue];
          if (typeof ce != "function")
            return v(ne, se, J, ue, ye(ce));
          var W = ce(Z, ue, ne, se, J + "." + ue, n);
          if (W)
            return W;
        }
        return null;
      }
      return b(q);
    }
    function L(d) {
      function q(oe, p, ne, se, J) {
        var Z = oe[p], le = pe(Z);
        if (le !== "object")
          return new y("Invalid " + se + " `" + J + "` of type `" + le + "` " + ("supplied to `" + ne + "`, expected `object`."));
        var ue = t({}, oe[p], d);
        for (var ce in ue) {
          var W = d[ce];
          if (r(d, ce) && typeof W != "function")
            return v(ne, se, J, ce, ye(W));
          if (!W)
            return new y(
              "Invalid " + se + " `" + J + "` key `" + ce + "` supplied to `" + ne + "`.\nBad object: " + JSON.stringify(oe[p], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(d), null, "  ")
            );
          var K = W(Z, ce, ne, se, J + "." + ce, n);
          if (K)
            return K;
        }
        return null;
      }
      return b(q);
    }
    function Q(d) {
      switch (typeof d) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !d;
        case "object":
          if (Array.isArray(d))
            return d.every(Q);
          if (d === null || l(d))
            return !0;
          var q = m(d);
          if (q) {
            var oe = q.call(d), p;
            if (q !== d.entries) {
              for (; !(p = oe.next()).done; )
                if (!Q(p.value))
                  return !1;
            } else
              for (; !(p = oe.next()).done; ) {
                var ne = p.value;
                if (ne && !Q(ne[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function te(d, q) {
      return d === "symbol" ? !0 : q ? q["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && q instanceof Symbol : !1;
    }
    function pe(d) {
      var q = typeof d;
      return Array.isArray(d) ? "array" : d instanceof RegExp ? "object" : te(q, d) ? "symbol" : q;
    }
    function ye(d) {
      if (typeof d > "u" || d === null)
        return "" + d;
      var q = pe(d);
      if (q === "object") {
        if (d instanceof Date)
          return "date";
        if (d instanceof RegExp)
          return "regexp";
      }
      return q;
    }
    function Ae(d) {
      var q = ye(d);
      switch (q) {
        case "array":
        case "object":
          return "an " + q;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + q;
        default:
          return q;
      }
    }
    function ke(d) {
      return !d.constructor || !d.constructor.name ? E : d.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, Ir;
}
var Rr, Po;
function I5() {
  if (Po)
    return Rr;
  Po = 1;
  var e = yi();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Rr = function() {
    function r(s, l, c, u, f, m) {
      if (m !== e) {
        var E = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw E.name = "Invariant Violation", E;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Rr;
}
if (process.env.NODE_ENV !== "production") {
  var R5 = Ql(), k5 = !0;
  ii.exports = O5()(R5.isElement, k5);
} else
  ii.exports = I5()();
var w5 = ii.exports;
const ge = /* @__PURE__ */ fn(w5);
let a1 = class {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
};
a1.prototype.property = {};
a1.prototype.normal = {};
a1.prototype.space = null;
function Zl(e, t) {
  const n = {}, r = {};
  let i = -1;
  for (; ++i < e.length; )
    Object.assign(n, e[i].property), Object.assign(r, e[i].normal);
  return new a1(n, r, t);
}
function oi(e) {
  return e.toLowerCase();
}
let mt = class {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
};
mt.prototype.space = null;
mt.prototype.boolean = !1;
mt.prototype.booleanish = !1;
mt.prototype.overloadedBoolean = !1;
mt.prototype.number = !1;
mt.prototype.commaSeparated = !1;
mt.prototype.spaceSeparated = !1;
mt.prototype.commaOrSpaceSeparated = !1;
mt.prototype.mustUseProperty = !1;
mt.prototype.defined = !1;
let L5 = 0;
const he = hn(), Be = hn(), ea = hn(), H = hn(), Me = hn(), On = hn(), it = hn();
function hn() {
  return 2 ** ++L5;
}
const si = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: he,
  booleanish: Be,
  commaOrSpaceSeparated: it,
  commaSeparated: On,
  number: H,
  overloadedBoolean: ea,
  spaceSeparated: Me
}, Symbol.toStringTag, { value: "Module" })), kr = Object.keys(si);
let Ci = class extends mt {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, i) {
    let o = -1;
    if (super(t, n), vo(this, "space", i), typeof r == "number")
      for (; ++o < kr.length; ) {
        const s = kr[o];
        vo(this, kr[o], (r & si[s]) === si[s]);
      }
  }
};
Ci.prototype.defined = !0;
function vo(e, t, n) {
  n && (e[t] = n);
}
const M5 = {}.hasOwnProperty;
function kn(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (M5.call(e.properties, r)) {
      const i = e.properties[r], o = new Ci(
        r,
        e.transform(e.attributes || {}, r),
        i,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (o.mustUseProperty = !0), t[r] = o, n[oi(r)] = r, n[oi(o.attribute)] = r;
    }
  return new a1(t, n, e.space);
}
const ta = kn({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), na = kn({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function ra(e, t) {
  return t in e ? e[t] : t;
}
function ia(e, t) {
  return ra(e, t.toLowerCase());
}
const oa = kn({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: ia,
  properties: { xmlns: null, xmlnsXLink: null }
}), sa = kn({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Be,
    ariaAutoComplete: null,
    ariaBusy: Be,
    ariaChecked: Be,
    ariaColCount: H,
    ariaColIndex: H,
    ariaColSpan: H,
    ariaControls: Me,
    ariaCurrent: null,
    ariaDescribedBy: Me,
    ariaDetails: null,
    ariaDisabled: Be,
    ariaDropEffect: Me,
    ariaErrorMessage: null,
    ariaExpanded: Be,
    ariaFlowTo: Me,
    ariaGrabbed: Be,
    ariaHasPopup: null,
    ariaHidden: Be,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Me,
    ariaLevel: H,
    ariaLive: null,
    ariaModal: Be,
    ariaMultiLine: Be,
    ariaMultiSelectable: Be,
    ariaOrientation: null,
    ariaOwns: Me,
    ariaPlaceholder: null,
    ariaPosInSet: H,
    ariaPressed: Be,
    ariaReadOnly: Be,
    ariaRelevant: null,
    ariaRequired: Be,
    ariaRoleDescription: Me,
    ariaRowCount: H,
    ariaRowIndex: H,
    ariaRowSpan: H,
    ariaSelected: Be,
    ariaSetSize: H,
    ariaSort: null,
    ariaValueMax: H,
    ariaValueMin: H,
    ariaValueNow: H,
    ariaValueText: null,
    role: null
  }
}), P5 = kn({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: ia,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: On,
    acceptCharset: Me,
    accessKey: Me,
    action: null,
    allow: null,
    allowFullScreen: he,
    allowPaymentRequest: he,
    allowUserMedia: he,
    alt: null,
    as: null,
    async: he,
    autoCapitalize: null,
    autoComplete: Me,
    autoFocus: he,
    autoPlay: he,
    capture: he,
    charSet: null,
    checked: he,
    cite: null,
    className: Me,
    cols: H,
    colSpan: null,
    content: null,
    contentEditable: Be,
    controls: he,
    controlsList: Me,
    coords: H | On,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: he,
    defer: he,
    dir: null,
    dirName: null,
    disabled: he,
    download: ea,
    draggable: Be,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: he,
    formTarget: null,
    headers: Me,
    height: H,
    hidden: he,
    high: H,
    href: null,
    hrefLang: null,
    htmlFor: Me,
    httpEquiv: Me,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: he,
    itemId: null,
    itemProp: Me,
    itemRef: Me,
    itemScope: he,
    itemType: Me,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: he,
    low: H,
    manifest: null,
    max: null,
    maxLength: H,
    media: null,
    method: null,
    min: null,
    minLength: H,
    multiple: he,
    muted: he,
    name: null,
    nonce: null,
    noModule: he,
    noValidate: he,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: he,
    optimum: H,
    pattern: null,
    ping: Me,
    placeholder: null,
    playsInline: he,
    poster: null,
    preload: null,
    readOnly: he,
    referrerPolicy: null,
    rel: Me,
    required: he,
    reversed: he,
    rows: H,
    rowSpan: H,
    sandbox: Me,
    scope: null,
    scoped: he,
    seamless: he,
    selected: he,
    shape: null,
    size: H,
    sizes: null,
    slot: null,
    span: H,
    spellCheck: Be,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: H,
    step: null,
    style: null,
    tabIndex: H,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: he,
    useMap: null,
    value: Be,
    width: H,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Me,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: H,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: H,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: he,
    // Lists. Use CSS to reduce space between items instead
    declare: he,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: H,
    // `<img>` and `<object>`
    leftMargin: H,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: H,
    // `<body>`
    marginWidth: H,
    // `<body>`
    noResize: he,
    // `<frame>`
    noHref: he,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: he,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: he,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: H,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Be,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: H,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: H,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: he,
    disableRemotePlayback: he,
    prefix: null,
    property: null,
    results: H,
    security: null,
    unselectable: null
  }
}), v5 = kn({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: ra,
  properties: {
    about: it,
    accentHeight: H,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: H,
    amplitude: H,
    arabicForm: null,
    ascent: H,
    attributeName: null,
    attributeType: null,
    azimuth: H,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: H,
    by: null,
    calcMode: null,
    capHeight: H,
    className: Me,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: H,
    diffuseConstant: H,
    direction: null,
    display: null,
    dur: null,
    divisor: H,
    dominantBaseline: null,
    download: he,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: H,
    enableBackground: null,
    end: null,
    event: null,
    exponent: H,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: H,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: On,
    g2: On,
    glyphName: On,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: H,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: H,
    horizOriginX: H,
    horizOriginY: H,
    id: null,
    ideographic: H,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: H,
    k: H,
    k1: H,
    k2: H,
    k3: H,
    k4: H,
    kernelMatrix: it,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: H,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: H,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: H,
    overlineThickness: H,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: H,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Me,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: H,
    pointsAtY: H,
    pointsAtZ: H,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: it,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: it,
    rev: it,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: it,
    requiredFeatures: it,
    requiredFonts: it,
    requiredFormats: it,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: H,
    specularExponent: H,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: H,
    strikethroughThickness: H,
    string: null,
    stroke: null,
    strokeDashArray: it,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: H,
    strokeOpacity: H,
    strokeWidth: null,
    style: null,
    surfaceScale: H,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: it,
    tabIndex: H,
    tableValues: null,
    target: null,
    targetX: H,
    targetY: H,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: it,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: H,
    underlineThickness: H,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: H,
    values: null,
    vAlphabetic: H,
    vMathematical: H,
    vectorEffect: null,
    vHanging: H,
    vIdeographic: H,
    version: null,
    vertAdvY: H,
    vertOriginX: H,
    vertOriginY: H,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: H,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), D5 = /^data[-\w.:]+$/i, Do = /-[a-z]/g, H5 = /[A-Z]/g;
function F5(e, t) {
  const n = oi(t);
  let r = t, i = mt;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && D5.test(t)) {
    if (t.charAt(4) === "-") {
      const o = t.slice(5).replace(Do, $5);
      r = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = t.slice(4);
      if (!Do.test(o)) {
        let s = o.replace(H5, B5);
        s.charAt(0) !== "-" && (s = "-" + s), t = "data" + s;
      }
    }
    i = Ci;
  }
  return new i(r, t);
}
function B5(e) {
  return "-" + e.toLowerCase();
}
function $5(e) {
  return e.charAt(1).toUpperCase();
}
const Ho = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, U5 = Zl([na, ta, oa, sa, P5], "html"), G5 = Zl([na, ta, oa, sa, v5], "svg"), la = (
  /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {AssertAnything}
   */
  function(e) {
    if (e == null)
      return q5;
    if (typeof e == "string")
      return K5(e);
    if (typeof e == "object")
      return Array.isArray(e) ? j5(e) : z5(e);
    if (typeof e == "function")
      return er(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function j5(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = la(e[n]);
  return er(r);
  function r(...i) {
    let o = -1;
    for (; ++o < t.length; )
      if (t[o].call(this, ...i))
        return !0;
    return !1;
  }
}
function z5(e) {
  return er(t);
  function t(n) {
    let r;
    for (r in e)
      if (n[r] !== e[r])
        return !1;
    return !0;
  }
}
function K5(e) {
  return er(t);
  function t(n) {
    return n && n.type === e;
  }
}
function er(e) {
  return t;
  function t(n, ...r) {
    return !!(n && typeof n == "object" && "type" in n && e.call(this, n, ...r));
  }
}
function q5() {
  return !0;
}
const Y5 = !0, Fo = !1, V5 = "skip", W5 = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor<Node>} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null);
    const i = la(t), o = r ? -1 : 1;
    s(e, void 0, [])();
    function s(l, c, u) {
      const f = l && typeof l == "object" ? l : {};
      if (typeof f.type == "string") {
        const E = (
          // `hast`
          typeof f.tagName == "string" ? f.tagName : (
            // `xast`
            typeof f.name == "string" ? f.name : void 0
          )
        );
        Object.defineProperty(m, "name", {
          value: "node (" + (l.type + (E ? "<" + E + ">" : "")) + ")"
        });
      }
      return m;
      function m() {
        let E = [], h, x, y;
        if ((!t || i(l, c, u[u.length - 1] || null)) && (E = X5(n(l, u)), E[0] === Fo))
          return E;
        if (l.children && E[0] !== V5)
          for (x = (r ? l.children.length : -1) + o, y = u.concat(l); x > -1 && x < l.children.length; ) {
            if (h = s(l.children[x], x, y)(), h[0] === Fo)
              return h;
            x = typeof h[1] == "number" ? h[1] : x + o;
          }
        return E;
      }
    }
  }
);
function X5(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [Y5, e] : [e];
}
const Q5 = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null), W5(e, t, i, r);
    function i(o, s) {
      const l = s[s.length - 1];
      return n(
        o,
        l ? l.children.indexOf(o) : null,
        l
      );
    }
  }
);
function J5(e) {
  if (e.allowedElements && e.disallowedElements)
    throw new TypeError(
      "Only one of `allowedElements` and `disallowedElements` should be defined"
    );
  if (e.allowedElements || e.disallowedElements || e.allowElement)
    return (t) => {
      Q5(t, "element", (n, r, i) => {
        const o = (
          /** @type {Element|Root} */
          i
        );
        let s;
        if (e.allowedElements ? s = !e.allowedElements.includes(n.tagName) : e.disallowedElements && (s = e.disallowedElements.includes(n.tagName)), !s && e.allowElement && typeof r == "number" && (s = !e.allowElement(n, r, o)), s && typeof r == "number")
          return e.unwrapDisallowed && n.children ? o.children.splice(r, 1, ...n.children) : o.children.splice(r, 1), r;
      });
    };
}
var li = { exports: {} }, be = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bo;
function Z5() {
  if (Bo)
    return be;
  Bo = 1;
  var e = 60103, t = 60106, n = 60107, r = 60108, i = 60114, o = 60109, s = 60110, l = 60112, c = 60113, u = 60120, f = 60115, m = 60116, E = 60121, h = 60122, x = 60117, y = 60129, b = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var _ = Symbol.for;
    e = _("react.element"), t = _("react.portal"), n = _("react.fragment"), r = _("react.strict_mode"), i = _("react.profiler"), o = _("react.provider"), s = _("react.context"), l = _("react.forward_ref"), c = _("react.suspense"), u = _("react.suspense_list"), f = _("react.memo"), m = _("react.lazy"), E = _("react.block"), h = _("react.server.block"), x = _("react.fundamental"), y = _("react.debug_trace_mode"), b = _("react.legacy_hidden");
  }
  function M(L) {
    if (typeof L == "object" && L !== null) {
      var Q = L.$$typeof;
      switch (Q) {
        case e:
          switch (L = L.type, L) {
            case n:
            case i:
            case r:
            case c:
            case u:
              return L;
            default:
              switch (L = L && L.$$typeof, L) {
                case s:
                case l:
                case m:
                case f:
                case o:
                  return L;
                default:
                  return Q;
              }
          }
        case t:
          return Q;
      }
    }
  }
  var O = o, P = e, N = l, C = n, I = m, D = f, z = t, ie = i, v = r, U = c;
  return be.ContextConsumer = s, be.ContextProvider = O, be.Element = P, be.ForwardRef = N, be.Fragment = C, be.Lazy = I, be.Memo = D, be.Portal = z, be.Profiler = ie, be.StrictMode = v, be.Suspense = U, be.isAsyncMode = function() {
    return !1;
  }, be.isConcurrentMode = function() {
    return !1;
  }, be.isContextConsumer = function(L) {
    return M(L) === s;
  }, be.isContextProvider = function(L) {
    return M(L) === o;
  }, be.isElement = function(L) {
    return typeof L == "object" && L !== null && L.$$typeof === e;
  }, be.isForwardRef = function(L) {
    return M(L) === l;
  }, be.isFragment = function(L) {
    return M(L) === n;
  }, be.isLazy = function(L) {
    return M(L) === m;
  }, be.isMemo = function(L) {
    return M(L) === f;
  }, be.isPortal = function(L) {
    return M(L) === t;
  }, be.isProfiler = function(L) {
    return M(L) === i;
  }, be.isStrictMode = function(L) {
    return M(L) === r;
  }, be.isSuspense = function(L) {
    return M(L) === c;
  }, be.isValidElementType = function(L) {
    return typeof L == "string" || typeof L == "function" || L === n || L === i || L === y || L === r || L === c || L === u || L === b || typeof L == "object" && L !== null && (L.$$typeof === m || L.$$typeof === f || L.$$typeof === o || L.$$typeof === s || L.$$typeof === l || L.$$typeof === x || L.$$typeof === E || L[0] === h);
  }, be.typeOf = M, be;
}
var Oe = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $o;
function eh() {
  return $o || ($o = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, n = 60107, r = 60108, i = 60114, o = 60109, s = 60110, l = 60112, c = 60113, u = 60120, f = 60115, m = 60116, E = 60121, h = 60122, x = 60117, y = 60129, b = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var _ = Symbol.for;
      e = _("react.element"), t = _("react.portal"), n = _("react.fragment"), r = _("react.strict_mode"), i = _("react.profiler"), o = _("react.provider"), s = _("react.context"), l = _("react.forward_ref"), c = _("react.suspense"), u = _("react.suspense_list"), f = _("react.memo"), m = _("react.lazy"), E = _("react.block"), h = _("react.server.block"), x = _("react.fundamental"), _("react.scope"), _("react.opaque.id"), y = _("react.debug_trace_mode"), _("react.offscreen"), b = _("react.legacy_hidden");
    }
    var M = !1;
    function O(W) {
      return !!(typeof W == "string" || typeof W == "function" || W === n || W === i || W === y || W === r || W === c || W === u || W === b || M || typeof W == "object" && W !== null && (W.$$typeof === m || W.$$typeof === f || W.$$typeof === o || W.$$typeof === s || W.$$typeof === l || W.$$typeof === x || W.$$typeof === E || W[0] === h));
    }
    function P(W) {
      if (typeof W == "object" && W !== null) {
        var K = W.$$typeof;
        switch (K) {
          case e:
            var je = W.type;
            switch (je) {
              case n:
              case i:
              case r:
              case c:
              case u:
                return je;
              default:
                var lt = je && je.$$typeof;
                switch (lt) {
                  case s:
                  case l:
                  case m:
                  case f:
                  case o:
                    return lt;
                  default:
                    return K;
                }
            }
          case t:
            return K;
        }
      }
    }
    var N = s, C = o, I = e, D = l, z = n, ie = m, v = f, U = t, L = i, Q = r, te = c, pe = !1, ye = !1;
    function Ae(W) {
      return pe || (pe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ke(W) {
      return ye || (ye = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function d(W) {
      return P(W) === s;
    }
    function q(W) {
      return P(W) === o;
    }
    function oe(W) {
      return typeof W == "object" && W !== null && W.$$typeof === e;
    }
    function p(W) {
      return P(W) === l;
    }
    function ne(W) {
      return P(W) === n;
    }
    function se(W) {
      return P(W) === m;
    }
    function J(W) {
      return P(W) === f;
    }
    function Z(W) {
      return P(W) === t;
    }
    function le(W) {
      return P(W) === i;
    }
    function ue(W) {
      return P(W) === r;
    }
    function ce(W) {
      return P(W) === c;
    }
    Oe.ContextConsumer = N, Oe.ContextProvider = C, Oe.Element = I, Oe.ForwardRef = D, Oe.Fragment = z, Oe.Lazy = ie, Oe.Memo = v, Oe.Portal = U, Oe.Profiler = L, Oe.StrictMode = Q, Oe.Suspense = te, Oe.isAsyncMode = Ae, Oe.isConcurrentMode = ke, Oe.isContextConsumer = d, Oe.isContextProvider = q, Oe.isElement = oe, Oe.isForwardRef = p, Oe.isFragment = ne, Oe.isLazy = se, Oe.isMemo = J, Oe.isPortal = Z, Oe.isProfiler = le, Oe.isStrictMode = ue, Oe.isSuspense = ce, Oe.isValidElementType = O, Oe.typeOf = P;
  }()), Oe;
}
process.env.NODE_ENV === "production" ? li.exports = Z5() : li.exports = eh();
var th = li.exports;
const nh = /* @__PURE__ */ fn(th);
function rh(e) {
  const t = (
    // @ts-expect-error looks like a node.
    e && typeof e == "object" && e.type === "text" ? (
      // @ts-expect-error looks like a text.
      e.value || ""
    ) : e
  );
  return typeof t == "string" && t.replace(/[ \t\n\f\r]/g, "") === "";
}
function ih(e) {
  return e.join(" ").trim();
}
function Uo(e) {
  for (var t = [], n = String(e || ""), r = n.indexOf(","), i = 0, o, s; !o; )
    r === -1 && (r = n.length, o = !0), s = n.slice(i, r).trim(), (s || !o) && t.push(s), i = r + 1, r = n.indexOf(",", i);
  return t;
}
function aa(e, t) {
  var n = t || {};
  return e[e.length - 1] === "" && (e = e.concat("")), e.join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
var Go = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, oh = /\n/g, sh = /^\s*/, lh = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, ah = /^:\s*/, uh = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, ch = /^[;\s]*/, fh = /^\s+|\s+$/g, hh = `
`, jo = "/", zo = "*", un = "", dh = "comment", mh = "declaration", ph = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e)
    return [];
  t = t || {};
  var n = 1, r = 1;
  function i(x) {
    var y = x.match(oh);
    y && (n += y.length);
    var b = x.lastIndexOf(hh);
    r = ~b ? x.length - b : r + x.length;
  }
  function o() {
    var x = { line: n, column: r };
    return function(y) {
      return y.position = new s(x), u(), y;
    };
  }
  function s(x) {
    this.start = x, this.end = { line: n, column: r }, this.source = t.source;
  }
  s.prototype.content = e;
  function l(x) {
    var y = new Error(
      t.source + ":" + n + ":" + r + ": " + x
    );
    if (y.reason = x, y.filename = t.source, y.line = n, y.column = r, y.source = e, !t.silent)
      throw y;
  }
  function c(x) {
    var y = x.exec(e);
    if (y) {
      var b = y[0];
      return i(b), e = e.slice(b.length), y;
    }
  }
  function u() {
    c(sh);
  }
  function f(x) {
    var y;
    for (x = x || []; y = m(); )
      y !== !1 && x.push(y);
    return x;
  }
  function m() {
    var x = o();
    if (!(jo != e.charAt(0) || zo != e.charAt(1))) {
      for (var y = 2; un != e.charAt(y) && (zo != e.charAt(y) || jo != e.charAt(y + 1)); )
        ++y;
      if (y += 2, un === e.charAt(y - 1))
        return l("End of comment missing");
      var b = e.slice(2, y - 2);
      return r += 2, i(b), e = e.slice(y), r += 2, x({
        type: dh,
        comment: b
      });
    }
  }
  function E() {
    var x = o(), y = c(lh);
    if (y) {
      if (m(), !c(ah))
        return l("property missing ':'");
      var b = c(uh), _ = x({
        type: mh,
        property: Ko(y[0].replace(Go, un)),
        value: b ? Ko(b[0].replace(Go, un)) : un
      });
      return c(ch), _;
    }
  }
  function h() {
    var x = [];
    f(x);
    for (var y; y = E(); )
      y !== !1 && (x.push(y), f(x));
    return x;
  }
  return u(), h();
};
function Ko(e) {
  return e ? e.replace(fh, un) : un;
}
var Th = ph;
function gh(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  for (var r, i = Th(e), o = typeof t == "function", s, l, c = 0, u = i.length; c < u; c++)
    r = i[c], s = r.property, l = r.value, o ? t(s, l, r) : l && (n || (n = {}), n[s] = l);
  return n;
}
var Eh = gh;
const Ah = /* @__PURE__ */ fn(Eh), ai = {}.hasOwnProperty, _h = /* @__PURE__ */ new Set(["table", "thead", "tbody", "tfoot", "tr"]);
function ua(e, t) {
  const n = [];
  let r = -1, i;
  for (; ++r < t.children.length; )
    i = t.children[r], i.type === "element" ? n.push(yh(e, i, r, t)) : i.type === "text" ? (t.type !== "element" || !_h.has(t.tagName) || !rh(i)) && n.push(i.value) : i.type === "raw" && !e.options.skipHtml && n.push(i.value);
  return n;
}
function yh(e, t, n, r) {
  const i = e.options, o = e.schema, s = t.tagName, l = {};
  let c = o, u;
  if (o.space === "html" && s === "svg" && (c = G5, e.schema = c), t.properties)
    for (u in t.properties)
      ai.call(t.properties, u) && Sh(l, u, t.properties[u], e);
  (s === "ol" || s === "ul") && e.listDepth++;
  const f = ua(e, t);
  (s === "ol" || s === "ul") && e.listDepth--, e.schema = o;
  const m = t.position || {
    start: { line: null, column: null, offset: null },
    end: { line: null, column: null, offset: null }
  }, E = i.components && ai.call(i.components, s) ? i.components[s] : s, h = typeof E == "string" || E === ee.Fragment;
  if (!nh.isValidElementType(E))
    throw new TypeError(
      `Component for name \`${s}\` not defined or is not renderable`
    );
  if (l.key = [
    s,
    m.start.line,
    m.start.column,
    n
  ].join("-"), s === "a" && i.linkTarget && (l.target = typeof i.linkTarget == "function" ? i.linkTarget(
    String(l.href || ""),
    t.children,
    typeof l.title == "string" ? l.title : null
  ) : i.linkTarget), s === "a" && i.transformLinkUri && (l.href = i.transformLinkUri(
    String(l.href || ""),
    t.children,
    typeof l.title == "string" ? l.title : null
  )), !h && s === "code" && r.type === "element" && r.tagName !== "pre" && (l.inline = !0), !h && (s === "h1" || s === "h2" || s === "h3" || s === "h4" || s === "h5" || s === "h6") && (l.level = Number.parseInt(s.charAt(1), 10)), s === "img" && i.transformImageUri && (l.src = i.transformImageUri(
    String(l.src || ""),
    String(l.alt || ""),
    typeof l.title == "string" ? l.title : null
  )), !h && s === "li" && r.type === "element") {
    const x = Ch(t);
    l.checked = x && x.properties ? !!x.properties.checked : null, l.index = wr(r, t), l.ordered = r.tagName === "ol";
  }
  return !h && (s === "ol" || s === "ul") && (l.ordered = s === "ol", l.depth = e.listDepth), (s === "td" || s === "th") && (l.align && (l.style || (l.style = {}), l.style.textAlign = l.align, delete l.align), h || (l.isHeader = s === "th")), !h && s === "tr" && r.type === "element" && (l.isHeader = r.tagName === "thead"), i.sourcePos && (l["data-sourcepos"] = bh(m)), !h && i.rawSourcePos && (l.sourcePosition = t.position), !h && i.includeElementIndex && (l.index = wr(r, t), l.siblingCount = wr(r)), h || (l.node = t), f.length > 0 ? ee.createElement(E, l, f) : ee.createElement(E, l);
}
function Ch(e) {
  let t = -1;
  for (; ++t < e.children.length; ) {
    const n = e.children[t];
    if (n.type === "element" && n.tagName === "input")
      return n;
  }
  return null;
}
function wr(e, t) {
  let n = -1, r = 0;
  for (; ++n < e.children.length && e.children[n] !== t; )
    e.children[n].type === "element" && r++;
  return r;
}
function Sh(e, t, n, r) {
  const i = F5(r.schema, t);
  let o = n;
  o == null || o !== o || (Array.isArray(o) && (o = i.commaSeparated ? aa(o) : ih(o)), i.property === "style" && typeof o == "string" && (o = xh(o)), i.space && i.property ? e[ai.call(Ho, i.property) ? Ho[i.property] : i.property] = o : i.attribute && (e[i.attribute] = o));
}
function xh(e) {
  const t = {};
  try {
    Ah(e, n);
  } catch {
  }
  return t;
  function n(r, i) {
    const o = r.slice(0, 4) === "-ms-" ? `ms-${r.slice(4)}` : r;
    t[o.replace(/-([a-z])/g, Nh)] = i;
  }
}
function Nh(e, t) {
  return t.toUpperCase();
}
function bh(e) {
  return [
    e.start.line,
    ":",
    e.start.column,
    "-",
    e.end.line,
    ":",
    e.end.column
  ].map((t) => String(t)).join("");
}
const qo = {}.hasOwnProperty, Oh = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", T1 = {
  renderers: { to: "components", id: "change-renderers-to-components" },
  astPlugins: { id: "remove-buggy-html-in-markdown-parser" },
  allowDangerousHtml: { id: "remove-buggy-html-in-markdown-parser" },
  escapeHtml: { id: "remove-buggy-html-in-markdown-parser" },
  source: { to: "children", id: "change-source-to-children" },
  allowNode: {
    to: "allowElement",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  allowedTypes: {
    to: "allowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  disallowedTypes: {
    to: "disallowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  includeNodeIndex: {
    to: "includeElementIndex",
    id: "change-includenodeindex-to-includeelementindex"
  }
};
function Si(e) {
  for (const o in T1)
    if (qo.call(T1, o) && qo.call(e, o)) {
      const s = T1[o];
      console.warn(
        `[react-markdown] Warning: please ${s.to ? `use \`${s.to}\` instead of` : "remove"} \`${o}\` (see <${Oh}#${s.id}> for more info)`
      ), delete T1[o];
    }
  const t = x0().use(vf).use(e.remarkPlugins || e.plugins || []).use(y5, { allowDangerousHtml: !0 }).use(e.rehypePlugins || []).use(J5, e), n = new Cl();
  typeof e.children == "string" ? n.value = e.children : e.children !== void 0 && e.children !== null && console.warn(
    `[react-markdown] Warning: please pass a string as \`children\` (not: \`${e.children}\`)`
  );
  const r = t.runSync(t.parse(n), n);
  if (r.type !== "root")
    throw new TypeError("Expected a `root` node");
  let i = ee.createElement(
    ee.Fragment,
    {},
    ua({ options: e, schema: U5, listDepth: 0 }, r)
  );
  return e.className && (i = ee.createElement("div", { className: e.className }, i)), i;
}
Si.defaultProps = { transformLinkUri: a0 };
Si.propTypes = {
  // Core options:
  children: ge.string,
  // Layout options:
  className: ge.string,
  // Filter options:
  allowElement: ge.func,
  allowedElements: ge.arrayOf(ge.string),
  disallowedElements: ge.arrayOf(ge.string),
  unwrapDisallowed: ge.bool,
  // Plugin options:
  remarkPlugins: ge.arrayOf(
    ge.oneOfType([
      ge.object,
      ge.func,
      ge.arrayOf(ge.oneOfType([ge.object, ge.func]))
    ])
  ),
  rehypePlugins: ge.arrayOf(
    ge.oneOfType([
      ge.object,
      ge.func,
      ge.arrayOf(ge.oneOfType([ge.object, ge.func]))
    ])
  ),
  // Transform options:
  sourcePos: ge.bool,
  rawSourcePos: ge.bool,
  skipHtml: ge.bool,
  includeElementIndex: ge.bool,
  transformLinkUri: ge.oneOfType([ge.func, ge.bool]),
  linkTarget: ge.oneOfType([ge.func, ge.string]),
  transformImageUri: ge.func,
  components: ge.object
};
var St = {};
const Ih = [
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
];
St.REPLACEMENT_CHARACTER = "�";
St.CODE_POINTS = {
  EOF: -1,
  NULL: 0,
  TABULATION: 9,
  CARRIAGE_RETURN: 13,
  LINE_FEED: 10,
  FORM_FEED: 12,
  SPACE: 32,
  EXCLAMATION_MARK: 33,
  QUOTATION_MARK: 34,
  NUMBER_SIGN: 35,
  AMPERSAND: 38,
  APOSTROPHE: 39,
  HYPHEN_MINUS: 45,
  SOLIDUS: 47,
  DIGIT_0: 48,
  DIGIT_9: 57,
  SEMICOLON: 59,
  LESS_THAN_SIGN: 60,
  EQUALS_SIGN: 61,
  GREATER_THAN_SIGN: 62,
  QUESTION_MARK: 63,
  LATIN_CAPITAL_A: 65,
  LATIN_CAPITAL_F: 70,
  LATIN_CAPITAL_X: 88,
  LATIN_CAPITAL_Z: 90,
  RIGHT_SQUARE_BRACKET: 93,
  GRAVE_ACCENT: 96,
  LATIN_SMALL_A: 97,
  LATIN_SMALL_F: 102,
  LATIN_SMALL_X: 120,
  LATIN_SMALL_Z: 122,
  REPLACEMENT_CHARACTER: 65533
};
St.CODE_POINT_SEQUENCES = {
  DASH_DASH_STRING: [45, 45],
  //--
  DOCTYPE_STRING: [68, 79, 67, 84, 89, 80, 69],
  //DOCTYPE
  CDATA_START_STRING: [91, 67, 68, 65, 84, 65, 91],
  //[CDATA[
  SCRIPT_STRING: [115, 99, 114, 105, 112, 116],
  //script
  PUBLIC_STRING: [80, 85, 66, 76, 73, 67],
  //PUBLIC
  SYSTEM_STRING: [83, 89, 83, 84, 69, 77]
  //SYSTEM
};
St.isSurrogate = function(e) {
  return e >= 55296 && e <= 57343;
};
St.isSurrogatePair = function(e) {
  return e >= 56320 && e <= 57343;
};
St.getSurrogatePairCodePoint = function(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
};
St.isControlCodePoint = function(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
};
St.isUndefinedCodePoint = function(e) {
  return e >= 64976 && e <= 65007 || Ih.indexOf(e) > -1;
};
var xi = {
  controlCharacterInInputStream: "control-character-in-input-stream",
  noncharacterInInputStream: "noncharacter-in-input-stream",
  surrogateInInputStream: "surrogate-in-input-stream",
  nonVoidHtmlElementStartTagWithTrailingSolidus: "non-void-html-element-start-tag-with-trailing-solidus",
  endTagWithAttributes: "end-tag-with-attributes",
  endTagWithTrailingSolidus: "end-tag-with-trailing-solidus",
  unexpectedSolidusInTag: "unexpected-solidus-in-tag",
  unexpectedNullCharacter: "unexpected-null-character",
  unexpectedQuestionMarkInsteadOfTagName: "unexpected-question-mark-instead-of-tag-name",
  invalidFirstCharacterOfTagName: "invalid-first-character-of-tag-name",
  unexpectedEqualsSignBeforeAttributeName: "unexpected-equals-sign-before-attribute-name",
  missingEndTagName: "missing-end-tag-name",
  unexpectedCharacterInAttributeName: "unexpected-character-in-attribute-name",
  unknownNamedCharacterReference: "unknown-named-character-reference",
  missingSemicolonAfterCharacterReference: "missing-semicolon-after-character-reference",
  unexpectedCharacterAfterDoctypeSystemIdentifier: "unexpected-character-after-doctype-system-identifier",
  unexpectedCharacterInUnquotedAttributeValue: "unexpected-character-in-unquoted-attribute-value",
  eofBeforeTagName: "eof-before-tag-name",
  eofInTag: "eof-in-tag",
  missingAttributeValue: "missing-attribute-value",
  missingWhitespaceBetweenAttributes: "missing-whitespace-between-attributes",
  missingWhitespaceAfterDoctypePublicKeyword: "missing-whitespace-after-doctype-public-keyword",
  missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: "missing-whitespace-between-doctype-public-and-system-identifiers",
  missingWhitespaceAfterDoctypeSystemKeyword: "missing-whitespace-after-doctype-system-keyword",
  missingQuoteBeforeDoctypePublicIdentifier: "missing-quote-before-doctype-public-identifier",
  missingQuoteBeforeDoctypeSystemIdentifier: "missing-quote-before-doctype-system-identifier",
  missingDoctypePublicIdentifier: "missing-doctype-public-identifier",
  missingDoctypeSystemIdentifier: "missing-doctype-system-identifier",
  abruptDoctypePublicIdentifier: "abrupt-doctype-public-identifier",
  abruptDoctypeSystemIdentifier: "abrupt-doctype-system-identifier",
  cdataInHtmlContent: "cdata-in-html-content",
  incorrectlyOpenedComment: "incorrectly-opened-comment",
  eofInScriptHtmlCommentLikeText: "eof-in-script-html-comment-like-text",
  eofInDoctype: "eof-in-doctype",
  nestedComment: "nested-comment",
  abruptClosingOfEmptyComment: "abrupt-closing-of-empty-comment",
  eofInComment: "eof-in-comment",
  incorrectlyClosedComment: "incorrectly-closed-comment",
  eofInCdata: "eof-in-cdata",
  absenceOfDigitsInNumericCharacterReference: "absence-of-digits-in-numeric-character-reference",
  nullCharacterReference: "null-character-reference",
  surrogateCharacterReference: "surrogate-character-reference",
  characterReferenceOutsideUnicodeRange: "character-reference-outside-unicode-range",
  controlCharacterReference: "control-character-reference",
  noncharacterCharacterReference: "noncharacter-character-reference",
  missingWhitespaceBeforeDoctypeName: "missing-whitespace-before-doctype-name",
  missingDoctypeName: "missing-doctype-name",
  invalidCharacterSequenceAfterDoctypeName: "invalid-character-sequence-after-doctype-name",
  duplicateAttribute: "duplicate-attribute",
  nonConformingDoctype: "non-conforming-doctype",
  missingDoctype: "missing-doctype",
  misplacedDoctype: "misplaced-doctype",
  endTagWithoutMatchingOpenElement: "end-tag-without-matching-open-element",
  closingOfElementWithOpenChildElements: "closing-of-element-with-open-child-elements",
  disallowedContentInNoscriptInHead: "disallowed-content-in-noscript-in-head",
  openElementsLeftAfterEof: "open-elements-left-after-eof",
  abandonedHeadElementChild: "abandoned-head-element-child",
  misplacedStartTagForHeadElement: "misplaced-start-tag-for-head-element",
  nestedNoscriptInHead: "nested-noscript-in-head",
  eofInElementThatCanContainOnlyText: "eof-in-element-that-can-contain-only-text"
};
const yn = St, Lr = xi, on = yn.CODE_POINTS, Rh = 65536;
let kh = class {
  constructor() {
    this.html = null, this.pos = -1, this.lastGapPos = -1, this.lastCharPos = -1, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = Rh;
  }
  _err() {
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(t) {
    if (this.pos !== this.lastCharPos) {
      const n = this.html.charCodeAt(this.pos + 1);
      if (yn.isSurrogatePair(n))
        return this.pos++, this._addGap(), yn.getSurrogatePairCodePoint(t, n);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, on.EOF;
    return this._err(Lr.surrogateInInputStream), t;
  }
  dropParsedChunk() {
    this.pos > this.bufferWaterline && (this.lastCharPos -= this.pos, this.html = this.html.substring(this.pos), this.pos = 0, this.lastGapPos = -1, this.gapStack = []);
  }
  write(t, n) {
    this.html ? this.html += t : this.html = t, this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1, this.lastChunkWritten = n;
  }
  insertHtmlAtCurrentPos(t) {
    this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1, this.html.length), this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1;
  }
  advance() {
    if (this.pos++, this.pos > this.lastCharPos)
      return this.endOfChunkHit = !this.lastChunkWritten, on.EOF;
    let t = this.html.charCodeAt(this.pos);
    return this.skipNextNewLine && t === on.LINE_FEED ? (this.skipNextNewLine = !1, this._addGap(), this.advance()) : t === on.CARRIAGE_RETURN ? (this.skipNextNewLine = !0, on.LINE_FEED) : (this.skipNextNewLine = !1, yn.isSurrogate(t) && (t = this._processSurrogate(t)), t > 31 && t < 127 || t === on.LINE_FEED || t === on.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
  }
  _checkForProblematicCharacters(t) {
    yn.isControlCodePoint(t) ? this._err(Lr.controlCharacterInInputStream) : yn.isUndefinedCodePoint(t) && this._err(Lr.noncharacterInInputStream);
  }
  retreat() {
    this.pos === this.lastGapPos && (this.lastGapPos = this.gapStack.pop(), this.pos--), this.pos--;
  }
};
var wh = kh, Lh = new Uint16Array([4, 52, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 106, 303, 412, 810, 1432, 1701, 1796, 1987, 2114, 2360, 2420, 2484, 3170, 3251, 4140, 4393, 4575, 4610, 5106, 5512, 5728, 6117, 6274, 6315, 6345, 6427, 6516, 7002, 7910, 8733, 9323, 9870, 10170, 10631, 10893, 11318, 11386, 11467, 12773, 13092, 14474, 14922, 15448, 15542, 16419, 17666, 18166, 18611, 19004, 19095, 19298, 19397, 4, 16, 69, 77, 97, 98, 99, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 140, 150, 158, 169, 176, 194, 199, 210, 216, 222, 226, 242, 256, 266, 283, 294, 108, 105, 103, 5, 198, 1, 59, 148, 1, 198, 80, 5, 38, 1, 59, 156, 1, 38, 99, 117, 116, 101, 5, 193, 1, 59, 167, 1, 193, 114, 101, 118, 101, 59, 1, 258, 4, 2, 105, 121, 182, 191, 114, 99, 5, 194, 1, 59, 189, 1, 194, 59, 1, 1040, 114, 59, 3, 55349, 56580, 114, 97, 118, 101, 5, 192, 1, 59, 208, 1, 192, 112, 104, 97, 59, 1, 913, 97, 99, 114, 59, 1, 256, 100, 59, 1, 10835, 4, 2, 103, 112, 232, 237, 111, 110, 59, 1, 260, 102, 59, 3, 55349, 56632, 112, 108, 121, 70, 117, 110, 99, 116, 105, 111, 110, 59, 1, 8289, 105, 110, 103, 5, 197, 1, 59, 264, 1, 197, 4, 2, 99, 115, 272, 277, 114, 59, 3, 55349, 56476, 105, 103, 110, 59, 1, 8788, 105, 108, 100, 101, 5, 195, 1, 59, 292, 1, 195, 109, 108, 5, 196, 1, 59, 301, 1, 196, 4, 8, 97, 99, 101, 102, 111, 114, 115, 117, 321, 350, 354, 383, 388, 394, 400, 405, 4, 2, 99, 114, 327, 336, 107, 115, 108, 97, 115, 104, 59, 1, 8726, 4, 2, 118, 119, 342, 345, 59, 1, 10983, 101, 100, 59, 1, 8966, 121, 59, 1, 1041, 4, 3, 99, 114, 116, 362, 369, 379, 97, 117, 115, 101, 59, 1, 8757, 110, 111, 117, 108, 108, 105, 115, 59, 1, 8492, 97, 59, 1, 914, 114, 59, 3, 55349, 56581, 112, 102, 59, 3, 55349, 56633, 101, 118, 101, 59, 1, 728, 99, 114, 59, 1, 8492, 109, 112, 101, 113, 59, 1, 8782, 4, 14, 72, 79, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 117, 442, 447, 456, 504, 542, 547, 569, 573, 577, 616, 678, 784, 790, 796, 99, 121, 59, 1, 1063, 80, 89, 5, 169, 1, 59, 454, 1, 169, 4, 3, 99, 112, 121, 464, 470, 497, 117, 116, 101, 59, 1, 262, 4, 2, 59, 105, 476, 478, 1, 8914, 116, 97, 108, 68, 105, 102, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8517, 108, 101, 121, 115, 59, 1, 8493, 4, 4, 97, 101, 105, 111, 514, 520, 530, 535, 114, 111, 110, 59, 1, 268, 100, 105, 108, 5, 199, 1, 59, 528, 1, 199, 114, 99, 59, 1, 264, 110, 105, 110, 116, 59, 1, 8752, 111, 116, 59, 1, 266, 4, 2, 100, 110, 553, 560, 105, 108, 108, 97, 59, 1, 184, 116, 101, 114, 68, 111, 116, 59, 1, 183, 114, 59, 1, 8493, 105, 59, 1, 935, 114, 99, 108, 101, 4, 4, 68, 77, 80, 84, 591, 596, 603, 609, 111, 116, 59, 1, 8857, 105, 110, 117, 115, 59, 1, 8854, 108, 117, 115, 59, 1, 8853, 105, 109, 101, 115, 59, 1, 8855, 111, 4, 2, 99, 115, 623, 646, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8754, 101, 67, 117, 114, 108, 121, 4, 2, 68, 81, 658, 671, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8221, 117, 111, 116, 101, 59, 1, 8217, 4, 4, 108, 110, 112, 117, 688, 701, 736, 753, 111, 110, 4, 2, 59, 101, 696, 698, 1, 8759, 59, 1, 10868, 4, 3, 103, 105, 116, 709, 717, 722, 114, 117, 101, 110, 116, 59, 1, 8801, 110, 116, 59, 1, 8751, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8750, 4, 2, 102, 114, 742, 745, 59, 1, 8450, 111, 100, 117, 99, 116, 59, 1, 8720, 110, 116, 101, 114, 67, 108, 111, 99, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8755, 111, 115, 115, 59, 1, 10799, 99, 114, 59, 3, 55349, 56478, 112, 4, 2, 59, 67, 803, 805, 1, 8915, 97, 112, 59, 1, 8781, 4, 11, 68, 74, 83, 90, 97, 99, 101, 102, 105, 111, 115, 834, 850, 855, 860, 865, 888, 903, 916, 921, 1011, 1415, 4, 2, 59, 111, 840, 842, 1, 8517, 116, 114, 97, 104, 100, 59, 1, 10513, 99, 121, 59, 1, 1026, 99, 121, 59, 1, 1029, 99, 121, 59, 1, 1039, 4, 3, 103, 114, 115, 873, 879, 883, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8609, 104, 118, 59, 1, 10980, 4, 2, 97, 121, 894, 900, 114, 111, 110, 59, 1, 270, 59, 1, 1044, 108, 4, 2, 59, 116, 910, 912, 1, 8711, 97, 59, 1, 916, 114, 59, 3, 55349, 56583, 4, 2, 97, 102, 927, 998, 4, 2, 99, 109, 933, 992, 114, 105, 116, 105, 99, 97, 108, 4, 4, 65, 68, 71, 84, 950, 957, 978, 985, 99, 117, 116, 101, 59, 1, 180, 111, 4, 2, 116, 117, 964, 967, 59, 1, 729, 98, 108, 101, 65, 99, 117, 116, 101, 59, 1, 733, 114, 97, 118, 101, 59, 1, 96, 105, 108, 100, 101, 59, 1, 732, 111, 110, 100, 59, 1, 8900, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8518, 4, 4, 112, 116, 117, 119, 1021, 1026, 1048, 1249, 102, 59, 3, 55349, 56635, 4, 3, 59, 68, 69, 1034, 1036, 1041, 1, 168, 111, 116, 59, 1, 8412, 113, 117, 97, 108, 59, 1, 8784, 98, 108, 101, 4, 6, 67, 68, 76, 82, 85, 86, 1065, 1082, 1101, 1189, 1211, 1236, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8751, 111, 4, 2, 116, 119, 1089, 1092, 59, 1, 168, 110, 65, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 101, 111, 1107, 1141, 102, 116, 4, 3, 65, 82, 84, 1117, 1124, 1136, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8660, 101, 101, 59, 1, 10980, 110, 103, 4, 2, 76, 82, 1149, 1177, 101, 102, 116, 4, 2, 65, 82, 1158, 1165, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10233, 105, 103, 104, 116, 4, 2, 65, 84, 1199, 1206, 114, 114, 111, 119, 59, 1, 8658, 101, 101, 59, 1, 8872, 112, 4, 2, 65, 68, 1218, 1225, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8741, 110, 4, 6, 65, 66, 76, 82, 84, 97, 1264, 1292, 1299, 1352, 1391, 1408, 114, 114, 111, 119, 4, 3, 59, 66, 85, 1276, 1278, 1283, 1, 8595, 97, 114, 59, 1, 10515, 112, 65, 114, 114, 111, 119, 59, 1, 8693, 114, 101, 118, 101, 59, 1, 785, 101, 102, 116, 4, 3, 82, 84, 86, 1310, 1323, 1334, 105, 103, 104, 116, 86, 101, 99, 116, 111, 114, 59, 1, 10576, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10590, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1345, 1347, 1, 8637, 97, 114, 59, 1, 10582, 105, 103, 104, 116, 4, 2, 84, 86, 1362, 1373, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10591, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1384, 1386, 1, 8641, 97, 114, 59, 1, 10583, 101, 101, 4, 2, 59, 65, 1399, 1401, 1, 8868, 114, 114, 111, 119, 59, 1, 8615, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 99, 116, 1421, 1426, 114, 59, 3, 55349, 56479, 114, 111, 107, 59, 1, 272, 4, 16, 78, 84, 97, 99, 100, 102, 103, 108, 109, 111, 112, 113, 115, 116, 117, 120, 1466, 1470, 1478, 1489, 1515, 1520, 1525, 1536, 1544, 1593, 1609, 1617, 1650, 1664, 1668, 1677, 71, 59, 1, 330, 72, 5, 208, 1, 59, 1476, 1, 208, 99, 117, 116, 101, 5, 201, 1, 59, 1487, 1, 201, 4, 3, 97, 105, 121, 1497, 1503, 1512, 114, 111, 110, 59, 1, 282, 114, 99, 5, 202, 1, 59, 1510, 1, 202, 59, 1, 1069, 111, 116, 59, 1, 278, 114, 59, 3, 55349, 56584, 114, 97, 118, 101, 5, 200, 1, 59, 1534, 1, 200, 101, 109, 101, 110, 116, 59, 1, 8712, 4, 2, 97, 112, 1550, 1555, 99, 114, 59, 1, 274, 116, 121, 4, 2, 83, 86, 1563, 1576, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9723, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9643, 4, 2, 103, 112, 1599, 1604, 111, 110, 59, 1, 280, 102, 59, 3, 55349, 56636, 115, 105, 108, 111, 110, 59, 1, 917, 117, 4, 2, 97, 105, 1624, 1640, 108, 4, 2, 59, 84, 1631, 1633, 1, 10869, 105, 108, 100, 101, 59, 1, 8770, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8652, 4, 2, 99, 105, 1656, 1660, 114, 59, 1, 8496, 109, 59, 1, 10867, 97, 59, 1, 919, 109, 108, 5, 203, 1, 59, 1675, 1, 203, 4, 2, 105, 112, 1683, 1689, 115, 116, 115, 59, 1, 8707, 111, 110, 101, 110, 116, 105, 97, 108, 69, 59, 1, 8519, 4, 5, 99, 102, 105, 111, 115, 1713, 1717, 1722, 1762, 1791, 121, 59, 1, 1060, 114, 59, 3, 55349, 56585, 108, 108, 101, 100, 4, 2, 83, 86, 1732, 1745, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9724, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9642, 4, 3, 112, 114, 117, 1770, 1775, 1781, 102, 59, 3, 55349, 56637, 65, 108, 108, 59, 1, 8704, 114, 105, 101, 114, 116, 114, 102, 59, 1, 8497, 99, 114, 59, 1, 8497, 4, 12, 74, 84, 97, 98, 99, 100, 102, 103, 111, 114, 115, 116, 1822, 1827, 1834, 1848, 1855, 1877, 1882, 1887, 1890, 1896, 1978, 1984, 99, 121, 59, 1, 1027, 5, 62, 1, 59, 1832, 1, 62, 109, 109, 97, 4, 2, 59, 100, 1843, 1845, 1, 915, 59, 1, 988, 114, 101, 118, 101, 59, 1, 286, 4, 3, 101, 105, 121, 1863, 1869, 1874, 100, 105, 108, 59, 1, 290, 114, 99, 59, 1, 284, 59, 1, 1043, 111, 116, 59, 1, 288, 114, 59, 3, 55349, 56586, 59, 1, 8921, 112, 102, 59, 3, 55349, 56638, 101, 97, 116, 101, 114, 4, 6, 69, 70, 71, 76, 83, 84, 1915, 1933, 1944, 1953, 1959, 1971, 113, 117, 97, 108, 4, 2, 59, 76, 1925, 1927, 1, 8805, 101, 115, 115, 59, 1, 8923, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8807, 114, 101, 97, 116, 101, 114, 59, 1, 10914, 101, 115, 115, 59, 1, 8823, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10878, 105, 108, 100, 101, 59, 1, 8819, 99, 114, 59, 3, 55349, 56482, 59, 1, 8811, 4, 8, 65, 97, 99, 102, 105, 111, 115, 117, 2005, 2012, 2026, 2032, 2036, 2049, 2073, 2089, 82, 68, 99, 121, 59, 1, 1066, 4, 2, 99, 116, 2018, 2023, 101, 107, 59, 1, 711, 59, 1, 94, 105, 114, 99, 59, 1, 292, 114, 59, 1, 8460, 108, 98, 101, 114, 116, 83, 112, 97, 99, 101, 59, 1, 8459, 4, 2, 112, 114, 2055, 2059, 102, 59, 1, 8461, 105, 122, 111, 110, 116, 97, 108, 76, 105, 110, 101, 59, 1, 9472, 4, 2, 99, 116, 2079, 2083, 114, 59, 1, 8459, 114, 111, 107, 59, 1, 294, 109, 112, 4, 2, 68, 69, 2097, 2107, 111, 119, 110, 72, 117, 109, 112, 59, 1, 8782, 113, 117, 97, 108, 59, 1, 8783, 4, 14, 69, 74, 79, 97, 99, 100, 102, 103, 109, 110, 111, 115, 116, 117, 2144, 2149, 2155, 2160, 2171, 2189, 2194, 2198, 2209, 2245, 2307, 2329, 2334, 2341, 99, 121, 59, 1, 1045, 108, 105, 103, 59, 1, 306, 99, 121, 59, 1, 1025, 99, 117, 116, 101, 5, 205, 1, 59, 2169, 1, 205, 4, 2, 105, 121, 2177, 2186, 114, 99, 5, 206, 1, 59, 2184, 1, 206, 59, 1, 1048, 111, 116, 59, 1, 304, 114, 59, 1, 8465, 114, 97, 118, 101, 5, 204, 1, 59, 2207, 1, 204, 4, 3, 59, 97, 112, 2217, 2219, 2238, 1, 8465, 4, 2, 99, 103, 2225, 2229, 114, 59, 1, 298, 105, 110, 97, 114, 121, 73, 59, 1, 8520, 108, 105, 101, 115, 59, 1, 8658, 4, 2, 116, 118, 2251, 2281, 4, 2, 59, 101, 2257, 2259, 1, 8748, 4, 2, 103, 114, 2265, 2271, 114, 97, 108, 59, 1, 8747, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8898, 105, 115, 105, 98, 108, 101, 4, 2, 67, 84, 2293, 2300, 111, 109, 109, 97, 59, 1, 8291, 105, 109, 101, 115, 59, 1, 8290, 4, 3, 103, 112, 116, 2315, 2320, 2325, 111, 110, 59, 1, 302, 102, 59, 3, 55349, 56640, 97, 59, 1, 921, 99, 114, 59, 1, 8464, 105, 108, 100, 101, 59, 1, 296, 4, 2, 107, 109, 2347, 2352, 99, 121, 59, 1, 1030, 108, 5, 207, 1, 59, 2358, 1, 207, 4, 5, 99, 102, 111, 115, 117, 2372, 2386, 2391, 2397, 2414, 4, 2, 105, 121, 2378, 2383, 114, 99, 59, 1, 308, 59, 1, 1049, 114, 59, 3, 55349, 56589, 112, 102, 59, 3, 55349, 56641, 4, 2, 99, 101, 2403, 2408, 114, 59, 3, 55349, 56485, 114, 99, 121, 59, 1, 1032, 107, 99, 121, 59, 1, 1028, 4, 7, 72, 74, 97, 99, 102, 111, 115, 2436, 2441, 2446, 2452, 2467, 2472, 2478, 99, 121, 59, 1, 1061, 99, 121, 59, 1, 1036, 112, 112, 97, 59, 1, 922, 4, 2, 101, 121, 2458, 2464, 100, 105, 108, 59, 1, 310, 59, 1, 1050, 114, 59, 3, 55349, 56590, 112, 102, 59, 3, 55349, 56642, 99, 114, 59, 3, 55349, 56486, 4, 11, 74, 84, 97, 99, 101, 102, 108, 109, 111, 115, 116, 2508, 2513, 2520, 2562, 2585, 2981, 2986, 3004, 3011, 3146, 3167, 99, 121, 59, 1, 1033, 5, 60, 1, 59, 2518, 1, 60, 4, 5, 99, 109, 110, 112, 114, 2532, 2538, 2544, 2548, 2558, 117, 116, 101, 59, 1, 313, 98, 100, 97, 59, 1, 923, 103, 59, 1, 10218, 108, 97, 99, 101, 116, 114, 102, 59, 1, 8466, 114, 59, 1, 8606, 4, 3, 97, 101, 121, 2570, 2576, 2582, 114, 111, 110, 59, 1, 317, 100, 105, 108, 59, 1, 315, 59, 1, 1051, 4, 2, 102, 115, 2591, 2907, 116, 4, 10, 65, 67, 68, 70, 82, 84, 85, 86, 97, 114, 2614, 2663, 2672, 2728, 2735, 2760, 2820, 2870, 2888, 2895, 4, 2, 110, 114, 2620, 2633, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10216, 114, 111, 119, 4, 3, 59, 66, 82, 2644, 2646, 2651, 1, 8592, 97, 114, 59, 1, 8676, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8646, 101, 105, 108, 105, 110, 103, 59, 1, 8968, 111, 4, 2, 117, 119, 2679, 2692, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10214, 110, 4, 2, 84, 86, 2699, 2710, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10593, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2721, 2723, 1, 8643, 97, 114, 59, 1, 10585, 108, 111, 111, 114, 59, 1, 8970, 105, 103, 104, 116, 4, 2, 65, 86, 2745, 2752, 114, 114, 111, 119, 59, 1, 8596, 101, 99, 116, 111, 114, 59, 1, 10574, 4, 2, 101, 114, 2766, 2792, 101, 4, 3, 59, 65, 86, 2775, 2777, 2784, 1, 8867, 114, 114, 111, 119, 59, 1, 8612, 101, 99, 116, 111, 114, 59, 1, 10586, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 2806, 2808, 2813, 1, 8882, 97, 114, 59, 1, 10703, 113, 117, 97, 108, 59, 1, 8884, 112, 4, 3, 68, 84, 86, 2829, 2841, 2852, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10577, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10592, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2863, 2865, 1, 8639, 97, 114, 59, 1, 10584, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2881, 2883, 1, 8636, 97, 114, 59, 1, 10578, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8660, 115, 4, 6, 69, 70, 71, 76, 83, 84, 2922, 2936, 2947, 2956, 2962, 2974, 113, 117, 97, 108, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8922, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8806, 114, 101, 97, 116, 101, 114, 59, 1, 8822, 101, 115, 115, 59, 1, 10913, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10877, 105, 108, 100, 101, 59, 1, 8818, 114, 59, 3, 55349, 56591, 4, 2, 59, 101, 2992, 2994, 1, 8920, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8666, 105, 100, 111, 116, 59, 1, 319, 4, 3, 110, 112, 119, 3019, 3110, 3115, 103, 4, 4, 76, 82, 108, 114, 3030, 3058, 3070, 3098, 101, 102, 116, 4, 2, 65, 82, 3039, 3046, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10231, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10230, 101, 102, 116, 4, 2, 97, 114, 3079, 3086, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10233, 102, 59, 3, 55349, 56643, 101, 114, 4, 2, 76, 82, 3123, 3134, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8601, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8600, 4, 3, 99, 104, 116, 3154, 3158, 3161, 114, 59, 1, 8466, 59, 1, 8624, 114, 111, 107, 59, 1, 321, 59, 1, 8810, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 3188, 3192, 3196, 3222, 3227, 3237, 3243, 3248, 112, 59, 1, 10501, 121, 59, 1, 1052, 4, 2, 100, 108, 3202, 3213, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8287, 108, 105, 110, 116, 114, 102, 59, 1, 8499, 114, 59, 3, 55349, 56592, 110, 117, 115, 80, 108, 117, 115, 59, 1, 8723, 112, 102, 59, 3, 55349, 56644, 99, 114, 59, 1, 8499, 59, 1, 924, 4, 9, 74, 97, 99, 101, 102, 111, 115, 116, 117, 3271, 3276, 3283, 3306, 3422, 3427, 4120, 4126, 4137, 99, 121, 59, 1, 1034, 99, 117, 116, 101, 59, 1, 323, 4, 3, 97, 101, 121, 3291, 3297, 3303, 114, 111, 110, 59, 1, 327, 100, 105, 108, 59, 1, 325, 59, 1, 1053, 4, 3, 103, 115, 119, 3314, 3380, 3415, 97, 116, 105, 118, 101, 4, 3, 77, 84, 86, 3327, 3340, 3365, 101, 100, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8203, 104, 105, 4, 2, 99, 110, 3348, 3357, 107, 83, 112, 97, 99, 101, 59, 1, 8203, 83, 112, 97, 99, 101, 59, 1, 8203, 101, 114, 121, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8203, 116, 101, 100, 4, 2, 71, 76, 3389, 3405, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8811, 101, 115, 115, 76, 101, 115, 115, 59, 1, 8810, 76, 105, 110, 101, 59, 1, 10, 114, 59, 3, 55349, 56593, 4, 4, 66, 110, 112, 116, 3437, 3444, 3460, 3464, 114, 101, 97, 107, 59, 1, 8288, 66, 114, 101, 97, 107, 105, 110, 103, 83, 112, 97, 99, 101, 59, 1, 160, 102, 59, 1, 8469, 4, 13, 59, 67, 68, 69, 71, 72, 76, 78, 80, 82, 83, 84, 86, 3492, 3494, 3517, 3536, 3578, 3657, 3685, 3784, 3823, 3860, 3915, 4066, 4107, 1, 10988, 4, 2, 111, 117, 3500, 3510, 110, 103, 114, 117, 101, 110, 116, 59, 1, 8802, 112, 67, 97, 112, 59, 1, 8813, 111, 117, 98, 108, 101, 86, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8742, 4, 3, 108, 113, 120, 3544, 3552, 3571, 101, 109, 101, 110, 116, 59, 1, 8713, 117, 97, 108, 4, 2, 59, 84, 3561, 3563, 1, 8800, 105, 108, 100, 101, 59, 3, 8770, 824, 105, 115, 116, 115, 59, 1, 8708, 114, 101, 97, 116, 101, 114, 4, 7, 59, 69, 70, 71, 76, 83, 84, 3600, 3602, 3609, 3621, 3631, 3637, 3650, 1, 8815, 113, 117, 97, 108, 59, 1, 8817, 117, 108, 108, 69, 113, 117, 97, 108, 59, 3, 8807, 824, 114, 101, 97, 116, 101, 114, 59, 3, 8811, 824, 101, 115, 115, 59, 1, 8825, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10878, 824, 105, 108, 100, 101, 59, 1, 8821, 117, 109, 112, 4, 2, 68, 69, 3666, 3677, 111, 119, 110, 72, 117, 109, 112, 59, 3, 8782, 824, 113, 117, 97, 108, 59, 3, 8783, 824, 101, 4, 2, 102, 115, 3692, 3724, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3709, 3711, 3717, 1, 8938, 97, 114, 59, 3, 10703, 824, 113, 117, 97, 108, 59, 1, 8940, 115, 4, 6, 59, 69, 71, 76, 83, 84, 3739, 3741, 3748, 3757, 3764, 3777, 1, 8814, 113, 117, 97, 108, 59, 1, 8816, 114, 101, 97, 116, 101, 114, 59, 1, 8824, 101, 115, 115, 59, 3, 8810, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10877, 824, 105, 108, 100, 101, 59, 1, 8820, 101, 115, 116, 101, 100, 4, 2, 71, 76, 3795, 3812, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 3, 10914, 824, 101, 115, 115, 76, 101, 115, 115, 59, 3, 10913, 824, 114, 101, 99, 101, 100, 101, 115, 4, 3, 59, 69, 83, 3838, 3840, 3848, 1, 8832, 113, 117, 97, 108, 59, 3, 10927, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8928, 4, 2, 101, 105, 3866, 3881, 118, 101, 114, 115, 101, 69, 108, 101, 109, 101, 110, 116, 59, 1, 8716, 103, 104, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3900, 3902, 3908, 1, 8939, 97, 114, 59, 3, 10704, 824, 113, 117, 97, 108, 59, 1, 8941, 4, 2, 113, 117, 3921, 3973, 117, 97, 114, 101, 83, 117, 4, 2, 98, 112, 3933, 3952, 115, 101, 116, 4, 2, 59, 69, 3942, 3945, 3, 8847, 824, 113, 117, 97, 108, 59, 1, 8930, 101, 114, 115, 101, 116, 4, 2, 59, 69, 3963, 3966, 3, 8848, 824, 113, 117, 97, 108, 59, 1, 8931, 4, 3, 98, 99, 112, 3981, 4e3, 4045, 115, 101, 116, 4, 2, 59, 69, 3990, 3993, 3, 8834, 8402, 113, 117, 97, 108, 59, 1, 8840, 99, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 4015, 4017, 4025, 4037, 1, 8833, 113, 117, 97, 108, 59, 3, 10928, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8929, 105, 108, 100, 101, 59, 3, 8831, 824, 101, 114, 115, 101, 116, 4, 2, 59, 69, 4056, 4059, 3, 8835, 8402, 113, 117, 97, 108, 59, 1, 8841, 105, 108, 100, 101, 4, 4, 59, 69, 70, 84, 4080, 4082, 4089, 4100, 1, 8769, 113, 117, 97, 108, 59, 1, 8772, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8775, 105, 108, 100, 101, 59, 1, 8777, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8740, 99, 114, 59, 3, 55349, 56489, 105, 108, 100, 101, 5, 209, 1, 59, 4135, 1, 209, 59, 1, 925, 4, 14, 69, 97, 99, 100, 102, 103, 109, 111, 112, 114, 115, 116, 117, 118, 4170, 4176, 4187, 4205, 4212, 4217, 4228, 4253, 4259, 4292, 4295, 4316, 4337, 4346, 108, 105, 103, 59, 1, 338, 99, 117, 116, 101, 5, 211, 1, 59, 4185, 1, 211, 4, 2, 105, 121, 4193, 4202, 114, 99, 5, 212, 1, 59, 4200, 1, 212, 59, 1, 1054, 98, 108, 97, 99, 59, 1, 336, 114, 59, 3, 55349, 56594, 114, 97, 118, 101, 5, 210, 1, 59, 4226, 1, 210, 4, 3, 97, 101, 105, 4236, 4241, 4246, 99, 114, 59, 1, 332, 103, 97, 59, 1, 937, 99, 114, 111, 110, 59, 1, 927, 112, 102, 59, 3, 55349, 56646, 101, 110, 67, 117, 114, 108, 121, 4, 2, 68, 81, 4272, 4285, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8220, 117, 111, 116, 101, 59, 1, 8216, 59, 1, 10836, 4, 2, 99, 108, 4301, 4306, 114, 59, 3, 55349, 56490, 97, 115, 104, 5, 216, 1, 59, 4314, 1, 216, 105, 4, 2, 108, 109, 4323, 4332, 100, 101, 5, 213, 1, 59, 4330, 1, 213, 101, 115, 59, 1, 10807, 109, 108, 5, 214, 1, 59, 4344, 1, 214, 101, 114, 4, 2, 66, 80, 4354, 4380, 4, 2, 97, 114, 4360, 4364, 114, 59, 1, 8254, 97, 99, 4, 2, 101, 107, 4372, 4375, 59, 1, 9182, 101, 116, 59, 1, 9140, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9180, 4, 9, 97, 99, 102, 104, 105, 108, 111, 114, 115, 4413, 4422, 4426, 4431, 4435, 4438, 4448, 4471, 4561, 114, 116, 105, 97, 108, 68, 59, 1, 8706, 121, 59, 1, 1055, 114, 59, 3, 55349, 56595, 105, 59, 1, 934, 59, 1, 928, 117, 115, 77, 105, 110, 117, 115, 59, 1, 177, 4, 2, 105, 112, 4454, 4467, 110, 99, 97, 114, 101, 112, 108, 97, 110, 101, 59, 1, 8460, 102, 59, 1, 8473, 4, 4, 59, 101, 105, 111, 4481, 4483, 4526, 4531, 1, 10939, 99, 101, 100, 101, 115, 4, 4, 59, 69, 83, 84, 4498, 4500, 4507, 4519, 1, 8826, 113, 117, 97, 108, 59, 1, 10927, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8828, 105, 108, 100, 101, 59, 1, 8830, 109, 101, 59, 1, 8243, 4, 2, 100, 112, 4537, 4543, 117, 99, 116, 59, 1, 8719, 111, 114, 116, 105, 111, 110, 4, 2, 59, 97, 4555, 4557, 1, 8759, 108, 59, 1, 8733, 4, 2, 99, 105, 4567, 4572, 114, 59, 3, 55349, 56491, 59, 1, 936, 4, 4, 85, 102, 111, 115, 4585, 4594, 4599, 4604, 79, 84, 5, 34, 1, 59, 4592, 1, 34, 114, 59, 3, 55349, 56596, 112, 102, 59, 1, 8474, 99, 114, 59, 3, 55349, 56492, 4, 12, 66, 69, 97, 99, 101, 102, 104, 105, 111, 114, 115, 117, 4636, 4642, 4650, 4681, 4704, 4763, 4767, 4771, 5047, 5069, 5081, 5094, 97, 114, 114, 59, 1, 10512, 71, 5, 174, 1, 59, 4648, 1, 174, 4, 3, 99, 110, 114, 4658, 4664, 4668, 117, 116, 101, 59, 1, 340, 103, 59, 1, 10219, 114, 4, 2, 59, 116, 4675, 4677, 1, 8608, 108, 59, 1, 10518, 4, 3, 97, 101, 121, 4689, 4695, 4701, 114, 111, 110, 59, 1, 344, 100, 105, 108, 59, 1, 342, 59, 1, 1056, 4, 2, 59, 118, 4710, 4712, 1, 8476, 101, 114, 115, 101, 4, 2, 69, 85, 4722, 4748, 4, 2, 108, 113, 4728, 4736, 101, 109, 101, 110, 116, 59, 1, 8715, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8651, 112, 69, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10607, 114, 59, 1, 8476, 111, 59, 1, 929, 103, 104, 116, 4, 8, 65, 67, 68, 70, 84, 85, 86, 97, 4792, 4840, 4849, 4905, 4912, 4972, 5022, 5040, 4, 2, 110, 114, 4798, 4811, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10217, 114, 111, 119, 4, 3, 59, 66, 76, 4822, 4824, 4829, 1, 8594, 97, 114, 59, 1, 8677, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8644, 101, 105, 108, 105, 110, 103, 59, 1, 8969, 111, 4, 2, 117, 119, 4856, 4869, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10215, 110, 4, 2, 84, 86, 4876, 4887, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10589, 101, 99, 116, 111, 114, 4, 2, 59, 66, 4898, 4900, 1, 8642, 97, 114, 59, 1, 10581, 108, 111, 111, 114, 59, 1, 8971, 4, 2, 101, 114, 4918, 4944, 101, 4, 3, 59, 65, 86, 4927, 4929, 4936, 1, 8866, 114, 114, 111, 119, 59, 1, 8614, 101, 99, 116, 111, 114, 59, 1, 10587, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 4958, 4960, 4965, 1, 8883, 97, 114, 59, 1, 10704, 113, 117, 97, 108, 59, 1, 8885, 112, 4, 3, 68, 84, 86, 4981, 4993, 5004, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10575, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10588, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5015, 5017, 1, 8638, 97, 114, 59, 1, 10580, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5033, 5035, 1, 8640, 97, 114, 59, 1, 10579, 114, 114, 111, 119, 59, 1, 8658, 4, 2, 112, 117, 5053, 5057, 102, 59, 1, 8477, 110, 100, 73, 109, 112, 108, 105, 101, 115, 59, 1, 10608, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8667, 4, 2, 99, 104, 5087, 5091, 114, 59, 1, 8475, 59, 1, 8625, 108, 101, 68, 101, 108, 97, 121, 101, 100, 59, 1, 10740, 4, 13, 72, 79, 97, 99, 102, 104, 105, 109, 111, 113, 115, 116, 117, 5134, 5150, 5157, 5164, 5198, 5203, 5259, 5265, 5277, 5283, 5374, 5380, 5385, 4, 2, 67, 99, 5140, 5146, 72, 99, 121, 59, 1, 1065, 121, 59, 1, 1064, 70, 84, 99, 121, 59, 1, 1068, 99, 117, 116, 101, 59, 1, 346, 4, 5, 59, 97, 101, 105, 121, 5176, 5178, 5184, 5190, 5195, 1, 10940, 114, 111, 110, 59, 1, 352, 100, 105, 108, 59, 1, 350, 114, 99, 59, 1, 348, 59, 1, 1057, 114, 59, 3, 55349, 56598, 111, 114, 116, 4, 4, 68, 76, 82, 85, 5216, 5227, 5238, 5250, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8595, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8592, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8594, 112, 65, 114, 114, 111, 119, 59, 1, 8593, 103, 109, 97, 59, 1, 931, 97, 108, 108, 67, 105, 114, 99, 108, 101, 59, 1, 8728, 112, 102, 59, 3, 55349, 56650, 4, 2, 114, 117, 5289, 5293, 116, 59, 1, 8730, 97, 114, 101, 4, 4, 59, 73, 83, 85, 5306, 5308, 5322, 5367, 1, 9633, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8851, 117, 4, 2, 98, 112, 5329, 5347, 115, 101, 116, 4, 2, 59, 69, 5338, 5340, 1, 8847, 113, 117, 97, 108, 59, 1, 8849, 101, 114, 115, 101, 116, 4, 2, 59, 69, 5358, 5360, 1, 8848, 113, 117, 97, 108, 59, 1, 8850, 110, 105, 111, 110, 59, 1, 8852, 99, 114, 59, 3, 55349, 56494, 97, 114, 59, 1, 8902, 4, 4, 98, 99, 109, 112, 5395, 5420, 5475, 5478, 4, 2, 59, 115, 5401, 5403, 1, 8912, 101, 116, 4, 2, 59, 69, 5411, 5413, 1, 8912, 113, 117, 97, 108, 59, 1, 8838, 4, 2, 99, 104, 5426, 5468, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 5440, 5442, 5449, 5461, 1, 8827, 113, 117, 97, 108, 59, 1, 10928, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8829, 105, 108, 100, 101, 59, 1, 8831, 84, 104, 97, 116, 59, 1, 8715, 59, 1, 8721, 4, 3, 59, 101, 115, 5486, 5488, 5507, 1, 8913, 114, 115, 101, 116, 4, 2, 59, 69, 5498, 5500, 1, 8835, 113, 117, 97, 108, 59, 1, 8839, 101, 116, 59, 1, 8913, 4, 11, 72, 82, 83, 97, 99, 102, 104, 105, 111, 114, 115, 5536, 5546, 5552, 5567, 5579, 5602, 5607, 5655, 5695, 5701, 5711, 79, 82, 78, 5, 222, 1, 59, 5544, 1, 222, 65, 68, 69, 59, 1, 8482, 4, 2, 72, 99, 5558, 5563, 99, 121, 59, 1, 1035, 121, 59, 1, 1062, 4, 2, 98, 117, 5573, 5576, 59, 1, 9, 59, 1, 932, 4, 3, 97, 101, 121, 5587, 5593, 5599, 114, 111, 110, 59, 1, 356, 100, 105, 108, 59, 1, 354, 59, 1, 1058, 114, 59, 3, 55349, 56599, 4, 2, 101, 105, 5613, 5631, 4, 2, 114, 116, 5619, 5627, 101, 102, 111, 114, 101, 59, 1, 8756, 97, 59, 1, 920, 4, 2, 99, 110, 5637, 5647, 107, 83, 112, 97, 99, 101, 59, 3, 8287, 8202, 83, 112, 97, 99, 101, 59, 1, 8201, 108, 100, 101, 4, 4, 59, 69, 70, 84, 5668, 5670, 5677, 5688, 1, 8764, 113, 117, 97, 108, 59, 1, 8771, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8773, 105, 108, 100, 101, 59, 1, 8776, 112, 102, 59, 3, 55349, 56651, 105, 112, 108, 101, 68, 111, 116, 59, 1, 8411, 4, 2, 99, 116, 5717, 5722, 114, 59, 3, 55349, 56495, 114, 111, 107, 59, 1, 358, 4, 14, 97, 98, 99, 100, 102, 103, 109, 110, 111, 112, 114, 115, 116, 117, 5758, 5789, 5805, 5823, 5830, 5835, 5846, 5852, 5921, 5937, 6089, 6095, 6101, 6108, 4, 2, 99, 114, 5764, 5774, 117, 116, 101, 5, 218, 1, 59, 5772, 1, 218, 114, 4, 2, 59, 111, 5781, 5783, 1, 8607, 99, 105, 114, 59, 1, 10569, 114, 4, 2, 99, 101, 5796, 5800, 121, 59, 1, 1038, 118, 101, 59, 1, 364, 4, 2, 105, 121, 5811, 5820, 114, 99, 5, 219, 1, 59, 5818, 1, 219, 59, 1, 1059, 98, 108, 97, 99, 59, 1, 368, 114, 59, 3, 55349, 56600, 114, 97, 118, 101, 5, 217, 1, 59, 5844, 1, 217, 97, 99, 114, 59, 1, 362, 4, 2, 100, 105, 5858, 5905, 101, 114, 4, 2, 66, 80, 5866, 5892, 4, 2, 97, 114, 5872, 5876, 114, 59, 1, 95, 97, 99, 4, 2, 101, 107, 5884, 5887, 59, 1, 9183, 101, 116, 59, 1, 9141, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9181, 111, 110, 4, 2, 59, 80, 5913, 5915, 1, 8899, 108, 117, 115, 59, 1, 8846, 4, 2, 103, 112, 5927, 5932, 111, 110, 59, 1, 370, 102, 59, 3, 55349, 56652, 4, 8, 65, 68, 69, 84, 97, 100, 112, 115, 5955, 5985, 5996, 6009, 6026, 6033, 6044, 6075, 114, 114, 111, 119, 4, 3, 59, 66, 68, 5967, 5969, 5974, 1, 8593, 97, 114, 59, 1, 10514, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8645, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8597, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10606, 101, 101, 4, 2, 59, 65, 6017, 6019, 1, 8869, 114, 114, 111, 119, 59, 1, 8613, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 4, 2, 76, 82, 6052, 6063, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8598, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8599, 105, 4, 2, 59, 108, 6082, 6084, 1, 978, 111, 110, 59, 1, 933, 105, 110, 103, 59, 1, 366, 99, 114, 59, 3, 55349, 56496, 105, 108, 100, 101, 59, 1, 360, 109, 108, 5, 220, 1, 59, 6115, 1, 220, 4, 9, 68, 98, 99, 100, 101, 102, 111, 115, 118, 6137, 6143, 6148, 6152, 6166, 6250, 6255, 6261, 6267, 97, 115, 104, 59, 1, 8875, 97, 114, 59, 1, 10987, 121, 59, 1, 1042, 97, 115, 104, 4, 2, 59, 108, 6161, 6163, 1, 8873, 59, 1, 10982, 4, 2, 101, 114, 6172, 6175, 59, 1, 8897, 4, 3, 98, 116, 121, 6183, 6188, 6238, 97, 114, 59, 1, 8214, 4, 2, 59, 105, 6194, 6196, 1, 8214, 99, 97, 108, 4, 4, 66, 76, 83, 84, 6209, 6214, 6220, 6231, 97, 114, 59, 1, 8739, 105, 110, 101, 59, 1, 124, 101, 112, 97, 114, 97, 116, 111, 114, 59, 1, 10072, 105, 108, 100, 101, 59, 1, 8768, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8202, 114, 59, 3, 55349, 56601, 112, 102, 59, 3, 55349, 56653, 99, 114, 59, 3, 55349, 56497, 100, 97, 115, 104, 59, 1, 8874, 4, 5, 99, 101, 102, 111, 115, 6286, 6292, 6298, 6303, 6309, 105, 114, 99, 59, 1, 372, 100, 103, 101, 59, 1, 8896, 114, 59, 3, 55349, 56602, 112, 102, 59, 3, 55349, 56654, 99, 114, 59, 3, 55349, 56498, 4, 4, 102, 105, 111, 115, 6325, 6330, 6333, 6339, 114, 59, 3, 55349, 56603, 59, 1, 926, 112, 102, 59, 3, 55349, 56655, 99, 114, 59, 3, 55349, 56499, 4, 9, 65, 73, 85, 97, 99, 102, 111, 115, 117, 6365, 6370, 6375, 6380, 6391, 6405, 6410, 6416, 6422, 99, 121, 59, 1, 1071, 99, 121, 59, 1, 1031, 99, 121, 59, 1, 1070, 99, 117, 116, 101, 5, 221, 1, 59, 6389, 1, 221, 4, 2, 105, 121, 6397, 6402, 114, 99, 59, 1, 374, 59, 1, 1067, 114, 59, 3, 55349, 56604, 112, 102, 59, 3, 55349, 56656, 99, 114, 59, 3, 55349, 56500, 109, 108, 59, 1, 376, 4, 8, 72, 97, 99, 100, 101, 102, 111, 115, 6445, 6450, 6457, 6472, 6477, 6501, 6505, 6510, 99, 121, 59, 1, 1046, 99, 117, 116, 101, 59, 1, 377, 4, 2, 97, 121, 6463, 6469, 114, 111, 110, 59, 1, 381, 59, 1, 1047, 111, 116, 59, 1, 379, 4, 2, 114, 116, 6483, 6497, 111, 87, 105, 100, 116, 104, 83, 112, 97, 99, 101, 59, 1, 8203, 97, 59, 1, 918, 114, 59, 1, 8488, 112, 102, 59, 1, 8484, 99, 114, 59, 3, 55349, 56501, 4, 16, 97, 98, 99, 101, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 119, 6550, 6561, 6568, 6612, 6622, 6634, 6645, 6672, 6699, 6854, 6870, 6923, 6933, 6963, 6974, 6983, 99, 117, 116, 101, 5, 225, 1, 59, 6559, 1, 225, 114, 101, 118, 101, 59, 1, 259, 4, 6, 59, 69, 100, 105, 117, 121, 6582, 6584, 6588, 6591, 6600, 6609, 1, 8766, 59, 3, 8766, 819, 59, 1, 8767, 114, 99, 5, 226, 1, 59, 6598, 1, 226, 116, 101, 5, 180, 1, 59, 6607, 1, 180, 59, 1, 1072, 108, 105, 103, 5, 230, 1, 59, 6620, 1, 230, 4, 2, 59, 114, 6628, 6630, 1, 8289, 59, 3, 55349, 56606, 114, 97, 118, 101, 5, 224, 1, 59, 6643, 1, 224, 4, 2, 101, 112, 6651, 6667, 4, 2, 102, 112, 6657, 6663, 115, 121, 109, 59, 1, 8501, 104, 59, 1, 8501, 104, 97, 59, 1, 945, 4, 2, 97, 112, 6678, 6692, 4, 2, 99, 108, 6684, 6688, 114, 59, 1, 257, 103, 59, 1, 10815, 5, 38, 1, 59, 6697, 1, 38, 4, 2, 100, 103, 6705, 6737, 4, 5, 59, 97, 100, 115, 118, 6717, 6719, 6724, 6727, 6734, 1, 8743, 110, 100, 59, 1, 10837, 59, 1, 10844, 108, 111, 112, 101, 59, 1, 10840, 59, 1, 10842, 4, 7, 59, 101, 108, 109, 114, 115, 122, 6753, 6755, 6758, 6762, 6814, 6835, 6848, 1, 8736, 59, 1, 10660, 101, 59, 1, 8736, 115, 100, 4, 2, 59, 97, 6770, 6772, 1, 8737, 4, 8, 97, 98, 99, 100, 101, 102, 103, 104, 6790, 6793, 6796, 6799, 6802, 6805, 6808, 6811, 59, 1, 10664, 59, 1, 10665, 59, 1, 10666, 59, 1, 10667, 59, 1, 10668, 59, 1, 10669, 59, 1, 10670, 59, 1, 10671, 116, 4, 2, 59, 118, 6821, 6823, 1, 8735, 98, 4, 2, 59, 100, 6830, 6832, 1, 8894, 59, 1, 10653, 4, 2, 112, 116, 6841, 6845, 104, 59, 1, 8738, 59, 1, 197, 97, 114, 114, 59, 1, 9084, 4, 2, 103, 112, 6860, 6865, 111, 110, 59, 1, 261, 102, 59, 3, 55349, 56658, 4, 7, 59, 69, 97, 101, 105, 111, 112, 6886, 6888, 6891, 6897, 6900, 6904, 6908, 1, 8776, 59, 1, 10864, 99, 105, 114, 59, 1, 10863, 59, 1, 8778, 100, 59, 1, 8779, 115, 59, 1, 39, 114, 111, 120, 4, 2, 59, 101, 6917, 6919, 1, 8776, 113, 59, 1, 8778, 105, 110, 103, 5, 229, 1, 59, 6931, 1, 229, 4, 3, 99, 116, 121, 6941, 6946, 6949, 114, 59, 3, 55349, 56502, 59, 1, 42, 109, 112, 4, 2, 59, 101, 6957, 6959, 1, 8776, 113, 59, 1, 8781, 105, 108, 100, 101, 5, 227, 1, 59, 6972, 1, 227, 109, 108, 5, 228, 1, 59, 6981, 1, 228, 4, 2, 99, 105, 6989, 6997, 111, 110, 105, 110, 116, 59, 1, 8755, 110, 116, 59, 1, 10769, 4, 16, 78, 97, 98, 99, 100, 101, 102, 105, 107, 108, 110, 111, 112, 114, 115, 117, 7036, 7041, 7119, 7135, 7149, 7155, 7219, 7224, 7347, 7354, 7463, 7489, 7786, 7793, 7814, 7866, 111, 116, 59, 1, 10989, 4, 2, 99, 114, 7047, 7094, 107, 4, 4, 99, 101, 112, 115, 7058, 7064, 7073, 7080, 111, 110, 103, 59, 1, 8780, 112, 115, 105, 108, 111, 110, 59, 1, 1014, 114, 105, 109, 101, 59, 1, 8245, 105, 109, 4, 2, 59, 101, 7088, 7090, 1, 8765, 113, 59, 1, 8909, 4, 2, 118, 119, 7100, 7105, 101, 101, 59, 1, 8893, 101, 100, 4, 2, 59, 103, 7113, 7115, 1, 8965, 101, 59, 1, 8965, 114, 107, 4, 2, 59, 116, 7127, 7129, 1, 9141, 98, 114, 107, 59, 1, 9142, 4, 2, 111, 121, 7141, 7146, 110, 103, 59, 1, 8780, 59, 1, 1073, 113, 117, 111, 59, 1, 8222, 4, 5, 99, 109, 112, 114, 116, 7167, 7181, 7188, 7193, 7199, 97, 117, 115, 4, 2, 59, 101, 7176, 7178, 1, 8757, 59, 1, 8757, 112, 116, 121, 118, 59, 1, 10672, 115, 105, 59, 1, 1014, 110, 111, 117, 59, 1, 8492, 4, 3, 97, 104, 119, 7207, 7210, 7213, 59, 1, 946, 59, 1, 8502, 101, 101, 110, 59, 1, 8812, 114, 59, 3, 55349, 56607, 103, 4, 7, 99, 111, 115, 116, 117, 118, 119, 7241, 7262, 7288, 7305, 7328, 7335, 7340, 4, 3, 97, 105, 117, 7249, 7253, 7258, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 4, 3, 100, 112, 116, 7270, 7275, 7281, 111, 116, 59, 1, 10752, 108, 117, 115, 59, 1, 10753, 105, 109, 101, 115, 59, 1, 10754, 4, 2, 113, 116, 7294, 7300, 99, 117, 112, 59, 1, 10758, 97, 114, 59, 1, 9733, 114, 105, 97, 110, 103, 108, 101, 4, 2, 100, 117, 7318, 7324, 111, 119, 110, 59, 1, 9661, 112, 59, 1, 9651, 112, 108, 117, 115, 59, 1, 10756, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 97, 114, 111, 119, 59, 1, 10509, 4, 3, 97, 107, 111, 7362, 7436, 7458, 4, 2, 99, 110, 7368, 7432, 107, 4, 3, 108, 115, 116, 7377, 7386, 7394, 111, 122, 101, 110, 103, 101, 59, 1, 10731, 113, 117, 97, 114, 101, 59, 1, 9642, 114, 105, 97, 110, 103, 108, 101, 4, 4, 59, 100, 108, 114, 7411, 7413, 7419, 7425, 1, 9652, 111, 119, 110, 59, 1, 9662, 101, 102, 116, 59, 1, 9666, 105, 103, 104, 116, 59, 1, 9656, 107, 59, 1, 9251, 4, 2, 49, 51, 7442, 7454, 4, 2, 50, 52, 7448, 7451, 59, 1, 9618, 59, 1, 9617, 52, 59, 1, 9619, 99, 107, 59, 1, 9608, 4, 2, 101, 111, 7469, 7485, 4, 2, 59, 113, 7475, 7478, 3, 61, 8421, 117, 105, 118, 59, 3, 8801, 8421, 116, 59, 1, 8976, 4, 4, 112, 116, 119, 120, 7499, 7504, 7517, 7523, 102, 59, 3, 55349, 56659, 4, 2, 59, 116, 7510, 7512, 1, 8869, 111, 109, 59, 1, 8869, 116, 105, 101, 59, 1, 8904, 4, 12, 68, 72, 85, 86, 98, 100, 104, 109, 112, 116, 117, 118, 7549, 7571, 7597, 7619, 7655, 7660, 7682, 7708, 7715, 7721, 7728, 7750, 4, 4, 76, 82, 108, 114, 7559, 7562, 7565, 7568, 59, 1, 9559, 59, 1, 9556, 59, 1, 9558, 59, 1, 9555, 4, 5, 59, 68, 85, 100, 117, 7583, 7585, 7588, 7591, 7594, 1, 9552, 59, 1, 9574, 59, 1, 9577, 59, 1, 9572, 59, 1, 9575, 4, 4, 76, 82, 108, 114, 7607, 7610, 7613, 7616, 59, 1, 9565, 59, 1, 9562, 59, 1, 9564, 59, 1, 9561, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7635, 7637, 7640, 7643, 7646, 7649, 7652, 1, 9553, 59, 1, 9580, 59, 1, 9571, 59, 1, 9568, 59, 1, 9579, 59, 1, 9570, 59, 1, 9567, 111, 120, 59, 1, 10697, 4, 4, 76, 82, 108, 114, 7670, 7673, 7676, 7679, 59, 1, 9557, 59, 1, 9554, 59, 1, 9488, 59, 1, 9484, 4, 5, 59, 68, 85, 100, 117, 7694, 7696, 7699, 7702, 7705, 1, 9472, 59, 1, 9573, 59, 1, 9576, 59, 1, 9516, 59, 1, 9524, 105, 110, 117, 115, 59, 1, 8863, 108, 117, 115, 59, 1, 8862, 105, 109, 101, 115, 59, 1, 8864, 4, 4, 76, 82, 108, 114, 7738, 7741, 7744, 7747, 59, 1, 9563, 59, 1, 9560, 59, 1, 9496, 59, 1, 9492, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7766, 7768, 7771, 7774, 7777, 7780, 7783, 1, 9474, 59, 1, 9578, 59, 1, 9569, 59, 1, 9566, 59, 1, 9532, 59, 1, 9508, 59, 1, 9500, 114, 105, 109, 101, 59, 1, 8245, 4, 2, 101, 118, 7799, 7804, 118, 101, 59, 1, 728, 98, 97, 114, 5, 166, 1, 59, 7812, 1, 166, 4, 4, 99, 101, 105, 111, 7824, 7829, 7834, 7846, 114, 59, 3, 55349, 56503, 109, 105, 59, 1, 8271, 109, 4, 2, 59, 101, 7841, 7843, 1, 8765, 59, 1, 8909, 108, 4, 3, 59, 98, 104, 7855, 7857, 7860, 1, 92, 59, 1, 10693, 115, 117, 98, 59, 1, 10184, 4, 2, 108, 109, 7872, 7885, 108, 4, 2, 59, 101, 7879, 7881, 1, 8226, 116, 59, 1, 8226, 112, 4, 3, 59, 69, 101, 7894, 7896, 7899, 1, 8782, 59, 1, 10926, 4, 2, 59, 113, 7905, 7907, 1, 8783, 59, 1, 8783, 4, 15, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 116, 117, 119, 121, 7942, 8021, 8075, 8080, 8121, 8126, 8157, 8279, 8295, 8430, 8446, 8485, 8491, 8707, 8726, 4, 3, 99, 112, 114, 7950, 7956, 8007, 117, 116, 101, 59, 1, 263, 4, 6, 59, 97, 98, 99, 100, 115, 7970, 7972, 7977, 7984, 7998, 8003, 1, 8745, 110, 100, 59, 1, 10820, 114, 99, 117, 112, 59, 1, 10825, 4, 2, 97, 117, 7990, 7994, 112, 59, 1, 10827, 112, 59, 1, 10823, 111, 116, 59, 1, 10816, 59, 3, 8745, 65024, 4, 2, 101, 111, 8013, 8017, 116, 59, 1, 8257, 110, 59, 1, 711, 4, 4, 97, 101, 105, 117, 8031, 8046, 8056, 8061, 4, 2, 112, 114, 8037, 8041, 115, 59, 1, 10829, 111, 110, 59, 1, 269, 100, 105, 108, 5, 231, 1, 59, 8054, 1, 231, 114, 99, 59, 1, 265, 112, 115, 4, 2, 59, 115, 8069, 8071, 1, 10828, 109, 59, 1, 10832, 111, 116, 59, 1, 267, 4, 3, 100, 109, 110, 8088, 8097, 8104, 105, 108, 5, 184, 1, 59, 8095, 1, 184, 112, 116, 121, 118, 59, 1, 10674, 116, 5, 162, 2, 59, 101, 8112, 8114, 1, 162, 114, 100, 111, 116, 59, 1, 183, 114, 59, 3, 55349, 56608, 4, 3, 99, 101, 105, 8134, 8138, 8154, 121, 59, 1, 1095, 99, 107, 4, 2, 59, 109, 8146, 8148, 1, 10003, 97, 114, 107, 59, 1, 10003, 59, 1, 967, 114, 4, 7, 59, 69, 99, 101, 102, 109, 115, 8174, 8176, 8179, 8258, 8261, 8268, 8273, 1, 9675, 59, 1, 10691, 4, 3, 59, 101, 108, 8187, 8189, 8193, 1, 710, 113, 59, 1, 8791, 101, 4, 2, 97, 100, 8200, 8223, 114, 114, 111, 119, 4, 2, 108, 114, 8210, 8216, 101, 102, 116, 59, 1, 8634, 105, 103, 104, 116, 59, 1, 8635, 4, 5, 82, 83, 97, 99, 100, 8235, 8238, 8241, 8246, 8252, 59, 1, 174, 59, 1, 9416, 115, 116, 59, 1, 8859, 105, 114, 99, 59, 1, 8858, 97, 115, 104, 59, 1, 8861, 59, 1, 8791, 110, 105, 110, 116, 59, 1, 10768, 105, 100, 59, 1, 10991, 99, 105, 114, 59, 1, 10690, 117, 98, 115, 4, 2, 59, 117, 8288, 8290, 1, 9827, 105, 116, 59, 1, 9827, 4, 4, 108, 109, 110, 112, 8305, 8326, 8376, 8400, 111, 110, 4, 2, 59, 101, 8313, 8315, 1, 58, 4, 2, 59, 113, 8321, 8323, 1, 8788, 59, 1, 8788, 4, 2, 109, 112, 8332, 8344, 97, 4, 2, 59, 116, 8339, 8341, 1, 44, 59, 1, 64, 4, 3, 59, 102, 108, 8352, 8354, 8358, 1, 8705, 110, 59, 1, 8728, 101, 4, 2, 109, 120, 8365, 8371, 101, 110, 116, 59, 1, 8705, 101, 115, 59, 1, 8450, 4, 2, 103, 105, 8382, 8395, 4, 2, 59, 100, 8388, 8390, 1, 8773, 111, 116, 59, 1, 10861, 110, 116, 59, 1, 8750, 4, 3, 102, 114, 121, 8408, 8412, 8417, 59, 3, 55349, 56660, 111, 100, 59, 1, 8720, 5, 169, 2, 59, 115, 8424, 8426, 1, 169, 114, 59, 1, 8471, 4, 2, 97, 111, 8436, 8441, 114, 114, 59, 1, 8629, 115, 115, 59, 1, 10007, 4, 2, 99, 117, 8452, 8457, 114, 59, 3, 55349, 56504, 4, 2, 98, 112, 8463, 8474, 4, 2, 59, 101, 8469, 8471, 1, 10959, 59, 1, 10961, 4, 2, 59, 101, 8480, 8482, 1, 10960, 59, 1, 10962, 100, 111, 116, 59, 1, 8943, 4, 7, 100, 101, 108, 112, 114, 118, 119, 8507, 8522, 8536, 8550, 8600, 8697, 8702, 97, 114, 114, 4, 2, 108, 114, 8516, 8519, 59, 1, 10552, 59, 1, 10549, 4, 2, 112, 115, 8528, 8532, 114, 59, 1, 8926, 99, 59, 1, 8927, 97, 114, 114, 4, 2, 59, 112, 8545, 8547, 1, 8630, 59, 1, 10557, 4, 6, 59, 98, 99, 100, 111, 115, 8564, 8566, 8573, 8587, 8592, 8596, 1, 8746, 114, 99, 97, 112, 59, 1, 10824, 4, 2, 97, 117, 8579, 8583, 112, 59, 1, 10822, 112, 59, 1, 10826, 111, 116, 59, 1, 8845, 114, 59, 1, 10821, 59, 3, 8746, 65024, 4, 4, 97, 108, 114, 118, 8610, 8623, 8663, 8672, 114, 114, 4, 2, 59, 109, 8618, 8620, 1, 8631, 59, 1, 10556, 121, 4, 3, 101, 118, 119, 8632, 8651, 8656, 113, 4, 2, 112, 115, 8639, 8645, 114, 101, 99, 59, 1, 8926, 117, 99, 99, 59, 1, 8927, 101, 101, 59, 1, 8910, 101, 100, 103, 101, 59, 1, 8911, 101, 110, 5, 164, 1, 59, 8670, 1, 164, 101, 97, 114, 114, 111, 119, 4, 2, 108, 114, 8684, 8690, 101, 102, 116, 59, 1, 8630, 105, 103, 104, 116, 59, 1, 8631, 101, 101, 59, 1, 8910, 101, 100, 59, 1, 8911, 4, 2, 99, 105, 8713, 8721, 111, 110, 105, 110, 116, 59, 1, 8754, 110, 116, 59, 1, 8753, 108, 99, 116, 121, 59, 1, 9005, 4, 19, 65, 72, 97, 98, 99, 100, 101, 102, 104, 105, 106, 108, 111, 114, 115, 116, 117, 119, 122, 8773, 8778, 8783, 8821, 8839, 8854, 8887, 8914, 8930, 8944, 9036, 9041, 9058, 9197, 9227, 9258, 9281, 9297, 9305, 114, 114, 59, 1, 8659, 97, 114, 59, 1, 10597, 4, 4, 103, 108, 114, 115, 8793, 8799, 8805, 8809, 103, 101, 114, 59, 1, 8224, 101, 116, 104, 59, 1, 8504, 114, 59, 1, 8595, 104, 4, 2, 59, 118, 8816, 8818, 1, 8208, 59, 1, 8867, 4, 2, 107, 108, 8827, 8834, 97, 114, 111, 119, 59, 1, 10511, 97, 99, 59, 1, 733, 4, 2, 97, 121, 8845, 8851, 114, 111, 110, 59, 1, 271, 59, 1, 1076, 4, 3, 59, 97, 111, 8862, 8864, 8880, 1, 8518, 4, 2, 103, 114, 8870, 8876, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8650, 116, 115, 101, 113, 59, 1, 10871, 4, 3, 103, 108, 109, 8895, 8902, 8907, 5, 176, 1, 59, 8900, 1, 176, 116, 97, 59, 1, 948, 112, 116, 121, 118, 59, 1, 10673, 4, 2, 105, 114, 8920, 8926, 115, 104, 116, 59, 1, 10623, 59, 3, 55349, 56609, 97, 114, 4, 2, 108, 114, 8938, 8941, 59, 1, 8643, 59, 1, 8642, 4, 5, 97, 101, 103, 115, 118, 8956, 8986, 8989, 8996, 9001, 109, 4, 3, 59, 111, 115, 8965, 8967, 8983, 1, 8900, 110, 100, 4, 2, 59, 115, 8975, 8977, 1, 8900, 117, 105, 116, 59, 1, 9830, 59, 1, 9830, 59, 1, 168, 97, 109, 109, 97, 59, 1, 989, 105, 110, 59, 1, 8946, 4, 3, 59, 105, 111, 9009, 9011, 9031, 1, 247, 100, 101, 5, 247, 2, 59, 111, 9020, 9022, 1, 247, 110, 116, 105, 109, 101, 115, 59, 1, 8903, 110, 120, 59, 1, 8903, 99, 121, 59, 1, 1106, 99, 4, 2, 111, 114, 9048, 9053, 114, 110, 59, 1, 8990, 111, 112, 59, 1, 8973, 4, 5, 108, 112, 116, 117, 119, 9070, 9076, 9081, 9130, 9144, 108, 97, 114, 59, 1, 36, 102, 59, 3, 55349, 56661, 4, 5, 59, 101, 109, 112, 115, 9093, 9095, 9109, 9116, 9122, 1, 729, 113, 4, 2, 59, 100, 9102, 9104, 1, 8784, 111, 116, 59, 1, 8785, 105, 110, 117, 115, 59, 1, 8760, 108, 117, 115, 59, 1, 8724, 113, 117, 97, 114, 101, 59, 1, 8865, 98, 108, 101, 98, 97, 114, 119, 101, 100, 103, 101, 59, 1, 8966, 110, 4, 3, 97, 100, 104, 9153, 9160, 9172, 114, 114, 111, 119, 59, 1, 8595, 111, 119, 110, 97, 114, 114, 111, 119, 115, 59, 1, 8650, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 9184, 9190, 101, 102, 116, 59, 1, 8643, 105, 103, 104, 116, 59, 1, 8642, 4, 2, 98, 99, 9203, 9211, 107, 97, 114, 111, 119, 59, 1, 10512, 4, 2, 111, 114, 9217, 9222, 114, 110, 59, 1, 8991, 111, 112, 59, 1, 8972, 4, 3, 99, 111, 116, 9235, 9248, 9252, 4, 2, 114, 121, 9241, 9245, 59, 3, 55349, 56505, 59, 1, 1109, 108, 59, 1, 10742, 114, 111, 107, 59, 1, 273, 4, 2, 100, 114, 9264, 9269, 111, 116, 59, 1, 8945, 105, 4, 2, 59, 102, 9276, 9278, 1, 9663, 59, 1, 9662, 4, 2, 97, 104, 9287, 9292, 114, 114, 59, 1, 8693, 97, 114, 59, 1, 10607, 97, 110, 103, 108, 101, 59, 1, 10662, 4, 2, 99, 105, 9311, 9315, 121, 59, 1, 1119, 103, 114, 97, 114, 114, 59, 1, 10239, 4, 18, 68, 97, 99, 100, 101, 102, 103, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 120, 9361, 9376, 9398, 9439, 9444, 9447, 9462, 9495, 9531, 9585, 9598, 9614, 9659, 9755, 9771, 9792, 9808, 9826, 4, 2, 68, 111, 9367, 9372, 111, 116, 59, 1, 10871, 116, 59, 1, 8785, 4, 2, 99, 115, 9382, 9392, 117, 116, 101, 5, 233, 1, 59, 9390, 1, 233, 116, 101, 114, 59, 1, 10862, 4, 4, 97, 105, 111, 121, 9408, 9414, 9430, 9436, 114, 111, 110, 59, 1, 283, 114, 4, 2, 59, 99, 9421, 9423, 1, 8790, 5, 234, 1, 59, 9428, 1, 234, 108, 111, 110, 59, 1, 8789, 59, 1, 1101, 111, 116, 59, 1, 279, 59, 1, 8519, 4, 2, 68, 114, 9453, 9458, 111, 116, 59, 1, 8786, 59, 3, 55349, 56610, 4, 3, 59, 114, 115, 9470, 9472, 9482, 1, 10906, 97, 118, 101, 5, 232, 1, 59, 9480, 1, 232, 4, 2, 59, 100, 9488, 9490, 1, 10902, 111, 116, 59, 1, 10904, 4, 4, 59, 105, 108, 115, 9505, 9507, 9515, 9518, 1, 10905, 110, 116, 101, 114, 115, 59, 1, 9191, 59, 1, 8467, 4, 2, 59, 100, 9524, 9526, 1, 10901, 111, 116, 59, 1, 10903, 4, 3, 97, 112, 115, 9539, 9544, 9564, 99, 114, 59, 1, 275, 116, 121, 4, 3, 59, 115, 118, 9554, 9556, 9561, 1, 8709, 101, 116, 59, 1, 8709, 59, 1, 8709, 112, 4, 2, 49, 59, 9571, 9583, 4, 2, 51, 52, 9577, 9580, 59, 1, 8196, 59, 1, 8197, 1, 8195, 4, 2, 103, 115, 9591, 9594, 59, 1, 331, 112, 59, 1, 8194, 4, 2, 103, 112, 9604, 9609, 111, 110, 59, 1, 281, 102, 59, 3, 55349, 56662, 4, 3, 97, 108, 115, 9622, 9635, 9640, 114, 4, 2, 59, 115, 9629, 9631, 1, 8917, 108, 59, 1, 10723, 117, 115, 59, 1, 10865, 105, 4, 3, 59, 108, 118, 9649, 9651, 9656, 1, 949, 111, 110, 59, 1, 949, 59, 1, 1013, 4, 4, 99, 115, 117, 118, 9669, 9686, 9716, 9747, 4, 2, 105, 111, 9675, 9680, 114, 99, 59, 1, 8790, 108, 111, 110, 59, 1, 8789, 4, 2, 105, 108, 9692, 9696, 109, 59, 1, 8770, 97, 110, 116, 4, 2, 103, 108, 9705, 9710, 116, 114, 59, 1, 10902, 101, 115, 115, 59, 1, 10901, 4, 3, 97, 101, 105, 9724, 9729, 9734, 108, 115, 59, 1, 61, 115, 116, 59, 1, 8799, 118, 4, 2, 59, 68, 9741, 9743, 1, 8801, 68, 59, 1, 10872, 112, 97, 114, 115, 108, 59, 1, 10725, 4, 2, 68, 97, 9761, 9766, 111, 116, 59, 1, 8787, 114, 114, 59, 1, 10609, 4, 3, 99, 100, 105, 9779, 9783, 9788, 114, 59, 1, 8495, 111, 116, 59, 1, 8784, 109, 59, 1, 8770, 4, 2, 97, 104, 9798, 9801, 59, 1, 951, 5, 240, 1, 59, 9806, 1, 240, 4, 2, 109, 114, 9814, 9822, 108, 5, 235, 1, 59, 9820, 1, 235, 111, 59, 1, 8364, 4, 3, 99, 105, 112, 9834, 9838, 9843, 108, 59, 1, 33, 115, 116, 59, 1, 8707, 4, 2, 101, 111, 9849, 9859, 99, 116, 97, 116, 105, 111, 110, 59, 1, 8496, 110, 101, 110, 116, 105, 97, 108, 101, 59, 1, 8519, 4, 12, 97, 99, 101, 102, 105, 106, 108, 110, 111, 112, 114, 115, 9896, 9910, 9914, 9921, 9954, 9960, 9967, 9989, 9994, 10027, 10036, 10164, 108, 108, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8786, 121, 59, 1, 1092, 109, 97, 108, 101, 59, 1, 9792, 4, 3, 105, 108, 114, 9929, 9935, 9950, 108, 105, 103, 59, 1, 64259, 4, 2, 105, 108, 9941, 9945, 103, 59, 1, 64256, 105, 103, 59, 1, 64260, 59, 3, 55349, 56611, 108, 105, 103, 59, 1, 64257, 108, 105, 103, 59, 3, 102, 106, 4, 3, 97, 108, 116, 9975, 9979, 9984, 116, 59, 1, 9837, 105, 103, 59, 1, 64258, 110, 115, 59, 1, 9649, 111, 102, 59, 1, 402, 4, 2, 112, 114, 1e4, 10005, 102, 59, 3, 55349, 56663, 4, 2, 97, 107, 10011, 10016, 108, 108, 59, 1, 8704, 4, 2, 59, 118, 10022, 10024, 1, 8916, 59, 1, 10969, 97, 114, 116, 105, 110, 116, 59, 1, 10765, 4, 2, 97, 111, 10042, 10159, 4, 2, 99, 115, 10048, 10155, 4, 6, 49, 50, 51, 52, 53, 55, 10062, 10102, 10114, 10135, 10139, 10151, 4, 6, 50, 51, 52, 53, 54, 56, 10076, 10083, 10086, 10093, 10096, 10099, 5, 189, 1, 59, 10081, 1, 189, 59, 1, 8531, 5, 188, 1, 59, 10091, 1, 188, 59, 1, 8533, 59, 1, 8537, 59, 1, 8539, 4, 2, 51, 53, 10108, 10111, 59, 1, 8532, 59, 1, 8534, 4, 3, 52, 53, 56, 10122, 10129, 10132, 5, 190, 1, 59, 10127, 1, 190, 59, 1, 8535, 59, 1, 8540, 53, 59, 1, 8536, 4, 2, 54, 56, 10145, 10148, 59, 1, 8538, 59, 1, 8541, 56, 59, 1, 8542, 108, 59, 1, 8260, 119, 110, 59, 1, 8994, 99, 114, 59, 3, 55349, 56507, 4, 17, 69, 97, 98, 99, 100, 101, 102, 103, 105, 106, 108, 110, 111, 114, 115, 116, 118, 10206, 10217, 10247, 10254, 10268, 10273, 10358, 10363, 10374, 10380, 10385, 10406, 10458, 10464, 10470, 10497, 10610, 4, 2, 59, 108, 10212, 10214, 1, 8807, 59, 1, 10892, 4, 3, 99, 109, 112, 10225, 10231, 10244, 117, 116, 101, 59, 1, 501, 109, 97, 4, 2, 59, 100, 10239, 10241, 1, 947, 59, 1, 989, 59, 1, 10886, 114, 101, 118, 101, 59, 1, 287, 4, 2, 105, 121, 10260, 10265, 114, 99, 59, 1, 285, 59, 1, 1075, 111, 116, 59, 1, 289, 4, 4, 59, 108, 113, 115, 10283, 10285, 10288, 10308, 1, 8805, 59, 1, 8923, 4, 3, 59, 113, 115, 10296, 10298, 10301, 1, 8805, 59, 1, 8807, 108, 97, 110, 116, 59, 1, 10878, 4, 4, 59, 99, 100, 108, 10318, 10320, 10324, 10345, 1, 10878, 99, 59, 1, 10921, 111, 116, 4, 2, 59, 111, 10332, 10334, 1, 10880, 4, 2, 59, 108, 10340, 10342, 1, 10882, 59, 1, 10884, 4, 2, 59, 101, 10351, 10354, 3, 8923, 65024, 115, 59, 1, 10900, 114, 59, 3, 55349, 56612, 4, 2, 59, 103, 10369, 10371, 1, 8811, 59, 1, 8921, 109, 101, 108, 59, 1, 8503, 99, 121, 59, 1, 1107, 4, 4, 59, 69, 97, 106, 10395, 10397, 10400, 10403, 1, 8823, 59, 1, 10898, 59, 1, 10917, 59, 1, 10916, 4, 4, 69, 97, 101, 115, 10416, 10419, 10434, 10453, 59, 1, 8809, 112, 4, 2, 59, 112, 10426, 10428, 1, 10890, 114, 111, 120, 59, 1, 10890, 4, 2, 59, 113, 10440, 10442, 1, 10888, 4, 2, 59, 113, 10448, 10450, 1, 10888, 59, 1, 8809, 105, 109, 59, 1, 8935, 112, 102, 59, 3, 55349, 56664, 97, 118, 101, 59, 1, 96, 4, 2, 99, 105, 10476, 10480, 114, 59, 1, 8458, 109, 4, 3, 59, 101, 108, 10489, 10491, 10494, 1, 8819, 59, 1, 10894, 59, 1, 10896, 5, 62, 6, 59, 99, 100, 108, 113, 114, 10512, 10514, 10527, 10532, 10538, 10545, 1, 62, 4, 2, 99, 105, 10520, 10523, 59, 1, 10919, 114, 59, 1, 10874, 111, 116, 59, 1, 8919, 80, 97, 114, 59, 1, 10645, 117, 101, 115, 116, 59, 1, 10876, 4, 5, 97, 100, 101, 108, 115, 10557, 10574, 10579, 10599, 10605, 4, 2, 112, 114, 10563, 10570, 112, 114, 111, 120, 59, 1, 10886, 114, 59, 1, 10616, 111, 116, 59, 1, 8919, 113, 4, 2, 108, 113, 10586, 10592, 101, 115, 115, 59, 1, 8923, 108, 101, 115, 115, 59, 1, 10892, 101, 115, 115, 59, 1, 8823, 105, 109, 59, 1, 8819, 4, 2, 101, 110, 10616, 10626, 114, 116, 110, 101, 113, 113, 59, 3, 8809, 65024, 69, 59, 3, 8809, 65024, 4, 10, 65, 97, 98, 99, 101, 102, 107, 111, 115, 121, 10653, 10658, 10713, 10718, 10724, 10760, 10765, 10786, 10850, 10875, 114, 114, 59, 1, 8660, 4, 4, 105, 108, 109, 114, 10668, 10674, 10678, 10684, 114, 115, 112, 59, 1, 8202, 102, 59, 1, 189, 105, 108, 116, 59, 1, 8459, 4, 2, 100, 114, 10690, 10695, 99, 121, 59, 1, 1098, 4, 3, 59, 99, 119, 10703, 10705, 10710, 1, 8596, 105, 114, 59, 1, 10568, 59, 1, 8621, 97, 114, 59, 1, 8463, 105, 114, 99, 59, 1, 293, 4, 3, 97, 108, 114, 10732, 10748, 10754, 114, 116, 115, 4, 2, 59, 117, 10741, 10743, 1, 9829, 105, 116, 59, 1, 9829, 108, 105, 112, 59, 1, 8230, 99, 111, 110, 59, 1, 8889, 114, 59, 3, 55349, 56613, 115, 4, 2, 101, 119, 10772, 10779, 97, 114, 111, 119, 59, 1, 10533, 97, 114, 111, 119, 59, 1, 10534, 4, 5, 97, 109, 111, 112, 114, 10798, 10803, 10809, 10839, 10844, 114, 114, 59, 1, 8703, 116, 104, 116, 59, 1, 8763, 107, 4, 2, 108, 114, 10816, 10827, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8617, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8618, 102, 59, 3, 55349, 56665, 98, 97, 114, 59, 1, 8213, 4, 3, 99, 108, 116, 10858, 10863, 10869, 114, 59, 3, 55349, 56509, 97, 115, 104, 59, 1, 8463, 114, 111, 107, 59, 1, 295, 4, 2, 98, 112, 10881, 10887, 117, 108, 108, 59, 1, 8259, 104, 101, 110, 59, 1, 8208, 4, 15, 97, 99, 101, 102, 103, 105, 106, 109, 110, 111, 112, 113, 115, 116, 117, 10925, 10936, 10958, 10977, 10990, 11001, 11039, 11045, 11101, 11192, 11220, 11226, 11237, 11285, 11299, 99, 117, 116, 101, 5, 237, 1, 59, 10934, 1, 237, 4, 3, 59, 105, 121, 10944, 10946, 10955, 1, 8291, 114, 99, 5, 238, 1, 59, 10953, 1, 238, 59, 1, 1080, 4, 2, 99, 120, 10964, 10968, 121, 59, 1, 1077, 99, 108, 5, 161, 1, 59, 10975, 1, 161, 4, 2, 102, 114, 10983, 10986, 59, 1, 8660, 59, 3, 55349, 56614, 114, 97, 118, 101, 5, 236, 1, 59, 10999, 1, 236, 4, 4, 59, 105, 110, 111, 11011, 11013, 11028, 11034, 1, 8520, 4, 2, 105, 110, 11019, 11024, 110, 116, 59, 1, 10764, 116, 59, 1, 8749, 102, 105, 110, 59, 1, 10716, 116, 97, 59, 1, 8489, 108, 105, 103, 59, 1, 307, 4, 3, 97, 111, 112, 11053, 11092, 11096, 4, 3, 99, 103, 116, 11061, 11065, 11088, 114, 59, 1, 299, 4, 3, 101, 108, 112, 11073, 11076, 11082, 59, 1, 8465, 105, 110, 101, 59, 1, 8464, 97, 114, 116, 59, 1, 8465, 104, 59, 1, 305, 102, 59, 1, 8887, 101, 100, 59, 1, 437, 4, 5, 59, 99, 102, 111, 116, 11113, 11115, 11121, 11136, 11142, 1, 8712, 97, 114, 101, 59, 1, 8453, 105, 110, 4, 2, 59, 116, 11129, 11131, 1, 8734, 105, 101, 59, 1, 10717, 100, 111, 116, 59, 1, 305, 4, 5, 59, 99, 101, 108, 112, 11154, 11156, 11161, 11179, 11186, 1, 8747, 97, 108, 59, 1, 8890, 4, 2, 103, 114, 11167, 11173, 101, 114, 115, 59, 1, 8484, 99, 97, 108, 59, 1, 8890, 97, 114, 104, 107, 59, 1, 10775, 114, 111, 100, 59, 1, 10812, 4, 4, 99, 103, 112, 116, 11202, 11206, 11211, 11216, 121, 59, 1, 1105, 111, 110, 59, 1, 303, 102, 59, 3, 55349, 56666, 97, 59, 1, 953, 114, 111, 100, 59, 1, 10812, 117, 101, 115, 116, 5, 191, 1, 59, 11235, 1, 191, 4, 2, 99, 105, 11243, 11248, 114, 59, 3, 55349, 56510, 110, 4, 5, 59, 69, 100, 115, 118, 11261, 11263, 11266, 11271, 11282, 1, 8712, 59, 1, 8953, 111, 116, 59, 1, 8949, 4, 2, 59, 118, 11277, 11279, 1, 8948, 59, 1, 8947, 59, 1, 8712, 4, 2, 59, 105, 11291, 11293, 1, 8290, 108, 100, 101, 59, 1, 297, 4, 2, 107, 109, 11305, 11310, 99, 121, 59, 1, 1110, 108, 5, 239, 1, 59, 11316, 1, 239, 4, 6, 99, 102, 109, 111, 115, 117, 11332, 11346, 11351, 11357, 11363, 11380, 4, 2, 105, 121, 11338, 11343, 114, 99, 59, 1, 309, 59, 1, 1081, 114, 59, 3, 55349, 56615, 97, 116, 104, 59, 1, 567, 112, 102, 59, 3, 55349, 56667, 4, 2, 99, 101, 11369, 11374, 114, 59, 3, 55349, 56511, 114, 99, 121, 59, 1, 1112, 107, 99, 121, 59, 1, 1108, 4, 8, 97, 99, 102, 103, 104, 106, 111, 115, 11404, 11418, 11433, 11438, 11445, 11450, 11455, 11461, 112, 112, 97, 4, 2, 59, 118, 11413, 11415, 1, 954, 59, 1, 1008, 4, 2, 101, 121, 11424, 11430, 100, 105, 108, 59, 1, 311, 59, 1, 1082, 114, 59, 3, 55349, 56616, 114, 101, 101, 110, 59, 1, 312, 99, 121, 59, 1, 1093, 99, 121, 59, 1, 1116, 112, 102, 59, 3, 55349, 56668, 99, 114, 59, 3, 55349, 56512, 4, 23, 65, 66, 69, 72, 97, 98, 99, 100, 101, 102, 103, 104, 106, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 11515, 11538, 11544, 11555, 11560, 11721, 11780, 11818, 11868, 12136, 12160, 12171, 12203, 12208, 12246, 12275, 12327, 12509, 12523, 12569, 12641, 12732, 12752, 4, 3, 97, 114, 116, 11523, 11528, 11532, 114, 114, 59, 1, 8666, 114, 59, 1, 8656, 97, 105, 108, 59, 1, 10523, 97, 114, 114, 59, 1, 10510, 4, 2, 59, 103, 11550, 11552, 1, 8806, 59, 1, 10891, 97, 114, 59, 1, 10594, 4, 9, 99, 101, 103, 109, 110, 112, 113, 114, 116, 11580, 11586, 11594, 11600, 11606, 11624, 11627, 11636, 11694, 117, 116, 101, 59, 1, 314, 109, 112, 116, 121, 118, 59, 1, 10676, 114, 97, 110, 59, 1, 8466, 98, 100, 97, 59, 1, 955, 103, 4, 3, 59, 100, 108, 11615, 11617, 11620, 1, 10216, 59, 1, 10641, 101, 59, 1, 10216, 59, 1, 10885, 117, 111, 5, 171, 1, 59, 11634, 1, 171, 114, 4, 8, 59, 98, 102, 104, 108, 112, 115, 116, 11655, 11657, 11669, 11673, 11677, 11681, 11685, 11690, 1, 8592, 4, 2, 59, 102, 11663, 11665, 1, 8676, 115, 59, 1, 10527, 115, 59, 1, 10525, 107, 59, 1, 8617, 112, 59, 1, 8619, 108, 59, 1, 10553, 105, 109, 59, 1, 10611, 108, 59, 1, 8610, 4, 3, 59, 97, 101, 11702, 11704, 11709, 1, 10923, 105, 108, 59, 1, 10521, 4, 2, 59, 115, 11715, 11717, 1, 10925, 59, 3, 10925, 65024, 4, 3, 97, 98, 114, 11729, 11734, 11739, 114, 114, 59, 1, 10508, 114, 107, 59, 1, 10098, 4, 2, 97, 107, 11745, 11758, 99, 4, 2, 101, 107, 11752, 11755, 59, 1, 123, 59, 1, 91, 4, 2, 101, 115, 11764, 11767, 59, 1, 10635, 108, 4, 2, 100, 117, 11774, 11777, 59, 1, 10639, 59, 1, 10637, 4, 4, 97, 101, 117, 121, 11790, 11796, 11811, 11815, 114, 111, 110, 59, 1, 318, 4, 2, 100, 105, 11802, 11807, 105, 108, 59, 1, 316, 108, 59, 1, 8968, 98, 59, 1, 123, 59, 1, 1083, 4, 4, 99, 113, 114, 115, 11828, 11832, 11845, 11864, 97, 59, 1, 10550, 117, 111, 4, 2, 59, 114, 11840, 11842, 1, 8220, 59, 1, 8222, 4, 2, 100, 117, 11851, 11857, 104, 97, 114, 59, 1, 10599, 115, 104, 97, 114, 59, 1, 10571, 104, 59, 1, 8626, 4, 5, 59, 102, 103, 113, 115, 11880, 11882, 12008, 12011, 12031, 1, 8804, 116, 4, 5, 97, 104, 108, 114, 116, 11895, 11913, 11935, 11947, 11996, 114, 114, 111, 119, 4, 2, 59, 116, 11905, 11907, 1, 8592, 97, 105, 108, 59, 1, 8610, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 11925, 11931, 111, 119, 110, 59, 1, 8637, 112, 59, 1, 8636, 101, 102, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8647, 105, 103, 104, 116, 4, 3, 97, 104, 115, 11959, 11974, 11984, 114, 114, 111, 119, 4, 2, 59, 115, 11969, 11971, 1, 8596, 59, 1, 8646, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8651, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8621, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8907, 59, 1, 8922, 4, 3, 59, 113, 115, 12019, 12021, 12024, 1, 8804, 59, 1, 8806, 108, 97, 110, 116, 59, 1, 10877, 4, 5, 59, 99, 100, 103, 115, 12043, 12045, 12049, 12070, 12083, 1, 10877, 99, 59, 1, 10920, 111, 116, 4, 2, 59, 111, 12057, 12059, 1, 10879, 4, 2, 59, 114, 12065, 12067, 1, 10881, 59, 1, 10883, 4, 2, 59, 101, 12076, 12079, 3, 8922, 65024, 115, 59, 1, 10899, 4, 5, 97, 100, 101, 103, 115, 12095, 12103, 12108, 12126, 12131, 112, 112, 114, 111, 120, 59, 1, 10885, 111, 116, 59, 1, 8918, 113, 4, 2, 103, 113, 12115, 12120, 116, 114, 59, 1, 8922, 103, 116, 114, 59, 1, 10891, 116, 114, 59, 1, 8822, 105, 109, 59, 1, 8818, 4, 3, 105, 108, 114, 12144, 12150, 12156, 115, 104, 116, 59, 1, 10620, 111, 111, 114, 59, 1, 8970, 59, 3, 55349, 56617, 4, 2, 59, 69, 12166, 12168, 1, 8822, 59, 1, 10897, 4, 2, 97, 98, 12177, 12198, 114, 4, 2, 100, 117, 12184, 12187, 59, 1, 8637, 4, 2, 59, 108, 12193, 12195, 1, 8636, 59, 1, 10602, 108, 107, 59, 1, 9604, 99, 121, 59, 1, 1113, 4, 5, 59, 97, 99, 104, 116, 12220, 12222, 12227, 12235, 12241, 1, 8810, 114, 114, 59, 1, 8647, 111, 114, 110, 101, 114, 59, 1, 8990, 97, 114, 100, 59, 1, 10603, 114, 105, 59, 1, 9722, 4, 2, 105, 111, 12252, 12258, 100, 111, 116, 59, 1, 320, 117, 115, 116, 4, 2, 59, 97, 12267, 12269, 1, 9136, 99, 104, 101, 59, 1, 9136, 4, 4, 69, 97, 101, 115, 12285, 12288, 12303, 12322, 59, 1, 8808, 112, 4, 2, 59, 112, 12295, 12297, 1, 10889, 114, 111, 120, 59, 1, 10889, 4, 2, 59, 113, 12309, 12311, 1, 10887, 4, 2, 59, 113, 12317, 12319, 1, 10887, 59, 1, 8808, 105, 109, 59, 1, 8934, 4, 8, 97, 98, 110, 111, 112, 116, 119, 122, 12345, 12359, 12364, 12421, 12446, 12467, 12474, 12490, 4, 2, 110, 114, 12351, 12355, 103, 59, 1, 10220, 114, 59, 1, 8701, 114, 107, 59, 1, 10214, 103, 4, 3, 108, 109, 114, 12373, 12401, 12409, 101, 102, 116, 4, 2, 97, 114, 12382, 12389, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10231, 97, 112, 115, 116, 111, 59, 1, 10236, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10230, 112, 97, 114, 114, 111, 119, 4, 2, 108, 114, 12433, 12439, 101, 102, 116, 59, 1, 8619, 105, 103, 104, 116, 59, 1, 8620, 4, 3, 97, 102, 108, 12454, 12458, 12462, 114, 59, 1, 10629, 59, 3, 55349, 56669, 117, 115, 59, 1, 10797, 105, 109, 101, 115, 59, 1, 10804, 4, 2, 97, 98, 12480, 12485, 115, 116, 59, 1, 8727, 97, 114, 59, 1, 95, 4, 3, 59, 101, 102, 12498, 12500, 12506, 1, 9674, 110, 103, 101, 59, 1, 9674, 59, 1, 10731, 97, 114, 4, 2, 59, 108, 12517, 12519, 1, 40, 116, 59, 1, 10643, 4, 5, 97, 99, 104, 109, 116, 12535, 12540, 12548, 12561, 12564, 114, 114, 59, 1, 8646, 111, 114, 110, 101, 114, 59, 1, 8991, 97, 114, 4, 2, 59, 100, 12556, 12558, 1, 8651, 59, 1, 10605, 59, 1, 8206, 114, 105, 59, 1, 8895, 4, 6, 97, 99, 104, 105, 113, 116, 12583, 12589, 12594, 12597, 12614, 12635, 113, 117, 111, 59, 1, 8249, 114, 59, 3, 55349, 56513, 59, 1, 8624, 109, 4, 3, 59, 101, 103, 12606, 12608, 12611, 1, 8818, 59, 1, 10893, 59, 1, 10895, 4, 2, 98, 117, 12620, 12623, 59, 1, 91, 111, 4, 2, 59, 114, 12630, 12632, 1, 8216, 59, 1, 8218, 114, 111, 107, 59, 1, 322, 5, 60, 8, 59, 99, 100, 104, 105, 108, 113, 114, 12660, 12662, 12675, 12680, 12686, 12692, 12698, 12705, 1, 60, 4, 2, 99, 105, 12668, 12671, 59, 1, 10918, 114, 59, 1, 10873, 111, 116, 59, 1, 8918, 114, 101, 101, 59, 1, 8907, 109, 101, 115, 59, 1, 8905, 97, 114, 114, 59, 1, 10614, 117, 101, 115, 116, 59, 1, 10875, 4, 2, 80, 105, 12711, 12716, 97, 114, 59, 1, 10646, 4, 3, 59, 101, 102, 12724, 12726, 12729, 1, 9667, 59, 1, 8884, 59, 1, 9666, 114, 4, 2, 100, 117, 12739, 12746, 115, 104, 97, 114, 59, 1, 10570, 104, 97, 114, 59, 1, 10598, 4, 2, 101, 110, 12758, 12768, 114, 116, 110, 101, 113, 113, 59, 3, 8808, 65024, 69, 59, 3, 8808, 65024, 4, 14, 68, 97, 99, 100, 101, 102, 104, 105, 108, 110, 111, 112, 115, 117, 12803, 12809, 12893, 12908, 12914, 12928, 12933, 12937, 13011, 13025, 13032, 13049, 13052, 13069, 68, 111, 116, 59, 1, 8762, 4, 4, 99, 108, 112, 114, 12819, 12827, 12849, 12887, 114, 5, 175, 1, 59, 12825, 1, 175, 4, 2, 101, 116, 12833, 12836, 59, 1, 9794, 4, 2, 59, 101, 12842, 12844, 1, 10016, 115, 101, 59, 1, 10016, 4, 2, 59, 115, 12855, 12857, 1, 8614, 116, 111, 4, 4, 59, 100, 108, 117, 12869, 12871, 12877, 12883, 1, 8614, 111, 119, 110, 59, 1, 8615, 101, 102, 116, 59, 1, 8612, 112, 59, 1, 8613, 107, 101, 114, 59, 1, 9646, 4, 2, 111, 121, 12899, 12905, 109, 109, 97, 59, 1, 10793, 59, 1, 1084, 97, 115, 104, 59, 1, 8212, 97, 115, 117, 114, 101, 100, 97, 110, 103, 108, 101, 59, 1, 8737, 114, 59, 3, 55349, 56618, 111, 59, 1, 8487, 4, 3, 99, 100, 110, 12945, 12954, 12985, 114, 111, 5, 181, 1, 59, 12952, 1, 181, 4, 4, 59, 97, 99, 100, 12964, 12966, 12971, 12976, 1, 8739, 115, 116, 59, 1, 42, 105, 114, 59, 1, 10992, 111, 116, 5, 183, 1, 59, 12983, 1, 183, 117, 115, 4, 3, 59, 98, 100, 12995, 12997, 13e3, 1, 8722, 59, 1, 8863, 4, 2, 59, 117, 13006, 13008, 1, 8760, 59, 1, 10794, 4, 2, 99, 100, 13017, 13021, 112, 59, 1, 10971, 114, 59, 1, 8230, 112, 108, 117, 115, 59, 1, 8723, 4, 2, 100, 112, 13038, 13044, 101, 108, 115, 59, 1, 8871, 102, 59, 3, 55349, 56670, 59, 1, 8723, 4, 2, 99, 116, 13058, 13063, 114, 59, 3, 55349, 56514, 112, 111, 115, 59, 1, 8766, 4, 3, 59, 108, 109, 13077, 13079, 13087, 1, 956, 116, 105, 109, 97, 112, 59, 1, 8888, 97, 112, 59, 1, 8888, 4, 24, 71, 76, 82, 86, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 108, 109, 111, 112, 114, 115, 116, 117, 118, 119, 13142, 13165, 13217, 13229, 13247, 13330, 13359, 13414, 13420, 13508, 13513, 13579, 13602, 13626, 13631, 13762, 13767, 13855, 13936, 13995, 14214, 14285, 14312, 14432, 4, 2, 103, 116, 13148, 13152, 59, 3, 8921, 824, 4, 2, 59, 118, 13158, 13161, 3, 8811, 8402, 59, 3, 8811, 824, 4, 3, 101, 108, 116, 13173, 13200, 13204, 102, 116, 4, 2, 97, 114, 13181, 13188, 114, 114, 111, 119, 59, 1, 8653, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8654, 59, 3, 8920, 824, 4, 2, 59, 118, 13210, 13213, 3, 8810, 8402, 59, 3, 8810, 824, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8655, 4, 2, 68, 100, 13235, 13241, 97, 115, 104, 59, 1, 8879, 97, 115, 104, 59, 1, 8878, 4, 5, 98, 99, 110, 112, 116, 13259, 13264, 13270, 13275, 13308, 108, 97, 59, 1, 8711, 117, 116, 101, 59, 1, 324, 103, 59, 3, 8736, 8402, 4, 5, 59, 69, 105, 111, 112, 13287, 13289, 13293, 13298, 13302, 1, 8777, 59, 3, 10864, 824, 100, 59, 3, 8779, 824, 115, 59, 1, 329, 114, 111, 120, 59, 1, 8777, 117, 114, 4, 2, 59, 97, 13316, 13318, 1, 9838, 108, 4, 2, 59, 115, 13325, 13327, 1, 9838, 59, 1, 8469, 4, 2, 115, 117, 13336, 13344, 112, 5, 160, 1, 59, 13342, 1, 160, 109, 112, 4, 2, 59, 101, 13352, 13355, 3, 8782, 824, 59, 3, 8783, 824, 4, 5, 97, 101, 111, 117, 121, 13371, 13385, 13391, 13407, 13411, 4, 2, 112, 114, 13377, 13380, 59, 1, 10819, 111, 110, 59, 1, 328, 100, 105, 108, 59, 1, 326, 110, 103, 4, 2, 59, 100, 13399, 13401, 1, 8775, 111, 116, 59, 3, 10861, 824, 112, 59, 1, 10818, 59, 1, 1085, 97, 115, 104, 59, 1, 8211, 4, 7, 59, 65, 97, 100, 113, 115, 120, 13436, 13438, 13443, 13466, 13472, 13478, 13494, 1, 8800, 114, 114, 59, 1, 8663, 114, 4, 2, 104, 114, 13450, 13454, 107, 59, 1, 10532, 4, 2, 59, 111, 13460, 13462, 1, 8599, 119, 59, 1, 8599, 111, 116, 59, 3, 8784, 824, 117, 105, 118, 59, 1, 8802, 4, 2, 101, 105, 13484, 13489, 97, 114, 59, 1, 10536, 109, 59, 3, 8770, 824, 105, 115, 116, 4, 2, 59, 115, 13503, 13505, 1, 8708, 59, 1, 8708, 114, 59, 3, 55349, 56619, 4, 4, 69, 101, 115, 116, 13523, 13527, 13563, 13568, 59, 3, 8807, 824, 4, 3, 59, 113, 115, 13535, 13537, 13559, 1, 8817, 4, 3, 59, 113, 115, 13545, 13547, 13551, 1, 8817, 59, 3, 8807, 824, 108, 97, 110, 116, 59, 3, 10878, 824, 59, 3, 10878, 824, 105, 109, 59, 1, 8821, 4, 2, 59, 114, 13574, 13576, 1, 8815, 59, 1, 8815, 4, 3, 65, 97, 112, 13587, 13592, 13597, 114, 114, 59, 1, 8654, 114, 114, 59, 1, 8622, 97, 114, 59, 1, 10994, 4, 3, 59, 115, 118, 13610, 13612, 13623, 1, 8715, 4, 2, 59, 100, 13618, 13620, 1, 8956, 59, 1, 8954, 59, 1, 8715, 99, 121, 59, 1, 1114, 4, 7, 65, 69, 97, 100, 101, 115, 116, 13647, 13652, 13656, 13661, 13665, 13737, 13742, 114, 114, 59, 1, 8653, 59, 3, 8806, 824, 114, 114, 59, 1, 8602, 114, 59, 1, 8229, 4, 4, 59, 102, 113, 115, 13675, 13677, 13703, 13725, 1, 8816, 116, 4, 2, 97, 114, 13684, 13691, 114, 114, 111, 119, 59, 1, 8602, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8622, 4, 3, 59, 113, 115, 13711, 13713, 13717, 1, 8816, 59, 3, 8806, 824, 108, 97, 110, 116, 59, 3, 10877, 824, 4, 2, 59, 115, 13731, 13734, 3, 10877, 824, 59, 1, 8814, 105, 109, 59, 1, 8820, 4, 2, 59, 114, 13748, 13750, 1, 8814, 105, 4, 2, 59, 101, 13757, 13759, 1, 8938, 59, 1, 8940, 105, 100, 59, 1, 8740, 4, 2, 112, 116, 13773, 13778, 102, 59, 3, 55349, 56671, 5, 172, 3, 59, 105, 110, 13787, 13789, 13829, 1, 172, 110, 4, 4, 59, 69, 100, 118, 13800, 13802, 13806, 13812, 1, 8713, 59, 3, 8953, 824, 111, 116, 59, 3, 8949, 824, 4, 3, 97, 98, 99, 13820, 13823, 13826, 59, 1, 8713, 59, 1, 8951, 59, 1, 8950, 105, 4, 2, 59, 118, 13836, 13838, 1, 8716, 4, 3, 97, 98, 99, 13846, 13849, 13852, 59, 1, 8716, 59, 1, 8958, 59, 1, 8957, 4, 3, 97, 111, 114, 13863, 13892, 13899, 114, 4, 4, 59, 97, 115, 116, 13874, 13876, 13883, 13888, 1, 8742, 108, 108, 101, 108, 59, 1, 8742, 108, 59, 3, 11005, 8421, 59, 3, 8706, 824, 108, 105, 110, 116, 59, 1, 10772, 4, 3, 59, 99, 101, 13907, 13909, 13914, 1, 8832, 117, 101, 59, 1, 8928, 4, 2, 59, 99, 13920, 13923, 3, 10927, 824, 4, 2, 59, 101, 13929, 13931, 1, 8832, 113, 59, 3, 10927, 824, 4, 4, 65, 97, 105, 116, 13946, 13951, 13971, 13982, 114, 114, 59, 1, 8655, 114, 114, 4, 3, 59, 99, 119, 13961, 13963, 13967, 1, 8603, 59, 3, 10547, 824, 59, 3, 8605, 824, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8603, 114, 105, 4, 2, 59, 101, 13990, 13992, 1, 8939, 59, 1, 8941, 4, 7, 99, 104, 105, 109, 112, 113, 117, 14011, 14036, 14060, 14080, 14085, 14090, 14106, 4, 4, 59, 99, 101, 114, 14021, 14023, 14028, 14032, 1, 8833, 117, 101, 59, 1, 8929, 59, 3, 10928, 824, 59, 3, 55349, 56515, 111, 114, 116, 4, 2, 109, 112, 14045, 14050, 105, 100, 59, 1, 8740, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8742, 109, 4, 2, 59, 101, 14067, 14069, 1, 8769, 4, 2, 59, 113, 14075, 14077, 1, 8772, 59, 1, 8772, 105, 100, 59, 1, 8740, 97, 114, 59, 1, 8742, 115, 117, 4, 2, 98, 112, 14098, 14102, 101, 59, 1, 8930, 101, 59, 1, 8931, 4, 3, 98, 99, 112, 14114, 14157, 14171, 4, 4, 59, 69, 101, 115, 14124, 14126, 14130, 14133, 1, 8836, 59, 3, 10949, 824, 59, 1, 8840, 101, 116, 4, 2, 59, 101, 14141, 14144, 3, 8834, 8402, 113, 4, 2, 59, 113, 14151, 14153, 1, 8840, 59, 3, 10949, 824, 99, 4, 2, 59, 101, 14164, 14166, 1, 8833, 113, 59, 3, 10928, 824, 4, 4, 59, 69, 101, 115, 14181, 14183, 14187, 14190, 1, 8837, 59, 3, 10950, 824, 59, 1, 8841, 101, 116, 4, 2, 59, 101, 14198, 14201, 3, 8835, 8402, 113, 4, 2, 59, 113, 14208, 14210, 1, 8841, 59, 3, 10950, 824, 4, 4, 103, 105, 108, 114, 14224, 14228, 14238, 14242, 108, 59, 1, 8825, 108, 100, 101, 5, 241, 1, 59, 14236, 1, 241, 103, 59, 1, 8824, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 14254, 14269, 101, 102, 116, 4, 2, 59, 101, 14263, 14265, 1, 8938, 113, 59, 1, 8940, 105, 103, 104, 116, 4, 2, 59, 101, 14279, 14281, 1, 8939, 113, 59, 1, 8941, 4, 2, 59, 109, 14291, 14293, 1, 957, 4, 3, 59, 101, 115, 14301, 14303, 14308, 1, 35, 114, 111, 59, 1, 8470, 112, 59, 1, 8199, 4, 9, 68, 72, 97, 100, 103, 105, 108, 114, 115, 14332, 14338, 14344, 14349, 14355, 14369, 14376, 14408, 14426, 97, 115, 104, 59, 1, 8877, 97, 114, 114, 59, 1, 10500, 112, 59, 3, 8781, 8402, 97, 115, 104, 59, 1, 8876, 4, 2, 101, 116, 14361, 14365, 59, 3, 8805, 8402, 59, 3, 62, 8402, 110, 102, 105, 110, 59, 1, 10718, 4, 3, 65, 101, 116, 14384, 14389, 14393, 114, 114, 59, 1, 10498, 59, 3, 8804, 8402, 4, 2, 59, 114, 14399, 14402, 3, 60, 8402, 105, 101, 59, 3, 8884, 8402, 4, 2, 65, 116, 14414, 14419, 114, 114, 59, 1, 10499, 114, 105, 101, 59, 3, 8885, 8402, 105, 109, 59, 3, 8764, 8402, 4, 3, 65, 97, 110, 14440, 14445, 14468, 114, 114, 59, 1, 8662, 114, 4, 2, 104, 114, 14452, 14456, 107, 59, 1, 10531, 4, 2, 59, 111, 14462, 14464, 1, 8598, 119, 59, 1, 8598, 101, 97, 114, 59, 1, 10535, 4, 18, 83, 97, 99, 100, 101, 102, 103, 104, 105, 108, 109, 111, 112, 114, 115, 116, 117, 118, 14512, 14515, 14535, 14560, 14597, 14603, 14618, 14643, 14657, 14662, 14701, 14741, 14747, 14769, 14851, 14877, 14907, 14916, 59, 1, 9416, 4, 2, 99, 115, 14521, 14531, 117, 116, 101, 5, 243, 1, 59, 14529, 1, 243, 116, 59, 1, 8859, 4, 2, 105, 121, 14541, 14557, 114, 4, 2, 59, 99, 14548, 14550, 1, 8858, 5, 244, 1, 59, 14555, 1, 244, 59, 1, 1086, 4, 5, 97, 98, 105, 111, 115, 14572, 14577, 14583, 14587, 14591, 115, 104, 59, 1, 8861, 108, 97, 99, 59, 1, 337, 118, 59, 1, 10808, 116, 59, 1, 8857, 111, 108, 100, 59, 1, 10684, 108, 105, 103, 59, 1, 339, 4, 2, 99, 114, 14609, 14614, 105, 114, 59, 1, 10687, 59, 3, 55349, 56620, 4, 3, 111, 114, 116, 14626, 14630, 14640, 110, 59, 1, 731, 97, 118, 101, 5, 242, 1, 59, 14638, 1, 242, 59, 1, 10689, 4, 2, 98, 109, 14649, 14654, 97, 114, 59, 1, 10677, 59, 1, 937, 110, 116, 59, 1, 8750, 4, 4, 97, 99, 105, 116, 14672, 14677, 14693, 14698, 114, 114, 59, 1, 8634, 4, 2, 105, 114, 14683, 14687, 114, 59, 1, 10686, 111, 115, 115, 59, 1, 10683, 110, 101, 59, 1, 8254, 59, 1, 10688, 4, 3, 97, 101, 105, 14709, 14714, 14719, 99, 114, 59, 1, 333, 103, 97, 59, 1, 969, 4, 3, 99, 100, 110, 14727, 14733, 14736, 114, 111, 110, 59, 1, 959, 59, 1, 10678, 117, 115, 59, 1, 8854, 112, 102, 59, 3, 55349, 56672, 4, 3, 97, 101, 108, 14755, 14759, 14764, 114, 59, 1, 10679, 114, 112, 59, 1, 10681, 117, 115, 59, 1, 8853, 4, 7, 59, 97, 100, 105, 111, 115, 118, 14785, 14787, 14792, 14831, 14837, 14841, 14848, 1, 8744, 114, 114, 59, 1, 8635, 4, 4, 59, 101, 102, 109, 14802, 14804, 14817, 14824, 1, 10845, 114, 4, 2, 59, 111, 14811, 14813, 1, 8500, 102, 59, 1, 8500, 5, 170, 1, 59, 14822, 1, 170, 5, 186, 1, 59, 14829, 1, 186, 103, 111, 102, 59, 1, 8886, 114, 59, 1, 10838, 108, 111, 112, 101, 59, 1, 10839, 59, 1, 10843, 4, 3, 99, 108, 111, 14859, 14863, 14873, 114, 59, 1, 8500, 97, 115, 104, 5, 248, 1, 59, 14871, 1, 248, 108, 59, 1, 8856, 105, 4, 2, 108, 109, 14884, 14893, 100, 101, 5, 245, 1, 59, 14891, 1, 245, 101, 115, 4, 2, 59, 97, 14901, 14903, 1, 8855, 115, 59, 1, 10806, 109, 108, 5, 246, 1, 59, 14914, 1, 246, 98, 97, 114, 59, 1, 9021, 4, 12, 97, 99, 101, 102, 104, 105, 108, 109, 111, 114, 115, 117, 14948, 14992, 14996, 15033, 15038, 15068, 15090, 15189, 15192, 15222, 15427, 15441, 114, 4, 4, 59, 97, 115, 116, 14959, 14961, 14976, 14989, 1, 8741, 5, 182, 2, 59, 108, 14968, 14970, 1, 182, 108, 101, 108, 59, 1, 8741, 4, 2, 105, 108, 14982, 14986, 109, 59, 1, 10995, 59, 1, 11005, 59, 1, 8706, 121, 59, 1, 1087, 114, 4, 5, 99, 105, 109, 112, 116, 15009, 15014, 15019, 15024, 15027, 110, 116, 59, 1, 37, 111, 100, 59, 1, 46, 105, 108, 59, 1, 8240, 59, 1, 8869, 101, 110, 107, 59, 1, 8241, 114, 59, 3, 55349, 56621, 4, 3, 105, 109, 111, 15046, 15057, 15063, 4, 2, 59, 118, 15052, 15054, 1, 966, 59, 1, 981, 109, 97, 116, 59, 1, 8499, 110, 101, 59, 1, 9742, 4, 3, 59, 116, 118, 15076, 15078, 15087, 1, 960, 99, 104, 102, 111, 114, 107, 59, 1, 8916, 59, 1, 982, 4, 2, 97, 117, 15096, 15119, 110, 4, 2, 99, 107, 15103, 15115, 107, 4, 2, 59, 104, 15110, 15112, 1, 8463, 59, 1, 8462, 118, 59, 1, 8463, 115, 4, 9, 59, 97, 98, 99, 100, 101, 109, 115, 116, 15140, 15142, 15148, 15151, 15156, 15168, 15171, 15179, 15184, 1, 43, 99, 105, 114, 59, 1, 10787, 59, 1, 8862, 105, 114, 59, 1, 10786, 4, 2, 111, 117, 15162, 15165, 59, 1, 8724, 59, 1, 10789, 59, 1, 10866, 110, 5, 177, 1, 59, 15177, 1, 177, 105, 109, 59, 1, 10790, 119, 111, 59, 1, 10791, 59, 1, 177, 4, 3, 105, 112, 117, 15200, 15208, 15213, 110, 116, 105, 110, 116, 59, 1, 10773, 102, 59, 3, 55349, 56673, 110, 100, 5, 163, 1, 59, 15220, 1, 163, 4, 10, 59, 69, 97, 99, 101, 105, 110, 111, 115, 117, 15244, 15246, 15249, 15253, 15258, 15334, 15347, 15367, 15416, 15421, 1, 8826, 59, 1, 10931, 112, 59, 1, 10935, 117, 101, 59, 1, 8828, 4, 2, 59, 99, 15264, 15266, 1, 10927, 4, 6, 59, 97, 99, 101, 110, 115, 15280, 15282, 15290, 15299, 15303, 15329, 1, 8826, 112, 112, 114, 111, 120, 59, 1, 10935, 117, 114, 108, 121, 101, 113, 59, 1, 8828, 113, 59, 1, 10927, 4, 3, 97, 101, 115, 15311, 15319, 15324, 112, 112, 114, 111, 120, 59, 1, 10937, 113, 113, 59, 1, 10933, 105, 109, 59, 1, 8936, 105, 109, 59, 1, 8830, 109, 101, 4, 2, 59, 115, 15342, 15344, 1, 8242, 59, 1, 8473, 4, 3, 69, 97, 115, 15355, 15358, 15362, 59, 1, 10933, 112, 59, 1, 10937, 105, 109, 59, 1, 8936, 4, 3, 100, 102, 112, 15375, 15378, 15404, 59, 1, 8719, 4, 3, 97, 108, 115, 15386, 15392, 15398, 108, 97, 114, 59, 1, 9006, 105, 110, 101, 59, 1, 8978, 117, 114, 102, 59, 1, 8979, 4, 2, 59, 116, 15410, 15412, 1, 8733, 111, 59, 1, 8733, 105, 109, 59, 1, 8830, 114, 101, 108, 59, 1, 8880, 4, 2, 99, 105, 15433, 15438, 114, 59, 3, 55349, 56517, 59, 1, 968, 110, 99, 115, 112, 59, 1, 8200, 4, 6, 102, 105, 111, 112, 115, 117, 15462, 15467, 15472, 15478, 15485, 15491, 114, 59, 3, 55349, 56622, 110, 116, 59, 1, 10764, 112, 102, 59, 3, 55349, 56674, 114, 105, 109, 101, 59, 1, 8279, 99, 114, 59, 3, 55349, 56518, 4, 3, 97, 101, 111, 15499, 15520, 15534, 116, 4, 2, 101, 105, 15506, 15515, 114, 110, 105, 111, 110, 115, 59, 1, 8461, 110, 116, 59, 1, 10774, 115, 116, 4, 2, 59, 101, 15528, 15530, 1, 63, 113, 59, 1, 8799, 116, 5, 34, 1, 59, 15540, 1, 34, 4, 21, 65, 66, 72, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 110, 111, 112, 114, 115, 116, 117, 120, 15586, 15609, 15615, 15620, 15796, 15855, 15893, 15931, 15977, 16001, 16039, 16183, 16204, 16222, 16228, 16285, 16312, 16318, 16363, 16408, 16416, 4, 3, 97, 114, 116, 15594, 15599, 15603, 114, 114, 59, 1, 8667, 114, 59, 1, 8658, 97, 105, 108, 59, 1, 10524, 97, 114, 114, 59, 1, 10511, 97, 114, 59, 1, 10596, 4, 7, 99, 100, 101, 110, 113, 114, 116, 15636, 15651, 15656, 15664, 15687, 15696, 15770, 4, 2, 101, 117, 15642, 15646, 59, 3, 8765, 817, 116, 101, 59, 1, 341, 105, 99, 59, 1, 8730, 109, 112, 116, 121, 118, 59, 1, 10675, 103, 4, 4, 59, 100, 101, 108, 15675, 15677, 15680, 15683, 1, 10217, 59, 1, 10642, 59, 1, 10661, 101, 59, 1, 10217, 117, 111, 5, 187, 1, 59, 15694, 1, 187, 114, 4, 11, 59, 97, 98, 99, 102, 104, 108, 112, 115, 116, 119, 15721, 15723, 15727, 15739, 15742, 15746, 15750, 15754, 15758, 15763, 15767, 1, 8594, 112, 59, 1, 10613, 4, 2, 59, 102, 15733, 15735, 1, 8677, 115, 59, 1, 10528, 59, 1, 10547, 115, 59, 1, 10526, 107, 59, 1, 8618, 112, 59, 1, 8620, 108, 59, 1, 10565, 105, 109, 59, 1, 10612, 108, 59, 1, 8611, 59, 1, 8605, 4, 2, 97, 105, 15776, 15781, 105, 108, 59, 1, 10522, 111, 4, 2, 59, 110, 15788, 15790, 1, 8758, 97, 108, 115, 59, 1, 8474, 4, 3, 97, 98, 114, 15804, 15809, 15814, 114, 114, 59, 1, 10509, 114, 107, 59, 1, 10099, 4, 2, 97, 107, 15820, 15833, 99, 4, 2, 101, 107, 15827, 15830, 59, 1, 125, 59, 1, 93, 4, 2, 101, 115, 15839, 15842, 59, 1, 10636, 108, 4, 2, 100, 117, 15849, 15852, 59, 1, 10638, 59, 1, 10640, 4, 4, 97, 101, 117, 121, 15865, 15871, 15886, 15890, 114, 111, 110, 59, 1, 345, 4, 2, 100, 105, 15877, 15882, 105, 108, 59, 1, 343, 108, 59, 1, 8969, 98, 59, 1, 125, 59, 1, 1088, 4, 4, 99, 108, 113, 115, 15903, 15907, 15914, 15927, 97, 59, 1, 10551, 100, 104, 97, 114, 59, 1, 10601, 117, 111, 4, 2, 59, 114, 15922, 15924, 1, 8221, 59, 1, 8221, 104, 59, 1, 8627, 4, 3, 97, 99, 103, 15939, 15966, 15970, 108, 4, 4, 59, 105, 112, 115, 15950, 15952, 15957, 15963, 1, 8476, 110, 101, 59, 1, 8475, 97, 114, 116, 59, 1, 8476, 59, 1, 8477, 116, 59, 1, 9645, 5, 174, 1, 59, 15975, 1, 174, 4, 3, 105, 108, 114, 15985, 15991, 15997, 115, 104, 116, 59, 1, 10621, 111, 111, 114, 59, 1, 8971, 59, 3, 55349, 56623, 4, 2, 97, 111, 16007, 16028, 114, 4, 2, 100, 117, 16014, 16017, 59, 1, 8641, 4, 2, 59, 108, 16023, 16025, 1, 8640, 59, 1, 10604, 4, 2, 59, 118, 16034, 16036, 1, 961, 59, 1, 1009, 4, 3, 103, 110, 115, 16047, 16167, 16171, 104, 116, 4, 6, 97, 104, 108, 114, 115, 116, 16063, 16081, 16103, 16130, 16143, 16155, 114, 114, 111, 119, 4, 2, 59, 116, 16073, 16075, 1, 8594, 97, 105, 108, 59, 1, 8611, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 16093, 16099, 111, 119, 110, 59, 1, 8641, 112, 59, 1, 8640, 101, 102, 116, 4, 2, 97, 104, 16112, 16120, 114, 114, 111, 119, 115, 59, 1, 8644, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8652, 105, 103, 104, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8649, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8605, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8908, 103, 59, 1, 730, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8787, 4, 3, 97, 104, 109, 16191, 16196, 16201, 114, 114, 59, 1, 8644, 97, 114, 59, 1, 8652, 59, 1, 8207, 111, 117, 115, 116, 4, 2, 59, 97, 16214, 16216, 1, 9137, 99, 104, 101, 59, 1, 9137, 109, 105, 100, 59, 1, 10990, 4, 4, 97, 98, 112, 116, 16238, 16252, 16257, 16278, 4, 2, 110, 114, 16244, 16248, 103, 59, 1, 10221, 114, 59, 1, 8702, 114, 107, 59, 1, 10215, 4, 3, 97, 102, 108, 16265, 16269, 16273, 114, 59, 1, 10630, 59, 3, 55349, 56675, 117, 115, 59, 1, 10798, 105, 109, 101, 115, 59, 1, 10805, 4, 2, 97, 112, 16291, 16304, 114, 4, 2, 59, 103, 16298, 16300, 1, 41, 116, 59, 1, 10644, 111, 108, 105, 110, 116, 59, 1, 10770, 97, 114, 114, 59, 1, 8649, 4, 4, 97, 99, 104, 113, 16328, 16334, 16339, 16342, 113, 117, 111, 59, 1, 8250, 114, 59, 3, 55349, 56519, 59, 1, 8625, 4, 2, 98, 117, 16348, 16351, 59, 1, 93, 111, 4, 2, 59, 114, 16358, 16360, 1, 8217, 59, 1, 8217, 4, 3, 104, 105, 114, 16371, 16377, 16383, 114, 101, 101, 59, 1, 8908, 109, 101, 115, 59, 1, 8906, 105, 4, 4, 59, 101, 102, 108, 16394, 16396, 16399, 16402, 1, 9657, 59, 1, 8885, 59, 1, 9656, 116, 114, 105, 59, 1, 10702, 108, 117, 104, 97, 114, 59, 1, 10600, 59, 1, 8478, 4, 19, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 111, 112, 113, 114, 115, 116, 117, 119, 122, 16459, 16466, 16472, 16572, 16590, 16672, 16687, 16746, 16844, 16850, 16924, 16963, 16988, 17115, 17121, 17154, 17206, 17614, 17656, 99, 117, 116, 101, 59, 1, 347, 113, 117, 111, 59, 1, 8218, 4, 10, 59, 69, 97, 99, 101, 105, 110, 112, 115, 121, 16494, 16496, 16499, 16513, 16518, 16531, 16536, 16556, 16564, 16569, 1, 8827, 59, 1, 10932, 4, 2, 112, 114, 16505, 16508, 59, 1, 10936, 111, 110, 59, 1, 353, 117, 101, 59, 1, 8829, 4, 2, 59, 100, 16524, 16526, 1, 10928, 105, 108, 59, 1, 351, 114, 99, 59, 1, 349, 4, 3, 69, 97, 115, 16544, 16547, 16551, 59, 1, 10934, 112, 59, 1, 10938, 105, 109, 59, 1, 8937, 111, 108, 105, 110, 116, 59, 1, 10771, 105, 109, 59, 1, 8831, 59, 1, 1089, 111, 116, 4, 3, 59, 98, 101, 16582, 16584, 16587, 1, 8901, 59, 1, 8865, 59, 1, 10854, 4, 7, 65, 97, 99, 109, 115, 116, 120, 16606, 16611, 16634, 16642, 16646, 16652, 16668, 114, 114, 59, 1, 8664, 114, 4, 2, 104, 114, 16618, 16622, 107, 59, 1, 10533, 4, 2, 59, 111, 16628, 16630, 1, 8600, 119, 59, 1, 8600, 116, 5, 167, 1, 59, 16640, 1, 167, 105, 59, 1, 59, 119, 97, 114, 59, 1, 10537, 109, 4, 2, 105, 110, 16659, 16665, 110, 117, 115, 59, 1, 8726, 59, 1, 8726, 116, 59, 1, 10038, 114, 4, 2, 59, 111, 16679, 16682, 3, 55349, 56624, 119, 110, 59, 1, 8994, 4, 4, 97, 99, 111, 121, 16697, 16702, 16716, 16739, 114, 112, 59, 1, 9839, 4, 2, 104, 121, 16708, 16713, 99, 121, 59, 1, 1097, 59, 1, 1096, 114, 116, 4, 2, 109, 112, 16724, 16729, 105, 100, 59, 1, 8739, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8741, 5, 173, 1, 59, 16744, 1, 173, 4, 2, 103, 109, 16752, 16770, 109, 97, 4, 3, 59, 102, 118, 16762, 16764, 16767, 1, 963, 59, 1, 962, 59, 1, 962, 4, 8, 59, 100, 101, 103, 108, 110, 112, 114, 16788, 16790, 16795, 16806, 16817, 16828, 16832, 16838, 1, 8764, 111, 116, 59, 1, 10858, 4, 2, 59, 113, 16801, 16803, 1, 8771, 59, 1, 8771, 4, 2, 59, 69, 16812, 16814, 1, 10910, 59, 1, 10912, 4, 2, 59, 69, 16823, 16825, 1, 10909, 59, 1, 10911, 101, 59, 1, 8774, 108, 117, 115, 59, 1, 10788, 97, 114, 114, 59, 1, 10610, 97, 114, 114, 59, 1, 8592, 4, 4, 97, 101, 105, 116, 16860, 16883, 16891, 16904, 4, 2, 108, 115, 16866, 16878, 108, 115, 101, 116, 109, 105, 110, 117, 115, 59, 1, 8726, 104, 112, 59, 1, 10803, 112, 97, 114, 115, 108, 59, 1, 10724, 4, 2, 100, 108, 16897, 16900, 59, 1, 8739, 101, 59, 1, 8995, 4, 2, 59, 101, 16910, 16912, 1, 10922, 4, 2, 59, 115, 16918, 16920, 1, 10924, 59, 3, 10924, 65024, 4, 3, 102, 108, 112, 16932, 16938, 16958, 116, 99, 121, 59, 1, 1100, 4, 2, 59, 98, 16944, 16946, 1, 47, 4, 2, 59, 97, 16952, 16954, 1, 10692, 114, 59, 1, 9023, 102, 59, 3, 55349, 56676, 97, 4, 2, 100, 114, 16970, 16985, 101, 115, 4, 2, 59, 117, 16978, 16980, 1, 9824, 105, 116, 59, 1, 9824, 59, 1, 8741, 4, 3, 99, 115, 117, 16996, 17028, 17089, 4, 2, 97, 117, 17002, 17015, 112, 4, 2, 59, 115, 17009, 17011, 1, 8851, 59, 3, 8851, 65024, 112, 4, 2, 59, 115, 17022, 17024, 1, 8852, 59, 3, 8852, 65024, 117, 4, 2, 98, 112, 17035, 17062, 4, 3, 59, 101, 115, 17043, 17045, 17048, 1, 8847, 59, 1, 8849, 101, 116, 4, 2, 59, 101, 17056, 17058, 1, 8847, 113, 59, 1, 8849, 4, 3, 59, 101, 115, 17070, 17072, 17075, 1, 8848, 59, 1, 8850, 101, 116, 4, 2, 59, 101, 17083, 17085, 1, 8848, 113, 59, 1, 8850, 4, 3, 59, 97, 102, 17097, 17099, 17112, 1, 9633, 114, 4, 2, 101, 102, 17106, 17109, 59, 1, 9633, 59, 1, 9642, 59, 1, 9642, 97, 114, 114, 59, 1, 8594, 4, 4, 99, 101, 109, 116, 17131, 17136, 17142, 17148, 114, 59, 3, 55349, 56520, 116, 109, 110, 59, 1, 8726, 105, 108, 101, 59, 1, 8995, 97, 114, 102, 59, 1, 8902, 4, 2, 97, 114, 17160, 17172, 114, 4, 2, 59, 102, 17167, 17169, 1, 9734, 59, 1, 9733, 4, 2, 97, 110, 17178, 17202, 105, 103, 104, 116, 4, 2, 101, 112, 17188, 17197, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 104, 105, 59, 1, 981, 115, 59, 1, 175, 4, 5, 98, 99, 109, 110, 112, 17218, 17351, 17420, 17423, 17427, 4, 9, 59, 69, 100, 101, 109, 110, 112, 114, 115, 17238, 17240, 17243, 17248, 17261, 17267, 17279, 17285, 17291, 1, 8834, 59, 1, 10949, 111, 116, 59, 1, 10941, 4, 2, 59, 100, 17254, 17256, 1, 8838, 111, 116, 59, 1, 10947, 117, 108, 116, 59, 1, 10945, 4, 2, 69, 101, 17273, 17276, 59, 1, 10955, 59, 1, 8842, 108, 117, 115, 59, 1, 10943, 97, 114, 114, 59, 1, 10617, 4, 3, 101, 105, 117, 17299, 17335, 17339, 116, 4, 3, 59, 101, 110, 17308, 17310, 17322, 1, 8834, 113, 4, 2, 59, 113, 17317, 17319, 1, 8838, 59, 1, 10949, 101, 113, 4, 2, 59, 113, 17330, 17332, 1, 8842, 59, 1, 10955, 109, 59, 1, 10951, 4, 2, 98, 112, 17345, 17348, 59, 1, 10965, 59, 1, 10963, 99, 4, 6, 59, 97, 99, 101, 110, 115, 17366, 17368, 17376, 17385, 17389, 17415, 1, 8827, 112, 112, 114, 111, 120, 59, 1, 10936, 117, 114, 108, 121, 101, 113, 59, 1, 8829, 113, 59, 1, 10928, 4, 3, 97, 101, 115, 17397, 17405, 17410, 112, 112, 114, 111, 120, 59, 1, 10938, 113, 113, 59, 1, 10934, 105, 109, 59, 1, 8937, 105, 109, 59, 1, 8831, 59, 1, 8721, 103, 59, 1, 9834, 4, 13, 49, 50, 51, 59, 69, 100, 101, 104, 108, 109, 110, 112, 115, 17455, 17462, 17469, 17476, 17478, 17481, 17496, 17509, 17524, 17530, 17536, 17548, 17554, 5, 185, 1, 59, 17460, 1, 185, 5, 178, 1, 59, 17467, 1, 178, 5, 179, 1, 59, 17474, 1, 179, 1, 8835, 59, 1, 10950, 4, 2, 111, 115, 17487, 17491, 116, 59, 1, 10942, 117, 98, 59, 1, 10968, 4, 2, 59, 100, 17502, 17504, 1, 8839, 111, 116, 59, 1, 10948, 115, 4, 2, 111, 117, 17516, 17520, 108, 59, 1, 10185, 98, 59, 1, 10967, 97, 114, 114, 59, 1, 10619, 117, 108, 116, 59, 1, 10946, 4, 2, 69, 101, 17542, 17545, 59, 1, 10956, 59, 1, 8843, 108, 117, 115, 59, 1, 10944, 4, 3, 101, 105, 117, 17562, 17598, 17602, 116, 4, 3, 59, 101, 110, 17571, 17573, 17585, 1, 8835, 113, 4, 2, 59, 113, 17580, 17582, 1, 8839, 59, 1, 10950, 101, 113, 4, 2, 59, 113, 17593, 17595, 1, 8843, 59, 1, 10956, 109, 59, 1, 10952, 4, 2, 98, 112, 17608, 17611, 59, 1, 10964, 59, 1, 10966, 4, 3, 65, 97, 110, 17622, 17627, 17650, 114, 114, 59, 1, 8665, 114, 4, 2, 104, 114, 17634, 17638, 107, 59, 1, 10534, 4, 2, 59, 111, 17644, 17646, 1, 8601, 119, 59, 1, 8601, 119, 97, 114, 59, 1, 10538, 108, 105, 103, 5, 223, 1, 59, 17664, 1, 223, 4, 13, 97, 98, 99, 100, 101, 102, 104, 105, 111, 112, 114, 115, 119, 17694, 17709, 17714, 17737, 17742, 17749, 17754, 17860, 17905, 17957, 17964, 18090, 18122, 4, 2, 114, 117, 17700, 17706, 103, 101, 116, 59, 1, 8982, 59, 1, 964, 114, 107, 59, 1, 9140, 4, 3, 97, 101, 121, 17722, 17728, 17734, 114, 111, 110, 59, 1, 357, 100, 105, 108, 59, 1, 355, 59, 1, 1090, 111, 116, 59, 1, 8411, 108, 114, 101, 99, 59, 1, 8981, 114, 59, 3, 55349, 56625, 4, 4, 101, 105, 107, 111, 17764, 17805, 17836, 17851, 4, 2, 114, 116, 17770, 17786, 101, 4, 2, 52, 102, 17777, 17780, 59, 1, 8756, 111, 114, 101, 59, 1, 8756, 97, 4, 3, 59, 115, 118, 17795, 17797, 17802, 1, 952, 121, 109, 59, 1, 977, 59, 1, 977, 4, 2, 99, 110, 17811, 17831, 107, 4, 2, 97, 115, 17818, 17826, 112, 112, 114, 111, 120, 59, 1, 8776, 105, 109, 59, 1, 8764, 115, 112, 59, 1, 8201, 4, 2, 97, 115, 17842, 17846, 112, 59, 1, 8776, 105, 109, 59, 1, 8764, 114, 110, 5, 254, 1, 59, 17858, 1, 254, 4, 3, 108, 109, 110, 17868, 17873, 17901, 100, 101, 59, 1, 732, 101, 115, 5, 215, 3, 59, 98, 100, 17884, 17886, 17898, 1, 215, 4, 2, 59, 97, 17892, 17894, 1, 8864, 114, 59, 1, 10801, 59, 1, 10800, 116, 59, 1, 8749, 4, 3, 101, 112, 115, 17913, 17917, 17953, 97, 59, 1, 10536, 4, 4, 59, 98, 99, 102, 17927, 17929, 17934, 17939, 1, 8868, 111, 116, 59, 1, 9014, 105, 114, 59, 1, 10993, 4, 2, 59, 111, 17945, 17948, 3, 55349, 56677, 114, 107, 59, 1, 10970, 97, 59, 1, 10537, 114, 105, 109, 101, 59, 1, 8244, 4, 3, 97, 105, 112, 17972, 17977, 18082, 100, 101, 59, 1, 8482, 4, 7, 97, 100, 101, 109, 112, 115, 116, 17993, 18051, 18056, 18059, 18066, 18072, 18076, 110, 103, 108, 101, 4, 5, 59, 100, 108, 113, 114, 18009, 18011, 18017, 18032, 18035, 1, 9653, 111, 119, 110, 59, 1, 9663, 101, 102, 116, 4, 2, 59, 101, 18026, 18028, 1, 9667, 113, 59, 1, 8884, 59, 1, 8796, 105, 103, 104, 116, 4, 2, 59, 101, 18045, 18047, 1, 9657, 113, 59, 1, 8885, 111, 116, 59, 1, 9708, 59, 1, 8796, 105, 110, 117, 115, 59, 1, 10810, 108, 117, 115, 59, 1, 10809, 98, 59, 1, 10701, 105, 109, 101, 59, 1, 10811, 101, 122, 105, 117, 109, 59, 1, 9186, 4, 3, 99, 104, 116, 18098, 18111, 18116, 4, 2, 114, 121, 18104, 18108, 59, 3, 55349, 56521, 59, 1, 1094, 99, 121, 59, 1, 1115, 114, 111, 107, 59, 1, 359, 4, 2, 105, 111, 18128, 18133, 120, 116, 59, 1, 8812, 104, 101, 97, 100, 4, 2, 108, 114, 18143, 18154, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8606, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8608, 4, 18, 65, 72, 97, 98, 99, 100, 102, 103, 104, 108, 109, 111, 112, 114, 115, 116, 117, 119, 18204, 18209, 18214, 18234, 18250, 18268, 18292, 18308, 18319, 18343, 18379, 18397, 18413, 18504, 18547, 18553, 18584, 18603, 114, 114, 59, 1, 8657, 97, 114, 59, 1, 10595, 4, 2, 99, 114, 18220, 18230, 117, 116, 101, 5, 250, 1, 59, 18228, 1, 250, 114, 59, 1, 8593, 114, 4, 2, 99, 101, 18241, 18245, 121, 59, 1, 1118, 118, 101, 59, 1, 365, 4, 2, 105, 121, 18256, 18265, 114, 99, 5, 251, 1, 59, 18263, 1, 251, 59, 1, 1091, 4, 3, 97, 98, 104, 18276, 18281, 18287, 114, 114, 59, 1, 8645, 108, 97, 99, 59, 1, 369, 97, 114, 59, 1, 10606, 4, 2, 105, 114, 18298, 18304, 115, 104, 116, 59, 1, 10622, 59, 3, 55349, 56626, 114, 97, 118, 101, 5, 249, 1, 59, 18317, 1, 249, 4, 2, 97, 98, 18325, 18338, 114, 4, 2, 108, 114, 18332, 18335, 59, 1, 8639, 59, 1, 8638, 108, 107, 59, 1, 9600, 4, 2, 99, 116, 18349, 18374, 4, 2, 111, 114, 18355, 18369, 114, 110, 4, 2, 59, 101, 18363, 18365, 1, 8988, 114, 59, 1, 8988, 111, 112, 59, 1, 8975, 114, 105, 59, 1, 9720, 4, 2, 97, 108, 18385, 18390, 99, 114, 59, 1, 363, 5, 168, 1, 59, 18395, 1, 168, 4, 2, 103, 112, 18403, 18408, 111, 110, 59, 1, 371, 102, 59, 3, 55349, 56678, 4, 6, 97, 100, 104, 108, 115, 117, 18427, 18434, 18445, 18470, 18475, 18494, 114, 114, 111, 119, 59, 1, 8593, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8597, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 18457, 18463, 101, 102, 116, 59, 1, 8639, 105, 103, 104, 116, 59, 1, 8638, 117, 115, 59, 1, 8846, 105, 4, 3, 59, 104, 108, 18484, 18486, 18489, 1, 965, 59, 1, 978, 111, 110, 59, 1, 965, 112, 97, 114, 114, 111, 119, 115, 59, 1, 8648, 4, 3, 99, 105, 116, 18512, 18537, 18542, 4, 2, 111, 114, 18518, 18532, 114, 110, 4, 2, 59, 101, 18526, 18528, 1, 8989, 114, 59, 1, 8989, 111, 112, 59, 1, 8974, 110, 103, 59, 1, 367, 114, 105, 59, 1, 9721, 99, 114, 59, 3, 55349, 56522, 4, 3, 100, 105, 114, 18561, 18566, 18572, 111, 116, 59, 1, 8944, 108, 100, 101, 59, 1, 361, 105, 4, 2, 59, 102, 18579, 18581, 1, 9653, 59, 1, 9652, 4, 2, 97, 109, 18590, 18595, 114, 114, 59, 1, 8648, 108, 5, 252, 1, 59, 18601, 1, 252, 97, 110, 103, 108, 101, 59, 1, 10663, 4, 15, 65, 66, 68, 97, 99, 100, 101, 102, 108, 110, 111, 112, 114, 115, 122, 18643, 18648, 18661, 18667, 18847, 18851, 18857, 18904, 18909, 18915, 18931, 18937, 18943, 18949, 18996, 114, 114, 59, 1, 8661, 97, 114, 4, 2, 59, 118, 18656, 18658, 1, 10984, 59, 1, 10985, 97, 115, 104, 59, 1, 8872, 4, 2, 110, 114, 18673, 18679, 103, 114, 116, 59, 1, 10652, 4, 7, 101, 107, 110, 112, 114, 115, 116, 18695, 18704, 18711, 18720, 18742, 18754, 18810, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 97, 112, 112, 97, 59, 1, 1008, 111, 116, 104, 105, 110, 103, 59, 1, 8709, 4, 3, 104, 105, 114, 18728, 18732, 18735, 105, 59, 1, 981, 59, 1, 982, 111, 112, 116, 111, 59, 1, 8733, 4, 2, 59, 104, 18748, 18750, 1, 8597, 111, 59, 1, 1009, 4, 2, 105, 117, 18760, 18766, 103, 109, 97, 59, 1, 962, 4, 2, 98, 112, 18772, 18791, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18784, 18787, 3, 8842, 65024, 59, 3, 10955, 65024, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18803, 18806, 3, 8843, 65024, 59, 3, 10956, 65024, 4, 2, 104, 114, 18816, 18822, 101, 116, 97, 59, 1, 977, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 18834, 18840, 101, 102, 116, 59, 1, 8882, 105, 103, 104, 116, 59, 1, 8883, 121, 59, 1, 1074, 97, 115, 104, 59, 1, 8866, 4, 3, 101, 108, 114, 18865, 18884, 18890, 4, 3, 59, 98, 101, 18873, 18875, 18880, 1, 8744, 97, 114, 59, 1, 8891, 113, 59, 1, 8794, 108, 105, 112, 59, 1, 8942, 4, 2, 98, 116, 18896, 18901, 97, 114, 59, 1, 124, 59, 1, 124, 114, 59, 3, 55349, 56627, 116, 114, 105, 59, 1, 8882, 115, 117, 4, 2, 98, 112, 18923, 18927, 59, 3, 8834, 8402, 59, 3, 8835, 8402, 112, 102, 59, 3, 55349, 56679, 114, 111, 112, 59, 1, 8733, 116, 114, 105, 59, 1, 8883, 4, 2, 99, 117, 18955, 18960, 114, 59, 3, 55349, 56523, 4, 2, 98, 112, 18966, 18981, 110, 4, 2, 69, 101, 18973, 18977, 59, 3, 10955, 65024, 59, 3, 8842, 65024, 110, 4, 2, 69, 101, 18988, 18992, 59, 3, 10956, 65024, 59, 3, 8843, 65024, 105, 103, 122, 97, 103, 59, 1, 10650, 4, 7, 99, 101, 102, 111, 112, 114, 115, 19020, 19026, 19061, 19066, 19072, 19075, 19089, 105, 114, 99, 59, 1, 373, 4, 2, 100, 105, 19032, 19055, 4, 2, 98, 103, 19038, 19043, 97, 114, 59, 1, 10847, 101, 4, 2, 59, 113, 19050, 19052, 1, 8743, 59, 1, 8793, 101, 114, 112, 59, 1, 8472, 114, 59, 3, 55349, 56628, 112, 102, 59, 3, 55349, 56680, 59, 1, 8472, 4, 2, 59, 101, 19081, 19083, 1, 8768, 97, 116, 104, 59, 1, 8768, 99, 114, 59, 3, 55349, 56524, 4, 14, 99, 100, 102, 104, 105, 108, 109, 110, 111, 114, 115, 117, 118, 119, 19125, 19146, 19152, 19157, 19173, 19176, 19192, 19197, 19202, 19236, 19252, 19269, 19286, 19291, 4, 3, 97, 105, 117, 19133, 19137, 19142, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 116, 114, 105, 59, 1, 9661, 114, 59, 3, 55349, 56629, 4, 2, 65, 97, 19163, 19168, 114, 114, 59, 1, 10234, 114, 114, 59, 1, 10231, 59, 1, 958, 4, 2, 65, 97, 19182, 19187, 114, 114, 59, 1, 10232, 114, 114, 59, 1, 10229, 97, 112, 59, 1, 10236, 105, 115, 59, 1, 8955, 4, 3, 100, 112, 116, 19210, 19215, 19230, 111, 116, 59, 1, 10752, 4, 2, 102, 108, 19221, 19225, 59, 3, 55349, 56681, 117, 115, 59, 1, 10753, 105, 109, 101, 59, 1, 10754, 4, 2, 65, 97, 19242, 19247, 114, 114, 59, 1, 10233, 114, 114, 59, 1, 10230, 4, 2, 99, 113, 19258, 19263, 114, 59, 3, 55349, 56525, 99, 117, 112, 59, 1, 10758, 4, 2, 112, 116, 19275, 19281, 108, 117, 115, 59, 1, 10756, 114, 105, 59, 1, 9651, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 19316, 19335, 19349, 19357, 19362, 19367, 19373, 19379, 99, 4, 2, 117, 121, 19323, 19332, 116, 101, 5, 253, 1, 59, 19330, 1, 253, 59, 1, 1103, 4, 2, 105, 121, 19341, 19346, 114, 99, 59, 1, 375, 59, 1, 1099, 110, 5, 165, 1, 59, 19355, 1, 165, 114, 59, 3, 55349, 56630, 99, 121, 59, 1, 1111, 112, 102, 59, 3, 55349, 56682, 99, 114, 59, 3, 55349, 56526, 4, 2, 99, 109, 19385, 19389, 121, 59, 1, 1102, 108, 5, 255, 1, 59, 19395, 1, 255, 4, 10, 97, 99, 100, 101, 102, 104, 105, 111, 115, 119, 19419, 19426, 19441, 19446, 19462, 19467, 19472, 19480, 19486, 19492, 99, 117, 116, 101, 59, 1, 378, 4, 2, 97, 121, 19432, 19438, 114, 111, 110, 59, 1, 382, 59, 1, 1079, 111, 116, 59, 1, 380, 4, 2, 101, 116, 19452, 19458, 116, 114, 102, 59, 1, 8488, 97, 59, 1, 950, 114, 59, 3, 55349, 56631, 99, 121, 59, 1, 1078, 103, 114, 97, 114, 114, 59, 1, 8669, 112, 102, 59, 3, 55349, 56683, 99, 114, 59, 3, 55349, 56527, 4, 2, 106, 110, 19498, 19501, 59, 1, 8205, 106, 59, 1, 8204]);
const Mh = wh, Ie = St, cn = Lh, k = xi, g = Ie.CODE_POINTS, sn = Ie.CODE_POINT_SEQUENCES, Ph = {
  128: 8364,
  130: 8218,
  131: 402,
  132: 8222,
  133: 8230,
  134: 8224,
  135: 8225,
  136: 710,
  137: 8240,
  138: 352,
  139: 8249,
  140: 338,
  142: 381,
  145: 8216,
  146: 8217,
  147: 8220,
  148: 8221,
  149: 8226,
  150: 8211,
  151: 8212,
  152: 732,
  153: 8482,
  154: 353,
  155: 8250,
  156: 339,
  158: 382,
  159: 376
}, ca = 1, fa = 2, ha = 4, vh = ca | fa | ha, Te = "DATA_STATE", Cn = "RCDATA_STATE", Yn = "RAWTEXT_STATE", $t = "SCRIPT_DATA_STATE", da = "PLAINTEXT_STATE", Yo = "TAG_OPEN_STATE", Vo = "END_TAG_OPEN_STATE", Mr = "TAG_NAME_STATE", Wo = "RCDATA_LESS_THAN_SIGN_STATE", Xo = "RCDATA_END_TAG_OPEN_STATE", Qo = "RCDATA_END_TAG_NAME_STATE", Jo = "RAWTEXT_LESS_THAN_SIGN_STATE", Zo = "RAWTEXT_END_TAG_OPEN_STATE", es = "RAWTEXT_END_TAG_NAME_STATE", ts = "SCRIPT_DATA_LESS_THAN_SIGN_STATE", ns = "SCRIPT_DATA_END_TAG_OPEN_STATE", rs = "SCRIPT_DATA_END_TAG_NAME_STATE", is = "SCRIPT_DATA_ESCAPE_START_STATE", os = "SCRIPT_DATA_ESCAPE_START_DASH_STATE", At = "SCRIPT_DATA_ESCAPED_STATE", ss = "SCRIPT_DATA_ESCAPED_DASH_STATE", Pr = "SCRIPT_DATA_ESCAPED_DASH_DASH_STATE", g1 = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE", ls = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE", as = "SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE", us = "SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE", vt = "SCRIPT_DATA_DOUBLE_ESCAPED_STATE", cs = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE", fs = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE", E1 = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE", hs = "SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE", Nt = "BEFORE_ATTRIBUTE_NAME_STATE", A1 = "ATTRIBUTE_NAME_STATE", vr = "AFTER_ATTRIBUTE_NAME_STATE", Dr = "BEFORE_ATTRIBUTE_VALUE_STATE", _1 = "ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE", y1 = "ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE", C1 = "ATTRIBUTE_VALUE_UNQUOTED_STATE", Hr = "AFTER_ATTRIBUTE_VALUE_QUOTED_STATE", qt = "SELF_CLOSING_START_TAG_STATE", $n = "BOGUS_COMMENT_STATE", ds = "MARKUP_DECLARATION_OPEN_STATE", ms = "COMMENT_START_STATE", ps = "COMMENT_START_DASH_STATE", Yt = "COMMENT_STATE", Ts = "COMMENT_LESS_THAN_SIGN_STATE", gs = "COMMENT_LESS_THAN_SIGN_BANG_STATE", Es = "COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE", As = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE", S1 = "COMMENT_END_DASH_STATE", x1 = "COMMENT_END_STATE", _s = "COMMENT_END_BANG_STATE", ys = "DOCTYPE_STATE", N1 = "BEFORE_DOCTYPE_NAME_STATE", b1 = "DOCTYPE_NAME_STATE", Cs = "AFTER_DOCTYPE_NAME_STATE", Ss = "AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE", xs = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE", Fr = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE", Br = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE", $r = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE", Ns = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE", bs = "AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE", Os = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE", Un = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE", Gn = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE", Ur = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE", Dt = "BOGUS_DOCTYPE_STATE", O1 = "CDATA_SECTION_STATE", Is = "CDATA_SECTION_BRACKET_STATE", Rs = "CDATA_SECTION_END_STATE", En = "CHARACTER_REFERENCE_STATE", ks = "NAMED_CHARACTER_REFERENCE_STATE", ws = "AMBIGUOS_AMPERSAND_STATE", Ls = "NUMERIC_CHARACTER_REFERENCE_STATE", Ms = "HEXADEMICAL_CHARACTER_REFERENCE_START_STATE", Ps = "DECIMAL_CHARACTER_REFERENCE_START_STATE", vs = "HEXADEMICAL_CHARACTER_REFERENCE_STATE", Ds = "DECIMAL_CHARACTER_REFERENCE_STATE", jn = "NUMERIC_CHARACTER_REFERENCE_END_STATE";
function Le(e) {
  return e === g.SPACE || e === g.LINE_FEED || e === g.TABULATION || e === g.FORM_FEED;
}
function Qn(e) {
  return e >= g.DIGIT_0 && e <= g.DIGIT_9;
}
function _t(e) {
  return e >= g.LATIN_CAPITAL_A && e <= g.LATIN_CAPITAL_Z;
}
function an(e) {
  return e >= g.LATIN_SMALL_A && e <= g.LATIN_SMALL_Z;
}
function Xt(e) {
  return an(e) || _t(e);
}
function Gr(e) {
  return Xt(e) || Qn(e);
}
function ma(e) {
  return e >= g.LATIN_CAPITAL_A && e <= g.LATIN_CAPITAL_F;
}
function pa(e) {
  return e >= g.LATIN_SMALL_A && e <= g.LATIN_SMALL_F;
}
function Dh(e) {
  return Qn(e) || ma(e) || pa(e);
}
function v1(e) {
  return e + 32;
}
function De(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(e >>> 10 & 1023 | 55296) + String.fromCharCode(56320 | e & 1023));
}
function Vt(e) {
  return String.fromCharCode(v1(e));
}
function Hs(e, t) {
  const n = cn[++e];
  let r = ++e, i = r + n - 1;
  for (; r <= i; ) {
    const o = r + i >>> 1, s = cn[o];
    if (s < t)
      r = o + 1;
    else if (s > t)
      i = o - 1;
    else
      return cn[o + n];
  }
  return -1;
}
let pt = class et {
  constructor() {
    this.preprocessor = new Mh(), this.tokenQueue = [], this.allowCDATA = !1, this.state = Te, this.returnState = "", this.charRefCode = -1, this.tempBuff = [], this.lastStartTagName = "", this.consumedAfterSnapshot = -1, this.active = !1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = null;
  }
  //Errors
  _err() {
  }
  _errOnNextCodePoint(t) {
    this._consume(), this._err(t), this._unconsume();
  }
  //API
  getNextToken() {
    for (; !this.tokenQueue.length && this.active; ) {
      this.consumedAfterSnapshot = 0;
      const t = this._consume();
      this._ensureHibernation() || this[this.state](t);
    }
    return this.tokenQueue.shift();
  }
  write(t, n) {
    this.active = !0, this.preprocessor.write(t, n);
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t);
  }
  //Hibernation
  _ensureHibernation() {
    if (this.preprocessor.endOfChunkHit) {
      for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--)
        this.preprocessor.retreat();
      return this.active = !1, this.tokenQueue.push({ type: et.HIBERNATION_TOKEN }), !0;
    }
    return !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _unconsume() {
    this.consumedAfterSnapshot--, this.preprocessor.retreat();
  }
  _reconsumeInState(t) {
    this.state = t, this._unconsume();
  }
  _consumeSequenceIfMatch(t, n, r) {
    let i = 0, o = !0;
    const s = t.length;
    let l = 0, c = n, u;
    for (; l < s; l++) {
      if (l > 0 && (c = this._consume(), i++), c === g.EOF) {
        o = !1;
        break;
      }
      if (u = t[l], c !== u && (r || c !== v1(u))) {
        o = !1;
        break;
      }
    }
    if (!o)
      for (; i--; )
        this._unconsume();
    return o;
  }
  //Temp buffer
  _isTempBufferEqualToScriptString() {
    if (this.tempBuff.length !== sn.SCRIPT_STRING.length)
      return !1;
    for (let t = 0; t < this.tempBuff.length; t++)
      if (this.tempBuff[t] !== sn.SCRIPT_STRING[t])
        return !1;
    return !0;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: et.START_TAG_TOKEN,
      tagName: "",
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: []
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: et.END_TAG_TOKEN,
      tagName: "",
      selfClosing: !1,
      attrs: []
    };
  }
  _createCommentToken() {
    this.currentToken = {
      type: et.COMMENT_TOKEN,
      data: ""
    };
  }
  _createDoctypeToken(t) {
    this.currentToken = {
      type: et.DOCTYPE_TOKEN,
      name: t,
      forceQuirks: !1,
      publicId: null,
      systemId: null
    };
  }
  _createCharacterToken(t, n) {
    this.currentCharacterToken = {
      type: t,
      chars: n
    };
  }
  _createEOFToken() {
    this.currentToken = { type: et.EOF_TOKEN };
  }
  //Tag attributes
  _createAttr(t) {
    this.currentAttr = {
      name: t,
      value: ""
    };
  }
  _leaveAttrName(t) {
    et.getTokenAttr(this.currentToken, this.currentAttr.name) === null ? this.currentToken.attrs.push(this.currentAttr) : this._err(k.duplicateAttribute), this.state = t;
  }
  _leaveAttrValue(t) {
    this.state = t;
  }
  //Token emission
  _emitCurrentToken() {
    this._emitCurrentCharacterToken();
    const t = this.currentToken;
    this.currentToken = null, t.type === et.START_TAG_TOKEN ? this.lastStartTagName = t.tagName : t.type === et.END_TAG_TOKEN && (t.attrs.length > 0 && this._err(k.endTagWithAttributes), t.selfClosing && this._err(k.endTagWithTrailingSolidus)), this.tokenQueue.push(t);
  }
  _emitCurrentCharacterToken() {
    this.currentCharacterToken && (this.tokenQueue.push(this.currentCharacterToken), this.currentCharacterToken = null);
  }
  _emitEOFToken() {
    this._createEOFToken(), this._emitCurrentToken();
  }
  //Characters emission
  //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(t, n) {
    this.currentCharacterToken && this.currentCharacterToken.type !== t && this._emitCurrentCharacterToken(), this.currentCharacterToken ? this.currentCharacterToken.chars += n : this._createCharacterToken(t, n);
  }
  _emitCodePoint(t) {
    let n = et.CHARACTER_TOKEN;
    Le(t) ? n = et.WHITESPACE_CHARACTER_TOKEN : t === g.NULL && (n = et.NULL_CHARACTER_TOKEN), this._appendCharToCurrentCharacterToken(n, De(t));
  }
  _emitSeveralCodePoints(t) {
    for (let n = 0; n < t.length; n++)
      this._emitCodePoint(t[n]);
  }
  //NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
  //So we can avoid additional checks here.
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(et.CHARACTER_TOKEN, t);
  }
  // Character reference helpers
  _matchNamedCharacterReference(t) {
    let n = null, r = 1, i = Hs(0, t);
    for (this.tempBuff.push(t); i > -1; ) {
      const o = cn[i], s = o < vh;
      s && o & ca && (n = o & fa ? [cn[++i], cn[++i]] : [cn[++i]], r = 0);
      const c = this._consume();
      if (this.tempBuff.push(c), r++, c === g.EOF)
        break;
      s ? i = o & ha ? Hs(i, c) : -1 : i = c === o ? ++i : -1;
    }
    for (; r--; )
      this.tempBuff.pop(), this._unconsume();
    return n;
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === _1 || this.returnState === y1 || this.returnState === C1;
  }
  _isCharacterReferenceAttributeQuirk(t) {
    if (!t && this._isCharacterReferenceInAttribute()) {
      const n = this._consume();
      return this._unconsume(), n === g.EQUALS_SIGN || Gr(n);
    }
    return !1;
  }
  _flushCodePointsConsumedAsCharacterReference() {
    if (this._isCharacterReferenceInAttribute())
      for (let t = 0; t < this.tempBuff.length; t++)
        this.currentAttr.value += De(this.tempBuff[t]);
    else
      this._emitSeveralCodePoints(this.tempBuff);
    this.tempBuff = [];
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  [Te](t) {
    this.preprocessor.dropParsedChunk(), t === g.LESS_THAN_SIGN ? this.state = Yo : t === g.AMPERSAND ? (this.returnState = Te, this.state = En) : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this._emitCodePoint(t)) : t === g.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  //  RCDATA state
  //------------------------------------------------------------------
  [Cn](t) {
    this.preprocessor.dropParsedChunk(), t === g.AMPERSAND ? (this.returnState = Cn, this.state = En) : t === g.LESS_THAN_SIGN ? this.state = Wo : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this._emitChars(Ie.REPLACEMENT_CHARACTER)) : t === g.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  [Yn](t) {
    this.preprocessor.dropParsedChunk(), t === g.LESS_THAN_SIGN ? this.state = Jo : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this._emitChars(Ie.REPLACEMENT_CHARACTER)) : t === g.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // Script data state
  //------------------------------------------------------------------
  [$t](t) {
    this.preprocessor.dropParsedChunk(), t === g.LESS_THAN_SIGN ? this.state = ts : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this._emitChars(Ie.REPLACEMENT_CHARACTER)) : t === g.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  [da](t) {
    this.preprocessor.dropParsedChunk(), t === g.NULL ? (this._err(k.unexpectedNullCharacter), this._emitChars(Ie.REPLACEMENT_CHARACTER)) : t === g.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // Tag open state
  //------------------------------------------------------------------
  [Yo](t) {
    t === g.EXCLAMATION_MARK ? this.state = ds : t === g.SOLIDUS ? this.state = Vo : Xt(t) ? (this._createStartTagToken(), this._reconsumeInState(Mr)) : t === g.QUESTION_MARK ? (this._err(k.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(), this._reconsumeInState($n)) : t === g.EOF ? (this._err(k.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken()) : (this._err(k.invalidFirstCharacterOfTagName), this._emitChars("<"), this._reconsumeInState(Te));
  }
  // End tag open state
  //------------------------------------------------------------------
  [Vo](t) {
    Xt(t) ? (this._createEndTagToken(), this._reconsumeInState(Mr)) : t === g.GREATER_THAN_SIGN ? (this._err(k.missingEndTagName), this.state = Te) : t === g.EOF ? (this._err(k.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken()) : (this._err(k.invalidFirstCharacterOfTagName), this._createCommentToken(), this._reconsumeInState($n));
  }
  // Tag name state
  //------------------------------------------------------------------
  [Mr](t) {
    Le(t) ? this.state = Nt : t === g.SOLIDUS ? this.state = qt : t === g.GREATER_THAN_SIGN ? (this.state = Te, this._emitCurrentToken()) : _t(t) ? this.currentToken.tagName += Vt(t) : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this.currentToken.tagName += Ie.REPLACEMENT_CHARACTER) : t === g.EOF ? (this._err(k.eofInTag), this._emitEOFToken()) : this.currentToken.tagName += De(t);
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  [Wo](t) {
    t === g.SOLIDUS ? (this.tempBuff = [], this.state = Xo) : (this._emitChars("<"), this._reconsumeInState(Cn));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  [Xo](t) {
    Xt(t) ? (this._createEndTagToken(), this._reconsumeInState(Qo)) : (this._emitChars("</"), this._reconsumeInState(Cn));
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  [Qo](t) {
    if (_t(t))
      this.currentToken.tagName += Vt(t), this.tempBuff.push(t);
    else if (an(t))
      this.currentToken.tagName += De(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Le(t)) {
          this.state = Nt;
          return;
        }
        if (t === g.SOLIDUS) {
          this.state = qt;
          return;
        }
        if (t === g.GREATER_THAN_SIGN) {
          this.state = Te, this._emitCurrentToken();
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(Cn);
    }
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  [Jo](t) {
    t === g.SOLIDUS ? (this.tempBuff = [], this.state = Zo) : (this._emitChars("<"), this._reconsumeInState(Yn));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  [Zo](t) {
    Xt(t) ? (this._createEndTagToken(), this._reconsumeInState(es)) : (this._emitChars("</"), this._reconsumeInState(Yn));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  [es](t) {
    if (_t(t))
      this.currentToken.tagName += Vt(t), this.tempBuff.push(t);
    else if (an(t))
      this.currentToken.tagName += De(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Le(t)) {
          this.state = Nt;
          return;
        }
        if (t === g.SOLIDUS) {
          this.state = qt;
          return;
        }
        if (t === g.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = Te;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(Yn);
    }
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  [ts](t) {
    t === g.SOLIDUS ? (this.tempBuff = [], this.state = ns) : t === g.EXCLAMATION_MARK ? (this.state = is, this._emitChars("<!")) : (this._emitChars("<"), this._reconsumeInState($t));
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  [ns](t) {
    Xt(t) ? (this._createEndTagToken(), this._reconsumeInState(rs)) : (this._emitChars("</"), this._reconsumeInState($t));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  [rs](t) {
    if (_t(t))
      this.currentToken.tagName += Vt(t), this.tempBuff.push(t);
    else if (an(t))
      this.currentToken.tagName += De(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Le(t)) {
          this.state = Nt;
          return;
        } else if (t === g.SOLIDUS) {
          this.state = qt;
          return;
        } else if (t === g.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = Te;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState($t);
    }
  }
  // Script data escape start state
  //------------------------------------------------------------------
  [is](t) {
    t === g.HYPHEN_MINUS ? (this.state = os, this._emitChars("-")) : this._reconsumeInState($t);
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  [os](t) {
    t === g.HYPHEN_MINUS ? (this.state = Pr, this._emitChars("-")) : this._reconsumeInState($t);
  }
  // Script data escaped state
  //------------------------------------------------------------------
  [At](t) {
    t === g.HYPHEN_MINUS ? (this.state = ss, this._emitChars("-")) : t === g.LESS_THAN_SIGN ? this.state = g1 : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this._emitChars(Ie.REPLACEMENT_CHARACTER)) : t === g.EOF ? (this._err(k.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  [ss](t) {
    t === g.HYPHEN_MINUS ? (this.state = Pr, this._emitChars("-")) : t === g.LESS_THAN_SIGN ? this.state = g1 : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this.state = At, this._emitChars(Ie.REPLACEMENT_CHARACTER)) : t === g.EOF ? (this._err(k.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = At, this._emitCodePoint(t));
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  [Pr](t) {
    t === g.HYPHEN_MINUS ? this._emitChars("-") : t === g.LESS_THAN_SIGN ? this.state = g1 : t === g.GREATER_THAN_SIGN ? (this.state = $t, this._emitChars(">")) : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this.state = At, this._emitChars(Ie.REPLACEMENT_CHARACTER)) : t === g.EOF ? (this._err(k.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = At, this._emitCodePoint(t));
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  [g1](t) {
    t === g.SOLIDUS ? (this.tempBuff = [], this.state = ls) : Xt(t) ? (this.tempBuff = [], this._emitChars("<"), this._reconsumeInState(us)) : (this._emitChars("<"), this._reconsumeInState(At));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  [ls](t) {
    Xt(t) ? (this._createEndTagToken(), this._reconsumeInState(as)) : (this._emitChars("</"), this._reconsumeInState(At));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  [as](t) {
    if (_t(t))
      this.currentToken.tagName += Vt(t), this.tempBuff.push(t);
    else if (an(t))
      this.currentToken.tagName += De(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Le(t)) {
          this.state = Nt;
          return;
        }
        if (t === g.SOLIDUS) {
          this.state = qt;
          return;
        }
        if (t === g.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = Te;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(At);
    }
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  [us](t) {
    Le(t) || t === g.SOLIDUS || t === g.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? vt : At, this._emitCodePoint(t)) : _t(t) ? (this.tempBuff.push(v1(t)), this._emitCodePoint(t)) : an(t) ? (this.tempBuff.push(t), this._emitCodePoint(t)) : this._reconsumeInState(At);
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  [vt](t) {
    t === g.HYPHEN_MINUS ? (this.state = cs, this._emitChars("-")) : t === g.LESS_THAN_SIGN ? (this.state = E1, this._emitChars("<")) : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this._emitChars(Ie.REPLACEMENT_CHARACTER)) : t === g.EOF ? (this._err(k.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  [cs](t) {
    t === g.HYPHEN_MINUS ? (this.state = fs, this._emitChars("-")) : t === g.LESS_THAN_SIGN ? (this.state = E1, this._emitChars("<")) : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this.state = vt, this._emitChars(Ie.REPLACEMENT_CHARACTER)) : t === g.EOF ? (this._err(k.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = vt, this._emitCodePoint(t));
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  [fs](t) {
    t === g.HYPHEN_MINUS ? this._emitChars("-") : t === g.LESS_THAN_SIGN ? (this.state = E1, this._emitChars("<")) : t === g.GREATER_THAN_SIGN ? (this.state = $t, this._emitChars(">")) : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this.state = vt, this._emitChars(Ie.REPLACEMENT_CHARACTER)) : t === g.EOF ? (this._err(k.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = vt, this._emitCodePoint(t));
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  [E1](t) {
    t === g.SOLIDUS ? (this.tempBuff = [], this.state = hs, this._emitChars("/")) : this._reconsumeInState(vt);
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  [hs](t) {
    Le(t) || t === g.SOLIDUS || t === g.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? At : vt, this._emitCodePoint(t)) : _t(t) ? (this.tempBuff.push(v1(t)), this._emitCodePoint(t)) : an(t) ? (this.tempBuff.push(t), this._emitCodePoint(t)) : this._reconsumeInState(vt);
  }
  // Before attribute name state
  //------------------------------------------------------------------
  [Nt](t) {
    Le(t) || (t === g.SOLIDUS || t === g.GREATER_THAN_SIGN || t === g.EOF ? this._reconsumeInState(vr) : t === g.EQUALS_SIGN ? (this._err(k.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = A1) : (this._createAttr(""), this._reconsumeInState(A1)));
  }
  // Attribute name state
  //------------------------------------------------------------------
  [A1](t) {
    Le(t) || t === g.SOLIDUS || t === g.GREATER_THAN_SIGN || t === g.EOF ? (this._leaveAttrName(vr), this._unconsume()) : t === g.EQUALS_SIGN ? this._leaveAttrName(Dr) : _t(t) ? this.currentAttr.name += Vt(t) : t === g.QUOTATION_MARK || t === g.APOSTROPHE || t === g.LESS_THAN_SIGN ? (this._err(k.unexpectedCharacterInAttributeName), this.currentAttr.name += De(t)) : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this.currentAttr.name += Ie.REPLACEMENT_CHARACTER) : this.currentAttr.name += De(t);
  }
  // After attribute name state
  //------------------------------------------------------------------
  [vr](t) {
    Le(t) || (t === g.SOLIDUS ? this.state = qt : t === g.EQUALS_SIGN ? this.state = Dr : t === g.GREATER_THAN_SIGN ? (this.state = Te, this._emitCurrentToken()) : t === g.EOF ? (this._err(k.eofInTag), this._emitEOFToken()) : (this._createAttr(""), this._reconsumeInState(A1)));
  }
  // Before attribute value state
  //------------------------------------------------------------------
  [Dr](t) {
    Le(t) || (t === g.QUOTATION_MARK ? this.state = _1 : t === g.APOSTROPHE ? this.state = y1 : t === g.GREATER_THAN_SIGN ? (this._err(k.missingAttributeValue), this.state = Te, this._emitCurrentToken()) : this._reconsumeInState(C1));
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  [_1](t) {
    t === g.QUOTATION_MARK ? this.state = Hr : t === g.AMPERSAND ? (this.returnState = _1, this.state = En) : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this.currentAttr.value += Ie.REPLACEMENT_CHARACTER) : t === g.EOF ? (this._err(k.eofInTag), this._emitEOFToken()) : this.currentAttr.value += De(t);
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  [y1](t) {
    t === g.APOSTROPHE ? this.state = Hr : t === g.AMPERSAND ? (this.returnState = y1, this.state = En) : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this.currentAttr.value += Ie.REPLACEMENT_CHARACTER) : t === g.EOF ? (this._err(k.eofInTag), this._emitEOFToken()) : this.currentAttr.value += De(t);
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  [C1](t) {
    Le(t) ? this._leaveAttrValue(Nt) : t === g.AMPERSAND ? (this.returnState = C1, this.state = En) : t === g.GREATER_THAN_SIGN ? (this._leaveAttrValue(Te), this._emitCurrentToken()) : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this.currentAttr.value += Ie.REPLACEMENT_CHARACTER) : t === g.QUOTATION_MARK || t === g.APOSTROPHE || t === g.LESS_THAN_SIGN || t === g.EQUALS_SIGN || t === g.GRAVE_ACCENT ? (this._err(k.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += De(t)) : t === g.EOF ? (this._err(k.eofInTag), this._emitEOFToken()) : this.currentAttr.value += De(t);
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  [Hr](t) {
    Le(t) ? this._leaveAttrValue(Nt) : t === g.SOLIDUS ? this._leaveAttrValue(qt) : t === g.GREATER_THAN_SIGN ? (this._leaveAttrValue(Te), this._emitCurrentToken()) : t === g.EOF ? (this._err(k.eofInTag), this._emitEOFToken()) : (this._err(k.missingWhitespaceBetweenAttributes), this._reconsumeInState(Nt));
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  [qt](t) {
    t === g.GREATER_THAN_SIGN ? (this.currentToken.selfClosing = !0, this.state = Te, this._emitCurrentToken()) : t === g.EOF ? (this._err(k.eofInTag), this._emitEOFToken()) : (this._err(k.unexpectedSolidusInTag), this._reconsumeInState(Nt));
  }
  // Bogus comment state
  //------------------------------------------------------------------
  [$n](t) {
    t === g.GREATER_THAN_SIGN ? (this.state = Te, this._emitCurrentToken()) : t === g.EOF ? (this._emitCurrentToken(), this._emitEOFToken()) : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this.currentToken.data += Ie.REPLACEMENT_CHARACTER) : this.currentToken.data += De(t);
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  [ds](t) {
    this._consumeSequenceIfMatch(sn.DASH_DASH_STRING, t, !0) ? (this._createCommentToken(), this.state = ms) : this._consumeSequenceIfMatch(sn.DOCTYPE_STRING, t, !1) ? this.state = ys : this._consumeSequenceIfMatch(sn.CDATA_START_STRING, t, !0) ? this.allowCDATA ? this.state = O1 : (this._err(k.cdataInHtmlContent), this._createCommentToken(), this.currentToken.data = "[CDATA[", this.state = $n) : this._ensureHibernation() || (this._err(k.incorrectlyOpenedComment), this._createCommentToken(), this._reconsumeInState($n));
  }
  // Comment start state
  //------------------------------------------------------------------
  [ms](t) {
    t === g.HYPHEN_MINUS ? this.state = ps : t === g.GREATER_THAN_SIGN ? (this._err(k.abruptClosingOfEmptyComment), this.state = Te, this._emitCurrentToken()) : this._reconsumeInState(Yt);
  }
  // Comment start dash state
  //------------------------------------------------------------------
  [ps](t) {
    t === g.HYPHEN_MINUS ? this.state = x1 : t === g.GREATER_THAN_SIGN ? (this._err(k.abruptClosingOfEmptyComment), this.state = Te, this._emitCurrentToken()) : t === g.EOF ? (this._err(k.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(Yt));
  }
  // Comment state
  //------------------------------------------------------------------
  [Yt](t) {
    t === g.HYPHEN_MINUS ? this.state = S1 : t === g.LESS_THAN_SIGN ? (this.currentToken.data += "<", this.state = Ts) : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this.currentToken.data += Ie.REPLACEMENT_CHARACTER) : t === g.EOF ? (this._err(k.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.data += De(t);
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  [Ts](t) {
    t === g.EXCLAMATION_MARK ? (this.currentToken.data += "!", this.state = gs) : t === g.LESS_THAN_SIGN ? this.currentToken.data += "!" : this._reconsumeInState(Yt);
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  [gs](t) {
    t === g.HYPHEN_MINUS ? this.state = Es : this._reconsumeInState(Yt);
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  [Es](t) {
    t === g.HYPHEN_MINUS ? this.state = As : this._reconsumeInState(S1);
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  [As](t) {
    t !== g.GREATER_THAN_SIGN && t !== g.EOF && this._err(k.nestedComment), this._reconsumeInState(x1);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  [S1](t) {
    t === g.HYPHEN_MINUS ? this.state = x1 : t === g.EOF ? (this._err(k.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(Yt));
  }
  // Comment end state
  //------------------------------------------------------------------
  [x1](t) {
    t === g.GREATER_THAN_SIGN ? (this.state = Te, this._emitCurrentToken()) : t === g.EXCLAMATION_MARK ? this.state = _s : t === g.HYPHEN_MINUS ? this.currentToken.data += "-" : t === g.EOF ? (this._err(k.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--", this._reconsumeInState(Yt));
  }
  // Comment end bang state
  //------------------------------------------------------------------
  [_s](t) {
    t === g.HYPHEN_MINUS ? (this.currentToken.data += "--!", this.state = S1) : t === g.GREATER_THAN_SIGN ? (this._err(k.incorrectlyClosedComment), this.state = Te, this._emitCurrentToken()) : t === g.EOF ? (this._err(k.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--!", this._reconsumeInState(Yt));
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  [ys](t) {
    Le(t) ? this.state = N1 : t === g.GREATER_THAN_SIGN ? this._reconsumeInState(N1) : t === g.EOF ? (this._err(k.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(k.missingWhitespaceBeforeDoctypeName), this._reconsumeInState(N1));
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  [N1](t) {
    Le(t) || (_t(t) ? (this._createDoctypeToken(Vt(t)), this.state = b1) : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this._createDoctypeToken(Ie.REPLACEMENT_CHARACTER), this.state = b1) : t === g.GREATER_THAN_SIGN ? (this._err(k.missingDoctypeName), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = Te) : t === g.EOF ? (this._err(k.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._createDoctypeToken(De(t)), this.state = b1));
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  [b1](t) {
    Le(t) ? this.state = Cs : t === g.GREATER_THAN_SIGN ? (this.state = Te, this._emitCurrentToken()) : _t(t) ? this.currentToken.name += Vt(t) : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this.currentToken.name += Ie.REPLACEMENT_CHARACTER) : t === g.EOF ? (this._err(k.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.name += De(t);
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  [Cs](t) {
    Le(t) || (t === g.GREATER_THAN_SIGN ? (this.state = Te, this._emitCurrentToken()) : t === g.EOF ? (this._err(k.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this._consumeSequenceIfMatch(sn.PUBLIC_STRING, t, !1) ? this.state = Ss : this._consumeSequenceIfMatch(sn.SYSTEM_STRING, t, !1) ? this.state = bs : this._ensureHibernation() || (this._err(k.invalidCharacterSequenceAfterDoctypeName), this.currentToken.forceQuirks = !0, this._reconsumeInState(Dt)));
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  [Ss](t) {
    Le(t) ? this.state = xs : t === g.QUOTATION_MARK ? (this._err(k.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = Fr) : t === g.APOSTROPHE ? (this._err(k.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = Br) : t === g.GREATER_THAN_SIGN ? (this._err(k.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = Te, this._emitCurrentToken()) : t === g.EOF ? (this._err(k.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(k.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Dt));
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  [xs](t) {
    Le(t) || (t === g.QUOTATION_MARK ? (this.currentToken.publicId = "", this.state = Fr) : t === g.APOSTROPHE ? (this.currentToken.publicId = "", this.state = Br) : t === g.GREATER_THAN_SIGN ? (this._err(k.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = Te, this._emitCurrentToken()) : t === g.EOF ? (this._err(k.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(k.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Dt)));
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  [Fr](t) {
    t === g.QUOTATION_MARK ? this.state = $r : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this.currentToken.publicId += Ie.REPLACEMENT_CHARACTER) : t === g.GREATER_THAN_SIGN ? (this._err(k.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = Te) : t === g.EOF ? (this._err(k.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += De(t);
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  [Br](t) {
    t === g.APOSTROPHE ? this.state = $r : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this.currentToken.publicId += Ie.REPLACEMENT_CHARACTER) : t === g.GREATER_THAN_SIGN ? (this._err(k.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = Te) : t === g.EOF ? (this._err(k.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += De(t);
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  [$r](t) {
    Le(t) ? this.state = Ns : t === g.GREATER_THAN_SIGN ? (this.state = Te, this._emitCurrentToken()) : t === g.QUOTATION_MARK ? (this._err(k.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = Un) : t === g.APOSTROPHE ? (this._err(k.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = Gn) : t === g.EOF ? (this._err(k.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(k.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Dt));
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  [Ns](t) {
    Le(t) || (t === g.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = Te) : t === g.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = Un) : t === g.APOSTROPHE ? (this.currentToken.systemId = "", this.state = Gn) : t === g.EOF ? (this._err(k.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(k.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Dt)));
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  [bs](t) {
    Le(t) ? this.state = Os : t === g.QUOTATION_MARK ? (this._err(k.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = Un) : t === g.APOSTROPHE ? (this._err(k.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = Gn) : t === g.GREATER_THAN_SIGN ? (this._err(k.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = Te, this._emitCurrentToken()) : t === g.EOF ? (this._err(k.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(k.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Dt));
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  [Os](t) {
    Le(t) || (t === g.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = Un) : t === g.APOSTROPHE ? (this.currentToken.systemId = "", this.state = Gn) : t === g.GREATER_THAN_SIGN ? (this._err(k.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = Te, this._emitCurrentToken()) : t === g.EOF ? (this._err(k.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(k.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Dt)));
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  [Un](t) {
    t === g.QUOTATION_MARK ? this.state = Ur : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this.currentToken.systemId += Ie.REPLACEMENT_CHARACTER) : t === g.GREATER_THAN_SIGN ? (this._err(k.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = Te) : t === g.EOF ? (this._err(k.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += De(t);
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  [Gn](t) {
    t === g.APOSTROPHE ? this.state = Ur : t === g.NULL ? (this._err(k.unexpectedNullCharacter), this.currentToken.systemId += Ie.REPLACEMENT_CHARACTER) : t === g.GREATER_THAN_SIGN ? (this._err(k.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = Te) : t === g.EOF ? (this._err(k.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += De(t);
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  [Ur](t) {
    Le(t) || (t === g.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = Te) : t === g.EOF ? (this._err(k.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(k.unexpectedCharacterAfterDoctypeSystemIdentifier), this._reconsumeInState(Dt)));
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  [Dt](t) {
    t === g.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = Te) : t === g.NULL ? this._err(k.unexpectedNullCharacter) : t === g.EOF && (this._emitCurrentToken(), this._emitEOFToken());
  }
  // CDATA section state
  //------------------------------------------------------------------
  [O1](t) {
    t === g.RIGHT_SQUARE_BRACKET ? this.state = Is : t === g.EOF ? (this._err(k.eofInCdata), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  [Is](t) {
    t === g.RIGHT_SQUARE_BRACKET ? this.state = Rs : (this._emitChars("]"), this._reconsumeInState(O1));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  [Rs](t) {
    t === g.GREATER_THAN_SIGN ? this.state = Te : t === g.RIGHT_SQUARE_BRACKET ? this._emitChars("]") : (this._emitChars("]]"), this._reconsumeInState(O1));
  }
  // Character reference state
  //------------------------------------------------------------------
  [En](t) {
    this.tempBuff = [g.AMPERSAND], t === g.NUMBER_SIGN ? (this.tempBuff.push(t), this.state = Ls) : Gr(t) ? this._reconsumeInState(ks) : (this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Named character reference state
  //------------------------------------------------------------------
  [ks](t) {
    const n = this._matchNamedCharacterReference(t);
    if (this._ensureHibernation())
      this.tempBuff = [g.AMPERSAND];
    else if (n) {
      const r = this.tempBuff[this.tempBuff.length - 1] === g.SEMICOLON;
      this._isCharacterReferenceAttributeQuirk(r) || (r || this._errOnNextCodePoint(k.missingSemicolonAfterCharacterReference), this.tempBuff = n), this._flushCodePointsConsumedAsCharacterReference(), this.state = this.returnState;
    } else
      this._flushCodePointsConsumedAsCharacterReference(), this.state = ws;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  [ws](t) {
    Gr(t) ? this._isCharacterReferenceInAttribute() ? this.currentAttr.value += De(t) : this._emitCodePoint(t) : (t === g.SEMICOLON && this._err(k.unknownNamedCharacterReference), this._reconsumeInState(this.returnState));
  }
  // Numeric character reference state
  //------------------------------------------------------------------
  [Ls](t) {
    this.charRefCode = 0, t === g.LATIN_SMALL_X || t === g.LATIN_CAPITAL_X ? (this.tempBuff.push(t), this.state = Ms) : this._reconsumeInState(Ps);
  }
  // Hexademical character reference start state
  //------------------------------------------------------------------
  [Ms](t) {
    Dh(t) ? this._reconsumeInState(vs) : (this._err(k.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Decimal character reference start state
  //------------------------------------------------------------------
  [Ps](t) {
    Qn(t) ? this._reconsumeInState(Ds) : (this._err(k.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Hexademical character reference state
  //------------------------------------------------------------------
  [vs](t) {
    ma(t) ? this.charRefCode = this.charRefCode * 16 + t - 55 : pa(t) ? this.charRefCode = this.charRefCode * 16 + t - 87 : Qn(t) ? this.charRefCode = this.charRefCode * 16 + t - 48 : t === g.SEMICOLON ? this.state = jn : (this._err(k.missingSemicolonAfterCharacterReference), this._reconsumeInState(jn));
  }
  // Decimal character reference state
  //------------------------------------------------------------------
  [Ds](t) {
    Qn(t) ? this.charRefCode = this.charRefCode * 10 + t - 48 : t === g.SEMICOLON ? this.state = jn : (this._err(k.missingSemicolonAfterCharacterReference), this._reconsumeInState(jn));
  }
  // Numeric character reference end state
  //------------------------------------------------------------------
  [jn]() {
    if (this.charRefCode === g.NULL)
      this._err(k.nullCharacterReference), this.charRefCode = g.REPLACEMENT_CHARACTER;
    else if (this.charRefCode > 1114111)
      this._err(k.characterReferenceOutsideUnicodeRange), this.charRefCode = g.REPLACEMENT_CHARACTER;
    else if (Ie.isSurrogate(this.charRefCode))
      this._err(k.surrogateCharacterReference), this.charRefCode = g.REPLACEMENT_CHARACTER;
    else if (Ie.isUndefinedCodePoint(this.charRefCode))
      this._err(k.noncharacterCharacterReference);
    else if (Ie.isControlCodePoint(this.charRefCode) || this.charRefCode === g.CARRIAGE_RETURN) {
      this._err(k.controlCharacterReference);
      const t = Ph[this.charRefCode];
      t && (this.charRefCode = t);
    }
    this.tempBuff = [this.charRefCode], this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState);
  }
};
pt.CHARACTER_TOKEN = "CHARACTER_TOKEN";
pt.NULL_CHARACTER_TOKEN = "NULL_CHARACTER_TOKEN";
pt.WHITESPACE_CHARACTER_TOKEN = "WHITESPACE_CHARACTER_TOKEN";
pt.START_TAG_TOKEN = "START_TAG_TOKEN";
pt.END_TAG_TOKEN = "END_TAG_TOKEN";
pt.COMMENT_TOKEN = "COMMENT_TOKEN";
pt.DOCTYPE_TOKEN = "DOCTYPE_TOKEN";
pt.EOF_TOKEN = "EOF_TOKEN";
pt.HIBERNATION_TOKEN = "HIBERNATION_TOKEN";
pt.MODE = {
  DATA: Te,
  RCDATA: Cn,
  RAWTEXT: Yn,
  SCRIPT_DATA: $t,
  PLAINTEXT: da
};
pt.getTokenAttr = function(e, t) {
  for (let n = e.attrs.length - 1; n >= 0; n--)
    if (e.attrs[n].name === t)
      return e.attrs[n].value;
  return null;
};
var tr = pt, xt = {};
const jr = xt.NAMESPACES = {
  HTML: "http://www.w3.org/1999/xhtml",
  MATHML: "http://www.w3.org/1998/Math/MathML",
  SVG: "http://www.w3.org/2000/svg",
  XLINK: "http://www.w3.org/1999/xlink",
  XML: "http://www.w3.org/XML/1998/namespace",
  XMLNS: "http://www.w3.org/2000/xmlns/"
};
xt.ATTRS = {
  TYPE: "type",
  ACTION: "action",
  ENCODING: "encoding",
  PROMPT: "prompt",
  NAME: "name",
  COLOR: "color",
  FACE: "face",
  SIZE: "size"
};
xt.DOCUMENT_MODE = {
  NO_QUIRKS: "no-quirks",
  QUIRKS: "quirks",
  LIMITED_QUIRKS: "limited-quirks"
};
const $ = xt.TAG_NAMES = {
  A: "a",
  ADDRESS: "address",
  ANNOTATION_XML: "annotation-xml",
  APPLET: "applet",
  AREA: "area",
  ARTICLE: "article",
  ASIDE: "aside",
  B: "b",
  BASE: "base",
  BASEFONT: "basefont",
  BGSOUND: "bgsound",
  BIG: "big",
  BLOCKQUOTE: "blockquote",
  BODY: "body",
  BR: "br",
  BUTTON: "button",
  CAPTION: "caption",
  CENTER: "center",
  CODE: "code",
  COL: "col",
  COLGROUP: "colgroup",
  DD: "dd",
  DESC: "desc",
  DETAILS: "details",
  DIALOG: "dialog",
  DIR: "dir",
  DIV: "div",
  DL: "dl",
  DT: "dt",
  EM: "em",
  EMBED: "embed",
  FIELDSET: "fieldset",
  FIGCAPTION: "figcaption",
  FIGURE: "figure",
  FONT: "font",
  FOOTER: "footer",
  FOREIGN_OBJECT: "foreignObject",
  FORM: "form",
  FRAME: "frame",
  FRAMESET: "frameset",
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6",
  HEAD: "head",
  HEADER: "header",
  HGROUP: "hgroup",
  HR: "hr",
  HTML: "html",
  I: "i",
  IMG: "img",
  IMAGE: "image",
  INPUT: "input",
  IFRAME: "iframe",
  KEYGEN: "keygen",
  LABEL: "label",
  LI: "li",
  LINK: "link",
  LISTING: "listing",
  MAIN: "main",
  MALIGNMARK: "malignmark",
  MARQUEE: "marquee",
  MATH: "math",
  MENU: "menu",
  META: "meta",
  MGLYPH: "mglyph",
  MI: "mi",
  MO: "mo",
  MN: "mn",
  MS: "ms",
  MTEXT: "mtext",
  NAV: "nav",
  NOBR: "nobr",
  NOFRAMES: "noframes",
  NOEMBED: "noembed",
  NOSCRIPT: "noscript",
  OBJECT: "object",
  OL: "ol",
  OPTGROUP: "optgroup",
  OPTION: "option",
  P: "p",
  PARAM: "param",
  PLAINTEXT: "plaintext",
  PRE: "pre",
  RB: "rb",
  RP: "rp",
  RT: "rt",
  RTC: "rtc",
  RUBY: "ruby",
  S: "s",
  SCRIPT: "script",
  SECTION: "section",
  SELECT: "select",
  SOURCE: "source",
  SMALL: "small",
  SPAN: "span",
  STRIKE: "strike",
  STRONG: "strong",
  STYLE: "style",
  SUB: "sub",
  SUMMARY: "summary",
  SUP: "sup",
  TABLE: "table",
  TBODY: "tbody",
  TEMPLATE: "template",
  TEXTAREA: "textarea",
  TFOOT: "tfoot",
  TD: "td",
  TH: "th",
  THEAD: "thead",
  TITLE: "title",
  TR: "tr",
  TRACK: "track",
  TT: "tt",
  U: "u",
  UL: "ul",
  SVG: "svg",
  VAR: "var",
  WBR: "wbr",
  XMP: "xmp"
};
xt.SPECIAL_ELEMENTS = {
  [jr.HTML]: {
    [$.ADDRESS]: !0,
    [$.APPLET]: !0,
    [$.AREA]: !0,
    [$.ARTICLE]: !0,
    [$.ASIDE]: !0,
    [$.BASE]: !0,
    [$.BASEFONT]: !0,
    [$.BGSOUND]: !0,
    [$.BLOCKQUOTE]: !0,
    [$.BODY]: !0,
    [$.BR]: !0,
    [$.BUTTON]: !0,
    [$.CAPTION]: !0,
    [$.CENTER]: !0,
    [$.COL]: !0,
    [$.COLGROUP]: !0,
    [$.DD]: !0,
    [$.DETAILS]: !0,
    [$.DIR]: !0,
    [$.DIV]: !0,
    [$.DL]: !0,
    [$.DT]: !0,
    [$.EMBED]: !0,
    [$.FIELDSET]: !0,
    [$.FIGCAPTION]: !0,
    [$.FIGURE]: !0,
    [$.FOOTER]: !0,
    [$.FORM]: !0,
    [$.FRAME]: !0,
    [$.FRAMESET]: !0,
    [$.H1]: !0,
    [$.H2]: !0,
    [$.H3]: !0,
    [$.H4]: !0,
    [$.H5]: !0,
    [$.H6]: !0,
    [$.HEAD]: !0,
    [$.HEADER]: !0,
    [$.HGROUP]: !0,
    [$.HR]: !0,
    [$.HTML]: !0,
    [$.IFRAME]: !0,
    [$.IMG]: !0,
    [$.INPUT]: !0,
    [$.LI]: !0,
    [$.LINK]: !0,
    [$.LISTING]: !0,
    [$.MAIN]: !0,
    [$.MARQUEE]: !0,
    [$.MENU]: !0,
    [$.META]: !0,
    [$.NAV]: !0,
    [$.NOEMBED]: !0,
    [$.NOFRAMES]: !0,
    [$.NOSCRIPT]: !0,
    [$.OBJECT]: !0,
    [$.OL]: !0,
    [$.P]: !0,
    [$.PARAM]: !0,
    [$.PLAINTEXT]: !0,
    [$.PRE]: !0,
    [$.SCRIPT]: !0,
    [$.SECTION]: !0,
    [$.SELECT]: !0,
    [$.SOURCE]: !0,
    [$.STYLE]: !0,
    [$.SUMMARY]: !0,
    [$.TABLE]: !0,
    [$.TBODY]: !0,
    [$.TD]: !0,
    [$.TEMPLATE]: !0,
    [$.TEXTAREA]: !0,
    [$.TFOOT]: !0,
    [$.TH]: !0,
    [$.THEAD]: !0,
    [$.TITLE]: !0,
    [$.TR]: !0,
    [$.TRACK]: !0,
    [$.UL]: !0,
    [$.WBR]: !0,
    [$.XMP]: !0
  },
  [jr.MATHML]: {
    [$.MI]: !0,
    [$.MO]: !0,
    [$.MN]: !0,
    [$.MS]: !0,
    [$.MTEXT]: !0,
    [$.ANNOTATION_XML]: !0
  },
  [jr.SVG]: {
    [$.TITLE]: !0,
    [$.FOREIGN_OBJECT]: !0,
    [$.DESC]: !0
  }
};
const Ta = xt, G = Ta.TAG_NAMES, Re = Ta.NAMESPACES;
function Fs(e) {
  switch (e.length) {
    case 1:
      return e === G.P;
    case 2:
      return e === G.RB || e === G.RP || e === G.RT || e === G.DD || e === G.DT || e === G.LI;
    case 3:
      return e === G.RTC;
    case 6:
      return e === G.OPTION;
    case 8:
      return e === G.OPTGROUP;
  }
  return !1;
}
function Hh(e) {
  switch (e.length) {
    case 1:
      return e === G.P;
    case 2:
      return e === G.RB || e === G.RP || e === G.RT || e === G.DD || e === G.DT || e === G.LI || e === G.TD || e === G.TH || e === G.TR;
    case 3:
      return e === G.RTC;
    case 5:
      return e === G.TBODY || e === G.TFOOT || e === G.THEAD;
    case 6:
      return e === G.OPTION;
    case 7:
      return e === G.CAPTION;
    case 8:
      return e === G.OPTGROUP || e === G.COLGROUP;
  }
  return !1;
}
function I1(e, t) {
  switch (e.length) {
    case 2:
      if (e === G.TD || e === G.TH)
        return t === Re.HTML;
      if (e === G.MI || e === G.MO || e === G.MN || e === G.MS)
        return t === Re.MATHML;
      break;
    case 4:
      if (e === G.HTML)
        return t === Re.HTML;
      if (e === G.DESC)
        return t === Re.SVG;
      break;
    case 5:
      if (e === G.TABLE)
        return t === Re.HTML;
      if (e === G.MTEXT)
        return t === Re.MATHML;
      if (e === G.TITLE)
        return t === Re.SVG;
      break;
    case 6:
      return (e === G.APPLET || e === G.OBJECT) && t === Re.HTML;
    case 7:
      return (e === G.CAPTION || e === G.MARQUEE) && t === Re.HTML;
    case 8:
      return e === G.TEMPLATE && t === Re.HTML;
    case 13:
      return e === G.FOREIGN_OBJECT && t === Re.SVG;
    case 14:
      return e === G.ANNOTATION_XML && t === Re.MATHML;
  }
  return !1;
}
let Fh = class {
  constructor(t, n) {
    this.stackTop = -1, this.items = [], this.current = t, this.currentTagName = null, this.currentTmplContent = null, this.tmplCount = 0, this.treeAdapter = n;
  }
  //Index of element
  _indexOf(t) {
    let n = -1;
    for (let r = this.stackTop; r >= 0; r--)
      if (this.items[r] === t) {
        n = r;
        break;
      }
    return n;
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagName === G.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === Re.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagName = this.current && this.treeAdapter.getTagName(this.current), this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
  }
  //Mutations
  push(t) {
    this.items[++this.stackTop] = t, this._updateCurrentElement(), this._isInTemplate() && this.tmplCount++;
  }
  pop() {
    this.stackTop--, this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this._updateCurrentElement();
  }
  replace(t, n) {
    const r = this._indexOf(t);
    this.items[r] = n, r === this.stackTop && this._updateCurrentElement();
  }
  insertAfter(t, n) {
    const r = this._indexOf(t) + 1;
    this.items.splice(r, 0, n), r === ++this.stackTop && this._updateCurrentElement();
  }
  popUntilTagNamePopped(t) {
    for (; this.stackTop > -1; ) {
      const n = this.currentTagName, r = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), n === t && r === Re.HTML)
        break;
    }
  }
  popUntilElementPopped(t) {
    for (; this.stackTop > -1; ) {
      const n = this.current;
      if (this.pop(), n === t)
        break;
    }
  }
  popUntilNumberedHeaderPopped() {
    for (; this.stackTop > -1; ) {
      const t = this.currentTagName, n = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), t === G.H1 || t === G.H2 || t === G.H3 || t === G.H4 || t === G.H5 || t === G.H6 && n === Re.HTML)
        break;
    }
  }
  popUntilTableCellPopped() {
    for (; this.stackTop > -1; ) {
      const t = this.currentTagName, n = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), t === G.TD || t === G.TH && n === Re.HTML)
        break;
    }
  }
  popAllUpToHtmlElement() {
    this.stackTop = 0, this._updateCurrentElement();
  }
  clearBackToTableContext() {
    for (; this.currentTagName !== G.TABLE && this.currentTagName !== G.TEMPLATE && this.currentTagName !== G.HTML || this.treeAdapter.getNamespaceURI(this.current) !== Re.HTML; )
      this.pop();
  }
  clearBackToTableBodyContext() {
    for (; this.currentTagName !== G.TBODY && this.currentTagName !== G.TFOOT && this.currentTagName !== G.THEAD && this.currentTagName !== G.TEMPLATE && this.currentTagName !== G.HTML || this.treeAdapter.getNamespaceURI(this.current) !== Re.HTML; )
      this.pop();
  }
  clearBackToTableRowContext() {
    for (; this.currentTagName !== G.TR && this.currentTagName !== G.TEMPLATE && this.currentTagName !== G.HTML || this.treeAdapter.getNamespaceURI(this.current) !== Re.HTML; )
      this.pop();
  }
  remove(t) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.items[n] === t) {
        this.items.splice(n, 1), this.stackTop--, this._updateCurrentElement();
        break;
      }
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    const t = this.items[1];
    return t && this.treeAdapter.getTagName(t) === G.BODY ? t : null;
  }
  contains(t) {
    return this._indexOf(t) > -1;
  }
  getCommonAncestor(t) {
    let n = this._indexOf(t);
    return --n >= 0 ? this.items[n] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.currentTagName === G.HTML;
  }
  //Element in scope
  hasInScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]), i = this.treeAdapter.getNamespaceURI(this.items[n]);
      if (r === t && i === Re.HTML)
        return !0;
      if (I1(r, i))
        return !1;
    }
    return !0;
  }
  hasNumberedHeaderInScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.treeAdapter.getTagName(this.items[t]), r = this.treeAdapter.getNamespaceURI(this.items[t]);
      if ((n === G.H1 || n === G.H2 || n === G.H3 || n === G.H4 || n === G.H5 || n === G.H6) && r === Re.HTML)
        return !0;
      if (I1(n, r))
        return !1;
    }
    return !0;
  }
  hasInListItemScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]), i = this.treeAdapter.getNamespaceURI(this.items[n]);
      if (r === t && i === Re.HTML)
        return !0;
      if ((r === G.UL || r === G.OL) && i === Re.HTML || I1(r, i))
        return !1;
    }
    return !0;
  }
  hasInButtonScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]), i = this.treeAdapter.getNamespaceURI(this.items[n]);
      if (r === t && i === Re.HTML)
        return !0;
      if (r === G.BUTTON && i === Re.HTML || I1(r, i))
        return !1;
    }
    return !0;
  }
  hasInTableScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]);
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === Re.HTML) {
        if (r === t)
          return !0;
        if (r === G.TABLE || r === G.TEMPLATE || r === G.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.treeAdapter.getTagName(this.items[t]);
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === Re.HTML) {
        if (n === G.TBODY || n === G.THEAD || n === G.TFOOT)
          return !0;
        if (n === G.TABLE || n === G.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasInSelectScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]);
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === Re.HTML) {
        if (r === t)
          return !0;
        if (r !== G.OPTION && r !== G.OPTGROUP)
          return !1;
      }
    }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; Fs(this.currentTagName); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; Hh(this.currentTagName); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(t) {
    for (; Fs(this.currentTagName) && this.currentTagName !== t; )
      this.pop();
  }
};
var Bh = Fh;
const R1 = 3;
let Ni = class Qt {
  constructor(t) {
    this.length = 0, this.entries = [], this.treeAdapter = t, this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(t) {
    const n = [];
    if (this.length >= R1) {
      const r = this.treeAdapter.getAttrList(t).length, i = this.treeAdapter.getTagName(t), o = this.treeAdapter.getNamespaceURI(t);
      for (let s = this.length - 1; s >= 0; s--) {
        const l = this.entries[s];
        if (l.type === Qt.MARKER_ENTRY)
          break;
        const c = l.element, u = this.treeAdapter.getAttrList(c);
        this.treeAdapter.getTagName(c) === i && this.treeAdapter.getNamespaceURI(c) === o && u.length === r && n.push({ idx: s, attrs: u });
      }
    }
    return n.length < R1 ? [] : n;
  }
  _ensureNoahArkCondition(t) {
    const n = this._getNoahArkConditionCandidates(t);
    let r = n.length;
    if (r) {
      const i = this.treeAdapter.getAttrList(t), o = i.length, s = /* @__PURE__ */ Object.create(null);
      for (let l = 0; l < o; l++) {
        const c = i[l];
        s[c.name] = c.value;
      }
      for (let l = 0; l < o; l++)
        for (let c = 0; c < r; c++) {
          const u = n[c].attrs[l];
          if (s[u.name] !== u.value && (n.splice(c, 1), r--), n.length < R1)
            return;
        }
      for (let l = r - 1; l >= R1 - 1; l--)
        this.entries.splice(n[l].idx, 1), this.length--;
    }
  }
  //Mutations
  insertMarker() {
    this.entries.push({ type: Qt.MARKER_ENTRY }), this.length++;
  }
  pushElement(t, n) {
    this._ensureNoahArkCondition(t), this.entries.push({
      type: Qt.ELEMENT_ENTRY,
      element: t,
      token: n
    }), this.length++;
  }
  insertElementAfterBookmark(t, n) {
    let r = this.length - 1;
    for (; r >= 0 && this.entries[r] !== this.bookmark; r--)
      ;
    this.entries.splice(r + 1, 0, {
      type: Qt.ELEMENT_ENTRY,
      element: t,
      token: n
    }), this.length++;
  }
  removeEntry(t) {
    for (let n = this.length - 1; n >= 0; n--)
      if (this.entries[n] === t) {
        this.entries.splice(n, 1), this.length--;
        break;
      }
  }
  clearToLastMarker() {
    for (; this.length; ) {
      const t = this.entries.pop();
      if (this.length--, t.type === Qt.MARKER_ENTRY)
        break;
    }
  }
  //Search
  getElementEntryInScopeWithTagName(t) {
    for (let n = this.length - 1; n >= 0; n--) {
      const r = this.entries[n];
      if (r.type === Qt.MARKER_ENTRY)
        return null;
      if (this.treeAdapter.getTagName(r.element) === t)
        return r;
    }
    return null;
  }
  getElementEntry(t) {
    for (let n = this.length - 1; n >= 0; n--) {
      const r = this.entries[n];
      if (r.type === Qt.ELEMENT_ENTRY && r.element === t)
        return r;
    }
    return null;
  }
};
Ni.MARKER_ENTRY = "MARKER_ENTRY";
Ni.ELEMENT_ENTRY = "ELEMENT_ENTRY";
var $h = Ni;
let ga = class {
  constructor(t) {
    const n = {}, r = this._getOverriddenMethods(this, n);
    for (const i of Object.keys(r))
      typeof r[i] == "function" && (n[i] = t[i], t[i] = r[i]);
  }
  _getOverriddenMethods() {
    throw new Error("Not implemented");
  }
};
ga.install = function(e, t, n) {
  e.__mixins || (e.__mixins = []);
  for (let i = 0; i < e.__mixins.length; i++)
    if (e.__mixins[i].constructor === t)
      return e.__mixins[i];
  const r = new t(e, n);
  return e.__mixins.push(r), r;
};
var jt = ga;
const Uh = jt;
let Gh = class extends Uh {
  constructor(t) {
    super(t), this.preprocessor = t, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.offset = 0, this.col = 0, this.line = 1;
  }
  _getOverriddenMethods(t, n) {
    return {
      advance() {
        const r = this.pos + 1, i = this.html[r];
        return t.isEol && (t.isEol = !1, t.line++, t.lineStartPos = r), (i === `
` || i === "\r" && this.html[r + 1] !== `
`) && (t.isEol = !0), t.col = r - t.lineStartPos + 1, t.offset = t.droppedBufferSize + r, n.advance.call(this);
      },
      retreat() {
        n.retreat.call(this), t.isEol = !1, t.col = this.pos - t.lineStartPos + 1;
      },
      dropParsedChunk() {
        const r = this.pos;
        n.dropParsedChunk.call(this);
        const i = r - this.pos;
        t.lineStartPos -= i, t.droppedBufferSize += i, t.offset = t.droppedBufferSize + this.pos;
      }
    };
  }
};
var Ea = Gh;
const Bs = jt, zr = tr, jh = Ea;
let zh = class extends Bs {
  constructor(t) {
    super(t), this.tokenizer = t, this.posTracker = Bs.install(t.preprocessor, jh), this.currentAttrLocation = null, this.ctLoc = null;
  }
  _getCurrentLocation() {
    return {
      startLine: this.posTracker.line,
      startCol: this.posTracker.col,
      startOffset: this.posTracker.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
  }
  _attachCurrentAttrLocationInfo() {
    this.currentAttrLocation.endLine = this.posTracker.line, this.currentAttrLocation.endCol = this.posTracker.col, this.currentAttrLocation.endOffset = this.posTracker.offset;
    const t = this.tokenizer.currentToken, n = this.tokenizer.currentAttr;
    t.location.attrs || (t.location.attrs = /* @__PURE__ */ Object.create(null)), t.location.attrs[n.name] = this.currentAttrLocation;
  }
  _getOverriddenMethods(t, n) {
    const r = {
      _createStartTagToken() {
        n._createStartTagToken.call(this), this.currentToken.location = t.ctLoc;
      },
      _createEndTagToken() {
        n._createEndTagToken.call(this), this.currentToken.location = t.ctLoc;
      },
      _createCommentToken() {
        n._createCommentToken.call(this), this.currentToken.location = t.ctLoc;
      },
      _createDoctypeToken(i) {
        n._createDoctypeToken.call(this, i), this.currentToken.location = t.ctLoc;
      },
      _createCharacterToken(i, o) {
        n._createCharacterToken.call(this, i, o), this.currentCharacterToken.location = t.ctLoc;
      },
      _createEOFToken() {
        n._createEOFToken.call(this), this.currentToken.location = t._getCurrentLocation();
      },
      _createAttr(i) {
        n._createAttr.call(this, i), t.currentAttrLocation = t._getCurrentLocation();
      },
      _leaveAttrName(i) {
        n._leaveAttrName.call(this, i), t._attachCurrentAttrLocationInfo();
      },
      _leaveAttrValue(i) {
        n._leaveAttrValue.call(this, i), t._attachCurrentAttrLocationInfo();
      },
      _emitCurrentToken() {
        const i = this.currentToken.location;
        this.currentCharacterToken && (this.currentCharacterToken.location.endLine = i.startLine, this.currentCharacterToken.location.endCol = i.startCol, this.currentCharacterToken.location.endOffset = i.startOffset), this.currentToken.type === zr.EOF_TOKEN ? (i.endLine = i.startLine, i.endCol = i.startCol, i.endOffset = i.startOffset) : (i.endLine = t.posTracker.line, i.endCol = t.posTracker.col + 1, i.endOffset = t.posTracker.offset + 1), n._emitCurrentToken.call(this);
      },
      _emitCurrentCharacterToken() {
        const i = this.currentCharacterToken && this.currentCharacterToken.location;
        i && i.endOffset === -1 && (i.endLine = t.posTracker.line, i.endCol = t.posTracker.col, i.endOffset = t.posTracker.offset), n._emitCurrentCharacterToken.call(this);
      }
    };
    return Object.keys(zr.MODE).forEach((i) => {
      const o = zr.MODE[i];
      r[o] = function(s) {
        t.ctLoc = t._getCurrentLocation(), n[o].call(this, s);
      };
    }), r;
  }
};
var Aa = zh;
const Kh = jt;
let qh = class extends Kh {
  constructor(t, n) {
    super(t), this.onItemPop = n.onItemPop;
  }
  _getOverriddenMethods(t, n) {
    return {
      pop() {
        t.onItemPop(this.current), n.pop.call(this);
      },
      popAllUpToHtmlElement() {
        for (let r = this.stackTop; r > 0; r--)
          t.onItemPop(this.items[r]);
        n.popAllUpToHtmlElement.call(this);
      },
      remove(r) {
        t.onItemPop(this.current), n.remove.call(this, r);
      }
    };
  }
};
var Yh = qh;
const Kr = jt, $s = tr, Vh = Aa, Wh = Yh, Xh = xt, qr = Xh.TAG_NAMES;
let Qh = class extends Kr {
  constructor(t) {
    super(t), this.parser = t, this.treeAdapter = this.parser.treeAdapter, this.posTracker = null, this.lastStartTagToken = null, this.lastFosterParentingLocation = null, this.currentToken = null;
  }
  _setStartLocation(t) {
    let n = null;
    this.lastStartTagToken && (n = Object.assign({}, this.lastStartTagToken.location), n.startTag = this.lastStartTagToken.location), this.treeAdapter.setNodeSourceCodeLocation(t, n);
  }
  _setEndLocation(t, n) {
    if (this.treeAdapter.getNodeSourceCodeLocation(t) && n.location) {
      const i = n.location, o = this.treeAdapter.getTagName(t), s = n.type === $s.END_TAG_TOKEN && o === n.tagName, l = {};
      s ? (l.endTag = Object.assign({}, i), l.endLine = i.endLine, l.endCol = i.endCol, l.endOffset = i.endOffset) : (l.endLine = i.startLine, l.endCol = i.startCol, l.endOffset = i.startOffset), this.treeAdapter.updateNodeSourceCodeLocation(t, l);
    }
  }
  _getOverriddenMethods(t, n) {
    return {
      _bootstrap(r, i) {
        n._bootstrap.call(this, r, i), t.lastStartTagToken = null, t.lastFosterParentingLocation = null, t.currentToken = null;
        const o = Kr.install(this.tokenizer, Vh);
        t.posTracker = o.posTracker, Kr.install(this.openElements, Wh, {
          onItemPop: function(s) {
            t._setEndLocation(s, t.currentToken);
          }
        });
      },
      _runParsingLoop(r) {
        n._runParsingLoop.call(this, r);
        for (let i = this.openElements.stackTop; i >= 0; i--)
          t._setEndLocation(this.openElements.items[i], t.currentToken);
      },
      //Token processing
      _processTokenInForeignContent(r) {
        t.currentToken = r, n._processTokenInForeignContent.call(this, r);
      },
      _processToken(r) {
        if (t.currentToken = r, n._processToken.call(this, r), r.type === $s.END_TAG_TOKEN && (r.tagName === qr.HTML || r.tagName === qr.BODY && this.openElements.hasInScope(qr.BODY)))
          for (let o = this.openElements.stackTop; o >= 0; o--) {
            const s = this.openElements.items[o];
            if (this.treeAdapter.getTagName(s) === r.tagName) {
              t._setEndLocation(s, r);
              break;
            }
          }
      },
      //Doctype
      _setDocumentType(r) {
        n._setDocumentType.call(this, r);
        const i = this.treeAdapter.getChildNodes(this.document), o = i.length;
        for (let s = 0; s < o; s++) {
          const l = i[s];
          if (this.treeAdapter.isDocumentTypeNode(l)) {
            this.treeAdapter.setNodeSourceCodeLocation(l, r.location);
            break;
          }
        }
      },
      //Elements
      _attachElementToTree(r) {
        t._setStartLocation(r), t.lastStartTagToken = null, n._attachElementToTree.call(this, r);
      },
      _appendElement(r, i) {
        t.lastStartTagToken = r, n._appendElement.call(this, r, i);
      },
      _insertElement(r, i) {
        t.lastStartTagToken = r, n._insertElement.call(this, r, i);
      },
      _insertTemplate(r) {
        t.lastStartTagToken = r, n._insertTemplate.call(this, r);
        const i = this.treeAdapter.getTemplateContent(this.openElements.current);
        this.treeAdapter.setNodeSourceCodeLocation(i, null);
      },
      _insertFakeRootElement() {
        n._insertFakeRootElement.call(this), this.treeAdapter.setNodeSourceCodeLocation(this.openElements.current, null);
      },
      //Comments
      _appendCommentNode(r, i) {
        n._appendCommentNode.call(this, r, i);
        const o = this.treeAdapter.getChildNodes(i), s = o[o.length - 1];
        this.treeAdapter.setNodeSourceCodeLocation(s, r.location);
      },
      //Text
      _findFosterParentingLocation() {
        return t.lastFosterParentingLocation = n._findFosterParentingLocation.call(this), t.lastFosterParentingLocation;
      },
      _insertCharacters(r) {
        n._insertCharacters.call(this, r);
        const i = this._shouldFosterParentOnInsertion(), o = i && t.lastFosterParentingLocation.parent || this.openElements.currentTmplContent || this.openElements.current, s = this.treeAdapter.getChildNodes(o), l = i && t.lastFosterParentingLocation.beforeElement ? s.indexOf(t.lastFosterParentingLocation.beforeElement) - 1 : s.length - 1, c = s[l];
        if (this.treeAdapter.getNodeSourceCodeLocation(c)) {
          const { endLine: f, endCol: m, endOffset: E } = r.location;
          this.treeAdapter.updateNodeSourceCodeLocation(c, { endLine: f, endCol: m, endOffset: E });
        } else
          this.treeAdapter.setNodeSourceCodeLocation(c, r.location);
      }
    };
  }
};
var Jh = Qh;
const Zh = jt;
let ed = class extends Zh {
  constructor(t, n) {
    super(t), this.posTracker = null, this.onParseError = n.onParseError;
  }
  _setErrorLocation(t) {
    t.startLine = t.endLine = this.posTracker.line, t.startCol = t.endCol = this.posTracker.col, t.startOffset = t.endOffset = this.posTracker.offset;
  }
  _reportError(t) {
    const n = {
      code: t,
      startLine: -1,
      startCol: -1,
      startOffset: -1,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    this._setErrorLocation(n), this.onParseError(n);
  }
  _getOverriddenMethods(t) {
    return {
      _err(n) {
        t._reportError(n);
      }
    };
  }
};
var bi = ed;
const td = bi, nd = Ea, rd = jt;
let id = class extends td {
  constructor(t, n) {
    super(t, n), this.posTracker = rd.install(t, nd), this.lastErrOffset = -1;
  }
  _reportError(t) {
    this.lastErrOffset !== this.posTracker.offset && (this.lastErrOffset = this.posTracker.offset, super._reportError(t));
  }
};
var od = id;
const sd = bi, ld = od, ad = jt;
let ud = class extends sd {
  constructor(t, n) {
    super(t, n);
    const r = ad.install(t.preprocessor, ld, n);
    this.posTracker = r.posTracker;
  }
};
var cd = ud;
const fd = bi, hd = cd, dd = Aa, Us = jt;
let md = class extends fd {
  constructor(t, n) {
    super(t, n), this.opts = n, this.ctLoc = null, this.locBeforeToken = !1;
  }
  _setErrorLocation(t) {
    this.ctLoc && (t.startLine = this.ctLoc.startLine, t.startCol = this.ctLoc.startCol, t.startOffset = this.ctLoc.startOffset, t.endLine = this.locBeforeToken ? this.ctLoc.startLine : this.ctLoc.endLine, t.endCol = this.locBeforeToken ? this.ctLoc.startCol : this.ctLoc.endCol, t.endOffset = this.locBeforeToken ? this.ctLoc.startOffset : this.ctLoc.endOffset);
  }
  _getOverriddenMethods(t, n) {
    return {
      _bootstrap(r, i) {
        n._bootstrap.call(this, r, i), Us.install(this.tokenizer, hd, t.opts), Us.install(this.tokenizer, dd);
      },
      _processInputToken(r) {
        t.ctLoc = r.location, n._processInputToken.call(this, r);
      },
      _err(r, i) {
        t.locBeforeToken = i && i.beforeToken, t._reportError(r);
      }
    };
  }
};
var pd = md, _e = {};
const { DOCUMENT_MODE: Td } = xt;
_e.createDocument = function() {
  return {
    nodeName: "#document",
    mode: Td.NO_QUIRKS,
    childNodes: []
  };
};
_e.createDocumentFragment = function() {
  return {
    nodeName: "#document-fragment",
    childNodes: []
  };
};
_e.createElement = function(e, t, n) {
  return {
    nodeName: e,
    tagName: e,
    attrs: n,
    namespaceURI: t,
    childNodes: [],
    parentNode: null
  };
};
_e.createCommentNode = function(e) {
  return {
    nodeName: "#comment",
    data: e,
    parentNode: null
  };
};
const _a = function(e) {
  return {
    nodeName: "#text",
    value: e,
    parentNode: null
  };
}, ya = _e.appendChild = function(e, t) {
  e.childNodes.push(t), t.parentNode = e;
}, gd = _e.insertBefore = function(e, t, n) {
  const r = e.childNodes.indexOf(n);
  e.childNodes.splice(r, 0, t), t.parentNode = e;
};
_e.setTemplateContent = function(e, t) {
  e.content = t;
};
_e.getTemplateContent = function(e) {
  return e.content;
};
_e.setDocumentType = function(e, t, n, r) {
  let i = null;
  for (let o = 0; o < e.childNodes.length; o++)
    if (e.childNodes[o].nodeName === "#documentType") {
      i = e.childNodes[o];
      break;
    }
  i ? (i.name = t, i.publicId = n, i.systemId = r) : ya(e, {
    nodeName: "#documentType",
    name: t,
    publicId: n,
    systemId: r
  });
};
_e.setDocumentMode = function(e, t) {
  e.mode = t;
};
_e.getDocumentMode = function(e) {
  return e.mode;
};
_e.detachNode = function(e) {
  if (e.parentNode) {
    const t = e.parentNode.childNodes.indexOf(e);
    e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
  }
};
_e.insertText = function(e, t) {
  if (e.childNodes.length) {
    const n = e.childNodes[e.childNodes.length - 1];
    if (n.nodeName === "#text") {
      n.value += t;
      return;
    }
  }
  ya(e, _a(t));
};
_e.insertTextBefore = function(e, t, n) {
  const r = e.childNodes[e.childNodes.indexOf(n) - 1];
  r && r.nodeName === "#text" ? r.value += t : gd(e, _a(t), n);
};
_e.adoptAttributes = function(e, t) {
  const n = [];
  for (let r = 0; r < e.attrs.length; r++)
    n.push(e.attrs[r].name);
  for (let r = 0; r < t.length; r++)
    n.indexOf(t[r].name) === -1 && e.attrs.push(t[r]);
};
_e.getFirstChild = function(e) {
  return e.childNodes[0];
};
_e.getChildNodes = function(e) {
  return e.childNodes;
};
_e.getParentNode = function(e) {
  return e.parentNode;
};
_e.getAttrList = function(e) {
  return e.attrs;
};
_e.getTagName = function(e) {
  return e.tagName;
};
_e.getNamespaceURI = function(e) {
  return e.namespaceURI;
};
_e.getTextNodeContent = function(e) {
  return e.value;
};
_e.getCommentNodeContent = function(e) {
  return e.data;
};
_e.getDocumentTypeNodeName = function(e) {
  return e.name;
};
_e.getDocumentTypeNodePublicId = function(e) {
  return e.publicId;
};
_e.getDocumentTypeNodeSystemId = function(e) {
  return e.systemId;
};
_e.isTextNode = function(e) {
  return e.nodeName === "#text";
};
_e.isCommentNode = function(e) {
  return e.nodeName === "#comment";
};
_e.isDocumentTypeNode = function(e) {
  return e.nodeName === "#documentType";
};
_e.isElementNode = function(e) {
  return !!e.tagName;
};
_e.setNodeSourceCodeLocation = function(e, t) {
  e.sourceCodeLocation = t;
};
_e.getNodeSourceCodeLocation = function(e) {
  return e.sourceCodeLocation;
};
_e.updateNodeSourceCodeLocation = function(e, t) {
  e.sourceCodeLocation = Object.assign(e.sourceCodeLocation, t);
};
var Ed = function(t, n) {
  return n = n || /* @__PURE__ */ Object.create(null), [t, n].reduce((r, i) => (Object.keys(i).forEach((o) => {
    r[o] = i[o];
  }), r), /* @__PURE__ */ Object.create(null));
}, nr = {};
const { DOCUMENT_MODE: An } = xt, Ca = "html", Ad = "about:legacy-compat", _d = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", Sa = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], yd = Sa.concat([
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
]), Cd = ["-//w3o//dtd w3 html strict 3.0//en//", "-/w3c/dtd html 4.0 transitional/en", "html"], xa = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], Sd = xa.concat([
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
]);
function Gs(e) {
  const t = e.indexOf('"') !== -1 ? "'" : '"';
  return t + e + t;
}
function js(e, t) {
  for (let n = 0; n < t.length; n++)
    if (e.indexOf(t[n]) === 0)
      return !0;
  return !1;
}
nr.isConforming = function(e) {
  return e.name === Ca && e.publicId === null && (e.systemId === null || e.systemId === Ad);
};
nr.getDocumentMode = function(e) {
  if (e.name !== Ca)
    return An.QUIRKS;
  const t = e.systemId;
  if (t && t.toLowerCase() === _d)
    return An.QUIRKS;
  let n = e.publicId;
  if (n !== null) {
    if (n = n.toLowerCase(), Cd.indexOf(n) > -1)
      return An.QUIRKS;
    let r = t === null ? yd : Sa;
    if (js(n, r))
      return An.QUIRKS;
    if (r = t === null ? xa : Sd, js(n, r))
      return An.LIMITED_QUIRKS;
  }
  return An.NO_QUIRKS;
};
nr.serializeContent = function(e, t, n) {
  let r = "!DOCTYPE ";
  return e && (r += e), t ? r += " PUBLIC " + Gs(t) : n && (r += " SYSTEM"), n !== null && (r += " " + Gs(n)), r;
};
var nn = {};
const Yr = tr, Oi = xt, re = Oi.TAG_NAMES, We = Oi.NAMESPACES, D1 = Oi.ATTRS, zs = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, xd = "definitionurl", Nd = "definitionURL", bd = {
  attributename: "attributeName",
  attributetype: "attributeType",
  basefrequency: "baseFrequency",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  clippathunits: "clipPathUnits",
  diffuseconstant: "diffuseConstant",
  edgemode: "edgeMode",
  filterunits: "filterUnits",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  limitingconeangle: "limitingConeAngle",
  markerheight: "markerHeight",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textlength: "textLength",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  xchannelselector: "xChannelSelector",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan"
}, Od = {
  "xlink:actuate": { prefix: "xlink", name: "actuate", namespace: We.XLINK },
  "xlink:arcrole": { prefix: "xlink", name: "arcrole", namespace: We.XLINK },
  "xlink:href": { prefix: "xlink", name: "href", namespace: We.XLINK },
  "xlink:role": { prefix: "xlink", name: "role", namespace: We.XLINK },
  "xlink:show": { prefix: "xlink", name: "show", namespace: We.XLINK },
  "xlink:title": { prefix: "xlink", name: "title", namespace: We.XLINK },
  "xlink:type": { prefix: "xlink", name: "type", namespace: We.XLINK },
  "xml:base": { prefix: "xml", name: "base", namespace: We.XML },
  "xml:lang": { prefix: "xml", name: "lang", namespace: We.XML },
  "xml:space": { prefix: "xml", name: "space", namespace: We.XML },
  xmlns: { prefix: "", name: "xmlns", namespace: We.XMLNS },
  "xmlns:xlink": { prefix: "xmlns", name: "xlink", namespace: We.XMLNS }
}, Id = nn.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
  altglyph: "altGlyph",
  altglyphdef: "altGlyphDef",
  altglyphitem: "altGlyphItem",
  animatecolor: "animateColor",
  animatemotion: "animateMotion",
  animatetransform: "animateTransform",
  clippath: "clipPath",
  feblend: "feBlend",
  fecolormatrix: "feColorMatrix",
  fecomponenttransfer: "feComponentTransfer",
  fecomposite: "feComposite",
  feconvolvematrix: "feConvolveMatrix",
  fediffuselighting: "feDiffuseLighting",
  fedisplacementmap: "feDisplacementMap",
  fedistantlight: "feDistantLight",
  feflood: "feFlood",
  fefunca: "feFuncA",
  fefuncb: "feFuncB",
  fefuncg: "feFuncG",
  fefuncr: "feFuncR",
  fegaussianblur: "feGaussianBlur",
  feimage: "feImage",
  femerge: "feMerge",
  femergenode: "feMergeNode",
  femorphology: "feMorphology",
  feoffset: "feOffset",
  fepointlight: "fePointLight",
  fespecularlighting: "feSpecularLighting",
  fespotlight: "feSpotLight",
  fetile: "feTile",
  feturbulence: "feTurbulence",
  foreignobject: "foreignObject",
  glyphref: "glyphRef",
  lineargradient: "linearGradient",
  radialgradient: "radialGradient",
  textpath: "textPath"
}, Rd = {
  [re.B]: !0,
  [re.BIG]: !0,
  [re.BLOCKQUOTE]: !0,
  [re.BODY]: !0,
  [re.BR]: !0,
  [re.CENTER]: !0,
  [re.CODE]: !0,
  [re.DD]: !0,
  [re.DIV]: !0,
  [re.DL]: !0,
  [re.DT]: !0,
  [re.EM]: !0,
  [re.EMBED]: !0,
  [re.H1]: !0,
  [re.H2]: !0,
  [re.H3]: !0,
  [re.H4]: !0,
  [re.H5]: !0,
  [re.H6]: !0,
  [re.HEAD]: !0,
  [re.HR]: !0,
  [re.I]: !0,
  [re.IMG]: !0,
  [re.LI]: !0,
  [re.LISTING]: !0,
  [re.MENU]: !0,
  [re.META]: !0,
  [re.NOBR]: !0,
  [re.OL]: !0,
  [re.P]: !0,
  [re.PRE]: !0,
  [re.RUBY]: !0,
  [re.S]: !0,
  [re.SMALL]: !0,
  [re.SPAN]: !0,
  [re.STRONG]: !0,
  [re.STRIKE]: !0,
  [re.SUB]: !0,
  [re.SUP]: !0,
  [re.TABLE]: !0,
  [re.TT]: !0,
  [re.U]: !0,
  [re.UL]: !0,
  [re.VAR]: !0
};
nn.causesExit = function(e) {
  const t = e.tagName;
  return t === re.FONT && (Yr.getTokenAttr(e, D1.COLOR) !== null || Yr.getTokenAttr(e, D1.SIZE) !== null || Yr.getTokenAttr(e, D1.FACE) !== null) ? !0 : Rd[t];
};
nn.adjustTokenMathMLAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++)
    if (e.attrs[t].name === xd) {
      e.attrs[t].name = Nd;
      break;
    }
};
nn.adjustTokenSVGAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = bd[e.attrs[t].name];
    n && (e.attrs[t].name = n);
  }
};
nn.adjustTokenXMLAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = Od[e.attrs[t].name];
    n && (e.attrs[t].prefix = n.prefix, e.attrs[t].name = n.name, e.attrs[t].namespace = n.namespace);
  }
};
nn.adjustTokenSVGTagName = function(e) {
  const t = Id[e.tagName];
  t && (e.tagName = t);
};
function kd(e, t) {
  return t === We.MATHML && (e === re.MI || e === re.MO || e === re.MN || e === re.MS || e === re.MTEXT);
}
function wd(e, t, n) {
  if (t === We.MATHML && e === re.ANNOTATION_XML) {
    for (let r = 0; r < n.length; r++)
      if (n[r].name === D1.ENCODING) {
        const i = n[r].value.toLowerCase();
        return i === zs.TEXT_HTML || i === zs.APPLICATION_XML;
      }
  }
  return t === We.SVG && (e === re.FOREIGN_OBJECT || e === re.DESC || e === re.TITLE);
}
nn.isIntegrationPoint = function(e, t, n, r) {
  return !!((!r || r === We.HTML) && wd(e, t, n) || (!r || r === We.MATHML) && kd(e, t));
};
const A = tr, Ld = Bh, Ks = $h, Md = Jh, Pd = pd, qs = jt, vd = _e, Dd = Ed, Ys = nr, It = nn, Xe = xi, Hd = St, dn = xt, a = dn.TAG_NAMES, X = dn.NAMESPACES, Na = dn.ATTRS, Fd = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  onParseError: null,
  treeAdapter: vd
}, ba = "hidden", Bd = 8, $d = 3, Oa = "INITIAL_MODE", Ii = "BEFORE_HTML_MODE", rr = "BEFORE_HEAD_MODE", wn = "IN_HEAD_MODE", Ia = "IN_HEAD_NO_SCRIPT_MODE", ir = "AFTER_HEAD_MODE", kt = "IN_BODY_MODE", U1 = "TEXT_MODE", Qe = "IN_TABLE_MODE", Ra = "IN_TABLE_TEXT_MODE", or = "IN_CAPTION_MODE", u1 = "IN_COLUMN_GROUP_MODE", ht = "IN_TABLE_BODY_MODE", Gt = "IN_ROW_MODE", sr = "IN_CELL_MODE", Ri = "IN_SELECT_MODE", ki = "IN_SELECT_IN_TABLE_MODE", G1 = "IN_TEMPLATE_MODE", wi = "AFTER_BODY_MODE", lr = "IN_FRAMESET_MODE", ka = "AFTER_FRAMESET_MODE", wa = "AFTER_AFTER_BODY_MODE", La = "AFTER_AFTER_FRAMESET_MODE", Ud = {
  [a.TR]: Gt,
  [a.TBODY]: ht,
  [a.THEAD]: ht,
  [a.TFOOT]: ht,
  [a.CAPTION]: or,
  [a.COLGROUP]: u1,
  [a.TABLE]: Qe,
  [a.BODY]: kt,
  [a.FRAMESET]: lr
}, Gd = {
  [a.CAPTION]: Qe,
  [a.COLGROUP]: Qe,
  [a.TBODY]: Qe,
  [a.TFOOT]: Qe,
  [a.THEAD]: Qe,
  [a.COL]: u1,
  [a.TR]: ht,
  [a.TD]: Gt,
  [a.TH]: Gt
}, Vs = {
  [Oa]: {
    [A.CHARACTER_TOKEN]: Kn,
    [A.NULL_CHARACTER_TOKEN]: Kn,
    [A.WHITESPACE_CHARACTER_TOKEN]: Ee,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: Jd,
    [A.START_TAG_TOKEN]: Kn,
    [A.END_TAG_TOKEN]: Kn,
    [A.EOF_TOKEN]: Kn
  },
  [Ii]: {
    [A.CHARACTER_TOKEN]: Jn,
    [A.NULL_CHARACTER_TOKEN]: Jn,
    [A.WHITESPACE_CHARACTER_TOKEN]: Ee,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: Zd,
    [A.END_TAG_TOKEN]: em,
    [A.EOF_TOKEN]: Jn
  },
  [rr]: {
    [A.CHARACTER_TOKEN]: Zn,
    [A.NULL_CHARACTER_TOKEN]: Zn,
    [A.WHITESPACE_CHARACTER_TOKEN]: Ee,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: k1,
    [A.START_TAG_TOKEN]: tm,
    [A.END_TAG_TOKEN]: nm,
    [A.EOF_TOKEN]: Zn
  },
  [wn]: {
    [A.CHARACTER_TOKEN]: e1,
    [A.NULL_CHARACTER_TOKEN]: e1,
    [A.WHITESPACE_CHARACTER_TOKEN]: tt,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: k1,
    [A.START_TAG_TOKEN]: qe,
    [A.END_TAG_TOKEN]: mn,
    [A.EOF_TOKEN]: e1
  },
  [Ia]: {
    [A.CHARACTER_TOKEN]: t1,
    [A.NULL_CHARACTER_TOKEN]: t1,
    [A.WHITESPACE_CHARACTER_TOKEN]: tt,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: k1,
    [A.START_TAG_TOKEN]: rm,
    [A.END_TAG_TOKEN]: im,
    [A.EOF_TOKEN]: t1
  },
  [ir]: {
    [A.CHARACTER_TOKEN]: n1,
    [A.NULL_CHARACTER_TOKEN]: n1,
    [A.WHITESPACE_CHARACTER_TOKEN]: tt,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: k1,
    [A.START_TAG_TOKEN]: om,
    [A.END_TAG_TOKEN]: sm,
    [A.EOF_TOKEN]: n1
  },
  [kt]: {
    [A.CHARACTER_TOKEN]: w1,
    [A.NULL_CHARACTER_TOKEN]: Ee,
    [A.WHITESPACE_CHARACTER_TOKEN]: ln,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: rt,
    [A.END_TAG_TOKEN]: Li,
    [A.EOF_TOKEN]: Ft
  },
  [U1]: {
    [A.CHARACTER_TOKEN]: tt,
    [A.NULL_CHARACTER_TOKEN]: tt,
    [A.WHITESPACE_CHARACTER_TOKEN]: tt,
    [A.COMMENT_TOKEN]: Ee,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: Ee,
    [A.END_TAG_TOKEN]: Hm,
    [A.EOF_TOKEN]: Fm
  },
  [Qe]: {
    [A.CHARACTER_TOKEN]: Bt,
    [A.NULL_CHARACTER_TOKEN]: Bt,
    [A.WHITESPACE_CHARACTER_TOKEN]: Bt,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: Mi,
    [A.END_TAG_TOKEN]: Pi,
    [A.EOF_TOKEN]: Ft
  },
  [Ra]: {
    [A.CHARACTER_TOKEN]: Vm,
    [A.NULL_CHARACTER_TOKEN]: Ee,
    [A.WHITESPACE_CHARACTER_TOKEN]: Ym,
    [A.COMMENT_TOKEN]: qn,
    [A.DOCTYPE_TOKEN]: qn,
    [A.START_TAG_TOKEN]: qn,
    [A.END_TAG_TOKEN]: qn,
    [A.EOF_TOKEN]: qn
  },
  [or]: {
    [A.CHARACTER_TOKEN]: w1,
    [A.NULL_CHARACTER_TOKEN]: Ee,
    [A.WHITESPACE_CHARACTER_TOKEN]: ln,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: Wm,
    [A.END_TAG_TOKEN]: Xm,
    [A.EOF_TOKEN]: Ft
  },
  [u1]: {
    [A.CHARACTER_TOKEN]: j1,
    [A.NULL_CHARACTER_TOKEN]: j1,
    [A.WHITESPACE_CHARACTER_TOKEN]: tt,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: Qm,
    [A.END_TAG_TOKEN]: Jm,
    [A.EOF_TOKEN]: Ft
  },
  [ht]: {
    [A.CHARACTER_TOKEN]: Bt,
    [A.NULL_CHARACTER_TOKEN]: Bt,
    [A.WHITESPACE_CHARACTER_TOKEN]: Bt,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: Zm,
    [A.END_TAG_TOKEN]: ep,
    [A.EOF_TOKEN]: Ft
  },
  [Gt]: {
    [A.CHARACTER_TOKEN]: Bt,
    [A.NULL_CHARACTER_TOKEN]: Bt,
    [A.WHITESPACE_CHARACTER_TOKEN]: Bt,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: tp,
    [A.END_TAG_TOKEN]: np,
    [A.EOF_TOKEN]: Ft
  },
  [sr]: {
    [A.CHARACTER_TOKEN]: w1,
    [A.NULL_CHARACTER_TOKEN]: Ee,
    [A.WHITESPACE_CHARACTER_TOKEN]: ln,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: rp,
    [A.END_TAG_TOKEN]: ip,
    [A.EOF_TOKEN]: Ft
  },
  [Ri]: {
    [A.CHARACTER_TOKEN]: tt,
    [A.NULL_CHARACTER_TOKEN]: Ee,
    [A.WHITESPACE_CHARACTER_TOKEN]: tt,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: Ma,
    [A.END_TAG_TOKEN]: Pa,
    [A.EOF_TOKEN]: Ft
  },
  [ki]: {
    [A.CHARACTER_TOKEN]: tt,
    [A.NULL_CHARACTER_TOKEN]: Ee,
    [A.WHITESPACE_CHARACTER_TOKEN]: tt,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: op,
    [A.END_TAG_TOKEN]: sp,
    [A.EOF_TOKEN]: Ft
  },
  [G1]: {
    [A.CHARACTER_TOKEN]: w1,
    [A.NULL_CHARACTER_TOKEN]: Ee,
    [A.WHITESPACE_CHARACTER_TOKEN]: ln,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: lp,
    [A.END_TAG_TOKEN]: ap,
    [A.EOF_TOKEN]: va
  },
  [wi]: {
    [A.CHARACTER_TOKEN]: z1,
    [A.NULL_CHARACTER_TOKEN]: z1,
    [A.WHITESPACE_CHARACTER_TOKEN]: ln,
    [A.COMMENT_TOKEN]: Qd,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: up,
    [A.END_TAG_TOKEN]: cp,
    [A.EOF_TOKEN]: zn
  },
  [lr]: {
    [A.CHARACTER_TOKEN]: Ee,
    [A.NULL_CHARACTER_TOKEN]: Ee,
    [A.WHITESPACE_CHARACTER_TOKEN]: tt,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: fp,
    [A.END_TAG_TOKEN]: hp,
    [A.EOF_TOKEN]: zn
  },
  [ka]: {
    [A.CHARACTER_TOKEN]: Ee,
    [A.NULL_CHARACTER_TOKEN]: Ee,
    [A.WHITESPACE_CHARACTER_TOKEN]: tt,
    [A.COMMENT_TOKEN]: ze,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: dp,
    [A.END_TAG_TOKEN]: mp,
    [A.EOF_TOKEN]: zn
  },
  [wa]: {
    [A.CHARACTER_TOKEN]: H1,
    [A.NULL_CHARACTER_TOKEN]: H1,
    [A.WHITESPACE_CHARACTER_TOKEN]: ln,
    [A.COMMENT_TOKEN]: Ws,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: pp,
    [A.END_TAG_TOKEN]: H1,
    [A.EOF_TOKEN]: zn
  },
  [La]: {
    [A.CHARACTER_TOKEN]: Ee,
    [A.NULL_CHARACTER_TOKEN]: Ee,
    [A.WHITESPACE_CHARACTER_TOKEN]: ln,
    [A.COMMENT_TOKEN]: Ws,
    [A.DOCTYPE_TOKEN]: Ee,
    [A.START_TAG_TOKEN]: Tp,
    [A.END_TAG_TOKEN]: Ee,
    [A.EOF_TOKEN]: zn
  }
};
class jd {
  constructor(t) {
    this.options = Dd(Fd, t), this.treeAdapter = this.options.treeAdapter, this.pendingScript = null, this.options.sourceCodeLocationInfo && qs.install(this, Md), this.options.onParseError && qs.install(this, Pd, { onParseError: this.options.onParseError });
  }
  // API
  parse(t) {
    const n = this.treeAdapter.createDocument();
    return this._bootstrap(n, null), this.tokenizer.write(t, !0), this._runParsingLoop(null), n;
  }
  parseFragment(t, n) {
    n || (n = this.treeAdapter.createElement(a.TEMPLATE, X.HTML, []));
    const r = this.treeAdapter.createElement("documentmock", X.HTML, []);
    this._bootstrap(r, n), this.treeAdapter.getTagName(n) === a.TEMPLATE && this._pushTmplInsertionMode(G1), this._initTokenizerForFragmentParsing(), this._insertFakeRootElement(), this._resetInsertionMode(), this._findFormInFragmentContext(), this.tokenizer.write(t, !0), this._runParsingLoop(null);
    const i = this.treeAdapter.getFirstChild(r), o = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(i, o), o;
  }
  //Bootstrap parser
  _bootstrap(t, n) {
    this.tokenizer = new A(this.options), this.stopped = !1, this.insertionMode = Oa, this.originalInsertionMode = "", this.document = t, this.fragmentContext = n, this.headElement = null, this.formElement = null, this.openElements = new Ld(this.document, this.treeAdapter), this.activeFormattingElements = new Ks(this.treeAdapter), this.tmplInsertionModeStack = [], this.tmplInsertionModeStackTop = -1, this.currentTmplInsertionMode = null, this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1;
  }
  //Errors
  _err() {
  }
  //Parsing loop
  _runParsingLoop(t) {
    for (; !this.stopped; ) {
      this._setupTokenizerCDATAMode();
      const n = this.tokenizer.getNextToken();
      if (n.type === A.HIBERNATION_TOKEN)
        break;
      if (this.skipNextNewLine && (this.skipNextNewLine = !1, n.type === A.WHITESPACE_CHARACTER_TOKEN && n.chars[0] === `
`)) {
        if (n.chars.length === 1)
          continue;
        n.chars = n.chars.substr(1);
      }
      if (this._processInputToken(n), t && this.pendingScript)
        break;
    }
  }
  runParsingLoopForCurrentChunk(t, n) {
    if (this._runParsingLoop(n), n && this.pendingScript) {
      const r = this.pendingScript;
      this.pendingScript = null, n(r);
      return;
    }
    t && t();
  }
  //Text parsing
  _setupTokenizerCDATAMode() {
    const t = this._getAdjustedCurrentElement();
    this.tokenizer.allowCDATA = t && t !== this.document && this.treeAdapter.getNamespaceURI(t) !== X.HTML && !this._isIntegrationPoint(t);
  }
  _switchToTextParsing(t, n) {
    this._insertElement(t, X.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = U1;
  }
  switchToPlaintextParsing() {
    this.insertionMode = U1, this.originalInsertionMode = kt, this.tokenizer.state = A.MODE.PLAINTEXT;
  }
  //Fragment parsing
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    do {
      if (this.treeAdapter.getTagName(t) === a.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    } while (t);
  }
  _initTokenizerForFragmentParsing() {
    if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === X.HTML) {
      const t = this.treeAdapter.getTagName(this.fragmentContext);
      t === a.TITLE || t === a.TEXTAREA ? this.tokenizer.state = A.MODE.RCDATA : t === a.STYLE || t === a.XMP || t === a.IFRAME || t === a.NOEMBED || t === a.NOFRAMES || t === a.NOSCRIPT ? this.tokenizer.state = A.MODE.RAWTEXT : t === a.SCRIPT ? this.tokenizer.state = A.MODE.SCRIPT_DATA : t === a.PLAINTEXT && (this.tokenizer.state = A.MODE.PLAINTEXT);
    }
  }
  //Tree mutation
  _setDocumentType(t) {
    const n = t.name || "", r = t.publicId || "", i = t.systemId || "";
    this.treeAdapter.setDocumentType(this.document, n, r, i);
  }
  _attachElementToTree(t) {
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const n = this.openElements.currentTmplContent || this.openElements.current;
      this.treeAdapter.appendChild(n, t);
    }
  }
  _appendElement(t, n) {
    const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(r);
  }
  _insertElement(t, n) {
    const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(r), this.openElements.push(r);
  }
  _insertFakeElement(t) {
    const n = this.treeAdapter.createElement(t, X.HTML, []);
    this._attachElementToTree(n), this.openElements.push(n);
  }
  _insertTemplate(t) {
    const n = this.treeAdapter.createElement(t.tagName, X.HTML, t.attrs), r = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(n, r), this._attachElementToTree(n), this.openElements.push(n);
  }
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(a.HTML, X.HTML, []);
    this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t);
  }
  _appendCommentNode(t, n) {
    const r = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(n, r);
  }
  _insertCharacters(t) {
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentText(t.chars);
    else {
      const n = this.openElements.currentTmplContent || this.openElements.current;
      this.treeAdapter.insertText(n, t.chars);
    }
  }
  _adoptNodes(t, n) {
    for (let r = this.treeAdapter.getFirstChild(t); r; r = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(r), this.treeAdapter.appendChild(n, r);
  }
  //Token processing
  _shouldProcessTokenInForeignContent(t) {
    const n = this._getAdjustedCurrentElement();
    if (!n || n === this.document)
      return !1;
    const r = this.treeAdapter.getNamespaceURI(n);
    if (r === X.HTML || this.treeAdapter.getTagName(n) === a.ANNOTATION_XML && r === X.MATHML && t.type === A.START_TAG_TOKEN && t.tagName === a.SVG)
      return !1;
    const i = t.type === A.CHARACTER_TOKEN || t.type === A.NULL_CHARACTER_TOKEN || t.type === A.WHITESPACE_CHARACTER_TOKEN;
    return (t.type === A.START_TAG_TOKEN && t.tagName !== a.MGLYPH && t.tagName !== a.MALIGNMARK || i) && this._isIntegrationPoint(n, X.MATHML) || (t.type === A.START_TAG_TOKEN || i) && this._isIntegrationPoint(n, X.HTML) ? !1 : t.type !== A.EOF_TOKEN;
  }
  _processToken(t) {
    Vs[this.insertionMode][t.type](this, t);
  }
  _processTokenInBodyMode(t) {
    Vs[kt][t.type](this, t);
  }
  _processTokenInForeignContent(t) {
    t.type === A.CHARACTER_TOKEN ? Ep(this, t) : t.type === A.NULL_CHARACTER_TOKEN ? gp(this, t) : t.type === A.WHITESPACE_CHARACTER_TOKEN ? tt(this, t) : t.type === A.COMMENT_TOKEN ? ze(this, t) : t.type === A.START_TAG_TOKEN ? Ap(this, t) : t.type === A.END_TAG_TOKEN && _p(this, t);
  }
  _processInputToken(t) {
    this._shouldProcessTokenInForeignContent(t) ? this._processTokenInForeignContent(t) : this._processToken(t), t.type === A.START_TAG_TOKEN && t.selfClosing && !t.ackSelfClosing && this._err(Xe.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  //Integration points
  _isIntegrationPoint(t, n) {
    const r = this.treeAdapter.getTagName(t), i = this.treeAdapter.getNamespaceURI(t), o = this.treeAdapter.getAttrList(t);
    return It.isIntegrationPoint(r, i, o, n);
  }
  //Active formatting elements reconstruction
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.length;
    if (t) {
      let n = t, r = null;
      do
        if (n--, r = this.activeFormattingElements.entries[n], r.type === Ks.MARKER_ENTRY || this.openElements.contains(r.element)) {
          n++;
          break;
        }
      while (n > 0);
      for (let i = n; i < t; i++)
        r = this.activeFormattingElements.entries[i], this._insertElement(r.token, this.treeAdapter.getNamespaceURI(r.element)), r.element = this.openElements.current;
    }
  }
  //Close elements
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = Gt;
  }
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(a.P), this.openElements.popUntilTagNamePopped(a.P);
  }
  //Insertion modes
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop, n = !1; t >= 0; t--) {
      let r = this.openElements.items[t];
      t === 0 && (n = !0, this.fragmentContext && (r = this.fragmentContext));
      const i = this.treeAdapter.getTagName(r), o = Ud[i];
      if (o) {
        this.insertionMode = o;
        break;
      } else if (!n && (i === a.TD || i === a.TH)) {
        this.insertionMode = sr;
        break;
      } else if (!n && i === a.HEAD) {
        this.insertionMode = wn;
        break;
      } else if (i === a.SELECT) {
        this._resetInsertionModeForSelect(t);
        break;
      } else if (i === a.TEMPLATE) {
        this.insertionMode = this.currentTmplInsertionMode;
        break;
      } else if (i === a.HTML) {
        this.insertionMode = this.headElement ? ir : rr;
        break;
      } else if (n) {
        this.insertionMode = kt;
        break;
      }
    }
  }
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let n = t - 1; n > 0; n--) {
        const r = this.openElements.items[n], i = this.treeAdapter.getTagName(r);
        if (i === a.TEMPLATE)
          break;
        if (i === a.TABLE) {
          this.insertionMode = ki;
          return;
        }
      }
    this.insertionMode = Ri;
  }
  _pushTmplInsertionMode(t) {
    this.tmplInsertionModeStack.push(t), this.tmplInsertionModeStackTop++, this.currentTmplInsertionMode = t;
  }
  _popTmplInsertionMode() {
    this.tmplInsertionModeStack.pop(), this.tmplInsertionModeStackTop--, this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
  }
  //Foster parenting
  _isElementCausesFosterParenting(t) {
    const n = this.treeAdapter.getTagName(t);
    return n === a.TABLE || n === a.TBODY || n === a.TFOOT || n === a.THEAD || n === a.TR;
  }
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
  }
  _findFosterParentingLocation() {
    const t = {
      parent: null,
      beforeElement: null
    };
    for (let n = this.openElements.stackTop; n >= 0; n--) {
      const r = this.openElements.items[n], i = this.treeAdapter.getTagName(r), o = this.treeAdapter.getNamespaceURI(r);
      if (i === a.TEMPLATE && o === X.HTML) {
        t.parent = this.treeAdapter.getTemplateContent(r);
        break;
      } else if (i === a.TABLE) {
        t.parent = this.treeAdapter.getParentNode(r), t.parent ? t.beforeElement = r : t.parent = this.openElements.items[n - 1];
        break;
      }
    }
    return t.parent || (t.parent = this.openElements.items[0]), t;
  }
  _fosterParentElement(t) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertBefore(n.parent, t, n.beforeElement) : this.treeAdapter.appendChild(n.parent, t);
  }
  _fosterParentText(t) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertTextBefore(n.parent, t, n.beforeElement) : this.treeAdapter.insertText(n.parent, t);
  }
  //Special elements
  _isSpecialElement(t) {
    const n = this.treeAdapter.getTagName(t), r = this.treeAdapter.getNamespaceURI(t);
    return dn.SPECIAL_ELEMENTS[r][n];
  }
}
var zd = jd;
function Kd(e, t) {
  let n = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return n ? e.openElements.contains(n.element) ? e.openElements.hasInScope(t.tagName) || (n = null) : (e.activeFormattingElements.removeEntry(n), n = null) : yt(e, t), n;
}
function qd(e, t) {
  let n = null;
  for (let r = e.openElements.stackTop; r >= 0; r--) {
    const i = e.openElements.items[r];
    if (i === t.element)
      break;
    e._isSpecialElement(i) && (n = i);
  }
  return n || (e.openElements.popUntilElementPopped(t.element), e.activeFormattingElements.removeEntry(t)), n;
}
function Yd(e, t, n) {
  let r = t, i = e.openElements.getCommonAncestor(t);
  for (let o = 0, s = i; s !== n; o++, s = i) {
    i = e.openElements.getCommonAncestor(s);
    const l = e.activeFormattingElements.getElementEntry(s), c = l && o >= $d;
    !l || c ? (c && e.activeFormattingElements.removeEntry(l), e.openElements.remove(s)) : (s = Vd(e, l), r === t && (e.activeFormattingElements.bookmark = l), e.treeAdapter.detachNode(r), e.treeAdapter.appendChild(s, r), r = s);
  }
  return r;
}
function Vd(e, t) {
  const n = e.treeAdapter.getNamespaceURI(t.element), r = e.treeAdapter.createElement(t.token.tagName, n, t.token.attrs);
  return e.openElements.replace(t.element, r), t.element = r, r;
}
function Wd(e, t, n) {
  if (e._isElementCausesFosterParenting(t))
    e._fosterParentElement(n);
  else {
    const r = e.treeAdapter.getTagName(t), i = e.treeAdapter.getNamespaceURI(t);
    r === a.TEMPLATE && i === X.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, n);
  }
}
function Xd(e, t, n) {
  const r = e.treeAdapter.getNamespaceURI(n.element), i = n.token, o = e.treeAdapter.createElement(i.tagName, r, i.attrs);
  e._adoptNodes(t, o), e.treeAdapter.appendChild(t, o), e.activeFormattingElements.insertElementAfterBookmark(o, n.token), e.activeFormattingElements.removeEntry(n), e.openElements.remove(n.element), e.openElements.insertAfter(t, o);
}
function Jt(e, t) {
  let n;
  for (let r = 0; r < Bd && (n = Kd(e, t), !!n); r++) {
    const i = qd(e, n);
    if (!i)
      break;
    e.activeFormattingElements.bookmark = n;
    const o = Yd(e, i, n.element), s = e.openElements.getCommonAncestor(n.element);
    e.treeAdapter.detachNode(o), Wd(e, s, o), Xd(e, i, n);
  }
}
function Ee() {
}
function k1(e) {
  e._err(Xe.misplacedDoctype);
}
function ze(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContent || e.openElements.current);
}
function Qd(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function Ws(e, t) {
  e._appendCommentNode(t, e.document);
}
function tt(e, t) {
  e._insertCharacters(t);
}
function zn(e) {
  e.stopped = !0;
}
function Jd(e, t) {
  e._setDocumentType(t);
  const n = t.forceQuirks ? dn.DOCUMENT_MODE.QUIRKS : Ys.getDocumentMode(t);
  Ys.isConforming(t) || e._err(Xe.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, n), e.insertionMode = Ii;
}
function Kn(e, t) {
  e._err(Xe.missingDoctype, { beforeToken: !0 }), e.treeAdapter.setDocumentMode(e.document, dn.DOCUMENT_MODE.QUIRKS), e.insertionMode = Ii, e._processToken(t);
}
function Zd(e, t) {
  t.tagName === a.HTML ? (e._insertElement(t, X.HTML), e.insertionMode = rr) : Jn(e, t);
}
function em(e, t) {
  const n = t.tagName;
  (n === a.HTML || n === a.HEAD || n === a.BODY || n === a.BR) && Jn(e, t);
}
function Jn(e, t) {
  e._insertFakeRootElement(), e.insertionMode = rr, e._processToken(t);
}
function tm(e, t) {
  const n = t.tagName;
  n === a.HTML ? rt(e, t) : n === a.HEAD ? (e._insertElement(t, X.HTML), e.headElement = e.openElements.current, e.insertionMode = wn) : Zn(e, t);
}
function nm(e, t) {
  const n = t.tagName;
  n === a.HEAD || n === a.BODY || n === a.HTML || n === a.BR ? Zn(e, t) : e._err(Xe.endTagWithoutMatchingOpenElement);
}
function Zn(e, t) {
  e._insertFakeElement(a.HEAD), e.headElement = e.openElements.current, e.insertionMode = wn, e._processToken(t);
}
function qe(e, t) {
  const n = t.tagName;
  n === a.HTML ? rt(e, t) : n === a.BASE || n === a.BASEFONT || n === a.BGSOUND || n === a.LINK || n === a.META ? (e._appendElement(t, X.HTML), t.ackSelfClosing = !0) : n === a.TITLE ? e._switchToTextParsing(t, A.MODE.RCDATA) : n === a.NOSCRIPT ? e.options.scriptingEnabled ? e._switchToTextParsing(t, A.MODE.RAWTEXT) : (e._insertElement(t, X.HTML), e.insertionMode = Ia) : n === a.NOFRAMES || n === a.STYLE ? e._switchToTextParsing(t, A.MODE.RAWTEXT) : n === a.SCRIPT ? e._switchToTextParsing(t, A.MODE.SCRIPT_DATA) : n === a.TEMPLATE ? (e._insertTemplate(t, X.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = G1, e._pushTmplInsertionMode(G1)) : n === a.HEAD ? e._err(Xe.misplacedStartTagForHeadElement) : e1(e, t);
}
function mn(e, t) {
  const n = t.tagName;
  n === a.HEAD ? (e.openElements.pop(), e.insertionMode = ir) : n === a.BODY || n === a.BR || n === a.HTML ? e1(e, t) : n === a.TEMPLATE && e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagName !== a.TEMPLATE && e._err(Xe.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(a.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e._popTmplInsertionMode(), e._resetInsertionMode()) : e._err(Xe.endTagWithoutMatchingOpenElement);
}
function e1(e, t) {
  e.openElements.pop(), e.insertionMode = ir, e._processToken(t);
}
function rm(e, t) {
  const n = t.tagName;
  n === a.HTML ? rt(e, t) : n === a.BASEFONT || n === a.BGSOUND || n === a.HEAD || n === a.LINK || n === a.META || n === a.NOFRAMES || n === a.STYLE ? qe(e, t) : n === a.NOSCRIPT ? e._err(Xe.nestedNoscriptInHead) : t1(e, t);
}
function im(e, t) {
  const n = t.tagName;
  n === a.NOSCRIPT ? (e.openElements.pop(), e.insertionMode = wn) : n === a.BR ? t1(e, t) : e._err(Xe.endTagWithoutMatchingOpenElement);
}
function t1(e, t) {
  const n = t.type === A.EOF_TOKEN ? Xe.openElementsLeftAfterEof : Xe.disallowedContentInNoscriptInHead;
  e._err(n), e.openElements.pop(), e.insertionMode = wn, e._processToken(t);
}
function om(e, t) {
  const n = t.tagName;
  n === a.HTML ? rt(e, t) : n === a.BODY ? (e._insertElement(t, X.HTML), e.framesetOk = !1, e.insertionMode = kt) : n === a.FRAMESET ? (e._insertElement(t, X.HTML), e.insertionMode = lr) : n === a.BASE || n === a.BASEFONT || n === a.BGSOUND || n === a.LINK || n === a.META || n === a.NOFRAMES || n === a.SCRIPT || n === a.STYLE || n === a.TEMPLATE || n === a.TITLE ? (e._err(Xe.abandonedHeadElementChild), e.openElements.push(e.headElement), qe(e, t), e.openElements.remove(e.headElement)) : n === a.HEAD ? e._err(Xe.misplacedStartTagForHeadElement) : n1(e, t);
}
function sm(e, t) {
  const n = t.tagName;
  n === a.BODY || n === a.HTML || n === a.BR ? n1(e, t) : n === a.TEMPLATE ? mn(e, t) : e._err(Xe.endTagWithoutMatchingOpenElement);
}
function n1(e, t) {
  e._insertFakeElement(a.BODY), e.insertionMode = kt, e._processToken(t);
}
function ln(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function w1(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function lm(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function am(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  n && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(n, t.attrs));
}
function um(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && n && (e.treeAdapter.detachNode(n), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, X.HTML), e.insertionMode = lr);
}
function Ht(e, t) {
  e.openElements.hasInButtonScope(a.P) && e._closePElement(), e._insertElement(t, X.HTML);
}
function cm(e, t) {
  e.openElements.hasInButtonScope(a.P) && e._closePElement();
  const n = e.openElements.currentTagName;
  (n === a.H1 || n === a.H2 || n === a.H3 || n === a.H4 || n === a.H5 || n === a.H6) && e.openElements.pop(), e._insertElement(t, X.HTML);
}
function Xs(e, t) {
  e.openElements.hasInButtonScope(a.P) && e._closePElement(), e._insertElement(t, X.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function fm(e, t) {
  const n = e.openElements.tmplCount > 0;
  (!e.formElement || n) && (e.openElements.hasInButtonScope(a.P) && e._closePElement(), e._insertElement(t, X.HTML), n || (e.formElement = e.openElements.current));
}
function hm(e, t) {
  e.framesetOk = !1;
  const n = t.tagName;
  for (let r = e.openElements.stackTop; r >= 0; r--) {
    const i = e.openElements.items[r], o = e.treeAdapter.getTagName(i);
    let s = null;
    if (n === a.LI && o === a.LI ? s = a.LI : (n === a.DD || n === a.DT) && (o === a.DD || o === a.DT) && (s = o), s) {
      e.openElements.generateImpliedEndTagsWithExclusion(s), e.openElements.popUntilTagNamePopped(s);
      break;
    }
    if (o !== a.ADDRESS && o !== a.DIV && o !== a.P && e._isSpecialElement(i))
      break;
  }
  e.openElements.hasInButtonScope(a.P) && e._closePElement(), e._insertElement(t, X.HTML);
}
function dm(e, t) {
  e.openElements.hasInButtonScope(a.P) && e._closePElement(), e._insertElement(t, X.HTML), e.tokenizer.state = A.MODE.PLAINTEXT;
}
function mm(e, t) {
  e.openElements.hasInScope(a.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(a.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, X.HTML), e.framesetOk = !1;
}
function pm(e, t) {
  const n = e.activeFormattingElements.getElementEntryInScopeWithTagName(a.A);
  n && (Jt(e, t), e.openElements.remove(n.element), e.activeFormattingElements.removeEntry(n)), e._reconstructActiveFormattingElements(), e._insertElement(t, X.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function _n(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, X.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Tm(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(a.NOBR) && (Jt(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, X.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Qs(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, X.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function gm(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== dn.DOCUMENT_MODE.QUIRKS && e.openElements.hasInButtonScope(a.P) && e._closePElement(), e._insertElement(t, X.HTML), e.framesetOk = !1, e.insertionMode = Qe;
}
function Sn(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, X.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function Em(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, X.HTML);
  const n = A.getTokenAttr(t, Na.TYPE);
  (!n || n.toLowerCase() !== ba) && (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function Js(e, t) {
  e._appendElement(t, X.HTML), t.ackSelfClosing = !0;
}
function Am(e, t) {
  e.openElements.hasInButtonScope(a.P) && e._closePElement(), e._appendElement(t, X.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function _m(e, t) {
  t.tagName = a.IMG, Sn(e, t);
}
function ym(e, t) {
  e._insertElement(t, X.HTML), e.skipNextNewLine = !0, e.tokenizer.state = A.MODE.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = U1;
}
function Cm(e, t) {
  e.openElements.hasInButtonScope(a.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, A.MODE.RAWTEXT);
}
function Sm(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, A.MODE.RAWTEXT);
}
function Zs(e, t) {
  e._switchToTextParsing(t, A.MODE.RAWTEXT);
}
function xm(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, X.HTML), e.framesetOk = !1, e.insertionMode === Qe || e.insertionMode === or || e.insertionMode === ht || e.insertionMode === Gt || e.insertionMode === sr ? e.insertionMode = ki : e.insertionMode = Ri;
}
function el(e, t) {
  e.openElements.currentTagName === a.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, X.HTML);
}
function tl(e, t) {
  e.openElements.hasInScope(a.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, X.HTML);
}
function Nm(e, t) {
  e.openElements.hasInScope(a.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(a.RTC), e._insertElement(t, X.HTML);
}
function bm(e, t) {
  e.openElements.hasInButtonScope(a.P) && e._closePElement(), e._insertElement(t, X.HTML);
}
function Om(e, t) {
  e._reconstructActiveFormattingElements(), It.adjustTokenMathMLAttrs(t), It.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, X.MATHML) : e._insertElement(t, X.MATHML), t.ackSelfClosing = !0;
}
function Im(e, t) {
  e._reconstructActiveFormattingElements(), It.adjustTokenSVGAttrs(t), It.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, X.SVG) : e._insertElement(t, X.SVG), t.ackSelfClosing = !0;
}
function at(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, X.HTML);
}
function rt(e, t) {
  const n = t.tagName;
  switch (n.length) {
    case 1:
      n === a.I || n === a.S || n === a.B || n === a.U ? _n(e, t) : n === a.P ? Ht(e, t) : n === a.A ? pm(e, t) : at(e, t);
      break;
    case 2:
      n === a.DL || n === a.OL || n === a.UL ? Ht(e, t) : n === a.H1 || n === a.H2 || n === a.H3 || n === a.H4 || n === a.H5 || n === a.H6 ? cm(e, t) : n === a.LI || n === a.DD || n === a.DT ? hm(e, t) : n === a.EM || n === a.TT ? _n(e, t) : n === a.BR ? Sn(e, t) : n === a.HR ? Am(e, t) : n === a.RB ? tl(e, t) : n === a.RT || n === a.RP ? Nm(e, t) : n !== a.TH && n !== a.TD && n !== a.TR && at(e, t);
      break;
    case 3:
      n === a.DIV || n === a.DIR || n === a.NAV ? Ht(e, t) : n === a.PRE ? Xs(e, t) : n === a.BIG ? _n(e, t) : n === a.IMG || n === a.WBR ? Sn(e, t) : n === a.XMP ? Cm(e, t) : n === a.SVG ? Im(e, t) : n === a.RTC ? tl(e, t) : n !== a.COL && at(e, t);
      break;
    case 4:
      n === a.HTML ? lm(e, t) : n === a.BASE || n === a.LINK || n === a.META ? qe(e, t) : n === a.BODY ? am(e, t) : n === a.MAIN || n === a.MENU ? Ht(e, t) : n === a.FORM ? fm(e, t) : n === a.CODE || n === a.FONT ? _n(e, t) : n === a.NOBR ? Tm(e, t) : n === a.AREA ? Sn(e, t) : n === a.MATH ? Om(e, t) : n === a.MENU ? bm(e, t) : n !== a.HEAD && at(e, t);
      break;
    case 5:
      n === a.STYLE || n === a.TITLE ? qe(e, t) : n === a.ASIDE ? Ht(e, t) : n === a.SMALL ? _n(e, t) : n === a.TABLE ? gm(e, t) : n === a.EMBED ? Sn(e, t) : n === a.INPUT ? Em(e, t) : n === a.PARAM || n === a.TRACK ? Js(e, t) : n === a.IMAGE ? _m(e, t) : n !== a.FRAME && n !== a.TBODY && n !== a.TFOOT && n !== a.THEAD && at(e, t);
      break;
    case 6:
      n === a.SCRIPT ? qe(e, t) : n === a.CENTER || n === a.FIGURE || n === a.FOOTER || n === a.HEADER || n === a.HGROUP || n === a.DIALOG ? Ht(e, t) : n === a.BUTTON ? mm(e, t) : n === a.STRIKE || n === a.STRONG ? _n(e, t) : n === a.APPLET || n === a.OBJECT ? Qs(e, t) : n === a.KEYGEN ? Sn(e, t) : n === a.SOURCE ? Js(e, t) : n === a.IFRAME ? Sm(e, t) : n === a.SELECT ? xm(e, t) : n === a.OPTION ? el(e, t) : at(e, t);
      break;
    case 7:
      n === a.BGSOUND ? qe(e, t) : n === a.DETAILS || n === a.ADDRESS || n === a.ARTICLE || n === a.SECTION || n === a.SUMMARY ? Ht(e, t) : n === a.LISTING ? Xs(e, t) : n === a.MARQUEE ? Qs(e, t) : n === a.NOEMBED ? Zs(e, t) : n !== a.CAPTION && at(e, t);
      break;
    case 8:
      n === a.BASEFONT ? qe(e, t) : n === a.FRAMESET ? um(e, t) : n === a.FIELDSET ? Ht(e, t) : n === a.TEXTAREA ? ym(e, t) : n === a.TEMPLATE ? qe(e, t) : n === a.NOSCRIPT ? e.options.scriptingEnabled ? Zs(e, t) : at(e, t) : n === a.OPTGROUP ? el(e, t) : n !== a.COLGROUP && at(e, t);
      break;
    case 9:
      n === a.PLAINTEXT ? dm(e, t) : at(e, t);
      break;
    case 10:
      n === a.BLOCKQUOTE || n === a.FIGCAPTION ? Ht(e, t) : at(e, t);
      break;
    default:
      at(e, t);
  }
}
function Rm(e) {
  e.openElements.hasInScope(a.BODY) && (e.insertionMode = wi);
}
function km(e, t) {
  e.openElements.hasInScope(a.BODY) && (e.insertionMode = wi, e._processToken(t));
}
function Wt(e, t) {
  const n = t.tagName;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n));
}
function wm(e) {
  const t = e.openElements.tmplCount > 0, n = e.formElement;
  t || (e.formElement = null), (n || t) && e.openElements.hasInScope(a.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(a.FORM) : e.openElements.remove(n));
}
function Lm(e) {
  e.openElements.hasInButtonScope(a.P) || e._insertFakeElement(a.P), e._closePElement();
}
function Mm(e) {
  e.openElements.hasInListItemScope(a.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(a.LI), e.openElements.popUntilTagNamePopped(a.LI));
}
function Pm(e, t) {
  const n = t.tagName;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilTagNamePopped(n));
}
function vm(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function nl(e, t) {
  const n = t.tagName;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker());
}
function Dm(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(a.BR), e.openElements.pop(), e.framesetOk = !1;
}
function yt(e, t) {
  const n = t.tagName;
  for (let r = e.openElements.stackTop; r > 0; r--) {
    const i = e.openElements.items[r];
    if (e.treeAdapter.getTagName(i) === n) {
      e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilElementPopped(i);
      break;
    }
    if (e._isSpecialElement(i))
      break;
  }
}
function Li(e, t) {
  const n = t.tagName;
  switch (n.length) {
    case 1:
      n === a.A || n === a.B || n === a.I || n === a.S || n === a.U ? Jt(e, t) : n === a.P ? Lm(e) : yt(e, t);
      break;
    case 2:
      n === a.DL || n === a.UL || n === a.OL ? Wt(e, t) : n === a.LI ? Mm(e) : n === a.DD || n === a.DT ? Pm(e, t) : n === a.H1 || n === a.H2 || n === a.H3 || n === a.H4 || n === a.H5 || n === a.H6 ? vm(e) : n === a.BR ? Dm(e) : n === a.EM || n === a.TT ? Jt(e, t) : yt(e, t);
      break;
    case 3:
      n === a.BIG ? Jt(e, t) : n === a.DIR || n === a.DIV || n === a.NAV || n === a.PRE ? Wt(e, t) : yt(e, t);
      break;
    case 4:
      n === a.BODY ? Rm(e) : n === a.HTML ? km(e, t) : n === a.FORM ? wm(e) : n === a.CODE || n === a.FONT || n === a.NOBR ? Jt(e, t) : n === a.MAIN || n === a.MENU ? Wt(e, t) : yt(e, t);
      break;
    case 5:
      n === a.ASIDE ? Wt(e, t) : n === a.SMALL ? Jt(e, t) : yt(e, t);
      break;
    case 6:
      n === a.CENTER || n === a.FIGURE || n === a.FOOTER || n === a.HEADER || n === a.HGROUP || n === a.DIALOG ? Wt(e, t) : n === a.APPLET || n === a.OBJECT ? nl(e, t) : n === a.STRIKE || n === a.STRONG ? Jt(e, t) : yt(e, t);
      break;
    case 7:
      n === a.ADDRESS || n === a.ARTICLE || n === a.DETAILS || n === a.SECTION || n === a.SUMMARY || n === a.LISTING ? Wt(e, t) : n === a.MARQUEE ? nl(e, t) : yt(e, t);
      break;
    case 8:
      n === a.FIELDSET ? Wt(e, t) : n === a.TEMPLATE ? mn(e, t) : yt(e, t);
      break;
    case 10:
      n === a.BLOCKQUOTE || n === a.FIGCAPTION ? Wt(e, t) : yt(e, t);
      break;
    default:
      yt(e, t);
  }
}
function Ft(e, t) {
  e.tmplInsertionModeStackTop > -1 ? va(e, t) : e.stopped = !0;
}
function Hm(e, t) {
  t.tagName === a.SCRIPT && (e.pendingScript = e.openElements.current), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function Fm(e, t) {
  e._err(Xe.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
function Bt(e, t) {
  const n = e.openElements.currentTagName;
  n === a.TABLE || n === a.TBODY || n === a.TFOOT || n === a.THEAD || n === a.TR ? (e.pendingCharacterTokens = [], e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = Ra, e._processToken(t)) : ct(e, t);
}
function Bm(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, X.HTML), e.insertionMode = or;
}
function $m(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, X.HTML), e.insertionMode = u1;
}
function Um(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(a.COLGROUP), e.insertionMode = u1, e._processToken(t);
}
function Gm(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, X.HTML), e.insertionMode = ht;
}
function jm(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(a.TBODY), e.insertionMode = ht, e._processToken(t);
}
function zm(e, t) {
  e.openElements.hasInTableScope(a.TABLE) && (e.openElements.popUntilTagNamePopped(a.TABLE), e._resetInsertionMode(), e._processToken(t));
}
function Km(e, t) {
  const n = A.getTokenAttr(t, Na.TYPE);
  n && n.toLowerCase() === ba ? e._appendElement(t, X.HTML) : ct(e, t), t.ackSelfClosing = !0;
}
function qm(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, X.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function Mi(e, t) {
  const n = t.tagName;
  switch (n.length) {
    case 2:
      n === a.TD || n === a.TH || n === a.TR ? jm(e, t) : ct(e, t);
      break;
    case 3:
      n === a.COL ? Um(e, t) : ct(e, t);
      break;
    case 4:
      n === a.FORM ? qm(e, t) : ct(e, t);
      break;
    case 5:
      n === a.TABLE ? zm(e, t) : n === a.STYLE ? qe(e, t) : n === a.TBODY || n === a.TFOOT || n === a.THEAD ? Gm(e, t) : n === a.INPUT ? Km(e, t) : ct(e, t);
      break;
    case 6:
      n === a.SCRIPT ? qe(e, t) : ct(e, t);
      break;
    case 7:
      n === a.CAPTION ? Bm(e, t) : ct(e, t);
      break;
    case 8:
      n === a.COLGROUP ? $m(e, t) : n === a.TEMPLATE ? qe(e, t) : ct(e, t);
      break;
    default:
      ct(e, t);
  }
}
function Pi(e, t) {
  const n = t.tagName;
  n === a.TABLE ? e.openElements.hasInTableScope(a.TABLE) && (e.openElements.popUntilTagNamePopped(a.TABLE), e._resetInsertionMode()) : n === a.TEMPLATE ? mn(e, t) : n !== a.BODY && n !== a.CAPTION && n !== a.COL && n !== a.COLGROUP && n !== a.HTML && n !== a.TBODY && n !== a.TD && n !== a.TFOOT && n !== a.TH && n !== a.THEAD && n !== a.TR && ct(e, t);
}
function ct(e, t) {
  const n = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, e._processTokenInBodyMode(t), e.fosterParentingEnabled = n;
}
function Ym(e, t) {
  e.pendingCharacterTokens.push(t);
}
function Vm(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function qn(e, t) {
  let n = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; n < e.pendingCharacterTokens.length; n++)
      ct(e, e.pendingCharacterTokens[n]);
  else
    for (; n < e.pendingCharacterTokens.length; n++)
      e._insertCharacters(e.pendingCharacterTokens[n]);
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
function Wm(e, t) {
  const n = t.tagName;
  n === a.CAPTION || n === a.COL || n === a.COLGROUP || n === a.TBODY || n === a.TD || n === a.TFOOT || n === a.TH || n === a.THEAD || n === a.TR ? e.openElements.hasInTableScope(a.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(a.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = Qe, e._processToken(t)) : rt(e, t);
}
function Xm(e, t) {
  const n = t.tagName;
  n === a.CAPTION || n === a.TABLE ? e.openElements.hasInTableScope(a.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(a.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = Qe, n === a.TABLE && e._processToken(t)) : n !== a.BODY && n !== a.COL && n !== a.COLGROUP && n !== a.HTML && n !== a.TBODY && n !== a.TD && n !== a.TFOOT && n !== a.TH && n !== a.THEAD && n !== a.TR && Li(e, t);
}
function Qm(e, t) {
  const n = t.tagName;
  n === a.HTML ? rt(e, t) : n === a.COL ? (e._appendElement(t, X.HTML), t.ackSelfClosing = !0) : n === a.TEMPLATE ? qe(e, t) : j1(e, t);
}
function Jm(e, t) {
  const n = t.tagName;
  n === a.COLGROUP ? e.openElements.currentTagName === a.COLGROUP && (e.openElements.pop(), e.insertionMode = Qe) : n === a.TEMPLATE ? mn(e, t) : n !== a.COL && j1(e, t);
}
function j1(e, t) {
  e.openElements.currentTagName === a.COLGROUP && (e.openElements.pop(), e.insertionMode = Qe, e._processToken(t));
}
function Zm(e, t) {
  const n = t.tagName;
  n === a.TR ? (e.openElements.clearBackToTableBodyContext(), e._insertElement(t, X.HTML), e.insertionMode = Gt) : n === a.TH || n === a.TD ? (e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(a.TR), e.insertionMode = Gt, e._processToken(t)) : n === a.CAPTION || n === a.COL || n === a.COLGROUP || n === a.TBODY || n === a.TFOOT || n === a.THEAD ? e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = Qe, e._processToken(t)) : Mi(e, t);
}
function ep(e, t) {
  const n = t.tagName;
  n === a.TBODY || n === a.TFOOT || n === a.THEAD ? e.openElements.hasInTableScope(n) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = Qe) : n === a.TABLE ? e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = Qe, e._processToken(t)) : (n !== a.BODY && n !== a.CAPTION && n !== a.COL && n !== a.COLGROUP || n !== a.HTML && n !== a.TD && n !== a.TH && n !== a.TR) && Pi(e, t);
}
function tp(e, t) {
  const n = t.tagName;
  n === a.TH || n === a.TD ? (e.openElements.clearBackToTableRowContext(), e._insertElement(t, X.HTML), e.insertionMode = sr, e.activeFormattingElements.insertMarker()) : n === a.CAPTION || n === a.COL || n === a.COLGROUP || n === a.TBODY || n === a.TFOOT || n === a.THEAD || n === a.TR ? e.openElements.hasInTableScope(a.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = ht, e._processToken(t)) : Mi(e, t);
}
function np(e, t) {
  const n = t.tagName;
  n === a.TR ? e.openElements.hasInTableScope(a.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = ht) : n === a.TABLE ? e.openElements.hasInTableScope(a.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = ht, e._processToken(t)) : n === a.TBODY || n === a.TFOOT || n === a.THEAD ? (e.openElements.hasInTableScope(n) || e.openElements.hasInTableScope(a.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = ht, e._processToken(t)) : (n !== a.BODY && n !== a.CAPTION && n !== a.COL && n !== a.COLGROUP || n !== a.HTML && n !== a.TD && n !== a.TH) && Pi(e, t);
}
function rp(e, t) {
  const n = t.tagName;
  n === a.CAPTION || n === a.COL || n === a.COLGROUP || n === a.TBODY || n === a.TD || n === a.TFOOT || n === a.TH || n === a.THEAD || n === a.TR ? (e.openElements.hasInTableScope(a.TD) || e.openElements.hasInTableScope(a.TH)) && (e._closeTableCell(), e._processToken(t)) : rt(e, t);
}
function ip(e, t) {
  const n = t.tagName;
  n === a.TD || n === a.TH ? e.openElements.hasInTableScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = Gt) : n === a.TABLE || n === a.TBODY || n === a.TFOOT || n === a.THEAD || n === a.TR ? e.openElements.hasInTableScope(n) && (e._closeTableCell(), e._processToken(t)) : n !== a.BODY && n !== a.CAPTION && n !== a.COL && n !== a.COLGROUP && n !== a.HTML && Li(e, t);
}
function Ma(e, t) {
  const n = t.tagName;
  n === a.HTML ? rt(e, t) : n === a.OPTION ? (e.openElements.currentTagName === a.OPTION && e.openElements.pop(), e._insertElement(t, X.HTML)) : n === a.OPTGROUP ? (e.openElements.currentTagName === a.OPTION && e.openElements.pop(), e.openElements.currentTagName === a.OPTGROUP && e.openElements.pop(), e._insertElement(t, X.HTML)) : n === a.INPUT || n === a.KEYGEN || n === a.TEXTAREA || n === a.SELECT ? e.openElements.hasInSelectScope(a.SELECT) && (e.openElements.popUntilTagNamePopped(a.SELECT), e._resetInsertionMode(), n !== a.SELECT && e._processToken(t)) : (n === a.SCRIPT || n === a.TEMPLATE) && qe(e, t);
}
function Pa(e, t) {
  const n = t.tagName;
  if (n === a.OPTGROUP) {
    const r = e.openElements.items[e.openElements.stackTop - 1], i = r && e.treeAdapter.getTagName(r);
    e.openElements.currentTagName === a.OPTION && i === a.OPTGROUP && e.openElements.pop(), e.openElements.currentTagName === a.OPTGROUP && e.openElements.pop();
  } else
    n === a.OPTION ? e.openElements.currentTagName === a.OPTION && e.openElements.pop() : n === a.SELECT && e.openElements.hasInSelectScope(a.SELECT) ? (e.openElements.popUntilTagNamePopped(a.SELECT), e._resetInsertionMode()) : n === a.TEMPLATE && mn(e, t);
}
function op(e, t) {
  const n = t.tagName;
  n === a.CAPTION || n === a.TABLE || n === a.TBODY || n === a.TFOOT || n === a.THEAD || n === a.TR || n === a.TD || n === a.TH ? (e.openElements.popUntilTagNamePopped(a.SELECT), e._resetInsertionMode(), e._processToken(t)) : Ma(e, t);
}
function sp(e, t) {
  const n = t.tagName;
  n === a.CAPTION || n === a.TABLE || n === a.TBODY || n === a.TFOOT || n === a.THEAD || n === a.TR || n === a.TD || n === a.TH ? e.openElements.hasInTableScope(n) && (e.openElements.popUntilTagNamePopped(a.SELECT), e._resetInsertionMode(), e._processToken(t)) : Pa(e, t);
}
function lp(e, t) {
  const n = t.tagName;
  if (n === a.BASE || n === a.BASEFONT || n === a.BGSOUND || n === a.LINK || n === a.META || n === a.NOFRAMES || n === a.SCRIPT || n === a.STYLE || n === a.TEMPLATE || n === a.TITLE)
    qe(e, t);
  else {
    const r = Gd[n] || kt;
    e._popTmplInsertionMode(), e._pushTmplInsertionMode(r), e.insertionMode = r, e._processToken(t);
  }
}
function ap(e, t) {
  t.tagName === a.TEMPLATE && mn(e, t);
}
function va(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(a.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e._popTmplInsertionMode(), e._resetInsertionMode(), e._processToken(t)) : e.stopped = !0;
}
function up(e, t) {
  t.tagName === a.HTML ? rt(e, t) : z1(e, t);
}
function cp(e, t) {
  t.tagName === a.HTML ? e.fragmentContext || (e.insertionMode = wa) : z1(e, t);
}
function z1(e, t) {
  e.insertionMode = kt, e._processToken(t);
}
function fp(e, t) {
  const n = t.tagName;
  n === a.HTML ? rt(e, t) : n === a.FRAMESET ? e._insertElement(t, X.HTML) : n === a.FRAME ? (e._appendElement(t, X.HTML), t.ackSelfClosing = !0) : n === a.NOFRAMES && qe(e, t);
}
function hp(e, t) {
  t.tagName === a.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagName !== a.FRAMESET && (e.insertionMode = ka));
}
function dp(e, t) {
  const n = t.tagName;
  n === a.HTML ? rt(e, t) : n === a.NOFRAMES && qe(e, t);
}
function mp(e, t) {
  t.tagName === a.HTML && (e.insertionMode = La);
}
function pp(e, t) {
  t.tagName === a.HTML ? rt(e, t) : H1(e, t);
}
function H1(e, t) {
  e.insertionMode = kt, e._processToken(t);
}
function Tp(e, t) {
  const n = t.tagName;
  n === a.HTML ? rt(e, t) : n === a.NOFRAMES && qe(e, t);
}
function gp(e, t) {
  t.chars = Hd.REPLACEMENT_CHARACTER, e._insertCharacters(t);
}
function Ep(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function Ap(e, t) {
  if (It.causesExit(t) && !e.fragmentContext) {
    for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== X.HTML && !e._isIntegrationPoint(e.openElements.current); )
      e.openElements.pop();
    e._processToken(t);
  } else {
    const n = e._getAdjustedCurrentElement(), r = e.treeAdapter.getNamespaceURI(n);
    r === X.MATHML ? It.adjustTokenMathMLAttrs(t) : r === X.SVG && (It.adjustTokenSVGTagName(t), It.adjustTokenSVGAttrs(t)), It.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, r) : e._insertElement(t, r), t.ackSelfClosing = !0;
  }
}
function _p(e, t) {
  for (let n = e.openElements.stackTop; n > 0; n--) {
    const r = e.openElements.items[n];
    if (e.treeAdapter.getNamespaceURI(r) === X.HTML) {
      e._processToken(t);
      break;
    }
    if (e.treeAdapter.getTagName(r).toLowerCase() === t.tagName) {
      e.openElements.popUntilElementPopped(r);
      break;
    }
  }
}
const yp = /* @__PURE__ */ fn(zd), Da = Ha("start"), Cp = Ha("end");
function Ha(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    return {
      // @ts-expect-error: in practice, null is allowed.
      line: r.line || null,
      // @ts-expect-error: in practice, null is allowed.
      column: r.column || null,
      // @ts-expect-error: in practice, null is allowed.
      offset: r.offset > -1 ? r.offset : null
    };
  }
}
const Fa = (
  /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {AssertAnything}
   */
  function(e) {
    if (e == null)
      return bp;
    if (typeof e == "string")
      return Np(e);
    if (typeof e == "object")
      return Array.isArray(e) ? Sp(e) : xp(e);
    if (typeof e == "function")
      return ar(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function Sp(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = Fa(e[n]);
  return ar(r);
  function r(...i) {
    let o = -1;
    for (; ++o < t.length; )
      if (t[o].call(this, ...i))
        return !0;
    return !1;
  }
}
function xp(e) {
  return ar(t);
  function t(n) {
    let r;
    for (r in e)
      if (n[r] !== e[r])
        return !1;
    return !0;
  }
}
function Np(e) {
  return ar(t);
  function t(n) {
    return n && n.type === e;
  }
}
function ar(e) {
  return t;
  function t(n, ...r) {
    return !!(n && typeof n == "object" && "type" in n && e.call(this, n, ...r));
  }
}
function bp() {
  return !0;
}
const Op = !0, rl = !1, Ip = "skip", Rp = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor<Node>} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null);
    const i = Fa(t), o = r ? -1 : 1;
    s(e, void 0, [])();
    function s(l, c, u) {
      const f = l && typeof l == "object" ? l : {};
      if (typeof f.type == "string") {
        const E = (
          // `hast`
          typeof f.tagName == "string" ? f.tagName : (
            // `xast`
            typeof f.name == "string" ? f.name : void 0
          )
        );
        Object.defineProperty(m, "name", {
          value: "node (" + (l.type + (E ? "<" + E + ">" : "")) + ")"
        });
      }
      return m;
      function m() {
        let E = [], h, x, y;
        if ((!t || i(l, c, u[u.length - 1] || null)) && (E = kp(n(l, u)), E[0] === rl))
          return E;
        if (l.children && E[0] !== Ip)
          for (x = (r ? l.children.length : -1) + o, y = u.concat(l); x > -1 && x < l.children.length; ) {
            if (h = s(l.children[x], x, y)(), h[0] === rl)
              return h;
            x = typeof h[1] == "number" ? h[1] : x + o;
          }
        return E;
      }
    }
  }
);
function kp(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [Op, e] : [e];
}
const wp = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null), Rp(e, t, i, r);
    function i(o, s) {
      const l = s[s.length - 1];
      return n(
        o,
        l ? l.children.indexOf(o) : null,
        l
      );
    }
  }
);
let c1 = class {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
};
c1.prototype.property = {};
c1.prototype.normal = {};
c1.prototype.space = null;
function Ba(e, t) {
  const n = {}, r = {};
  let i = -1;
  for (; ++i < e.length; )
    Object.assign(n, e[i].property), Object.assign(r, e[i].normal);
  return new c1(n, r, t);
}
function o1(e) {
  return e.toLowerCase();
}
let Tt = class {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
};
Tt.prototype.space = null;
Tt.prototype.boolean = !1;
Tt.prototype.booleanish = !1;
Tt.prototype.overloadedBoolean = !1;
Tt.prototype.number = !1;
Tt.prototype.commaSeparated = !1;
Tt.prototype.spaceSeparated = !1;
Tt.prototype.commaOrSpaceSeparated = !1;
Tt.prototype.mustUseProperty = !1;
Tt.prototype.defined = !1;
let Lp = 0;
const de = pn(), $e = pn(), $a = pn(), F = pn(), Pe = pn(), In = pn(), ot = pn();
function pn() {
  return 2 ** ++Lp;
}
const ui = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: de,
  booleanish: $e,
  commaOrSpaceSeparated: ot,
  commaSeparated: In,
  number: F,
  overloadedBoolean: $a,
  spaceSeparated: Pe
}, Symbol.toStringTag, { value: "Module" })), Vr = Object.keys(ui);
let vi = class extends Tt {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, i) {
    let o = -1;
    if (super(t, n), il(this, "space", i), typeof r == "number")
      for (; ++o < Vr.length; ) {
        const s = Vr[o];
        il(this, Vr[o], (r & ui[s]) === ui[s]);
      }
  }
};
vi.prototype.defined = !0;
function il(e, t, n) {
  n && (e[t] = n);
}
const Mp = {}.hasOwnProperty;
function Ln(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (Mp.call(e.properties, r)) {
      const i = e.properties[r], o = new vi(
        r,
        e.transform(e.attributes || {}, r),
        i,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (o.mustUseProperty = !0), t[r] = o, n[o1(r)] = r, n[o1(o.attribute)] = r;
    }
  return new c1(t, n, e.space);
}
const Ua = Ln({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), Ga = Ln({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function ja(e, t) {
  return t in e ? e[t] : t;
}
function za(e, t) {
  return ja(e, t.toLowerCase());
}
const Ka = Ln({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: za,
  properties: { xmlns: null, xmlnsXLink: null }
}), qa = Ln({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: $e,
    ariaAutoComplete: null,
    ariaBusy: $e,
    ariaChecked: $e,
    ariaColCount: F,
    ariaColIndex: F,
    ariaColSpan: F,
    ariaControls: Pe,
    ariaCurrent: null,
    ariaDescribedBy: Pe,
    ariaDetails: null,
    ariaDisabled: $e,
    ariaDropEffect: Pe,
    ariaErrorMessage: null,
    ariaExpanded: $e,
    ariaFlowTo: Pe,
    ariaGrabbed: $e,
    ariaHasPopup: null,
    ariaHidden: $e,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Pe,
    ariaLevel: F,
    ariaLive: null,
    ariaModal: $e,
    ariaMultiLine: $e,
    ariaMultiSelectable: $e,
    ariaOrientation: null,
    ariaOwns: Pe,
    ariaPlaceholder: null,
    ariaPosInSet: F,
    ariaPressed: $e,
    ariaReadOnly: $e,
    ariaRelevant: null,
    ariaRequired: $e,
    ariaRoleDescription: Pe,
    ariaRowCount: F,
    ariaRowIndex: F,
    ariaRowSpan: F,
    ariaSelected: $e,
    ariaSetSize: F,
    ariaSort: null,
    ariaValueMax: F,
    ariaValueMin: F,
    ariaValueNow: F,
    ariaValueText: null,
    role: null
  }
}), Pp = Ln({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: za,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: In,
    acceptCharset: Pe,
    accessKey: Pe,
    action: null,
    allow: null,
    allowFullScreen: de,
    allowPaymentRequest: de,
    allowUserMedia: de,
    alt: null,
    as: null,
    async: de,
    autoCapitalize: null,
    autoComplete: Pe,
    autoFocus: de,
    autoPlay: de,
    capture: de,
    charSet: null,
    checked: de,
    cite: null,
    className: Pe,
    cols: F,
    colSpan: null,
    content: null,
    contentEditable: $e,
    controls: de,
    controlsList: Pe,
    coords: F | In,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: de,
    defer: de,
    dir: null,
    dirName: null,
    disabled: de,
    download: $a,
    draggable: $e,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: de,
    formTarget: null,
    headers: Pe,
    height: F,
    hidden: de,
    high: F,
    href: null,
    hrefLang: null,
    htmlFor: Pe,
    httpEquiv: Pe,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: de,
    itemId: null,
    itemProp: Pe,
    itemRef: Pe,
    itemScope: de,
    itemType: Pe,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: de,
    low: F,
    manifest: null,
    max: null,
    maxLength: F,
    media: null,
    method: null,
    min: null,
    minLength: F,
    multiple: de,
    muted: de,
    name: null,
    nonce: null,
    noModule: de,
    noValidate: de,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: de,
    optimum: F,
    pattern: null,
    ping: Pe,
    placeholder: null,
    playsInline: de,
    poster: null,
    preload: null,
    readOnly: de,
    referrerPolicy: null,
    rel: Pe,
    required: de,
    reversed: de,
    rows: F,
    rowSpan: F,
    sandbox: Pe,
    scope: null,
    scoped: de,
    seamless: de,
    selected: de,
    shape: null,
    size: F,
    sizes: null,
    slot: null,
    span: F,
    spellCheck: $e,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: F,
    step: null,
    style: null,
    tabIndex: F,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: de,
    useMap: null,
    value: $e,
    width: F,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Pe,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: F,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: F,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: de,
    // Lists. Use CSS to reduce space between items instead
    declare: de,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: F,
    // `<img>` and `<object>`
    leftMargin: F,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: F,
    // `<body>`
    marginWidth: F,
    // `<body>`
    noResize: de,
    // `<frame>`
    noHref: de,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: de,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: de,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: F,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: $e,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: F,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: F,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: de,
    disableRemotePlayback: de,
    prefix: null,
    property: null,
    results: F,
    security: null,
    unselectable: null
  }
}), vp = Ln({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: ja,
  properties: {
    about: ot,
    accentHeight: F,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: F,
    amplitude: F,
    arabicForm: null,
    ascent: F,
    attributeName: null,
    attributeType: null,
    azimuth: F,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: F,
    by: null,
    calcMode: null,
    capHeight: F,
    className: Pe,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: F,
    diffuseConstant: F,
    direction: null,
    display: null,
    dur: null,
    divisor: F,
    dominantBaseline: null,
    download: de,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: F,
    enableBackground: null,
    end: null,
    event: null,
    exponent: F,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: F,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: In,
    g2: In,
    glyphName: In,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: F,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: F,
    horizOriginX: F,
    horizOriginY: F,
    id: null,
    ideographic: F,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: F,
    k: F,
    k1: F,
    k2: F,
    k3: F,
    k4: F,
    kernelMatrix: ot,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: F,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: F,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: F,
    overlineThickness: F,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: F,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Pe,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: F,
    pointsAtY: F,
    pointsAtZ: F,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: ot,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: ot,
    rev: ot,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: ot,
    requiredFeatures: ot,
    requiredFonts: ot,
    requiredFormats: ot,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: F,
    specularExponent: F,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: F,
    strikethroughThickness: F,
    string: null,
    stroke: null,
    strokeDashArray: ot,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: F,
    strokeOpacity: F,
    strokeWidth: null,
    style: null,
    surfaceScale: F,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: ot,
    tabIndex: F,
    tableValues: null,
    target: null,
    targetX: F,
    targetY: F,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: ot,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: F,
    underlineThickness: F,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: F,
    values: null,
    vAlphabetic: F,
    vMathematical: F,
    vectorEffect: null,
    vHanging: F,
    vIdeographic: F,
    version: null,
    vertAdvY: F,
    vertOriginX: F,
    vertOriginY: F,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: F,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), Dp = /^data[-\w.:]+$/i, ol = /-[a-z]/g, Hp = /[A-Z]/g;
function Ya(e, t) {
  const n = o1(t);
  let r = t, i = Tt;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && Dp.test(t)) {
    if (t.charAt(4) === "-") {
      const o = t.slice(5).replace(ol, Bp);
      r = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = t.slice(4);
      if (!ol.test(o)) {
        let s = o.replace(Hp, Fp);
        s.charAt(0) !== "-" && (s = "-" + s), t = "data" + s;
      }
    }
    i = vi;
  }
  return new i(r, t);
}
function Fp(e) {
  return "-" + e.toLowerCase();
}
function Bp(e) {
  return e.charAt(1).toUpperCase();
}
const Di = Ba([Ga, Ua, Ka, qa, Pp], "html"), Hi = Ba([Ga, Ua, Ka, qa, vp], "svg"), sl = /[#.]/g;
function $p(e, t) {
  const n = e || "", r = {};
  let i = 0, o, s;
  for (; i < n.length; ) {
    sl.lastIndex = i;
    const l = sl.exec(n), c = n.slice(i, l ? l.index : n.length);
    c && (o ? o === "#" ? r.id = c : Array.isArray(r.className) ? r.className.push(c) : r.className = [c] : s = c, i += c.length), l && (o = l[0], i++);
  }
  return {
    type: "element",
    // @ts-expect-error: fine.
    tagName: s || t || "div",
    properties: r,
    children: []
  };
}
function ll(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
const Up = /* @__PURE__ */ new Set(["menu", "submit", "reset", "button"]), ci = {}.hasOwnProperty;
function Va(e, t, n) {
  const r = n && Kp(n);
  return (
    /**
     * @type {{
     *   (): Root
     *   (selector: null | undefined, ...children: Array<HChild>): Root
     *   (selector: string, properties?: HProperties, ...children: Array<HChild>): Element
     *   (selector: string, ...children: Array<HChild>): Element
     * }}
     */
    /**
     * Hyperscript compatible DSL for creating virtual hast trees.
     *
     * @param {string | null} [selector]
     * @param {HProperties | HChild} [properties]
     * @param {Array<HChild>} children
     * @returns {HResult}
     */
    function(o, s, ...l) {
      let c = -1, u;
      if (o == null)
        u = { type: "root", children: [] }, l.unshift(s);
      else if (u = $p(o, t), u.tagName = u.tagName.toLowerCase(), r && ci.call(r, u.tagName) && (u.tagName = r[u.tagName]), Gp(s, u.tagName)) {
        let f;
        for (f in s)
          ci.call(s, f) && jp(e, u.properties, f, s[f]);
      } else
        l.unshift(s);
      for (; ++c < l.length; )
        fi(u.children, l[c]);
      return u.type === "element" && u.tagName === "template" && (u.content = { type: "root", children: u.children }, u.children = []), u;
    }
  );
}
function Gp(e, t) {
  return e == null || typeof e != "object" || Array.isArray(e) ? !1 : t === "input" || !e.type || typeof e.type != "string" ? !0 : "children" in e && Array.isArray(e.children) ? !1 : t === "button" ? Up.has(e.type.toLowerCase()) : !("value" in e);
}
function jp(e, t, n, r) {
  const i = Ya(e, n);
  let o = -1, s;
  if (r != null) {
    if (typeof r == "number") {
      if (Number.isNaN(r))
        return;
      s = r;
    } else
      typeof r == "boolean" ? s = r : typeof r == "string" ? i.spaceSeparated ? s = ll(r) : i.commaSeparated ? s = Uo(r) : i.commaOrSpaceSeparated ? s = ll(Uo(r).join(" ")) : s = al(i, i.property, r) : Array.isArray(r) ? s = r.concat() : s = i.property === "style" ? zp(r) : String(r);
    if (Array.isArray(s)) {
      const l = [];
      for (; ++o < s.length; )
        l[o] = al(i, i.property, s[o]);
      s = l;
    }
    i.property === "className" && Array.isArray(t.className) && (s = t.className.concat(s)), t[i.property] = s;
  }
}
function fi(e, t) {
  let n = -1;
  if (t != null)
    if (typeof t == "string" || typeof t == "number")
      e.push({ type: "text", value: String(t) });
    else if (Array.isArray(t))
      for (; ++n < t.length; )
        fi(e, t[n]);
    else if (typeof t == "object" && "type" in t)
      t.type === "root" ? fi(e, t.children) : e.push(t);
    else
      throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function al(e, t, n) {
  if (typeof n == "string") {
    if (e.number && n && !Number.isNaN(Number(n)))
      return Number(n);
    if ((e.boolean || e.overloadedBoolean) && (n === "" || o1(n) === o1(t)))
      return !0;
  }
  return n;
}
function zp(e) {
  const t = [];
  let n;
  for (n in e)
    ci.call(e, n) && t.push([n, e[n]].join(": "));
  return t.join("; ");
}
function Kp(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    t[e[n].toLowerCase()] = e[n];
  return t;
}
const qp = Va(Di, "div"), Yp = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], Vp = Va(Hi, "g", Yp);
function Wp(e) {
  const t = String(e), n = [], r = /\r?\n|\r/g;
  for (; r.test(t); )
    n.push(r.lastIndex);
  return n.push(t.length + 1), { toPoint: i, toOffset: o };
  function i(s) {
    let l = -1;
    if (typeof s == "number" && s > -1 && s < n[n.length - 1]) {
      for (; ++l < n.length; )
        if (n[l] > s)
          return {
            line: l + 1,
            column: s - (l > 0 ? n[l - 1] : 0) + 1,
            offset: s
          };
    }
    return { line: void 0, column: void 0, offset: void 0 };
  }
  function o(s) {
    const l = s && s.line, c = s && s.column;
    if (typeof l == "number" && typeof c == "number" && !Number.isNaN(l) && !Number.isNaN(c) && l - 1 in n) {
      const u = (n[l - 2] || 0) + c - 1 || 0;
      if (u > -1 && u < n[n.length - 1])
        return u;
    }
    return -1;
  }
}
const Xp = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, Wa = {}.hasOwnProperty, Qp = Object.prototype;
function Jp(e, t) {
  const n = t || {};
  let r, i;
  return t4(n) ? (i = n, r = {}) : (i = n.file || void 0, r = n), Fi(
    {
      schema: r.space === "svg" ? Hi : Di,
      file: i,
      verbose: r.verbose,
      location: !1
    },
    e
  );
}
function Fi(e, t) {
  let n;
  switch (t.nodeName) {
    case "#comment": {
      const r = (
        /** @type {P5Comment} */
        t
      );
      return n = { type: "comment", value: r.data }, F1(e, r, n), n;
    }
    case "#document":
    case "#document-fragment": {
      const r = (
        /** @type {P5Document | P5DocumentFragment} */
        t
      ), i = "mode" in r ? r.mode === "quirks" || r.mode === "limited-quirks" : !1;
      if (n = {
        type: "root",
        children: Xa(e, t.childNodes),
        data: { quirksMode: i }
      }, e.file && e.location) {
        const o = String(e.file), s = Wp(o), l = s.toPoint(0), c = s.toPoint(o.length);
        n.position = { start: l, end: c };
      }
      return n;
    }
    case "#documentType": {
      const r = (
        /** @type {P5DocumentType} */
        t
      );
      return n = { type: "doctype" }, F1(e, r, n), n;
    }
    case "#text": {
      const r = (
        /** @type {P5Text} */
        t
      );
      return n = { type: "text", value: r.value }, F1(e, r, n), n;
    }
    default:
      return n = Zp(
        e,
        /** @type {P5Element} */
        t
      ), n;
  }
}
function Xa(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    r[n] = Fi(e, t[n]);
  return r;
}
function Zp(e, t) {
  const n = e.schema;
  e.schema = t.namespaceURI === Xp.svg ? Hi : Di;
  let r = -1;
  const i = {};
  for (; ++r < t.attrs.length; ) {
    const l = t.attrs[r], c = (l.prefix ? l.prefix + ":" : "") + l.name;
    Wa.call(Qp, c) || (i[c] = l.value);
  }
  const s = (e.schema.space === "svg" ? Vp : qp)(t.tagName, i, Xa(e, t.childNodes));
  if (F1(e, t, s), s.tagName === "template") {
    const l = (
      /** @type {P5Template} */
      t
    ), c = l.sourceCodeLocation, u = c && c.startTag && xn(c.startTag), f = c && c.endTag && xn(c.endTag), m = Fi(e, l.content);
    u && f && e.file && (m.position = { start: u.end, end: f.start }), s.content = m;
  }
  return e.schema = n, s;
}
function F1(e, t, n) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
    const r = e4(e, n, t.sourceCodeLocation);
    r && (e.location = !0, n.position = r);
  }
}
function e4(e, t, n) {
  const r = xn(n);
  if (t.type === "element") {
    const i = t.children[t.children.length - 1];
    if (r && !n.endTag && i && i.position && i.position.end && (r.end = Object.assign({}, i.position.end)), e.verbose) {
      const o = {};
      let s;
      if (n.attrs)
        for (s in n.attrs)
          Wa.call(n.attrs, s) && (o[Ya(e.schema, s).property] = xn(
            n.attrs[s]
          ));
      t.data = {
        position: {
          // @ts-expect-error: assume not `undefined`.
          opening: xn(n.startTag),
          closing: n.endTag ? xn(n.endTag) : null,
          properties: o
        }
      };
    }
  }
  return r;
}
function xn(e) {
  const t = ul({
    line: e.startLine,
    column: e.startCol,
    offset: e.startOffset
  }), n = ul({
    line: e.endLine,
    column: e.endCol,
    offset: e.endOffset
  });
  return t || n ? { start: t, end: n } : void 0;
}
function ul(e) {
  return e.line && e.column ? e : void 0;
}
function t4(e) {
  return "messages" in e;
}
class f1 {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
}
f1.prototype.property = {};
f1.prototype.normal = {};
f1.prototype.space = null;
function Qa(e, t) {
  const n = {}, r = {};
  let i = -1;
  for (; ++i < e.length; )
    Object.assign(n, e[i].property), Object.assign(r, e[i].normal);
  return new f1(n, r, t);
}
function hi(e) {
  return e.toLowerCase();
}
class gt {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
gt.prototype.space = null;
gt.prototype.boolean = !1;
gt.prototype.booleanish = !1;
gt.prototype.overloadedBoolean = !1;
gt.prototype.number = !1;
gt.prototype.commaSeparated = !1;
gt.prototype.spaceSeparated = !1;
gt.prototype.commaOrSpaceSeparated = !1;
gt.prototype.mustUseProperty = !1;
gt.prototype.defined = !1;
let n4 = 0;
const me = Tn(), Ue = Tn(), Ja = Tn(), B = Tn(), ve = Tn(), Rn = Tn(), st = Tn();
function Tn() {
  return 2 ** ++n4;
}
const di = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: me,
  booleanish: Ue,
  commaOrSpaceSeparated: st,
  commaSeparated: Rn,
  number: B,
  overloadedBoolean: Ja,
  spaceSeparated: ve
}, Symbol.toStringTag, { value: "Module" })), Wr = Object.keys(di);
class Bi extends gt {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, i) {
    let o = -1;
    if (super(t, n), cl(this, "space", i), typeof r == "number")
      for (; ++o < Wr.length; ) {
        const s = Wr[o];
        cl(this, Wr[o], (r & di[s]) === di[s]);
      }
  }
}
Bi.prototype.defined = !0;
function cl(e, t, n) {
  n && (e[t] = n);
}
const r4 = {}.hasOwnProperty;
function Mn(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (r4.call(e.properties, r)) {
      const i = e.properties[r], o = new Bi(
        r,
        e.transform(e.attributes || {}, r),
        i,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (o.mustUseProperty = !0), t[r] = o, n[hi(r)] = r, n[hi(o.attribute)] = r;
    }
  return new f1(t, n, e.space);
}
const Za = Mn({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), eu = Mn({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function tu(e, t) {
  return t in e ? e[t] : t;
}
function nu(e, t) {
  return tu(e, t.toLowerCase());
}
const ru = Mn({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: nu,
  properties: { xmlns: null, xmlnsXLink: null }
}), iu = Mn({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Ue,
    ariaAutoComplete: null,
    ariaBusy: Ue,
    ariaChecked: Ue,
    ariaColCount: B,
    ariaColIndex: B,
    ariaColSpan: B,
    ariaControls: ve,
    ariaCurrent: null,
    ariaDescribedBy: ve,
    ariaDetails: null,
    ariaDisabled: Ue,
    ariaDropEffect: ve,
    ariaErrorMessage: null,
    ariaExpanded: Ue,
    ariaFlowTo: ve,
    ariaGrabbed: Ue,
    ariaHasPopup: null,
    ariaHidden: Ue,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: ve,
    ariaLevel: B,
    ariaLive: null,
    ariaModal: Ue,
    ariaMultiLine: Ue,
    ariaMultiSelectable: Ue,
    ariaOrientation: null,
    ariaOwns: ve,
    ariaPlaceholder: null,
    ariaPosInSet: B,
    ariaPressed: Ue,
    ariaReadOnly: Ue,
    ariaRelevant: null,
    ariaRequired: Ue,
    ariaRoleDescription: ve,
    ariaRowCount: B,
    ariaRowIndex: B,
    ariaRowSpan: B,
    ariaSelected: Ue,
    ariaSetSize: B,
    ariaSort: null,
    ariaValueMax: B,
    ariaValueMin: B,
    ariaValueNow: B,
    ariaValueText: null,
    role: null
  }
}), i4 = Mn({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: nu,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Rn,
    acceptCharset: ve,
    accessKey: ve,
    action: null,
    allow: null,
    allowFullScreen: me,
    allowPaymentRequest: me,
    allowUserMedia: me,
    alt: null,
    as: null,
    async: me,
    autoCapitalize: null,
    autoComplete: ve,
    autoFocus: me,
    autoPlay: me,
    capture: me,
    charSet: null,
    checked: me,
    cite: null,
    className: ve,
    cols: B,
    colSpan: null,
    content: null,
    contentEditable: Ue,
    controls: me,
    controlsList: ve,
    coords: B | Rn,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: me,
    defer: me,
    dir: null,
    dirName: null,
    disabled: me,
    download: Ja,
    draggable: Ue,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: me,
    formTarget: null,
    headers: ve,
    height: B,
    hidden: me,
    high: B,
    href: null,
    hrefLang: null,
    htmlFor: ve,
    httpEquiv: ve,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: me,
    itemId: null,
    itemProp: ve,
    itemRef: ve,
    itemScope: me,
    itemType: ve,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: me,
    low: B,
    manifest: null,
    max: null,
    maxLength: B,
    media: null,
    method: null,
    min: null,
    minLength: B,
    multiple: me,
    muted: me,
    name: null,
    nonce: null,
    noModule: me,
    noValidate: me,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: me,
    optimum: B,
    pattern: null,
    ping: ve,
    placeholder: null,
    playsInline: me,
    poster: null,
    preload: null,
    readOnly: me,
    referrerPolicy: null,
    rel: ve,
    required: me,
    reversed: me,
    rows: B,
    rowSpan: B,
    sandbox: ve,
    scope: null,
    scoped: me,
    seamless: me,
    selected: me,
    shape: null,
    size: B,
    sizes: null,
    slot: null,
    span: B,
    spellCheck: Ue,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: B,
    step: null,
    style: null,
    tabIndex: B,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: me,
    useMap: null,
    value: Ue,
    width: B,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: ve,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: B,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: B,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: me,
    // Lists. Use CSS to reduce space between items instead
    declare: me,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: B,
    // `<img>` and `<object>`
    leftMargin: B,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: B,
    // `<body>`
    marginWidth: B,
    // `<body>`
    noResize: me,
    // `<frame>`
    noHref: me,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: me,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: me,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: B,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Ue,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: B,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: B,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: me,
    disableRemotePlayback: me,
    prefix: null,
    property: null,
    results: B,
    security: null,
    unselectable: null
  }
}), o4 = Mn({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: tu,
  properties: {
    about: st,
    accentHeight: B,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: B,
    amplitude: B,
    arabicForm: null,
    ascent: B,
    attributeName: null,
    attributeType: null,
    azimuth: B,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: B,
    by: null,
    calcMode: null,
    capHeight: B,
    className: ve,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: B,
    diffuseConstant: B,
    direction: null,
    display: null,
    dur: null,
    divisor: B,
    dominantBaseline: null,
    download: me,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: B,
    enableBackground: null,
    end: null,
    event: null,
    exponent: B,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: B,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Rn,
    g2: Rn,
    glyphName: Rn,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: B,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: B,
    horizOriginX: B,
    horizOriginY: B,
    id: null,
    ideographic: B,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: B,
    k: B,
    k1: B,
    k2: B,
    k3: B,
    k4: B,
    kernelMatrix: st,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: B,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: B,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: B,
    overlineThickness: B,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: B,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: ve,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: B,
    pointsAtY: B,
    pointsAtZ: B,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: st,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: st,
    rev: st,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: st,
    requiredFeatures: st,
    requiredFonts: st,
    requiredFormats: st,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: B,
    specularExponent: B,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: B,
    strikethroughThickness: B,
    string: null,
    stroke: null,
    strokeDashArray: st,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: B,
    strokeOpacity: B,
    strokeWidth: null,
    style: null,
    surfaceScale: B,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: st,
    tabIndex: B,
    tableValues: null,
    target: null,
    targetX: B,
    targetY: B,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: st,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: B,
    underlineThickness: B,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: B,
    values: null,
    vAlphabetic: B,
    vMathematical: B,
    vectorEffect: null,
    vHanging: B,
    vIdeographic: B,
    version: null,
    vertAdvY: B,
    vertOriginX: B,
    vertOriginY: B,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: B,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), s4 = /^data[-\w.:]+$/i, fl = /-[a-z]/g, l4 = /[A-Z]/g;
function a4(e, t) {
  const n = hi(t);
  let r = t, i = gt;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && s4.test(t)) {
    if (t.charAt(4) === "-") {
      const o = t.slice(5).replace(fl, c4);
      r = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = t.slice(4);
      if (!fl.test(o)) {
        let s = o.replace(l4, u4);
        s.charAt(0) !== "-" && (s = "-" + s), t = "data" + s;
      }
    }
    i = Bi;
  }
  return new i(r, t);
}
function u4(e) {
  return "-" + e.toLowerCase();
}
function c4(e) {
  return e.charAt(1).toUpperCase();
}
const f4 = Qa([eu, Za, ru, iu, i4], "html"), ou = Qa([eu, Za, ru, iu, o4], "svg");
function h4(e) {
  return e.join(" ").trim();
}
const su = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
var hl = {}.hasOwnProperty;
function d4(e, t) {
  var n = t || {};
  function r(i) {
    var o = r.invalid, s = r.handlers;
    if (i && hl.call(i, e) && (o = hl.call(s, i[e]) ? s[i[e]] : r.unknown), o)
      return o.apply(this, arguments);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
const m4 = {}.hasOwnProperty, lu = d4("type", { handlers: { root: T4, element: y4, text: A4, comment: _4, doctype: E4 } });
function p4(e, t) {
  const n = t && typeof t == "object" ? t.space : t;
  return lu(e, n === "svg" ? ou : f4);
}
function T4(e, t) {
  const n = {
    nodeName: "#document",
    // @ts-expect-error: `parse5` uses enums, which are actually strings.
    mode: (e.data || {}).quirksMode ? "quirks" : "no-quirks",
    childNodes: []
  };
  return n.childNodes = $i(e.children, n, t), Pn(e, n), n;
}
function g4(e, t) {
  const n = { nodeName: "#document-fragment", childNodes: [] };
  return n.childNodes = $i(e.children, n, t), Pn(e, n), n;
}
function E4(e) {
  const t = {
    nodeName: "#documentType",
    name: "html",
    publicId: "",
    systemId: "",
    // @ts-expect-error: change to `null` in a major?
    parentNode: void 0
  };
  return Pn(e, t), t;
}
function A4(e) {
  const t = {
    nodeName: "#text",
    value: e.value,
    // @ts-expect-error: no `parentNode`
    parentNode: void 0
  };
  return Pn(e, t), t;
}
function _4(e) {
  const t = {
    nodeName: "#comment",
    data: e.value,
    // @ts-expect-error: no `parentNode`
    parentNode: void 0
  };
  return Pn(e, t), t;
}
function y4(e, t) {
  const n = t;
  let r = n;
  e.type === "element" && e.tagName.toLowerCase() === "svg" && n.space === "html" && (r = ou);
  const i = [];
  let o;
  if (e.properties) {
    for (o in e.properties)
      if (o !== "children" && m4.call(e.properties, o)) {
        const l = C4(
          r,
          o,
          e.properties[o]
        );
        l && i.push(l);
      }
  }
  const s = {
    nodeName: e.tagName,
    tagName: e.tagName,
    attrs: i,
    // @ts-expect-error: html and svg both have a space.
    namespaceURI: su[r.space],
    childNodes: [],
    // @ts-expect-error: no `parentNode`
    parentNode: void 0
  };
  return s.childNodes = $i(e.children, s, r), Pn(e, s), e.tagName === "template" && e.content && (s.content = g4(e.content, r)), s;
}
function C4(e, t, n) {
  const r = a4(e, t);
  if (n == null || n === !1 || typeof n == "number" && Number.isNaN(n) || !n && r.boolean)
    return;
  Array.isArray(n) && (n = r.commaSeparated ? aa(n) : h4(n));
  const i = {
    name: r.attribute,
    value: n === !0 ? "" : String(n)
  };
  if (r.space && r.space !== "html" && r.space !== "svg") {
    const o = i.name.indexOf(":");
    o < 0 ? i.prefix = "" : (i.name = i.name.slice(o + 1), i.prefix = r.attribute.slice(0, o)), i.namespace = su[r.space];
  }
  return i;
}
function $i(e, t, n) {
  let r = -1;
  const i = [];
  if (e)
    for (; ++r < e.length; ) {
      const o = lu(e[r], n);
      o.parentNode = t, i.push(o);
    }
  return i;
}
function Pn(e, t) {
  const n = e.position;
  n && n.start && n.end && (t.sourceCodeLocation = {
    startLine: n.start.line,
    startCol: n.start.column,
    // @ts-expect-error assume this is set.
    startOffset: n.start.offset,
    endLine: n.end.line,
    endCol: n.end.column,
    // @ts-expect-error assume this is set.
    endOffset: n.end.offset
  });
}
const S4 = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "menuitem",
  "meta",
  "nextid",
  "param",
  "source",
  "track",
  "wbr"
], dl = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
var ml = {}.hasOwnProperty;
function x4(e, t) {
  var n = t || {};
  function r(i) {
    var o = r.invalid, s = r.handlers;
    if (i && ml.call(i, e) && (o = ml.call(s, i[e]) ? s[i[e]] : r.unknown), o)
      return o.apply(this, arguments);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
const N4 = "IN_TEMPLATE_MODE", b4 = "DATA_STATE", O4 = "CHARACTER_TOKEN", I4 = "START_TAG_TOKEN", R4 = "END_TAG_TOKEN", k4 = "COMMENT_TOKEN", w4 = "DOCTYPE_TOKEN", L4 = { sourceCodeLocationInfo: !0, scriptingEnabled: !1 }, au = (
  /**
   * @type {(
   *   ((tree: Node, file: VFile|undefined, options?: Options) => Node) &
   *   ((tree: Node, options?: Options) => Node)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {VFile} [file]
   * @param {Options} [options]
   */
  function(e, t, n) {
    let r = -1;
    const i = new yp(L4), o = x4("type", {
      handlers: { root: y, element: b, text: _, comment: O, doctype: M, raw: P },
      // @ts-expect-error: hush.
      unknown: D4
    });
    let s, l, c, u, f;
    if (F4(t) && (n = t, t = void 0), n && n.passThrough)
      for (; ++r < n.passThrough.length; )
        o.handlers[n.passThrough[r]] = N;
    const m = Jp(
      H4(e) ? h() : E(),
      t
    );
    if (s && wp(m, "comment", (I, D, z) => {
      const ie = (
        /** @type {Stitch} */
        /** @type {unknown} */
        I
      );
      if (ie.value.stitch && z !== null && D !== null)
        return z.children[D] = ie.value.stitch, D;
    }), e.type !== "root" && m.type === "root" && m.children.length === 1)
      return m.children[0];
    return m;
    function E() {
      const I = {
        nodeName: "template",
        tagName: "template",
        attrs: [],
        namespaceURI: dl.html,
        childNodes: []
      }, D = {
        nodeName: "documentmock",
        tagName: "documentmock",
        attrs: [],
        namespaceURI: dl.html,
        childNodes: []
      }, z = { nodeName: "#document-fragment", childNodes: [] };
      if (i._bootstrap(D, I), i._pushTmplInsertionMode(N4), i._initTokenizerForFragmentParsing(), i._insertFakeRootElement(), i._resetInsertionMode(), i._findFormInFragmentContext(), l = i.tokenizer, !l)
        throw new Error("Expected `tokenizer`");
      return c = l.preprocessor, f = l.__mixins[0], u = f.posTracker, o(e), C(), i._adoptNodes(D.childNodes[0], z), z;
    }
    function h() {
      const I = i.treeAdapter.createDocument();
      if (i._bootstrap(I, void 0), l = i.tokenizer, !l)
        throw new Error("Expected `tokenizer`");
      return c = l.preprocessor, f = l.__mixins[0], u = f.posTracker, o(e), C(), I;
    }
    function x(I) {
      let D = -1;
      if (I)
        for (; ++D < I.length; )
          o(I[D]);
    }
    function y(I) {
      x(I.children);
    }
    function b(I) {
      C(), i._processInputToken(M4(I)), x(I.children), S4.includes(I.tagName) || (C(), i._processInputToken(v4(I)));
    }
    function _(I) {
      C(), i._processInputToken({
        type: O4,
        chars: I.value,
        location: Nn(I)
      });
    }
    function M(I) {
      C(), i._processInputToken({
        type: w4,
        name: "html",
        forceQuirks: !1,
        publicId: "",
        systemId: "",
        location: Nn(I)
      });
    }
    function O(I) {
      C(), i._processInputToken({
        type: k4,
        data: I.value,
        location: Nn(I)
      });
    }
    function P(I) {
      const D = Da(I), z = D.line || 1, ie = D.column || 1, v = D.offset || 0;
      if (!c)
        throw new Error("Expected `preprocessor`");
      if (!l)
        throw new Error("Expected `tokenizer`");
      if (!u)
        throw new Error("Expected `posTracker`");
      if (!f)
        throw new Error("Expected `locationTracker`");
      c.html = void 0, c.pos = -1, c.lastGapPos = -1, c.lastCharPos = -1, c.gapStack = [], c.skipNextNewLine = !1, c.lastChunkWritten = !1, c.endOfChunkHit = !1, u.isEol = !1, u.lineStartPos = -ie + 1, u.droppedBufferSize = v, u.offset = 0, u.col = 1, u.line = z, f.currentAttrLocation = void 0, f.ctLoc = Nn(I), l.write(I.value), i._runParsingLoop(null), (l.state === "NAMED_CHARACTER_REFERENCE_STATE" || l.state === "NUMERIC_CHARACTER_REFERENCE_END_STATE") && (c.lastChunkWritten = !0, l[l.state](l._consume()));
    }
    function N(I) {
      s = !0;
      let D;
      "children" in I ? D = {
        ...I,
        children: au(
          { type: "root", children: I.children },
          t,
          n
          // @ts-expect-error Assume a given parent yields a parent.
        ).children
      } : D = { ...I }, O({ type: "comment", value: { stitch: D } });
    }
    function C() {
      if (!l)
        throw new Error("Expected `tokenizer`");
      if (!u)
        throw new Error("Expected `posTracker`");
      const I = l.currentCharacterToken;
      I && (I.location.endLine = u.line, I.location.endCol = u.col + 1, I.location.endOffset = u.offset + 1, i._processInputToken(I)), l.tokenQueue = [], l.state = b4, l.returnState = "", l.charRefCode = -1, l.tempBuff = [], l.lastStartTagName = "", l.consumedAfterSnapshot = -1, l.active = !1, l.currentCharacterToken = void 0, l.currentToken = void 0, l.currentAttr = void 0;
    }
  }
);
function M4(e) {
  const t = Object.assign(Nn(e));
  return t.startTag = Object.assign({}, t), {
    type: I4,
    tagName: e.tagName,
    selfClosing: !1,
    attrs: P4(e),
    location: t
  };
}
function P4(e) {
  return p4({
    tagName: e.tagName,
    type: "element",
    properties: e.properties,
    children: []
    // @ts-expect-error Assume element.
  }).attrs;
}
function v4(e) {
  const t = Object.assign(Nn(e));
  return t.startTag = Object.assign({}, t), {
    type: R4,
    tagName: e.tagName,
    attrs: [],
    location: t
  };
}
function D4(e) {
  throw new Error("Cannot compile `" + e.type + "` node");
}
function H4(e) {
  const t = e.type === "root" ? e.children[0] : e;
  return !!(t && (t.type === "doctype" || t.type === "element" && t.tagName === "html"));
}
function Nn(e) {
  const t = Da(e), n = Cp(e);
  return {
    startLine: t.line,
    startCol: t.column,
    startOffset: t.offset,
    endLine: n.line,
    endCol: n.column,
    endOffset: n.offset
  };
}
function F4(e) {
  return !!(e && !("message" in e && "messages" in e));
}
function B4(e = {}) {
  return (t, n) => (
    /** @type {Root} */
    au(t, n, e)
  );
}
const $4 = `
  strong {
    font-weight: 600;
  }

  ul, ol {
    margin: 0;
    padding: 0.5rem 1.1rem;
  }
`, U4 = Y(/* @__PURE__ */ ee.forwardRef(function(t, n) {
  return /* @__PURE__ */ T.jsx(j, {
    ref: n,
    ...t
  });
}))`
  ${$4}
  ${Ve}
`, G4 = Y.a`
  text-decoration: none;
`, j4 = Y.ol`
  ${({ variant: e }) => z4(e)}
  ${({ weight: e }) => K4(e)}
  ${({ color: e }) => `color: ${e};`}
`, z4 = (e) => {
  switch (e) {
    case "h1":
      return yu();
    case "h2":
      return _u();
    case "h3":
      return Au();
    case "h4":
      return Eu();
    case "h5":
      return gu();
    case "body":
      return mi();
    case "paragraph":
      return Tu();
    case "small":
      return pu();
    case "medium":
      return mu();
  }
}, K4 = (e) => {
  switch (e) {
    case "medium":
      return "font-weight: 500;";
    case "regular":
      return "font-weight: 400;";
  }
}, KT = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "markdown", color: n = "black", paragraphProps: r = {
  weight: "regular",
  variant: "body"
}, linkProps: i = {
  underlined: !0
}, linkTarget: o, children: s, ...l }, c) {
  return /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsx(U4, {
      testId: t,
      ref: c,
      ...l,
      children: /* @__PURE__ */ T.jsx(xu, {
        fallback: /* @__PURE__ */ T.jsxs("div", {
          children: [
            /* @__PURE__ */ T.jsx("code", {
              children: "document"
            }),
            " is not supported."
          ]
        }),
        children: /* @__PURE__ */ T.jsx(Si, {
          linkTarget: o,
          rehypePlugins: [
            B4
          ],
          components: {
            h1: function({ children: f }) {
              return /* @__PURE__ */ T.jsx(ut, {
                variant: "h1",
                padding: "1rem 0",
                color: n,
                children: f
              });
            },
            h2: function({ children: f }) {
              return /* @__PURE__ */ T.jsx(ut, {
                variant: "h2",
                padding: "1rem 0",
                color: n,
                children: f
              });
            },
            h3: function({ children: f }) {
              return /* @__PURE__ */ T.jsx(ut, {
                variant: "h3",
                padding: "1rem 0",
                color: n,
                children: f
              });
            },
            h4: function({ children: f }) {
              return /* @__PURE__ */ T.jsx(ut, {
                variant: "h4",
                padding: "1rem 0",
                color: n,
                children: f
              });
            },
            h5: function({ children: f }) {
              return /* @__PURE__ */ T.jsx(ut, {
                variant: "h5",
                padding: "1rem 0",
                color: n,
                children: f
              });
            },
            p: function({ children: f }) {
              return /* @__PURE__ */ T.jsx(ut, {
                display: "block",
                color: n,
                padding: "0.5rem 0",
                ...r,
                children: f
              });
            },
            a: function({ children: f, href: m, target: E }) {
              return /* @__PURE__ */ T.jsx(G4, {
                href: m,
                target: E,
                children: /* @__PURE__ */ T.jsx(ut, {
                  color: n,
                  ...r,
                  ...i,
                  children: f
                })
              });
            },
            li: function({ children: f }) {
              return /* @__PURE__ */ T.jsx("li", {
                children: /* @__PURE__ */ T.jsx(ut, {
                  color: n,
                  ...r,
                  children: f
                })
              });
            },
            ol: function({ children: f }) {
              return /* @__PURE__ */ T.jsx(j4, {
                color: n,
                variant: r.variant,
                weight: r.weight,
                children: f
              });
            }
          },
          children: s
        })
      })
    })
  });
}), q4 = Y(/* @__PURE__ */ ee.forwardRef(function({ children: t, className: n, testId: r, domProps: i }, o) {
  return /* @__PURE__ */ T.jsx(j, {
    display: "inline-flex",
    borderRadius: "4px",
    padding: "0 8px",
    minHeight: "24px",
    testId: r,
    className: n,
    ref: o,
    ...i,
    children: t
  });
}))`
  align-items: center;
  white-space: nowrap;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  ${Ve}
`, qT = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "tag", children: n, icon: r, iconPosition: i, ...o }, s) {
  return /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsxs(q4, {
      ref: s,
      testId: t,
      ...o,
      children: [
        i === "left" && /* @__PURE__ */ T.jsx(j, {
          height: "0.5rem",
          width: "0.5rem",
          marginRight: "0.25rem",
          display: "inline-flex",
          children: r
        }),
        n,
        i === "right" && /* @__PURE__ */ T.jsx(j, {
          height: "0.5rem",
          width: "0.5rem",
          marginLeft: "0.25rem",
          display: "inline-flex",
          children: r
        })
      ]
    })
  });
}), Y4 = (e) => e ? R`
      border-color: ${({ theme: t }) => t.colors.interface};
    ` : R`
      border-color: ${({ theme: t }) => t.colors.lightGrey};
    `, V4 = (e, t) => {
  if (t)
    return R`
      transform: translateY(100px);
      bottom: 2rem;
      right: 1rem;
      left: 1rem;
    `;
  switch (e) {
    case "topLeft":
      return R`
          transform: translateX(-300px);
          top: 1rem;
          right: auto;
          left: 1rem;
          width: 21.5rem;
        `;
    case "topRight":
      return R`
          transform: translateX(300px);
          top: 1rem;
          right: 1rem;
          left: auto;
          width: 21.5rem;
        `;
    case "bottomLeft":
      return R`
          transform: translateX(-300px);
          bottom: 1rem;
          right: auto;
          left: 1rem;
          width: 21.5rem;
        `;
    case "bottomRight":
      return R`
          transform: translateX(300px);
          bottom: 1rem;
          right: 1rem;
          left: auto;
          width: 21.5rem;
        `;
    case "unset":
      return R`
          transform: scale(0);
          position: unset;
          width: 21.5rem;
        `;
  }
}, W4 = `
  opacity: 1;
  transform: translate(0);
`, X4 = `
  opacity: 0;
  transition: opacity 0.5s ease 0s, transform 0.5s ease 0s;
  position: fixed;
  padding: 1rem;
  border-radius: 6px;
  border-width: 1px;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.12), 0 0 4px 0 rgba(0, 0, 0, 0.24);
  border: solid 1px;
  background-color: ${en};
`, Q4 = Y(/* @__PURE__ */ ee.forwardRef(function({ children: t, className: n, testId: r, role: i, ...o }, s) {
  return /* @__PURE__ */ T.jsx(j, {
    testId: r,
    className: n,
    role: i,
    ref: s,
    ...o,
    children: t
  });
}))`
  ${X4}
  ${({ location: e = "topLeft", isMobile: t = !1 }) => R`
      ${V4(e, t)}
    `}
  ${({ highlightBorder: e = !1, open: t }) => t ? R`
        ${W4}
        ${Y4(e)}
        ${Ve}
      ` : R`
        visibility: none;
      `}
`, pl = Y((e) => /* @__PURE__ */ T.jsx(B1, {
  ...e
}))`
  margin-right: 0.5rem;
  &:last-child {
    margin-right: 0;
  }
`, J4 = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  position: absolute;
  cursor: pointer;
  top: 0.5rem;
  right: 0.5rem;
`, Z4 = Y((e) => /* @__PURE__ */ T.jsx(B1, {
  ...e
}))`
  background-color: transparent;
  padding: 0 !important;
  top: 0.5rem;
  right: 0.5rem;
  position: static !important;
  border: none;
  &:hover,
  &:focus,
  &:active {
    background-color: transparent;
  }
`, YT = /* @__PURE__ */ ee.forwardRef(function({ title: t, open: n, icon: r, children: i, location: o = "topLeft", hiddenCloseIcon: s = !1, enableDismissButton: l = !1, enableActionButton: c = !1, dissmissButtonLabel: u = "Dismiss", actionButtonLabel: f = "OK", highlightBorder: m = !1, onCloseIconClick: E, onDismissClick: h, onActionClick: x, onOutsideClick: y, mobile: b = !1, testId: _ = "Toast", role: M, ...O }, P) {
  const N = wt(null);
  Fe(() => {
    const z = (ie) => {
      N.current && !N.current.contains(ie.target) && y && y();
    };
    if (n)
      return document.addEventListener("click", z, !1), () => {
        document.removeEventListener("click", z, !1);
      };
  }, [
    n,
    y
  ]);
  const C = (z) => {
    z.persist(), E && E(z);
  }, I = i != null, D = Ut(() => {
    if (!(!l && !c))
      return /* @__PURE__ */ T.jsxs(j, {
        paddingTop: "1rem",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "flex-end",
        children: [
          l && /* @__PURE__ */ T.jsx(pl, {
            shape: "pill",
            onClick: h,
            variant: "tertiary",
            testId: `${_}-dismiss-button`,
            children: u
          }),
          c && /* @__PURE__ */ T.jsx(pl, {
            shape: "pill",
            onClick: x,
            testId: `${_}-action-button`,
            children: f
          })
        ]
      });
  }, [
    c,
    l,
    x,
    h,
    _,
    u,
    f
  ]);
  return /* @__PURE__ */ T.jsxs(Q4, {
    open: n,
    highlightBorder: m,
    testId: _,
    role: M || "status",
    ref: N,
    zIndex: 100,
    location: o,
    isMobile: b,
    ...O,
    children: [
      !s && /* @__PURE__ */ T.jsx(J4, {
        testId: `${_}-close-icon-container`,
        onClick: C,
        children: /* @__PURE__ */ T.jsx(Z4, {
          "aria-label": "Close",
          children: /* @__PURE__ */ T.jsx(s1, {
            size: 15
          })
        })
      }),
      /* @__PURE__ */ T.jsx(j, {
        testId: `${_}-content`,
        ref: P,
        children: /* @__PURE__ */ T.jsxs(j, {
          children: [
            /* @__PURE__ */ T.jsxs(j, {
              display: "flex",
              alignItems: "flex-end",
              marginBottom: I ? "0.5rem" : "0rem",
              children: [
                r && /* @__PURE__ */ T.jsx(j, {
                  testId: `${_}-warning-icon-container`,
                  display: "inline-flex",
                  marginRight: "0.5rem",
                  alignSelf: "flex-start",
                  children: r
                }),
                /* @__PURE__ */ T.jsx(ut, {
                  testId: `${_}-title`,
                  margin: "0.125rem 0 0.125rem 0",
                  variant: "body",
                  children: t
                })
              ]
            }),
            i && /* @__PURE__ */ T.jsx(j, {
              testId: `${_}-children-container`,
              children: i
            })
          ]
        })
      }),
      D()
    ]
  });
}), e8 = `
  display: flex;
  justify-content: center;
  align-items: center;

`, t8 = `
  -webkit-transition: visibility 0.3s, opacity 0.3s ease-in-out;
  -moz-transition: visibility 0.3s, opacity 0.3s ease-in-out;
  -ms-transition: visibility 0.3s, opacity 0.3s ease-in-out;
  -o-transition: visibility 0.3s, opacity 0.3s ease-in-out;
   opacity: 1;
   visibility: visible;
`, n8 = Y(({ children: e, className: t, testId: n, onMouseDown: r }) => /* @__PURE__ */ T.jsx(Y1, {
  className: t,
  testId: n,
  children: /* @__PURE__ */ T.jsx(j, {
    className: t,
    onMouseDown: r,
    children: e
  })
}))`
  ${e8}
  ${({ open: e = !1 }) => e ? R`
        ${t8}
        ${Ve}
      ` : R`
        -webkit-transition: visibility 0.3s, opacity 0.3s ease-in-out;
        -moz-transition: visibility 0.3s, opacity 0.3s ease-in-out;
        -ms-transition: visibility 0.3s, opacity 0.3s ease-in-out;
        -o-transition: visibility 0.3s, opacity 0.3s ease-in-out;
        opacity: 0;
        visibility: hidden;
      `}
`, r8 = (e) => R`
    padding: ${e ? "0" : "1.25rem"};
  `, i8 = `
  overflow: hidden;
  position: relative;
  border-radius: 0px;
  user-select: none;
`, o8 = Y(/* @__PURE__ */ ee.forwardRef(function({ ...t }, n) {
  return /* @__PURE__ */ T.jsx(V1, {
    ref: n,
    ...t
  });
}))`
  ${i8}

  ${({ noMargin: e }) => R`
      ${r8(e)}
    `}
`, s8 = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  ${({ alternateIcon: e = !1 }) => e ? R`
        position: fixed;
        height: 40px;
        width: 40px;
        cursor: pointer;
        z-index: 101;
        background: rgba(238, 238, 238, 0.3);
        border-radius: 7px;
        margin: 0.7rem;
        > div {
          margin: 0.5rem;
        }
      ` : R`
        position: absolute;
        cursor: pointer;
        top: 1.2rem;
        left: 1.2rem;
        z-index: 101;
      `}
`, l8 = () => R`
    position: fixed;
    top: 0;
    left: auto;
    right: 0;
    height: 100%;
  `, a8 = `
  opacity: 1;
  transform: translate(0);
`, u8 = (e) => {
  if (!e)
    return `
    max-height: 100%;
    overflow: auto;
  `;
}, c8 = Y(/* @__PURE__ */ ee.forwardRef(function({ children: t, className: n, testId: r, ...i }, o) {
  return /* @__PURE__ */ T.jsx(j, {
    testId: r,
    className: n,
    ref: o,
    ...i,
    children: t
  });
}))`
  ${l8}

  ${({ open: e = !1, width: t, disabledHeightLimit: n }) => {
  if (e)
    return R`
        width: ${t};

        ${u8(n)}
        ${a8}
      `;
}}
`, f8 = (e) => R`
    padding-top: ${e ? "0rem" : "3rem"};
  `, h8 = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  overflow: auto;
  ${({ noMargin: e }) => R`
      ${f8(e)}
    `}

  ${({ hiddenScrollBar: e }) => {
  if (e)
    return R`
        > *:first-child {
          ::-webkit-scrollbar {
            width: 0;
          }
          overflow: -moz-scrollbars-none;
          -ms-overflow-style: none;
        }
      `;
}}
`;
Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  width: 52px;
  height: 5px;
  border-radius: 5px;
  cursor: pointer;
`;
Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  width: 134px;
  height: 5px;
  object-fit: contain;
  border-radius: 100px;
`;
const d8 = Y.button`
  ${pi};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;

  /* styles */
  &:hover,
  &:active,
  &:focus {
    background-color: ${Ti};
  }
  &:focus-visible {
    box-shadow: 0 0 0 2px ${q1};
  }
`, m8 = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "modal", children: n, icon: r = "close", width: i = "50%", maxWidth: o, minWidth: s, bodyScrollDisabled: l = !1, open: c, onScroll: u, noMargin: f = !1, alternateIcon: m = !1, persistent: E = !1, onClose: h, zIndex: x = 100, hiddenScrollBar: y = !1, containerHeight: b = "100vh", disabledHeightLimit: _ = !1, closeButtonDomProps: M, ...O }, P) {
  const N = wt(null);
  Fe(() => {
    l && (c ? document.body.style.overflow = "hidden" : document.body.style.overflow = "visible");
  }, [
    l,
    c
  ]);
  const C = (z) => {
    if (E)
      return;
    const ie = z.target;
    c && N.current && ie instanceof Node && !N.current.contains(ie) && h(z);
  }, I = Rt(() => {
    switch (r) {
      case "close":
        return /* @__PURE__ */ T.jsx(s1, {
          size: 24,
          color: m ? "white" : "black"
        });
      case "back":
        return /* @__PURE__ */ T.jsx(r1, {
          size: 24,
          color: m ? "white" : "black"
        });
    }
  }, [
    r,
    m
  ]), D = Rt(() => {
    const z = (v) => {
      v.persist(), h && h(v);
    }, ie = (v) => {
      v.persist(), u && u(v);
    };
    return /* @__PURE__ */ T.jsxs(o8, {
      ref: P,
      testId: `${t}-card`,
      noMargin: f,
      height: "100%",
      ...O,
      children: [
        !E && /* @__PURE__ */ T.jsx(s8, {
          testId: `${t}-icon-container`,
          onClick: z,
          alternateIcon: m,
          children: /* @__PURE__ */ T.jsx(d8, {
            "aria-label": `${r} button`,
            tabIndex: 0,
            ...M,
            children: I
          })
        }),
        /* @__PURE__ */ T.jsx(h8, {
          testId: `${t}-card-content`,
          noMargin: f,
          onScroll: ie,
          hiddenScrollBar: y,
          children: n
        })
      ]
    });
  }, [
    P,
    t,
    f,
    O,
    E,
    m,
    M,
    I,
    y,
    r,
    n,
    h,
    u
  ]);
  return /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsx(n8, {
      height: b,
      width: "100vw",
      top: "0",
      left: "0",
      zIndex: x,
      onMouseDown: C,
      open: c,
      testId: t,
      children: /* @__PURE__ */ T.jsx(c8, {
        open: c,
        ref: N,
        disabledHeightLimit: _,
        width: i,
        maxWidth: o,
        minWidth: s,
        display: c ? void 0 : "none",
        children: D
      })
    })
  });
}), p8 = `
  display: flex;
  justify-content: center;
  align-items: center;

`, T8 = `
  -webkit-transition: visibility 0.3s, opacity 0.3s ease-in-out;
  -moz-transition: visibility 0.3s, opacity 0.3s ease-in-out;
  -ms-transition: visibility 0.3s, opacity 0.3s ease-in-out;
  -o-transition: visibility 0.3s, opacity 0.3s ease-in-out;
   opacity: 1;
   visibility: visible;
`, g8 = Y(({ children: e, className: t, testId: n }) => /* @__PURE__ */ T.jsx(j, {
  size: "100%",
  position: "fixed",
  testId: n,
  className: t,
  children: e
}))`
  ${p8}
  ${({ open: e = !1 }) => e ? R`
        ${T8}
        ${Ve}
      ` : R`
        -webkit-transition: visibility 0.3s, opacity 0.3s ease-in-out;
        -moz-transition: visibility 0.3s, opacity 0.3s ease-in-out;
        -ms-transition: visibility 0.3s, opacity 0.3s ease-in-out;
        -o-transition: visibility 0.3s, opacity 0.3s ease-in-out;
        opacity: 0;
        visibility: hidden;
      `}
`, E8 = (e) => R`
    padding: ${e ? "" : "1.25rem"};
  `, A8 = `
  overflow: auto;
  position: relative;
`, _8 = Y(/* @__PURE__ */ ee.forwardRef(function({ ...t }, n) {
  return /* @__PURE__ */ T.jsx(V1, {
    ref: n,
    ...t
  });
}))`
  ${A8}
  user-select: none;
  ${({ noMargin: e }) => e ? R`
        border-radius: 0px;
      ` : R`
      ${E8(e)}
    `}
`, y8 = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  ${({ alternateIcon: e = !1 }) => e ? R`
        position: fixed;
        height: 40px;
        width: 40px;
        cursor: pointer;
        z-index: 101;
        background: rgba(238, 238, 238, 0.3);
        border-radius: 7px;
        margin: 0.7rem;
        > div {
          margin: 0.5rem;
        }
      ` : R`
        position: absolute;
        cursor: pointer;
        top: 1.2rem;
        left: 1.2rem;
        z-index: 101;
      `}
`, C8 = (e, t) => R`
    width: ${e};
    height: ${t};
  `, S8 = `
  opacity: 1;
  transform: translate(0);

`, x8 = (e) => {
  if (!e)
    return `
    max-height: 100%;
    overflow: auto;
  `;
}, N8 = Y(/* @__PURE__ */ ee.forwardRef(function({ children: t, className: n, testId: r, ...i }, o) {
  return /* @__PURE__ */ T.jsx(j, {
    testId: r,
    className: n,
    ref: o,
    ...i,
    children: t
  });
}))`
  ${({ open: e = !1, width: t, height: n, disabledHeightLimit: r }) => {
  if (e)
    return R`
        ${C8(t, n)};
        ${x8(r)}
        ${S8}
      `;
}}
`, b8 = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  overflow: auto;

  ${({ noMargin: e }) => {
  if (!e)
    return R`
      padding-top: 3rem;
    `;
}}

  ${({ hiddenScrollBar: e }) => {
  if (e)
    return R`
        > *:first-child {
          ::-webkit-scrollbar {
            width: 0;
          }
          overflow: -moz-scrollbars-none;
          -ms-overflow-style: none;
        }
      `;
}}
`, O8 = Y.button`
  ${pi};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;

  /* styles */
  &:hover,
  &:active,
  &:focus {
    background-color: ${Ti};
  }
  &:focus-visible {
    box-shadow: 0 0 0 2px ${q1};
  }
`, I8 = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "FullScreenModal", children: n, icon: r = "close", bodyScrollDisabled: i = !1, open: o, onScroll: s, noMargin: l = !1, alternateIcon: c = !1, persistent: u = !1, onClose: f, zIndex: m = 100, hiddenScrollBar: E = !1, disabledHeightLimit: h = !1, containerHeight: x = "100vh", closeButtonDomProps: y, ...b }, _) {
  const M = wt(null);
  Fe(() => {
    i && (o ? document.body.style.overflow = "hidden" : document.body.style.overflow = "visible");
  }, [
    i,
    o
  ]);
  const O = Rt(() => {
    switch (r) {
      case "close":
        return /* @__PURE__ */ T.jsx(s1, {
          size: 24,
          color: c ? "white" : "black"
        });
      case "back":
        return /* @__PURE__ */ T.jsx(r1, {
          size: 24,
          color: c ? "white" : "black"
        });
    }
  }, [
    r,
    c
  ]), P = Rt(() => {
    const C = (D) => {
      D.persist(), f && f(D);
    }, I = (D) => {
      D.persist(), s && s(D);
    };
    return /* @__PURE__ */ T.jsxs(_8, {
      ref: _,
      testId: `${t}-card`,
      noMargin: l,
      ...b,
      children: [
        !u && /* @__PURE__ */ T.jsx(y8, {
          testId: `${t}-icon-container`,
          onClick: C,
          alternateIcon: c,
          children: /* @__PURE__ */ T.jsx(O8, {
            "aria-label": `${r} button`,
            tabIndex: 0,
            ...y,
            children: O
          })
        }),
        /* @__PURE__ */ T.jsx(b8, {
          testId: `${t}-card-content`,
          noMargin: l,
          onScroll: I,
          hiddenScrollBar: E,
          children: n
        })
      ]
    });
  }, [
    _,
    t,
    l,
    b,
    u,
    c,
    y,
    O,
    E,
    r,
    n,
    f,
    s
  ]), N = Rt(() => P, [
    P
  ]);
  return /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsx(g8, {
      height: x,
      width: "100vw",
      top: "0",
      left: "0",
      zIndex: m,
      open: o,
      testId: t,
      children: /* @__PURE__ */ T.jsx(N8, {
        open: o,
        ref: M,
        disabledHeightLimit: h,
        height: "100%",
        width: "100%",
        children: N
      })
    })
  });
}), R8 = `
  display: flex;
  justify-content: center;
  align-items: center;

`, k8 = `
  -webkit-transition: visibility 0.3s, opacity 0.3s ease-in-out;
  -moz-transition: visibility 0.3s, opacity 0.3s ease-in-out;
  -ms-transition: visibility 0.3s, opacity 0.3s ease-in-out;
  -o-transition: visibility 0.3s, opacity 0.3s ease-in-out;
   opacity: 1;
   visibility: visible;
`, w8 = Y(({ children: e, className: t, testId: n, onMouseDown: r }) => /* @__PURE__ */ T.jsx(Y1, {
  className: t,
  testId: n,
  children: /* @__PURE__ */ T.jsx(j, {
    className: t,
    onMouseDown: r,
    children: e
  })
}))`
  ${R8}
  ${({ open: e = !1 }) => e ? R`
        ${k8}
        ${Ve}
      ` : R`
        -webkit-transition: visibility 0.3s, opacity 0.3s ease-in-out;
        -moz-transition: visibility 0.3s, opacity 0.3s ease-in-out;
        -ms-transition: visibility 0.3s, opacity 0.3s ease-in-out;
        -o-transition: visibility 0.3s, opacity 0.3s ease-in-out;
        opacity: 0;
        visibility: hidden;
      `}
`, L8 = (e) => R`
    padding: ${e ? "0" : "1.25rem"};
  `, M8 = `
  overflow: auto;
  position: relative;
  padding: 1.25rem;
`, P8 = Y(/* @__PURE__ */ ee.forwardRef(function({ ...t }, n) {
  return /* @__PURE__ */ T.jsx(V1, {
    ref: n,
    ...t
  });
}))`
  ${M8}
  user-select: none;
  ${({ noMargin: e }) => {
  if (e)
    return R`
        ${L8(e)};
      `;
}}
`, v8 = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  ${({ alternateIcon: e = !1 }) => e ? R`
        position: fixed;
        height: 40px;
        width: 40px;
        cursor: pointer;
        z-index: 101;
        background: rgba(238, 238, 238, 0.3);
        border-radius: 7px;
        margin: 0.7rem;
        > div {
          margin: 0.5rem;
        }
      ` : R`
        position: absolute;
        cursor: pointer;
        top: 1.2rem;
        left: 1.2rem;
        z-index: 101;
      `}
`, D8 = (e, t) => R`
    width: ${e};
    height: ${t};
  `, H8 = `
  opacity: 1;
  transform: translate(0);

`, F8 = (e) => {
  if (!e)
    return `
    max-height: 100%;
    overflow: auto;
  `;
}, B8 = Y(/* @__PURE__ */ ee.forwardRef(function({ children: t, className: n, testId: r, ...i }, o) {
  return /* @__PURE__ */ T.jsx(j, {
    testId: r,
    className: n,
    ref: o,
    ...i,
    children: t
  });
}))`
  position: relative;

  ${({ open: e = !1, width: t, height: n, disabledHeightLimit: r }) => {
  if (e)
    return R`
        ${D8(t, n)};
        ${F8(r)}
        ${H8}
      `;
}}
`, $8 = (e) => R`
    padding-top: ${e ? "0rem" : "3rem"};
  `, U8 = Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  overflow: auto;
  ${({ noMargin: e }) => R`
      ${$8(e)}
    `}

  ${({ hiddenScrollBar: e, noMargin: t }) => {
  if (!t && e)
    return R`
        > *:first-child {
          ::-webkit-scrollbar {
            width: 0;
          }
          overflow: -moz-scrollbars-none;
          -ms-overflow-style: none;
        }
      `;
}}
`;
Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  width: 52px;
  height: 5px;
  border-radius: 5px;
  cursor: pointer;
`;
Y((e) => /* @__PURE__ */ T.jsx(j, {
  ...e
}))`
  width: 134px;
  height: 5px;
  object-fit: contain;
  border-radius: 100px;
`;
const G8 = Y.button`
  ${pi};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;

  /* styles */
  &:hover,
  &:active,
  &:focus {
    background-color: ${Ti};
  }
  &:focus-visible {
    box-shadow: 0 0 0 2px ${q1};
  }
`, j8 = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "centermodal", children: n, icon: r = "close", width: i = "50%", maxWidth: o, minWidth: s, bodyScrollDisabled: l = !1, open: c, onScroll: u, noMargin: f = !1, alternateIcon: m = !1, persistent: E = !1, onClose: h, zIndex: x = 100, hiddenScrollBar: y = !1, containerHeight: b = "100vh", disabledHeightLimit: _ = !1, closeButtonDomProps: M, ...O }, P) {
  const N = wt(null), C = wt(null);
  Fe(() => {
    l && (c ? document.body.style.overflow = "hidden" : document.body.style.overflow = "visible");
  }, [
    l,
    c
  ]), Fe(() => {
    var v;
    c && C && C.current && ((v = C == null ? void 0 : C.current) == null || v.focus());
  }, [
    c
  ]);
  const I = (v) => {
    if (E)
      return;
    const U = v.target;
    c && N.current && U instanceof Node && !N.current.contains(U) && h(v);
  }, D = () => ({
    width: i,
    height: "",
    maxWidth: o,
    minWidth: s
  }), z = Rt(() => {
    switch (r) {
      case "close":
        return /* @__PURE__ */ T.jsx(s1, {
          size: 24,
          color: m ? "white" : "black"
        });
      case "back":
        return /* @__PURE__ */ T.jsx(r1, {
          size: 24,
          color: m ? "white" : "black"
        });
    }
  }, [
    r,
    m
  ]), ie = Rt(() => {
    const v = (L) => {
      L.persist(), h && h(L);
    }, U = (L) => {
      L.persist(), u && u(L);
    };
    return /* @__PURE__ */ T.jsxs(P8, {
      ref: P,
      testId: `${t}-card`,
      noMargin: f,
      ...O,
      children: [
        !E && /* @__PURE__ */ T.jsx(v8, {
          testId: `${t}-icon-container`,
          onClick: v,
          alternateIcon: m,
          children: /* @__PURE__ */ T.jsx(G8, {
            ref: C,
            "aria-label": `${r} button`,
            tabIndex: 0,
            ...M,
            children: z
          })
        }),
        /* @__PURE__ */ T.jsx(U8, {
          testId: `${t}-card-content`,
          noMargin: f,
          onScroll: U,
          hiddenScrollBar: y,
          children: n
        })
      ]
    });
  }, [
    P,
    t,
    f,
    O,
    E,
    m,
    M,
    z,
    y,
    n,
    r,
    h,
    u
  ]);
  return /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsx(w8, {
      height: b,
      width: "100vw",
      top: "0",
      left: "0",
      zIndex: x,
      onMouseDown: I,
      open: c,
      testId: t,
      children: /* @__PURE__ */ T.jsx(B8, {
        open: c,
        ref: N,
        disabledHeightLimit: _,
        ...D(),
        children: ie
      })
    })
  });
}), z8 = Y(j)`
  user-select: none;
`, K8 = Y(j)`
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  outline: none;
`, q8 = Y(j)`
  overflow: hidden;
  width: 100%;
`, Y8 = Y.div`
  display: flex;
  img {
    user-drag: none;
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
`;
Y.div`
  height: 100%;
  display: flex;
`;
const V8 = ({ testId: e = "Carousel-display", carouselRef: t, carouselWidth: n, cards: r, transform: i, swipeEnabled: o, children: s, swipeAmount: l, transition: c, carouselScrollLeft: u, onClick: f, onDrag: m, onSlide: E }) => {
  const [h, x] = Ke({
    initial: i,
    start: 0,
    isDown: !1,
    drag: 0,
    finished: !0,
    pointers: !0
  }), [y, b] = Ke(!0);
  Fe(() => {
    m(i), x({
      initial: i,
      start: 0,
      isDown: !1,
      drag: u,
      finished: !0,
      pointers: !0
    });
  }, [
    u
  ]);
  const _ = (N) => {
    N.persist(), x({
      ...h,
      isDown: !0,
      start: u + zi(N),
      initial: i,
      finished: !1
    });
  }, M = (N) => {
    if (N.persist(), setTimeout(() => {
      b(!0);
    }, 160), h.finished)
      return;
    m(i), x({
      initial: i,
      start: 0,
      isDown: !1,
      drag: u,
      finished: !0,
      pointers: !0
    });
    const C = l;
    Math.abs(h.drag - u) < C || E(h.drag - u > 0 ? $1.Right : $1.Left);
  }, O = (N) => {
    if (N.persist(), y && h.drag - u && b(!1), !h.isDown)
      return;
    const C = u + zi(N), I = h.start - C, D = Math.max(Math.min(I, l * 1.5), -l * 1.5);
    x({
      ...h,
      drag: u + D,
      pointers: !1
    }), Math.abs(I) > l * 1.5 && M(N);
  }, P = o ? {
    onTouchCancel: M,
    onTouchEnd: M,
    onTouchMove: O,
    onTouchStart: _,
    onMouseDown: _,
    onMouseLeave: M,
    onMouseUp: M,
    onMouseMove: O
  } : {};
  return (
    // This will change when the Box supports ref
    /* @__PURE__ */ T.jsx(q8, {
      testId: e,
      ref: t,
      children: /* @__PURE__ */ T.jsx(Y8, {
        "data-testid": `${e}-slider`,
        ...P,
        style: {
          width: n + l * 2,
          transform: `translateX(${i - h.drag}px)`,
          transition: `transform ${c}s ease 0s`
        },
        children: s.map((N, C) => /* @__PURE__ */ T.jsx("div", {
          ref: r[C].ref,
          style: {
            position: "relative",
            userSelect: "none",
            cursor: "pointer",
            marginRight: r[C].spacing
          },
          onClick: () => {
            y && f(C);
          },
          children: N
        }, C))
      })
    })
  );
}, W8 = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "carousel", transition: n = 0.7, swipeEnabled: r = !1, hiddenArrows: i = !1, noScrollAnimationOnLoad: o = !1, skipCropCheck: s = !1, step: l = "page", spacing: c = 16, swipeAmount: u = 50, children: f, selected: m, onScroll: E, onClick: h, onSelect: x, header: y, actions: b, previousButtonDomProps: _, nextButtonDomProps: M, ...O }, P) {
  const C = (() => {
    const S = ee.useRef({});
    return ee.useCallback((w) => S.current[w] = S.current[w] ?? /* @__PURE__ */ ee.createRef(), [
      S
    ]);
  })(), [I, D] = Ke(0), [z, ie] = Ke(0), [v, U] = Ke(0), [L, Q] = Ke(0), [te, pe] = Ke(!o), ye = (S) => {
    let w = 0, V = Z.findIndex((Ce) => Ce.x >= S);
    U(V);
    let fe = Z[V].x - S;
    for (; Z[V] && fe + Z[V].width <= z; )
      fe += Z[V].width + c, w++, V++;
    return w;
  }, Ae = wt(null);
  let ke;
  const d = () => {
    ke && clearTimeout(ke);
    const S = Ae.current, w = S === null ? 0 : S.offsetWidth;
    ie(w), ke = setTimeout(() => {
      const V = Ae.current, fe = V === null ? 0 : V.offsetWidth;
      ie(fe);
    }, 240);
  };
  Fe(() => {
    z && ue(v);
  }, [
    z
  ]), Fe(() => (window.addEventListener("resize", d), function() {
    window.removeEventListener("resize", d);
  }), [
    v,
    z
  ]), Fe(() => {
    d();
  }, []), Fe(() => {
    z && m !== void 0 && lt(m);
  }, [
    m,
    z
  ]), Fe(() => {
    if (Ae.current === null)
      return;
    const S = te ? "smooth" : "unset";
    Ae.current.style.scrollBehavior = S;
  }, [
    te
  ]);
  let q = 0;
  const oe = (S, w) => {
    const V = C(S), fe = V.current;
    return S || (q = fe == null ? 0 : fe.offsetLeft), {
      ref: V,
      width: fe === null ? 0 : fe.offsetWidth,
      x: (fe === null ? 0 : fe.offsetLeft) - q,
      spacing: S < w - 1 ? c : 0
    };
  }, p = (S) => {
    const w = [];
    let V = 0;
    for (; V < S; )
      w.push(oe(V, S)), V++;
    return w;
  }, ne = (S) => {
    const w = S[S.length - 1];
    return w ? w.x + w.width : 0;
  }, se = Array.isArray(f) ? f : [
    f
  ], J = se.length || 0, Z = p(J), le = ne(Z) || 0, ue = (S) => {
    if (se.length === 0 || Ae.current === null)
      return;
    S !== v && (E && E(S), U(S));
    const w = Math.min(Z[S].x, le - z);
    le > z && Q(w);
    const V = ye(w);
    D(V), h1(S > 0), cr(S < Z.length - V), pe(!0);
  }, ce = () => {
    switch (l) {
      case "item":
        return 1;
      case "page":
        return I;
    }
  }, W = (S) => {
    const w = Z[S].x, V = Z[S].width, fe = w < L, Ce = w + V - L > z;
    return fe || Ce;
  }, K = (S) => Math.min(Math.max(S, 0), J - I), je = (S) => Math.min(Math.max(S, -1), J - 1), lt = (S) => {
    const w = je(S);
    if (w >= 0) {
      if (s) {
        const V = K(w);
        ue(V);
      } else if (W(w)) {
        const V = K(w);
        ue(V);
      }
    }
  }, rn = () => {
    const S = K(v - ce());
    ue(S);
  }, vn = () => {
    const S = K(v + ce());
    ue(S);
  }, [gn, Dn] = Ke({
    transform: 0,
    transition: 0,
    isSliding: !1
  }), [ur, h1] = Ke(!1), [d1, cr] = Ke(!1), fr = (S) => {
    lt(S), h && h(S), x && x(S);
  }, hr = (S) => {
    Dn({
      transform: S,
      isSliding: !1,
      transition: n
    }), setTimeout(() => Dn({
      ...gn,
      transition: 0
    }), n * 1e3);
  }, dr = (S) => {
    S > 0 ? rn() : vn();
  }, mr = !!y || !i;
  return /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsxs(K8, {
      opacity: te ? 1 : 0,
      testId: t,
      display: "flex",
      width: "100%",
      flexDirection: "column",
      tabIndex: 0,
      ref: P,
      ...O,
      children: [
        mr && /* @__PURE__ */ T.jsxs(j, {
          display: "flex",
          marginBottom: "1rem",
          alignItems: "center",
          justifyContent: y ? "space-between" : "flex-end",
          children: [
            y && /* @__PURE__ */ T.jsx(z8, {
              testId: `${t}-header-container`,
              children: y
            }),
            /* @__PURE__ */ T.jsxs(j, {
              display: "flex",
              alignSelf: "start",
              children: [
                b && /* @__PURE__ */ T.jsx(j, {
                  testId: `${t}-actions-container`,
                  marginRight: "1rem",
                  alignSelf: "center",
                  flexShrink: 0,
                  children: b
                }),
                !i && /* @__PURE__ */ T.jsxs(j, {
                  testId: `${t}-pagination-button`,
                  children: [
                    /* @__PURE__ */ T.jsx(B1, {
                      paginationDirection: "left",
                      shape: "pagination",
                      disabled: !ur || se.length === 0,
                      onClick: rn,
                      testId: `${t}-back-container`,
                      domProps: {
                        "aria-label": "backward",
                        ..._
                      }
                    }),
                    /* @__PURE__ */ T.jsx(B1, {
                      paginationDirection: "right",
                      shape: "pagination",
                      disabled: !d1 || se.length === 0,
                      onClick: vn,
                      testId: `${t}-forward-container`,
                      marginLeft: "0.5rem",
                      domProps: {
                        "aria-label": "forward",
                        ...M
                      }
                    })
                  ]
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ T.jsx(V8, {
          testId: `${t}-display`,
          carouselRef: Ae,
          carouselWidth: le,
          cards: Z,
          swipeEnabled: r,
          swipeAmount: u,
          transition: gn.transition,
          transform: gn.transform,
          carouselScrollLeft: L,
          onDrag: hr,
          onSlide: dr,
          onClick: fr,
          children: se
        })
      ]
    })
  });
}), uu = `
  display: flex;
  position: absolute;
  height: 44px;
  width: 44px;
  background-color: ${en};
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`, X8 = Y(Y1)`
  left: 0px;
  top: 0px;
  height: ${({ $open: e }) => e ? "100vh" : "0px"};
  width: ${({ $open: e }) => e ? "100vw" : "0px"};
  visibility: ${({ $open: e }) => e ? "visible" : "hidden"};
`, Q8 = Y(j)`
  height: ${({ $mobile: e }) => e ? "60px" : "92px"};
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
`, J8 = Y(j)`
  position: absolute;
  left: ${({ $mobile: e }) => e ? "16px" : "62px"};
  cursor: pointer;
`, Z8 = Y(j)`
  padding-bottom: ${({ $mobile: e }) => e ? "none" : "92px"};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`, eT = Y(j)`
  left: 62px;
  ${uu};
`, tT = Y(j)`
  right: 62px;
  ${uu};
`, nT = Y(j)`
  width: ${({ $mobile: e }) => e ? "100vw" : "calc(100vw - 277px)"};
  max-height: ${({ $mobile: e }) => e ? "calc(100vh - 60px)" : "calc(100vh - 184px)"};
`, rT = Y(j)`
  position: relative;
  width: ${({ $mobile: e }) => e ? "100vw" : "calc(100vw - 276px)"};
  height: ${({ $mobile: e }) => e ? "calc(100vh - 60px)" : "calc(100vh - 184px)"};
`, VT = ({ testId: e = "lightbox", open: t, selected: n = 0, mobile: r = !1, onClose: i, onChange: o, children: s, ...l }) => {
  const [c, u] = Ke(n), f = Array.isArray(s) ? s : [
    s
  ], m = c > 0 && !r, E = c < f.length - 1 && !r, h = () => r ? /* @__PURE__ */ T.jsx(r1, {
    size: 24,
    color: en
  }) : /* @__PURE__ */ T.jsx(s1, {
    size: 24,
    color: en
  }), x = () => f.map((M, O) => /* @__PURE__ */ T.jsx(nT, {
    testId: `${e}-body-carousel-element-${O}`,
    $mobile: r,
    children: M
  }, O)), y = Ut((M) => {
    o && o(M), M !== c && u(M);
  }, [
    o,
    u,
    c
  ]), b = Ut(() => {
    c > 0 && u(c - 1);
  }, [
    u,
    c
  ]), _ = Ut(() => {
    c < f.length - 1 && u(c + 1);
  }, [
    u,
    c,
    f.length
  ]);
  return Fe(() => {
    const M = (P) => {
      P.key === "ArrowLeft" && b();
    }, O = (P) => {
      P.key === "ArrowRight" && _();
    };
    if (!r)
      return document.addEventListener("keydown", M), document.addEventListener("keydown", O), () => {
        document.removeEventListener("keydown", M), document.removeEventListener("keydown", O);
      };
  }, [
    b,
    _,
    r
  ]), Fe(() => {
    u(n);
  }, [
    n,
    u
  ]), /* @__PURE__ */ T.jsx(Ge, {
    children: /* @__PURE__ */ T.jsxs(X8, {
      variant: "default",
      percentage: 100,
      testId: e,
      $open: t,
      ...l,
      children: [
        /* @__PURE__ */ T.jsxs(Q8, {
          $mobile: r,
          testId: `${e}-header`,
          children: [
            /* @__PURE__ */ T.jsx(J8, {
              onClick: i,
              $mobile: r,
              children: h()
            }),
            /* @__PURE__ */ T.jsx(ut, {
              weight: "regular",
              variant: "body",
              color: en,
              testId: `${e}-header-title`,
              children: `${c + 1} of ${f.length}`
            })
          ]
        }),
        /* @__PURE__ */ T.jsxs(Z8, {
          $mobile: r,
          testId: `${e}-body`,
          children: [
            m && /* @__PURE__ */ T.jsx(eT, {
              onClick: b,
              children: /* @__PURE__ */ T.jsx(r1, {
                size: 16
              })
            }),
            /* @__PURE__ */ T.jsx(rT, {
              $mobile: r,
              children: /* @__PURE__ */ T.jsx(W8, {
                selected: c,
                swipeEnabled: r,
                swipeAmount: 100,
                testId: `${e}-body-carousel`,
                onScroll: y,
                step: "item",
                hiddenArrows: !0,
                noScrollAnimationOnLoad: !0,
                children: x()
              })
            }),
            E && /* @__PURE__ */ T.jsx(tT, {
              onClick: _,
              children: /* @__PURE__ */ T.jsx(wu, {
                size: 16
              })
            })
          ]
        })
      ]
    })
  });
}, WT = /* @__PURE__ */ ee.forwardRef(function({ testId: t = "modal", children: n, variant: r = "center", icon: i = "close", width: o, bodyScrollDisabled: s = !1, open: l, onScroll: c, dragDisabled: u = !1, dragAmount: f = 100, noMargin: m = !1, alternateIcon: E = !1, persistent: h = !1, onClose: x, hiddenScrollBar: y = !1, containerHeight: b = "100vh", disabledHeightLimit: _ = !1, closeButtonDomProps: M, ...O }, P) {
  const N = Rt(() => {
    switch (r) {
      case "center":
        return /* @__PURE__ */ T.jsx(j8, {
          open: l,
          noMargin: m,
          alternateIcon: E,
          icon: i,
          width: o,
          bodyScrollDisabled: s,
          persistent: h,
          hiddenScrollBar: y,
          onClose: x,
          onScroll: c,
          testId: t,
          containerHeight: b,
          disabledHeightLimit: _,
          closeButtonDomProps: M,
          ...O,
          children: n
        });
      case "fullscreen":
        return /* @__PURE__ */ T.jsx(I8, {
          open: l,
          noMargin: m,
          alternateIcon: E,
          icon: i,
          bodyScrollDisabled: s,
          persistent: h,
          hiddenScrollBar: y,
          disabledHeightLimit: _,
          onClose: x,
          onScroll: c,
          testId: t,
          containerHeight: b,
          closeButtonDomProps: M,
          ...O,
          children: n
        });
      case "bottom":
        return /* @__PURE__ */ T.jsx(Xc, {
          open: l,
          noMargin: m,
          width: o,
          bodyScrollDisabled: s,
          persistent: h,
          dragDisabled: u,
          dragAmount: f,
          containerHeight: b,
          hiddenScrollBar: y,
          disabledHeightLimit: _,
          onClose: x,
          onScroll: c,
          testId: t,
          ...O,
          children: n
        });
      case "side":
        return /* @__PURE__ */ T.jsx(m8, {
          open: l,
          noMargin: m,
          width: o,
          alternateIcon: E,
          icon: i,
          bodyScrollDisabled: s,
          persistent: h,
          containerHeight: b,
          hiddenScrollBar: y,
          disabledHeightLimit: _,
          onClose: x,
          onScroll: c,
          testId: t,
          closeButtonDomProps: M,
          ...O,
          children: n
        });
    }
  }, [
    E,
    s,
    n,
    b,
    _,
    f,
    u,
    y,
    i,
    m,
    x,
    c,
    l,
    h,
    O,
    t,
    r,
    o,
    M
  ]);
  return /* @__PURE__ */ T.jsx(j, {
    ref: P,
    children: N
  });
});
export {
  e2 as AccessibilityFilledIcon,
  t2 as AccessibilityIcon,
  n2 as AccessibilityOutlinedIcon,
  NT as Accordion,
  ug as Alert,
  r1 as BackIcon,
  r2 as BedIcon,
  i2 as BellIcon,
  Xc as BottomModal,
  j as Box,
  B1 as Button,
  o2 as CalendarIcon,
  V1 as Card,
  Du as CardContainer,
  s2 as CardsIcon,
  W8 as Carousel,
  l2 as CartIcon,
  j8 as CenterModal,
  bu as CheckIcon,
  TT as Checkbox,
  a2 as CheckoutIcon,
  u2 as CloseAltIcon,
  c2 as CloseFilledIcon,
  s1 as CloseIcon,
  f2 as CocktailIcon,
  bT as Column,
  gT as ColumnItem,
  qu as ColumnItemContextProvider,
  h2 as CreditCardIcon,
  d2 as DiamondIcon,
  ET as Divider,
  Ou as DropdownArrowIcon,
  AT as DropdownContainer,
  _T as DropdownItem,
  m2 as EnlargeIcon,
  p2 as FamilyIcon,
  T2 as FilterIcon,
  g2 as FineDiningIcon,
  wu as ForwardIcon,
  I8 as FullScreenModal,
  ig as Grid,
  E2 as GridFilledIcon,
  A2 as GridOutlinedIcon,
  _2 as GuestIcon,
  y2 as HotelIcon,
  sg as Icon,
  lg as IconContextProvider,
  yT as Image,
  C2 as InformationIcon,
  OT as Input,
  tc as InputContainer,
  S2 as LeftArrowIcon,
  VT as LightBox,
  x2 as ListIcon,
  Lu as LoadingSpinnerIcon,
  N2 as LocationFilledIcon,
  b2 as LocationIcon,
  ku as LockFilledIcon,
  O2 as LockOutlinedIcon,
  I2 as LoungeChairIcon,
  R2 as MGMRewardsIcon,
  KT as Markdown,
  k2 as MenuIcon,
  w2 as MicrophoneIcon,
  L2 as MinusIcon,
  M2 as MinusOutlinedIcon,
  WT as Modal,
  CT as NavigationItem,
  P2 as NightLifeIcon,
  Y1 as Overlay,
  v2 as ParkingIcon,
  D2 as PinIcon,
  H2 as PlateIcon,
  F2 as PlayIcon,
  B2 as PlusIcon,
  $2 as PlusOutlinedIcon,
  ST as Radio,
  U2 as RefreshIcon,
  G2 as RewardPointsIcon,
  j2 as RightArrowIcon,
  z2 as ShieldIcon,
  m8 as SideModal,
  K2 as SlotDollarsIcon,
  q2 as SortAscendingIcon,
  Y2 as SortDescendingIcon,
  V2 as SpaIcon,
  W2 as StairsIcon,
  X2 as StarIcon,
  Q2 as StartPointIcon,
  xT as Switch,
  qT as Tag,
  J2 as TaxiIcon,
  Z2 as TentIcon,
  JT as ThemeContextProvider,
  YT as Toast,
  eg as TravelCreditIcon,
  ut as Typography,
  tg as UpwardArrowIcon,
  Iu as VisibilityIcon,
  Ru as VisibilityOffIcon,
  ji as WarningIcon,
  ng as WarningOutlinedIcon
};
